/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/wp-content/themes/Maxomedia/assets";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _materializeCss = __webpack_require__(1);
	
	var _materializeCss2 = _interopRequireDefault(_materializeCss);
	
	var _slickCarousel = __webpack_require__(5);
	
	var _slickCarousel2 = _interopRequireDefault(_slickCarousel);
	
	var _dropzone = __webpack_require__(6);
	
	var _dropzone2 = _interopRequireDefault(_dropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import Isotope from 'isotope-layout';
	//import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic.js';
	//import ScrollMagicInit from 'modules/scrollfire/init';
	
	// vendor
	//@import "bootstrap-sass/assets/javascripts/bootstrap.js";
	
	__webpack_require__(8);
	__webpack_require__(10);
	__webpack_require__(11);
	// require('./vendor/dropzone');
	
	
	// modules
	__webpack_require__(12);
	__webpack_require__(13);
	__webpack_require__(14);
	__webpack_require__(15);
	__webpack_require__(16);
	__webpack_require__(17);
	__webpack_require__(18);
	__webpack_require__(19);
	__webpack_require__(20);
	__webpack_require__(21);
	__webpack_require__(22);
	__webpack_require__(23);
	__webpack_require__(24);
	__webpack_require__(30);
	__webpack_require__(31);
	__webpack_require__(32);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(35);
	
	// special
	//require('./modules/browserdetection.js');
	// require('./modules/test.js');
	
	// init global materialize stuff
	$(document).ready(function () {
	
		$('.collapsible').collapsible();
	
		// inject the close button
		var backbtn = $('.category-back, #page-closer');
		var title = $('.line-container > .row:first-child .intro-title');
	
		if (backbtn.length && title.length) {
			title.append('<a href="' + backbtn.data('link') + '" class="title-back" id="page-closer"><div class="cssicon close"></div></a>');
		}
	
		$(document).on('click', '.category-back', function (e) {
			e.preventDefault();
			history.back();
		});
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_LOCAL_MODULE_0__;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;if("undefined"==typeof jQuery){var jQuery;jQuery= true?$=__webpack_require__(2):$}jQuery.easing.jswing=jQuery.easing.swing,jQuery.extend(jQuery.easing,{def:"easeOutQuad",swing:function(a,b,c,d,e){return jQuery.easing[jQuery.easing.def](a,b,c,d,e)},easeInQuad:function(a,b,c,d,e){return d*(b/=e)*b+c},easeOutQuad:function(a,b,c,d,e){return-d*(b/=e)*(b-2)+c},easeInOutQuad:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b+c:-d/2*(--b*(b-2)-1)+c},easeInCubic:function(a,b,c,d,e){return d*(b/=e)*b*b+c},easeOutCubic:function(a,b,c,d,e){return d*((b=b/e-1)*b*b+1)+c},easeInOutCubic:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b*b+c:d/2*((b-=2)*b*b+2)+c},easeInQuart:function(a,b,c,d,e){return d*(b/=e)*b*b*b+c},easeOutQuart:function(a,b,c,d,e){return-d*((b=b/e-1)*b*b*b-1)+c},easeInOutQuart:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b*b*b+c:-d/2*((b-=2)*b*b*b-2)+c},easeInQuint:function(a,b,c,d,e){return d*(b/=e)*b*b*b*b+c},easeOutQuint:function(a,b,c,d,e){return d*((b=b/e-1)*b*b*b*b+1)+c},easeInOutQuint:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b*b*b*b+c:d/2*((b-=2)*b*b*b*b+2)+c},easeInSine:function(a,b,c,d,e){return-d*Math.cos(b/e*(Math.PI/2))+d+c},easeOutSine:function(a,b,c,d,e){return d*Math.sin(b/e*(Math.PI/2))+c},easeInOutSine:function(a,b,c,d,e){return-d/2*(Math.cos(Math.PI*b/e)-1)+c},easeInExpo:function(a,b,c,d,e){return 0==b?c:d*Math.pow(2,10*(b/e-1))+c},easeOutExpo:function(a,b,c,d,e){return b==e?c+d:d*(-Math.pow(2,-10*b/e)+1)+c},easeInOutExpo:function(a,b,c,d,e){return 0==b?c:b==e?c+d:(b/=e/2)<1?d/2*Math.pow(2,10*(b-1))+c:d/2*(-Math.pow(2,-10*--b)+2)+c},easeInCirc:function(a,b,c,d,e){return-d*(Math.sqrt(1-(b/=e)*b)-1)+c},easeOutCirc:function(a,b,c,d,e){return d*Math.sqrt(1-(b=b/e-1)*b)+c},easeInOutCirc:function(a,b,c,d,e){return(b/=e/2)<1?-d/2*(Math.sqrt(1-b*b)-1)+c:d/2*(Math.sqrt(1-(b-=2)*b)+1)+c},easeInElastic:function(a,b,c,d,e){var f=1.70158,g=0,h=d;if(0==b)return c;if(1==(b/=e))return c+d;if(g||(g=.3*e),h<Math.abs(d)){h=d;var f=g/4}else var f=g/(2*Math.PI)*Math.asin(d/h);return-(h*Math.pow(2,10*(b-=1))*Math.sin((b*e-f)*(2*Math.PI)/g))+c},easeOutElastic:function(a,b,c,d,e){var f=1.70158,g=0,h=d;if(0==b)return c;if(1==(b/=e))return c+d;if(g||(g=.3*e),h<Math.abs(d)){h=d;var f=g/4}else var f=g/(2*Math.PI)*Math.asin(d/h);return h*Math.pow(2,-10*b)*Math.sin((b*e-f)*(2*Math.PI)/g)+d+c},easeInOutElastic:function(a,b,c,d,e){var f=1.70158,g=0,h=d;if(0==b)return c;if(2==(b/=e/2))return c+d;if(g||(g=e*(.3*1.5)),h<Math.abs(d)){h=d;var f=g/4}else var f=g/(2*Math.PI)*Math.asin(d/h);return 1>b?-.5*(h*Math.pow(2,10*(b-=1))*Math.sin((b*e-f)*(2*Math.PI)/g))+c:h*Math.pow(2,-10*(b-=1))*Math.sin((b*e-f)*(2*Math.PI)/g)*.5+d+c},easeInBack:function(a,b,c,d,e,f){return void 0==f&&(f=1.70158),d*(b/=e)*b*((f+1)*b-f)+c},easeOutBack:function(a,b,c,d,e,f){return void 0==f&&(f=1.70158),d*((b=b/e-1)*b*((f+1)*b+f)+1)+c},easeInOutBack:function(a,b,c,d,e,f){return void 0==f&&(f=1.70158),(b/=e/2)<1?d/2*(b*b*(((f*=1.525)+1)*b-f))+c:d/2*((b-=2)*b*(((f*=1.525)+1)*b+f)+2)+c},easeInBounce:function(a,b,c,d,e){return d-jQuery.easing.easeOutBounce(a,e-b,0,d,e)+c},easeOutBounce:function(a,b,c,d,e){return(b/=e)<1/2.75?d*(7.5625*b*b)+c:2/2.75>b?d*(7.5625*(b-=1.5/2.75)*b+.75)+c:2.5/2.75>b?d*(7.5625*(b-=2.25/2.75)*b+.9375)+c:d*(7.5625*(b-=2.625/2.75)*b+.984375)+c},easeInOutBounce:function(a,b,c,d,e){return e/2>b?.5*jQuery.easing.easeInBounce(a,2*b,0,d,e)+c:.5*jQuery.easing.easeOutBounce(a,2*b-e,0,d,e)+.5*d+c}}),jQuery.extend(jQuery.easing,{easeInOutMaterial:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b+c:d/4*((b-=2)*b*b+2)+c}}),jQuery.Velocity?console.log("Velocity is already loaded. You may be needlessly importing Velocity again; note that Materialize includes Velocity."):(!function(a){function b(a){var b=a.length,d=c.type(a);return"function"===d||c.isWindow(a)?!1:1===a.nodeType&&b?!0:"array"===d||0===b||"number"==typeof b&&b>0&&b-1 in a}if(!a.jQuery){var c=function(a,b){return new c.fn.init(a,b)};c.isWindow=function(a){return null!=a&&a==a.window},c.type=function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?e[g.call(a)]||"object":typeof a},c.isArray=Array.isArray||function(a){return"array"===c.type(a)},c.isPlainObject=function(a){var b;if(!a||"object"!==c.type(a)||a.nodeType||c.isWindow(a))return!1;try{if(a.constructor&&!f.call(a,"constructor")&&!f.call(a.constructor.prototype,"isPrototypeOf"))return!1}catch(d){return!1}for(b in a);return void 0===b||f.call(a,b)},c.each=function(a,c,d){var e,f=0,g=a.length,h=b(a);if(d){if(h)for(;g>f&&(e=c.apply(a[f],d),e!==!1);f++);else for(f in a)if(e=c.apply(a[f],d),e===!1)break}else if(h)for(;g>f&&(e=c.call(a[f],f,a[f]),e!==!1);f++);else for(f in a)if(e=c.call(a[f],f,a[f]),e===!1)break;return a},c.data=function(a,b,e){if(void 0===e){var f=a[c.expando],g=f&&d[f];if(void 0===b)return g;if(g&&b in g)return g[b]}else if(void 0!==b){var f=a[c.expando]||(a[c.expando]=++c.uuid);return d[f]=d[f]||{},d[f][b]=e,e}},c.removeData=function(a,b){var e=a[c.expando],f=e&&d[e];f&&c.each(b,function(a,b){delete f[b]})},c.extend=function(){var a,b,d,e,f,g,h=arguments[0]||{},i=1,j=arguments.length,k=!1;for("boolean"==typeof h&&(k=h,h=arguments[i]||{},i++),"object"!=typeof h&&"function"!==c.type(h)&&(h={}),i===j&&(h=this,i--);j>i;i++)if(null!=(f=arguments[i]))for(e in f)a=h[e],d=f[e],h!==d&&(k&&d&&(c.isPlainObject(d)||(b=c.isArray(d)))?(b?(b=!1,g=a&&c.isArray(a)?a:[]):g=a&&c.isPlainObject(a)?a:{},h[e]=c.extend(k,g,d)):void 0!==d&&(h[e]=d));return h},c.queue=function(a,d,e){function f(a,c){var d=c||[];return null!=a&&(b(Object(a))?!function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;)a[e++]=b[d++];if(c!==c)for(;void 0!==b[d];)a[e++]=b[d++];return a.length=e,a}(d,"string"==typeof a?[a]:a):[].push.call(d,a)),d}if(a){d=(d||"fx")+"queue";var g=c.data(a,d);return e?(!g||c.isArray(e)?g=c.data(a,d,f(e)):g.push(e),g):g||[]}},c.dequeue=function(a,b){c.each(a.nodeType?[a]:a,function(a,d){b=b||"fx";var e=c.queue(d,b),f=e.shift();"inprogress"===f&&(f=e.shift()),f&&("fx"===b&&e.unshift("inprogress"),f.call(d,function(){c.dequeue(d,b)}))})},c.fn=c.prototype={init:function(a){if(a.nodeType)return this[0]=a,this;throw new Error("Not a DOM node.")},offset:function(){var b=this[0].getBoundingClientRect?this[0].getBoundingClientRect():{top:0,left:0};return{top:b.top+(a.pageYOffset||document.scrollTop||0)-(document.clientTop||0),left:b.left+(a.pageXOffset||document.scrollLeft||0)-(document.clientLeft||0)}},position:function(){function a(){for(var a=this.offsetParent||document;a&&"html"===!a.nodeType.toLowerCase&&"static"===a.style.position;)a=a.offsetParent;return a||document}var b=this[0],a=a.apply(b),d=this.offset(),e=/^(?:body|html)$/i.test(a.nodeName)?{top:0,left:0}:c(a).offset();return d.top-=parseFloat(b.style.marginTop)||0,d.left-=parseFloat(b.style.marginLeft)||0,a.style&&(e.top+=parseFloat(a.style.borderTopWidth)||0,e.left+=parseFloat(a.style.borderLeftWidth)||0),{top:d.top-e.top,left:d.left-e.left}}};var d={};c.expando="velocity"+(new Date).getTime(),c.uuid=0;for(var e={},f=e.hasOwnProperty,g=e.toString,h="Boolean Number String Function Array Date RegExp Object Error".split(" "),i=0;i<h.length;i++)e["[object "+h[i]+"]"]=h[i].toLowerCase();c.fn.init.prototype=c.fn,a.Velocity={Utilities:c}}}(window),function(a){"object"==typeof module&&"object"==typeof module.exports?module.exports=a(): true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):a()}(function(){return function(a,b,c,d){function e(a){for(var b=-1,c=a?a.length:0,d=[];++b<c;){var e=a[b];e&&d.push(e)}return d}function f(a){return p.isWrapped(a)?a=[].slice.call(a):p.isNode(a)&&(a=[a]),a}function g(a){var b=m.data(a,"velocity");return null===b?d:b}function h(a){return function(b){return Math.round(b*a)*(1/a)}}function i(a,c,d,e){function f(a,b){return 1-3*b+3*a}function g(a,b){return 3*b-6*a}function h(a){return 3*a}function i(a,b,c){return((f(b,c)*a+g(b,c))*a+h(b))*a}function j(a,b,c){return 3*f(b,c)*a*a+2*g(b,c)*a+h(b)}function k(b,c){for(var e=0;p>e;++e){var f=j(c,a,d);if(0===f)return c;var g=i(c,a,d)-b;c-=g/f}return c}function l(){for(var b=0;t>b;++b)x[b]=i(b*u,a,d)}function m(b,c,e){var f,g,h=0;do g=c+(e-c)/2,f=i(g,a,d)-b,f>0?e=g:c=g;while(Math.abs(f)>r&&++h<s);return g}function n(b){for(var c=0,e=1,f=t-1;e!=f&&x[e]<=b;++e)c+=u;--e;var g=(b-x[e])/(x[e+1]-x[e]),h=c+g*u,i=j(h,a,d);return i>=q?k(b,h):0==i?h:m(b,c,c+u)}function o(){y=!0,(a!=c||d!=e)&&l()}var p=4,q=.001,r=1e-7,s=10,t=11,u=1/(t-1),v="Float32Array"in b;if(4!==arguments.length)return!1;for(var w=0;4>w;++w)if("number"!=typeof arguments[w]||isNaN(arguments[w])||!isFinite(arguments[w]))return!1;a=Math.min(a,1),d=Math.min(d,1),a=Math.max(a,0),d=Math.max(d,0);var x=v?new Float32Array(t):new Array(t),y=!1,z=function(b){return y||o(),a===c&&d===e?b:0===b?0:1===b?1:i(n(b),c,e)};z.getControlPoints=function(){return[{x:a,y:c},{x:d,y:e}]};var A="generateBezier("+[a,c,d,e]+")";return z.toString=function(){return A},z}function j(a,b){var c=a;return p.isString(a)?t.Easings[a]||(c=!1):c=p.isArray(a)&&1===a.length?h.apply(null,a):p.isArray(a)&&2===a.length?u.apply(null,a.concat([b])):p.isArray(a)&&4===a.length?i.apply(null,a):!1,c===!1&&(c=t.Easings[t.defaults.easing]?t.defaults.easing:s),c}function k(a){if(a){var b=(new Date).getTime(),c=t.State.calls.length;c>1e4&&(t.State.calls=e(t.State.calls));for(var f=0;c>f;f++)if(t.State.calls[f]){var h=t.State.calls[f],i=h[0],j=h[2],n=h[3],o=!!n,q=null;n||(n=t.State.calls[f][3]=b-16);for(var r=Math.min((b-n)/j.duration,1),s=0,u=i.length;u>s;s++){var w=i[s],y=w.element;if(g(y)){var z=!1;if(j.display!==d&&null!==j.display&&"none"!==j.display){if("flex"===j.display){var A=["-webkit-box","-moz-box","-ms-flexbox","-webkit-flex"];m.each(A,function(a,b){v.setPropertyValue(y,"display",b)})}v.setPropertyValue(y,"display",j.display)}j.visibility!==d&&"hidden"!==j.visibility&&v.setPropertyValue(y,"visibility",j.visibility);for(var B in w)if("element"!==B){var C,D=w[B],E=p.isString(D.easing)?t.Easings[D.easing]:D.easing;if(1===r)C=D.endValue;else{var F=D.endValue-D.startValue;if(C=D.startValue+F*E(r,j,F),!o&&C===D.currentValue)continue}if(D.currentValue=C,"tween"===B)q=C;else{if(v.Hooks.registered[B]){var G=v.Hooks.getRoot(B),H=g(y).rootPropertyValueCache[G];H&&(D.rootPropertyValue=H)}var I=v.setPropertyValue(y,B,D.currentValue+(0===parseFloat(C)?"":D.unitType),D.rootPropertyValue,D.scrollData);v.Hooks.registered[B]&&(g(y).rootPropertyValueCache[G]=v.Normalizations.registered[G]?v.Normalizations.registered[G]("extract",null,I[1]):I[1]),"transform"===I[0]&&(z=!0)}}j.mobileHA&&g(y).transformCache.translate3d===d&&(g(y).transformCache.translate3d="(0px, 0px, 0px)",z=!0),z&&v.flushTransformCache(y)}}j.display!==d&&"none"!==j.display&&(t.State.calls[f][2].display=!1),j.visibility!==d&&"hidden"!==j.visibility&&(t.State.calls[f][2].visibility=!1),j.progress&&j.progress.call(h[1],h[1],r,Math.max(0,n+j.duration-b),n,q),1===r&&l(f)}}t.State.isTicking&&x(k)}function l(a,b){if(!t.State.calls[a])return!1;for(var c=t.State.calls[a][0],e=t.State.calls[a][1],f=t.State.calls[a][2],h=t.State.calls[a][4],i=!1,j=0,k=c.length;k>j;j++){var l=c[j].element;if(b||f.loop||("none"===f.display&&v.setPropertyValue(l,"display",f.display),"hidden"===f.visibility&&v.setPropertyValue(l,"visibility",f.visibility)),f.loop!==!0&&(m.queue(l)[1]===d||!/\.velocityQueueEntryFlag/i.test(m.queue(l)[1]))&&g(l)){g(l).isAnimating=!1,g(l).rootPropertyValueCache={};var n=!1;m.each(v.Lists.transforms3D,function(a,b){var c=/^scale/.test(b)?1:0,e=g(l).transformCache[b];g(l).transformCache[b]!==d&&new RegExp("^\\("+c+"[^.]").test(e)&&(n=!0,delete g(l).transformCache[b])}),f.mobileHA&&(n=!0,delete g(l).transformCache.translate3d),n&&v.flushTransformCache(l),v.Values.removeClass(l,"velocity-animating")}if(!b&&f.complete&&!f.loop&&j===k-1)try{f.complete.call(e,e)}catch(o){setTimeout(function(){throw o},1)}h&&f.loop!==!0&&h(e),g(l)&&f.loop===!0&&!b&&(m.each(g(l).tweensContainer,function(a,b){/^rotate/.test(a)&&360===parseFloat(b.endValue)&&(b.endValue=0,b.startValue=360),/^backgroundPosition/.test(a)&&100===parseFloat(b.endValue)&&"%"===b.unitType&&(b.endValue=0,b.startValue=100)}),t(l,"reverse",{loop:!0,delay:f.delay})),f.queue!==!1&&m.dequeue(l,f.queue)}t.State.calls[a]=!1;for(var p=0,q=t.State.calls.length;q>p;p++)if(t.State.calls[p]!==!1){i=!0;break}i===!1&&(t.State.isTicking=!1,delete t.State.calls,t.State.calls=[])}var m,n=function(){if(c.documentMode)return c.documentMode;for(var a=7;a>4;a--){var b=c.createElement("div");if(b.innerHTML="<!--[if IE "+a+"]><span></span><![endif]-->",b.getElementsByTagName("span").length)return b=null,a}return d}(),o=function(){var a=0;return b.webkitRequestAnimationFrame||b.mozRequestAnimationFrame||function(b){var c,d=(new Date).getTime();return c=Math.max(0,16-(d-a)),a=d+c,setTimeout(function(){b(d+c)},c)}}(),p={isString:function(a){return"string"==typeof a},isArray:Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)},isFunction:function(a){return"[object Function]"===Object.prototype.toString.call(a)},isNode:function(a){return a&&a.nodeType},isNodeList:function(a){return"object"==typeof a&&/^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(a))&&a.length!==d&&(0===a.length||"object"==typeof a[0]&&a[0].nodeType>0)},isWrapped:function(a){return a&&(a.jquery||b.Zepto&&b.Zepto.zepto.isZ(a))},isSVG:function(a){return b.SVGElement&&a instanceof b.SVGElement},isEmptyObject:function(a){for(var b in a)return!1;return!0}},q=!1;if(a.fn&&a.fn.jquery?(m=a,q=!0):m=b.Velocity.Utilities,8>=n&&!q)throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");if(7>=n)return void(jQuery.fn.velocity=jQuery.fn.animate);var r=400,s="swing",t={State:{isMobile:/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),isAndroid:/Android/i.test(navigator.userAgent),isGingerbread:/Android 2\.3\.[3-7]/i.test(navigator.userAgent),isChrome:b.chrome,isFirefox:/Firefox/i.test(navigator.userAgent),prefixElement:c.createElement("div"),prefixMatches:{},scrollAnchor:null,scrollPropertyLeft:null,scrollPropertyTop:null,isTicking:!1,calls:[]},CSS:{},Utilities:m,Redirects:{},Easings:{},Promise:b.Promise,defaults:{queue:"",duration:r,easing:s,begin:d,complete:d,progress:d,display:d,visibility:d,loop:!1,delay:!1,mobileHA:!0,_cacheValues:!0},init:function(a){m.data(a,"velocity",{isSVG:p.isSVG(a),isAnimating:!1,computedStyle:null,tweensContainer:null,rootPropertyValueCache:{},transformCache:{}})},hook:null,mock:!1,version:{major:1,minor:2,patch:2},debug:!1};b.pageYOffset!==d?(t.State.scrollAnchor=b,t.State.scrollPropertyLeft="pageXOffset",t.State.scrollPropertyTop="pageYOffset"):(t.State.scrollAnchor=c.documentElement||c.body.parentNode||c.body,t.State.scrollPropertyLeft="scrollLeft",t.State.scrollPropertyTop="scrollTop");var u=function(){function a(a){return-a.tension*a.x-a.friction*a.v}function b(b,c,d){var e={x:b.x+d.dx*c,v:b.v+d.dv*c,tension:b.tension,friction:b.friction};return{dx:e.v,dv:a(e)}}function c(c,d){var e={dx:c.v,dv:a(c)},f=b(c,.5*d,e),g=b(c,.5*d,f),h=b(c,d,g),i=1/6*(e.dx+2*(f.dx+g.dx)+h.dx),j=1/6*(e.dv+2*(f.dv+g.dv)+h.dv);return c.x=c.x+i*d,c.v=c.v+j*d,c}return function d(a,b,e){var f,g,h,i={x:-1,v:0,tension:null,friction:null},j=[0],k=0,l=1e-4,m=.016;for(a=parseFloat(a)||500,b=parseFloat(b)||20,e=e||null,i.tension=a,i.friction=b,f=null!==e,f?(k=d(a,b),g=k/e*m):g=m;h=c(h||i,g),j.push(1+h.x),k+=16,Math.abs(h.x)>l&&Math.abs(h.v)>l;);return f?function(a){return j[a*(j.length-1)|0]}:k}}();t.Easings={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},spring:function(a){return 1-Math.cos(4.5*a*Math.PI)*Math.exp(6*-a)}},m.each([["ease",[.25,.1,.25,1]],["ease-in",[.42,0,1,1]],["ease-out",[0,0,.58,1]],["ease-in-out",[.42,0,.58,1]],["easeInSine",[.47,0,.745,.715]],["easeOutSine",[.39,.575,.565,1]],["easeInOutSine",[.445,.05,.55,.95]],["easeInQuad",[.55,.085,.68,.53]],["easeOutQuad",[.25,.46,.45,.94]],["easeInOutQuad",[.455,.03,.515,.955]],["easeInCubic",[.55,.055,.675,.19]],["easeOutCubic",[.215,.61,.355,1]],["easeInOutCubic",[.645,.045,.355,1]],["easeInQuart",[.895,.03,.685,.22]],["easeOutQuart",[.165,.84,.44,1]],["easeInOutQuart",[.77,0,.175,1]],["easeInQuint",[.755,.05,.855,.06]],["easeOutQuint",[.23,1,.32,1]],["easeInOutQuint",[.86,0,.07,1]],["easeInExpo",[.95,.05,.795,.035]],["easeOutExpo",[.19,1,.22,1]],["easeInOutExpo",[1,0,0,1]],["easeInCirc",[.6,.04,.98,.335]],["easeOutCirc",[.075,.82,.165,1]],["easeInOutCirc",[.785,.135,.15,.86]]],function(a,b){t.Easings[b[0]]=i.apply(null,b[1])});var v=t.CSS={RegEx:{isHex:/^#([A-f\d]{3}){1,2}$/i,valueUnwrap:/^[A-z]+\((.*)\)$/i,wrappedValueAlreadyExtracted:/[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,valueSplit:/([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi},Lists:{colors:["fill","stroke","stopColor","color","backgroundColor","borderColor","borderTopColor","borderRightColor","borderBottomColor","borderLeftColor","outlineColor"],transformsBase:["translateX","translateY","scale","scaleX","scaleY","skewX","skewY","rotateZ"],transforms3D:["transformPerspective","translateZ","scaleZ","rotateX","rotateY"]},Hooks:{templates:{textShadow:["Color X Y Blur","black 0px 0px 0px"],boxShadow:["Color X Y Blur Spread","black 0px 0px 0px 0px"],clip:["Top Right Bottom Left","0px 0px 0px 0px"],backgroundPosition:["X Y","0% 0%"],transformOrigin:["X Y Z","50% 50% 0px"],perspectiveOrigin:["X Y","50% 50%"]},registered:{},register:function(){for(var a=0;a<v.Lists.colors.length;a++){var b="color"===v.Lists.colors[a]?"0 0 0 1":"255 255 255 1";v.Hooks.templates[v.Lists.colors[a]]=["Red Green Blue Alpha",b]}var c,d,e;if(n)for(c in v.Hooks.templates){d=v.Hooks.templates[c],e=d[0].split(" ");var f=d[1].match(v.RegEx.valueSplit);"Color"===e[0]&&(e.push(e.shift()),f.push(f.shift()),v.Hooks.templates[c]=[e.join(" "),f.join(" ")])}for(c in v.Hooks.templates){d=v.Hooks.templates[c],e=d[0].split(" ");for(var a in e){var g=c+e[a],h=a;v.Hooks.registered[g]=[c,h]}}},getRoot:function(a){var b=v.Hooks.registered[a];return b?b[0]:a},cleanRootPropertyValue:function(a,b){return v.RegEx.valueUnwrap.test(b)&&(b=b.match(v.RegEx.valueUnwrap)[1]),v.Values.isCSSNullValue(b)&&(b=v.Hooks.templates[a][1]),b},extractValue:function(a,b){var c=v.Hooks.registered[a];if(c){var d=c[0],e=c[1];return b=v.Hooks.cleanRootPropertyValue(d,b),b.toString().match(v.RegEx.valueSplit)[e]}return b},injectValue:function(a,b,c){var d=v.Hooks.registered[a];if(d){var e,f,g=d[0],h=d[1];return c=v.Hooks.cleanRootPropertyValue(g,c),e=c.toString().match(v.RegEx.valueSplit),e[h]=b,f=e.join(" ")}return c}},Normalizations:{registered:{clip:function(a,b,c){switch(a){case"name":return"clip";case"extract":var d;return v.RegEx.wrappedValueAlreadyExtracted.test(c)?d=c:(d=c.toString().match(v.RegEx.valueUnwrap),d=d?d[1].replace(/,(\s+)?/g," "):c),d;case"inject":return"rect("+c+")"}},blur:function(a,b,c){switch(a){case"name":return t.State.isFirefox?"filter":"-webkit-filter";case"extract":var d=parseFloat(c);if(!d&&0!==d){var e=c.toString().match(/blur\(([0-9]+[A-z]+)\)/i);d=e?e[1]:0}return d;case"inject":return parseFloat(c)?"blur("+c+")":"none"}},opacity:function(a,b,c){if(8>=n)switch(a){case"name":return"filter";case"extract":var d=c.toString().match(/alpha\(opacity=(.*)\)/i);return c=d?d[1]/100:1;case"inject":return b.style.zoom=1,parseFloat(c)>=1?"":"alpha(opacity="+parseInt(100*parseFloat(c),10)+")"}else switch(a){case"name":return"opacity";case"extract":return c;case"inject":return c}}},register:function(){9>=n||t.State.isGingerbread||(v.Lists.transformsBase=v.Lists.transformsBase.concat(v.Lists.transforms3D));for(var a=0;a<v.Lists.transformsBase.length;a++)!function(){var b=v.Lists.transformsBase[a];v.Normalizations.registered[b]=function(a,c,e){switch(a){case"name":return"transform";case"extract":return g(c)===d||g(c).transformCache[b]===d?/^scale/i.test(b)?1:0:g(c).transformCache[b].replace(/[()]/g,"");case"inject":var f=!1;switch(b.substr(0,b.length-1)){case"translate":f=!/(%|px|em|rem|vw|vh|\d)$/i.test(e);break;case"scal":case"scale":t.State.isAndroid&&g(c).transformCache[b]===d&&1>e&&(e=1),f=!/(\d)$/i.test(e);break;case"skew":f=!/(deg|\d)$/i.test(e);break;case"rotate":f=!/(deg|\d)$/i.test(e)}return f||(g(c).transformCache[b]="("+e+")"),g(c).transformCache[b]}}}();for(var a=0;a<v.Lists.colors.length;a++)!function(){var b=v.Lists.colors[a];v.Normalizations.registered[b]=function(a,c,e){switch(a){case"name":return b;case"extract":var f;if(v.RegEx.wrappedValueAlreadyExtracted.test(e))f=e;else{var g,h={black:"rgb(0, 0, 0)",blue:"rgb(0, 0, 255)",gray:"rgb(128, 128, 128)",green:"rgb(0, 128, 0)",red:"rgb(255, 0, 0)",white:"rgb(255, 255, 255)"};/^[A-z]+$/i.test(e)?g=h[e]!==d?h[e]:h.black:v.RegEx.isHex.test(e)?g="rgb("+v.Values.hexToRgb(e).join(" ")+")":/^rgba?\(/i.test(e)||(g=h.black),f=(g||e).toString().match(v.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g," ")}return 8>=n||3!==f.split(" ").length||(f+=" 1"),f;case"inject":return 8>=n?4===e.split(" ").length&&(e=e.split(/\s+/).slice(0,3).join(" ")):3===e.split(" ").length&&(e+=" 1"),(8>=n?"rgb":"rgba")+"("+e.replace(/\s+/g,",").replace(/\.(\d)+(?=,)/g,"")+")"}}}()}},Names:{camelCase:function(a){return a.replace(/-(\w)/g,function(a,b){return b.toUpperCase()})},SVGAttribute:function(a){var b="width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";return(n||t.State.isAndroid&&!t.State.isChrome)&&(b+="|transform"),new RegExp("^("+b+")$","i").test(a)},prefixCheck:function(a){if(t.State.prefixMatches[a])return[t.State.prefixMatches[a],!0];for(var b=["","Webkit","Moz","ms","O"],c=0,d=b.length;d>c;c++){var e;if(e=0===c?a:b[c]+a.replace(/^\w/,function(a){return a.toUpperCase()}),p.isString(t.State.prefixElement.style[e]))return t.State.prefixMatches[a]=e,[e,!0]}return[a,!1]}},Values:{hexToRgb:function(a){var b,c=/^#?([a-f\d])([a-f\d])([a-f\d])$/i,d=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;return a=a.replace(c,function(a,b,c,d){return b+b+c+c+d+d}),b=d.exec(a),b?[parseInt(b[1],16),parseInt(b[2],16),parseInt(b[3],16)]:[0,0,0]},isCSSNullValue:function(a){return 0==a||/^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(a)},getUnitType:function(a){return/^(rotate|skew)/i.test(a)?"deg":/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(a)?"":"px"},getDisplayType:function(a){var b=a&&a.tagName.toString().toLowerCase();return/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(b)?"inline":/^(li)$/i.test(b)?"list-item":/^(tr)$/i.test(b)?"table-row":/^(table)$/i.test(b)?"table":/^(tbody)$/i.test(b)?"table-row-group":"block"},addClass:function(a,b){a.classList?a.classList.add(b):a.className+=(a.className.length?" ":"")+b},removeClass:function(a,b){a.classList?a.classList.remove(b):a.className=a.className.toString().replace(new RegExp("(^|\\s)"+b.split(" ").join("|")+"(\\s|$)","gi")," ")}},getPropertyValue:function(a,c,e,f){function h(a,c){function e(){j&&v.setPropertyValue(a,"display","none")}var i=0;if(8>=n)i=m.css(a,c);else{var j=!1;if(/^(width|height)$/.test(c)&&0===v.getPropertyValue(a,"display")&&(j=!0,v.setPropertyValue(a,"display",v.Values.getDisplayType(a))),!f){if("height"===c&&"border-box"!==v.getPropertyValue(a,"boxSizing").toString().toLowerCase()){var k=a.offsetHeight-(parseFloat(v.getPropertyValue(a,"borderTopWidth"))||0)-(parseFloat(v.getPropertyValue(a,"borderBottomWidth"))||0)-(parseFloat(v.getPropertyValue(a,"paddingTop"))||0)-(parseFloat(v.getPropertyValue(a,"paddingBottom"))||0);return e(),k}if("width"===c&&"border-box"!==v.getPropertyValue(a,"boxSizing").toString().toLowerCase()){var l=a.offsetWidth-(parseFloat(v.getPropertyValue(a,"borderLeftWidth"))||0)-(parseFloat(v.getPropertyValue(a,"borderRightWidth"))||0)-(parseFloat(v.getPropertyValue(a,"paddingLeft"))||0)-(parseFloat(v.getPropertyValue(a,"paddingRight"))||0);return e(),l}}var o;o=g(a)===d?b.getComputedStyle(a,null):g(a).computedStyle?g(a).computedStyle:g(a).computedStyle=b.getComputedStyle(a,null),"borderColor"===c&&(c="borderTopColor"),i=9===n&&"filter"===c?o.getPropertyValue(c):o[c],(""===i||null===i)&&(i=a.style[c]),e()}if("auto"===i&&/^(top|right|bottom|left)$/i.test(c)){var p=h(a,"position");("fixed"===p||"absolute"===p&&/top|left/i.test(c))&&(i=m(a).position()[c]+"px")}return i}var i;if(v.Hooks.registered[c]){var j=c,k=v.Hooks.getRoot(j);e===d&&(e=v.getPropertyValue(a,v.Names.prefixCheck(k)[0])),v.Normalizations.registered[k]&&(e=v.Normalizations.registered[k]("extract",a,e)),i=v.Hooks.extractValue(j,e)}else if(v.Normalizations.registered[c]){var l,o;l=v.Normalizations.registered[c]("name",a),"transform"!==l&&(o=h(a,v.Names.prefixCheck(l)[0]),v.Values.isCSSNullValue(o)&&v.Hooks.templates[c]&&(o=v.Hooks.templates[c][1])),i=v.Normalizations.registered[c]("extract",a,o)}if(!/^[\d-]/.test(i))if(g(a)&&g(a).isSVG&&v.Names.SVGAttribute(c))if(/^(height|width)$/i.test(c))try{i=a.getBBox()[c]}catch(p){i=0}else i=a.getAttribute(c);else i=h(a,v.Names.prefixCheck(c)[0]);return v.Values.isCSSNullValue(i)&&(i=0),t.debug>=2&&console.log("Get "+c+": "+i),i},setPropertyValue:function(a,c,d,e,f){var h=c;if("scroll"===c)f.container?f.container["scroll"+f.direction]=d:"Left"===f.direction?b.scrollTo(d,f.alternateValue):b.scrollTo(f.alternateValue,d);else if(v.Normalizations.registered[c]&&"transform"===v.Normalizations.registered[c]("name",a))v.Normalizations.registered[c]("inject",a,d),h="transform",d=g(a).transformCache[c];else{if(v.Hooks.registered[c]){var i=c,j=v.Hooks.getRoot(c);e=e||v.getPropertyValue(a,j),d=v.Hooks.injectValue(i,d,e),c=j}if(v.Normalizations.registered[c]&&(d=v.Normalizations.registered[c]("inject",a,d),c=v.Normalizations.registered[c]("name",a)),h=v.Names.prefixCheck(c)[0],8>=n)try{a.style[h]=d}catch(k){t.debug&&console.log("Browser does not support ["+d+"] for ["+h+"]")}else g(a)&&g(a).isSVG&&v.Names.SVGAttribute(c)?a.setAttribute(c,d):a.style[h]=d;t.debug>=2&&console.log("Set "+c+" ("+h+"): "+d)}return[h,d]},flushTransformCache:function(a){function b(b){return parseFloat(v.getPropertyValue(a,b))}var c="";if((n||t.State.isAndroid&&!t.State.isChrome)&&g(a).isSVG){var d={translate:[b("translateX"),b("translateY")],skewX:[b("skewX")],skewY:[b("skewY")],scale:1!==b("scale")?[b("scale"),b("scale")]:[b("scaleX"),b("scaleY")],rotate:[b("rotateZ"),0,0]};m.each(g(a).transformCache,function(a){/^translate/i.test(a)?a="translate":/^scale/i.test(a)?a="scale":/^rotate/i.test(a)&&(a="rotate"),d[a]&&(c+=a+"("+d[a].join(" ")+") ",delete d[a])})}else{var e,f;m.each(g(a).transformCache,function(b){return e=g(a).transformCache[b],"transformPerspective"===b?(f=e,!0):(9===n&&"rotateZ"===b&&(b="rotate"),void(c+=b+e+" "))}),f&&(c="perspective"+f+" "+c)}v.setPropertyValue(a,"transform",c)}};v.Hooks.register(),v.Normalizations.register(),t.hook=function(a,b,c){var e=d;return a=f(a),m.each(a,function(a,f){if(g(f)===d&&t.init(f),c===d)e===d&&(e=t.CSS.getPropertyValue(f,b));else{var h=t.CSS.setPropertyValue(f,b,c);"transform"===h[0]&&t.CSS.flushTransformCache(f),e=h}}),e};var w=function(){function a(){return h?B.promise||null:i}function e(){function a(a){function l(a,b){var c=d,e=d,g=d;return p.isArray(a)?(c=a[0],!p.isArray(a[1])&&/^[\d-]/.test(a[1])||p.isFunction(a[1])||v.RegEx.isHex.test(a[1])?g=a[1]:(p.isString(a[1])&&!v.RegEx.isHex.test(a[1])||p.isArray(a[1]))&&(e=b?a[1]:j(a[1],h.duration),a[2]!==d&&(g=a[2]))):c=a,b||(e=e||h.easing),p.isFunction(c)&&(c=c.call(f,y,x)),p.isFunction(g)&&(g=g.call(f,y,x)),[c||0,e,g]}function n(a,b){var c,d;return d=(b||"0").toString().toLowerCase().replace(/[%A-z]+$/,function(a){return c=a,""}),c||(c=v.Values.getUnitType(a)),[d,c]}function r(){var a={myParent:f.parentNode||c.body,position:v.getPropertyValue(f,"position"),fontSize:v.getPropertyValue(f,"fontSize")},d=a.position===I.lastPosition&&a.myParent===I.lastParent,e=a.fontSize===I.lastFontSize;I.lastParent=a.myParent,I.lastPosition=a.position,I.lastFontSize=a.fontSize;var h=100,i={};if(e&&d)i.emToPx=I.lastEmToPx,i.percentToPxWidth=I.lastPercentToPxWidth,i.percentToPxHeight=I.lastPercentToPxHeight;else{var j=g(f).isSVG?c.createElementNS("http://www.w3.org/2000/svg","rect"):c.createElement("div");t.init(j),a.myParent.appendChild(j),m.each(["overflow","overflowX","overflowY"],function(a,b){t.CSS.setPropertyValue(j,b,"hidden")}),t.CSS.setPropertyValue(j,"position",a.position),t.CSS.setPropertyValue(j,"fontSize",a.fontSize),t.CSS.setPropertyValue(j,"boxSizing","content-box"),m.each(["minWidth","maxWidth","width","minHeight","maxHeight","height"],function(a,b){t.CSS.setPropertyValue(j,b,h+"%")}),t.CSS.setPropertyValue(j,"paddingLeft",h+"em"),i.percentToPxWidth=I.lastPercentToPxWidth=(parseFloat(v.getPropertyValue(j,"width",null,!0))||1)/h,i.percentToPxHeight=I.lastPercentToPxHeight=(parseFloat(v.getPropertyValue(j,"height",null,!0))||1)/h,i.emToPx=I.lastEmToPx=(parseFloat(v.getPropertyValue(j,"paddingLeft"))||1)/h,a.myParent.removeChild(j)}return null===I.remToPx&&(I.remToPx=parseFloat(v.getPropertyValue(c.body,"fontSize"))||16),null===I.vwToPx&&(I.vwToPx=parseFloat(b.innerWidth)/100,I.vhToPx=parseFloat(b.innerHeight)/100),i.remToPx=I.remToPx,i.vwToPx=I.vwToPx,i.vhToPx=I.vhToPx,t.debug>=1&&console.log("Unit ratios: "+JSON.stringify(i),f),i}if(h.begin&&0===y)try{h.begin.call(o,o)}catch(u){setTimeout(function(){throw u},1)}if("scroll"===C){var w,z,A,D=/^x$/i.test(h.axis)?"Left":"Top",E=parseFloat(h.offset)||0;h.container?p.isWrapped(h.container)||p.isNode(h.container)?(h.container=h.container[0]||h.container,w=h.container["scroll"+D],A=w+m(f).position()[D.toLowerCase()]+E):h.container=null:(w=t.State.scrollAnchor[t.State["scrollProperty"+D]],z=t.State.scrollAnchor[t.State["scrollProperty"+("Left"===D?"Top":"Left")]],A=m(f).offset()[D.toLowerCase()]+E),i={scroll:{rootPropertyValue:!1,startValue:w,currentValue:w,endValue:A,unitType:"",easing:h.easing,scrollData:{container:h.container,direction:D,alternateValue:z}},element:f},t.debug&&console.log("tweensContainer (scroll): ",i.scroll,f)}else if("reverse"===C){if(!g(f).tweensContainer)return void m.dequeue(f,h.queue);"none"===g(f).opts.display&&(g(f).opts.display="auto"),"hidden"===g(f).opts.visibility&&(g(f).opts.visibility="visible"),g(f).opts.loop=!1,g(f).opts.begin=null,g(f).opts.complete=null,s.easing||delete h.easing,s.duration||delete h.duration,h=m.extend({},g(f).opts,h);var F=m.extend(!0,{},g(f).tweensContainer);for(var G in F)if("element"!==G){var H=F[G].startValue;F[G].startValue=F[G].currentValue=F[G].endValue,F[G].endValue=H,p.isEmptyObject(s)||(F[G].easing=h.easing),t.debug&&console.log("reverse tweensContainer ("+G+"): "+JSON.stringify(F[G]),f)}i=F}else if("start"===C){var F;g(f).tweensContainer&&g(f).isAnimating===!0&&(F=g(f).tweensContainer),m.each(q,function(a,b){if(RegExp("^"+v.Lists.colors.join("$|^")+"$").test(a)){var c=l(b,!0),e=c[0],f=c[1],g=c[2];if(v.RegEx.isHex.test(e)){for(var h=["Red","Green","Blue"],i=v.Values.hexToRgb(e),j=g?v.Values.hexToRgb(g):d,k=0;k<h.length;k++){var m=[i[k]];f&&m.push(f),j!==d&&m.push(j[k]),q[a+h[k]]=m}delete q[a]}}});for(var K in q){var L=l(q[K]),M=L[0],N=L[1],O=L[2];K=v.Names.camelCase(K);var P=v.Hooks.getRoot(K),Q=!1;if(g(f).isSVG||"tween"===P||v.Names.prefixCheck(P)[1]!==!1||v.Normalizations.registered[P]!==d){(h.display!==d&&null!==h.display&&"none"!==h.display||h.visibility!==d&&"hidden"!==h.visibility)&&/opacity|filter/.test(K)&&!O&&0!==M&&(O=0),h._cacheValues&&F&&F[K]?(O===d&&(O=F[K].endValue+F[K].unitType),Q=g(f).rootPropertyValueCache[P]):v.Hooks.registered[K]?O===d?(Q=v.getPropertyValue(f,P),O=v.getPropertyValue(f,K,Q)):Q=v.Hooks.templates[P][1]:O===d&&(O=v.getPropertyValue(f,K));var R,S,T,U=!1;if(R=n(K,O),O=R[0],T=R[1],R=n(K,M),M=R[0].replace(/^([+-\/*])=/,function(a,b){return U=b,""}),S=R[1],O=parseFloat(O)||0,M=parseFloat(M)||0,"%"===S&&(/^(fontSize|lineHeight)$/.test(K)?(M/=100,S="em"):/^scale/.test(K)?(M/=100,S=""):/(Red|Green|Blue)$/i.test(K)&&(M=M/100*255,S="")),/[\/*]/.test(U))S=T;else if(T!==S&&0!==O)if(0===M)S=T;else{e=e||r();var V=/margin|padding|left|right|width|text|word|letter/i.test(K)||/X$/.test(K)||"x"===K?"x":"y";
	switch(T){case"%":O*="x"===V?e.percentToPxWidth:e.percentToPxHeight;break;case"px":break;default:O*=e[T+"ToPx"]}switch(S){case"%":O*=1/("x"===V?e.percentToPxWidth:e.percentToPxHeight);break;case"px":break;default:O*=1/e[S+"ToPx"]}}switch(U){case"+":M=O+M;break;case"-":M=O-M;break;case"*":M=O*M;break;case"/":M=O/M}i[K]={rootPropertyValue:Q,startValue:O,currentValue:O,endValue:M,unitType:S,easing:N},t.debug&&console.log("tweensContainer ("+K+"): "+JSON.stringify(i[K]),f)}else t.debug&&console.log("Skipping ["+P+"] due to a lack of browser support.")}i.element=f}i.element&&(v.Values.addClass(f,"velocity-animating"),J.push(i),""===h.queue&&(g(f).tweensContainer=i,g(f).opts=h),g(f).isAnimating=!0,y===x-1?(t.State.calls.push([J,o,h,null,B.resolver]),t.State.isTicking===!1&&(t.State.isTicking=!0,k())):y++)}var e,f=this,h=m.extend({},t.defaults,s),i={};switch(g(f)===d&&t.init(f),parseFloat(h.delay)&&h.queue!==!1&&m.queue(f,h.queue,function(a){t.velocityQueueEntryFlag=!0,g(f).delayTimer={setTimeout:setTimeout(a,parseFloat(h.delay)),next:a}}),h.duration.toString().toLowerCase()){case"fast":h.duration=200;break;case"normal":h.duration=r;break;case"slow":h.duration=600;break;default:h.duration=parseFloat(h.duration)||1}t.mock!==!1&&(t.mock===!0?h.duration=h.delay=1:(h.duration*=parseFloat(t.mock)||1,h.delay*=parseFloat(t.mock)||1)),h.easing=j(h.easing,h.duration),h.begin&&!p.isFunction(h.begin)&&(h.begin=null),h.progress&&!p.isFunction(h.progress)&&(h.progress=null),h.complete&&!p.isFunction(h.complete)&&(h.complete=null),h.display!==d&&null!==h.display&&(h.display=h.display.toString().toLowerCase(),"auto"===h.display&&(h.display=t.CSS.Values.getDisplayType(f))),h.visibility!==d&&null!==h.visibility&&(h.visibility=h.visibility.toString().toLowerCase()),h.mobileHA=h.mobileHA&&t.State.isMobile&&!t.State.isGingerbread,h.queue===!1?h.delay?setTimeout(a,h.delay):a():m.queue(f,h.queue,function(b,c){return c===!0?(B.promise&&B.resolver(o),!0):(t.velocityQueueEntryFlag=!0,void a(b))}),""!==h.queue&&"fx"!==h.queue||"inprogress"===m.queue(f)[0]||m.dequeue(f)}var h,i,n,o,q,s,u=arguments[0]&&(arguments[0].p||m.isPlainObject(arguments[0].properties)&&!arguments[0].properties.names||p.isString(arguments[0].properties));if(p.isWrapped(this)?(h=!1,n=0,o=this,i=this):(h=!0,n=1,o=u?arguments[0].elements||arguments[0].e:arguments[0]),o=f(o)){u?(q=arguments[0].properties||arguments[0].p,s=arguments[0].options||arguments[0].o):(q=arguments[n],s=arguments[n+1]);var x=o.length,y=0;if(!/^(stop|finish)$/i.test(q)&&!m.isPlainObject(s)){var z=n+1;s={};for(var A=z;A<arguments.length;A++)p.isArray(arguments[A])||!/^(fast|normal|slow)$/i.test(arguments[A])&&!/^\d/.test(arguments[A])?p.isString(arguments[A])||p.isArray(arguments[A])?s.easing=arguments[A]:p.isFunction(arguments[A])&&(s.complete=arguments[A]):s.duration=arguments[A]}var B={promise:null,resolver:null,rejecter:null};h&&t.Promise&&(B.promise=new t.Promise(function(a,b){B.resolver=a,B.rejecter=b}));var C;switch(q){case"scroll":C="scroll";break;case"reverse":C="reverse";break;case"finish":case"stop":m.each(o,function(a,b){g(b)&&g(b).delayTimer&&(clearTimeout(g(b).delayTimer.setTimeout),g(b).delayTimer.next&&g(b).delayTimer.next(),delete g(b).delayTimer)});var D=[];return m.each(t.State.calls,function(a,b){b&&m.each(b[1],function(c,e){var f=s===d?"":s;return f===!0||b[2].queue===f||s===d&&b[2].queue===!1?void m.each(o,function(c,d){d===e&&((s===!0||p.isString(s))&&(m.each(m.queue(d,p.isString(s)?s:""),function(a,b){p.isFunction(b)&&b(null,!0)}),m.queue(d,p.isString(s)?s:"",[])),"stop"===q?(g(d)&&g(d).tweensContainer&&f!==!1&&m.each(g(d).tweensContainer,function(a,b){b.endValue=b.currentValue}),D.push(a)):"finish"===q&&(b[2].duration=1))}):!0})}),"stop"===q&&(m.each(D,function(a,b){l(b,!0)}),B.promise&&B.resolver(o)),a();default:if(!m.isPlainObject(q)||p.isEmptyObject(q)){if(p.isString(q)&&t.Redirects[q]){var E=m.extend({},s),F=E.duration,G=E.delay||0;return E.backwards===!0&&(o=m.extend(!0,[],o).reverse()),m.each(o,function(a,b){parseFloat(E.stagger)?E.delay=G+parseFloat(E.stagger)*a:p.isFunction(E.stagger)&&(E.delay=G+E.stagger.call(b,a,x)),E.drag&&(E.duration=parseFloat(F)||(/^(callout|transition)/.test(q)?1e3:r),E.duration=Math.max(E.duration*(E.backwards?1-a/x:(a+1)/x),.75*E.duration,200)),t.Redirects[q].call(b,b,E||{},a,x,o,B.promise?B:d)}),a()}var H="Velocity: First argument ("+q+") was not a property map, a known action, or a registered redirect. Aborting.";return B.promise?B.rejecter(new Error(H)):console.log(H),a()}C="start"}var I={lastParent:null,lastPosition:null,lastFontSize:null,lastPercentToPxWidth:null,lastPercentToPxHeight:null,lastEmToPx:null,remToPx:null,vwToPx:null,vhToPx:null},J=[];m.each(o,function(a,b){p.isNode(b)&&e.call(b)});var K,E=m.extend({},t.defaults,s);if(E.loop=parseInt(E.loop),K=2*E.loop-1,E.loop)for(var L=0;K>L;L++){var M={delay:E.delay,progress:E.progress};L===K-1&&(M.display=E.display,M.visibility=E.visibility,M.complete=E.complete),w(o,"reverse",M)}return a()}};t=m.extend(w,t),t.animate=w;var x=b.requestAnimationFrame||o;return t.State.isMobile||c.hidden===d||c.addEventListener("visibilitychange",function(){c.hidden?(x=function(a){return setTimeout(function(){a(!0)},16)},k()):x=b.requestAnimationFrame||o}),a.Velocity=t,a!==b&&(a.fn.velocity=w,a.fn.velocity.defaults=t.defaults),m.each(["Down","Up"],function(a,b){t.Redirects["slide"+b]=function(a,c,e,f,g,h){var i=m.extend({},c),j=i.begin,k=i.complete,l={height:"",marginTop:"",marginBottom:"",paddingTop:"",paddingBottom:""},n={};i.display===d&&(i.display="Down"===b?"inline"===t.CSS.Values.getDisplayType(a)?"inline-block":"block":"none"),i.begin=function(){j&&j.call(g,g);for(var c in l){n[c]=a.style[c];var d=t.CSS.getPropertyValue(a,c);l[c]="Down"===b?[d,0]:[0,d]}n.overflow=a.style.overflow,a.style.overflow="hidden"},i.complete=function(){for(var b in n)a.style[b]=n[b];k&&k.call(g,g),h&&h.resolver(g)},t(a,l,i)}}),m.each(["In","Out"],function(a,b){t.Redirects["fade"+b]=function(a,c,e,f,g,h){var i=m.extend({},c),j={opacity:"In"===b?1:0},k=i.complete;i.complete=e!==f-1?i.begin=null:function(){k&&k.call(g,g),h&&h.resolver(g)},i.display===d&&(i.display="In"===b?"auto":"none"),t(this,j,i)}}),t}(window.jQuery||window.Zepto||window,window,document)})),!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(k(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a}function i(a,b){return h(a,b,!0)}function j(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&h(d,c)}function k(a,b){return function(){return a.apply(b,arguments)}}function l(a,b){return typeof a==ka?a.apply(b?b[0]||d:d,b):a}function m(a,b){return a===d?b:a}function n(a,b,c){g(r(b),function(b){a.addEventListener(b,c,!1)})}function o(a,b,c){g(r(b),function(b){a.removeEventListener(b,c,!1)})}function p(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function q(a,b){return a.indexOf(b)>-1}function r(a){return a.trim().split(/\s+/g)}function s(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function t(a){return Array.prototype.slice.call(a,0)}function u(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];s(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function v(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ia.length;){if(c=ia[g],e=c?c+f:b,e in a)return e;g++}return d}function w(){return oa++}function x(a){var b=a.ownerDocument;return b.defaultView||b.parentWindow}function y(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){l(a.options.enable,[a])&&c.handler(b)},this.init()}function z(a){var b,c=a.options.inputClass;return new(b=c?c:ra?N:sa?Q:qa?S:M)(a,A)}function A(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&ya&&0===d-e,g=b&(Aa|Ba)&&0===d-e;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,B(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function B(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=E(b)),e>1&&!c.firstMultiple?c.firstMultiple=E(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=F(d);b.timeStamp=na(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=J(h,i),b.distance=I(h,i),C(c,b),b.offsetDirection=H(b.deltaX,b.deltaY),b.scale=g?L(g.pointers,d):1,b.rotation=g?K(g.pointers,d):0,D(c,b);var j=a.element;p(b.srcEvent.target,j)&&(j=b.srcEvent.target),b.target=j}function C(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};(b.eventType===ya||f.eventType===Aa)&&(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function D(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ba&&(i>xa||h.velocity===d)){var j=h.deltaX-b.deltaX,k=h.deltaY-b.deltaY,l=G(i,j,k);e=l.x,f=l.y,c=ma(l.x)>ma(l.y)?l.x:l.y,g=H(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function E(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:la(a.pointers[c].clientX),clientY:la(a.pointers[c].clientY)},c++;return{timeStamp:na(),pointers:b,center:F(b),deltaX:a.deltaX,deltaY:a.deltaY}}function F(a){var b=a.length;if(1===b)return{x:la(a[0].clientX),y:la(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:la(c/b),y:la(d/b)}}function G(a,b,c){return{x:b/a||0,y:c/a||0}}function H(a,b){return a===b?Ca:ma(a)>=ma(b)?a>0?Da:Ea:b>0?Fa:Ga}function I(a,b,c){c||(c=Ka);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function J(a,b,c){c||(c=Ka);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function K(a,b){return J(b[1],b[0],La)-J(a[1],a[0],La)}function L(a,b){return I(b[0],b[1],La)/I(a[0],a[1],La)}function M(){this.evEl=Na,this.evWin=Oa,this.allow=!0,this.pressed=!1,y.apply(this,arguments)}function N(){this.evEl=Ra,this.evWin=Sa,y.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function O(){this.evTarget=Ua,this.evWin=Va,this.started=!1,y.apply(this,arguments)}function P(a,b){var c=t(a.touches),d=t(a.changedTouches);return b&(Aa|Ba)&&(c=u(c.concat(d),"identifier",!0)),[c,d]}function Q(){this.evTarget=Xa,this.targetIds={},y.apply(this,arguments)}function R(a,b){var c=t(a.touches),d=this.targetIds;if(b&(ya|za)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=t(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return p(a.target,i)}),b===ya)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Aa|Ba)&&delete d[g[e].identifier],e++;return h.length?[u(f.concat(h),"identifier",!0),h]:void 0}function S(){y.apply(this,arguments);var a=k(this.handler,this);this.touch=new Q(this.manager,a),this.mouse=new M(this.manager,a)}function T(a,b){this.manager=a,this.set(b)}function U(a){if(q(a,bb))return bb;var b=q(a,cb),c=q(a,db);return b&&c?cb+" "+db:b||c?b?cb:db:q(a,ab)?ab:_a}function V(a){this.id=w(),this.manager=null,this.options=i(a||{},this.defaults),this.options.enable=m(this.options.enable,!0),this.state=eb,this.simultaneous={},this.requireFail=[]}function W(a){return a&jb?"cancel":a&hb?"end":a&gb?"move":a&fb?"start":""}function X(a){return a==Ga?"down":a==Fa?"up":a==Da?"left":a==Ea?"right":""}function Y(a,b){var c=b.manager;return c?c.get(a):a}function Z(){V.apply(this,arguments)}function $(){Z.apply(this,arguments),this.pX=null,this.pY=null}function _(){Z.apply(this,arguments)}function aa(){V.apply(this,arguments),this._timer=null,this._input=null}function ba(){Z.apply(this,arguments)}function ca(){Z.apply(this,arguments)}function da(){V.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ea(a,b){return b=b||{},b.recognizers=m(b.recognizers,ea.defaults.preset),new fa(a,b)}function fa(a,b){b=b||{},this.options=i(b,ea.defaults),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.element=a,this.input=z(this),this.touchAction=new T(this,this.options.touchAction),ga(this,!0),g(b.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ga(a,b){var c=a.element;g(a.options.cssProps,function(a,d){c.style[v(c.style,d)]=b?a:""})}function ha(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var ia=["","webkit","moz","MS","ms","o"],ja=b.createElement("div"),ka="function",la=Math.round,ma=Math.abs,na=Date.now,oa=1,pa=/mobile|tablet|ip(ad|hone|od)|android/i,qa="ontouchstart"in a,ra=v(a,"PointerEvent")!==d,sa=qa&&pa.test(navigator.userAgent),ta="touch",ua="pen",va="mouse",wa="kinect",xa=25,ya=1,za=2,Aa=4,Ba=8,Ca=1,Da=2,Ea=4,Fa=8,Ga=16,Ha=Da|Ea,Ia=Fa|Ga,Ja=Ha|Ia,Ka=["x","y"],La=["clientX","clientY"];y.prototype={handler:function(){},init:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(x(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&o(this.element,this.evEl,this.domHandler),this.evTarget&&o(this.target,this.evTarget,this.domHandler),this.evWin&&o(x(this.element),this.evWin,this.domHandler)}};var Ma={mousedown:ya,mousemove:za,mouseup:Aa},Na="mousedown",Oa="mousemove mouseup";j(M,y,{handler:function(a){var b=Ma[a.type];b&ya&&0===a.button&&(this.pressed=!0),b&za&&1!==a.which&&(b=Aa),this.pressed&&this.allow&&(b&Aa&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:va,srcEvent:a}))}});var Pa={pointerdown:ya,pointermove:za,pointerup:Aa,pointercancel:Ba,pointerout:Ba},Qa={2:ta,3:ua,4:va,5:wa},Ra="pointerdown",Sa="pointermove pointerup pointercancel";a.MSPointerEvent&&(Ra="MSPointerDown",Sa="MSPointerMove MSPointerUp MSPointerCancel"),j(N,y,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Pa[d],f=Qa[a.pointerType]||a.pointerType,g=f==ta,h=s(b,a.pointerId,"pointerId");e&ya&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Aa|Ba)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Ta={touchstart:ya,touchmove:za,touchend:Aa,touchcancel:Ba},Ua="touchstart",Va="touchstart touchmove touchend touchcancel";j(O,y,{handler:function(a){var b=Ta[a.type];if(b===ya&&(this.started=!0),this.started){var c=P.call(this,a,b);b&(Aa|Ba)&&0===c[0].length-c[1].length&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:ta,srcEvent:a})}}});var Wa={touchstart:ya,touchmove:za,touchend:Aa,touchcancel:Ba},Xa="touchstart touchmove touchend touchcancel";j(Q,y,{handler:function(a){var b=Wa[a.type],c=R.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:ta,srcEvent:a})}}),j(S,y,{handler:function(a,b,c){var d=c.pointerType==ta,e=c.pointerType==va;if(d)this.mouse.allow=!1;else if(e&&!this.mouse.allow)return;b&(Aa|Ba)&&(this.mouse.allow=!0),this.callback(a,b,c)},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var Ya=v(ja.style,"touchAction"),Za=Ya!==d,$a="compute",_a="auto",ab="manipulation",bb="none",cb="pan-x",db="pan-y";T.prototype={set:function(a){a==$a&&(a=this.compute()),Za&&(this.manager.element.style[Ya]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){l(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),U(a.join(" "))},preventDefaults:function(a){if(!Za){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=q(d,bb),f=q(d,db),g=q(d,cb);return e||f&&c&Ha||g&&c&Ia?this.preventSrc(b):void 0}},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var eb=1,fb=2,gb=4,hb=8,ib=hb,jb=16,kb=32;V.prototype={defaults:{},set:function(a){return h(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=Y(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=Y(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=Y(a,this),-1===s(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=Y(a,this);var b=s(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(c.options.event+(b?W(d):""),a)}var c=this,d=this.state;hb>d&&b(!0),b(),d>=hb&&b(!0)},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=kb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(kb|eb)))return!1;a++}return!0},recognize:function(a){var b=h({},a);return l(this.options.enable,[this,b])?(this.state&(ib|jb|kb)&&(this.state=eb),this.state=this.process(b),void(this.state&(fb|gb|hb|jb)&&this.tryEmit(b))):(this.reset(),void(this.state=kb))},process:function(){},getTouchAction:function(){},reset:function(){}},j(Z,V,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(fb|gb),e=this.attrTest(a);return d&&(c&Ba||!e)?b|jb:d||e?c&Aa?b|hb:b&fb?b|gb:fb:kb}}),j($,Z,{defaults:{event:"pan",threshold:10,pointers:1,direction:Ja},getTouchAction:function(){var a=this.options.direction,b=[];return a&Ha&&b.push(db),a&Ia&&b.push(cb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Ha?(e=0===f?Ca:0>f?Da:Ea,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ca:0>g?Fa:Ga,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return Z.prototype.attrTest.call(this,a)&&(this.state&fb||!(this.state&fb)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=X(a.direction);b&&this.manager.emit(this.options.event+b,a),this._super.emit.call(this,a)}}),j(_,Z,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[bb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&fb)},emit:function(a){if(this._super.emit.call(this,a),1!==a.scale){var b=a.scale<1?"in":"out";this.manager.emit(this.options.event+b,a)}}}),j(aa,V,{defaults:{event:"press",pointers:1,time:500,threshold:5},getTouchAction:function(){return[_a]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Aa|Ba)&&!f)this.reset();else if(a.eventType&ya)this.reset(),this._timer=e(function(){this.state=ib,this.tryEmit()},b.time,this);else if(a.eventType&Aa)return ib;return kb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===ib&&(a&&a.eventType&Aa?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=na(),this.manager.emit(this.options.event,this._input)))}}),j(ba,Z,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[bb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&fb)}}),j(ca,Z,{defaults:{event:"swipe",threshold:10,velocity:.65,direction:Ha|Ia,pointers:1},getTouchAction:function(){return $.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Ha|Ia)?b=a.velocity:c&Ha?b=a.velocityX:c&Ia&&(b=a.velocityY),this._super.attrTest.call(this,a)&&c&a.direction&&a.distance>this.options.threshold&&ma(b)>this.options.velocity&&a.eventType&Aa},emit:function(a){var b=X(a.direction);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),j(da,V,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:2,posThreshold:10},getTouchAction:function(){return[ab]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&ya&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Aa)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||I(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=ib,this.tryEmit()},b.interval,this),fb):ib}return kb},failTimeout:function(){return this._timer=e(function(){this.state=kb},this.options.interval,this),kb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==ib&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ea.VERSION="2.0.4",ea.defaults={domEvents:!1,touchAction:$a,enable:!0,inputTarget:null,inputClass:null,preset:[[ba,{enable:!1}],[_,{enable:!1},["rotate"]],[ca,{direction:Ha}],[$,{direction:Ha},["swipe"]],[da],[da,{event:"doubletap",taps:2},["tap"]],[aa]],cssProps:{userSelect:"default",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var lb=1,mb=2;fa.prototype={set:function(a){return h(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?mb:lb},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&ib)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===mb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(fb|gb|hb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof V)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;var b=this.recognizers;return a=this.get(a),b.splice(s(b,a),1),this.touchAction.update(),this},on:function(a,b){var c=this.handlers;return g(r(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this},off:function(a,b){var c=this.handlers;return g(r(a),function(a){b?c[a].splice(s(c[a],b),1):delete c[a]}),this},emit:function(a,b){this.options.domEvents&&ha(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ga(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},h(ea,{INPUT_START:ya,INPUT_MOVE:za,INPUT_END:Aa,INPUT_CANCEL:Ba,STATE_POSSIBLE:eb,STATE_BEGAN:fb,STATE_CHANGED:gb,STATE_ENDED:hb,STATE_RECOGNIZED:ib,STATE_CANCELLED:jb,STATE_FAILED:kb,DIRECTION_NONE:Ca,DIRECTION_LEFT:Da,DIRECTION_RIGHT:Ea,DIRECTION_UP:Fa,DIRECTION_DOWN:Ga,DIRECTION_HORIZONTAL:Ha,DIRECTION_VERTICAL:Ia,DIRECTION_ALL:Ja,Manager:fa,Input:y,TouchAction:T,TouchInput:Q,MouseInput:M,PointerEventInput:N,TouchMouseInput:S,SingleTouchInput:O,Recognizer:V,AttrRecognizer:Z,Tap:da,Pan:$,Swipe:ca,Pinch:_,Rotate:ba,Press:aa,on:n,off:o,each:g,merge:i,extend:h,inherit:j,bindFn:k,prefixed:v}),"function"==ka&&__webpack_require__(3)?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return ea}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?module.exports=ea:a[c]=ea}(window,document,"Hammer"),function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2),__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?a(require("jquery"),require("hammerjs")):a(jQuery,Hammer)}(function(a,b){function c(c,d){var e=a(c);e.data("hammer")||e.data("hammer",new b(e[0],d))}a.fn.hammer=function(a){return this.each(function(){c(this,a)})},b.Manager.prototype.emit=function(b){return function(c,d){b.call(this,c,d),a(this.element).trigger({type:c,gesture:d})}}(b.Manager.prototype.emit)}),function(a){a.Package?Materialize={}:a.Materialize={}}(window),function(a){for(var b=0,c=["webkit","moz"],d=a.requestAnimationFrame,e=a.cancelAnimationFrame,f=c.length;--f>=0&&!d;)d=a[c[f]+"RequestAnimationFrame"],e=a[c[f]+"CancelRequestAnimationFrame"];d&&e||(d=function(a){var c=+Date.now(),d=Math.max(b+16,c);return setTimeout(function(){a(b=d)},d-c)},e=clearTimeout),a.requestAnimationFrame=d,a.cancelAnimationFrame=e}(window),Materialize.guid=function(){function a(){return Math.floor(65536*(1+Math.random())).toString(16).substring(1)}return function(){return a()+a()+"-"+a()+"-"+a()+"-"+a()+"-"+a()+a()+a()}}(),Materialize.escapeHash=function(a){return a.replace(/(:|\.|\[|\]|,|=)/g,"\\$1")},Materialize.elementOrParentIsFixed=function(a){var b=$(a),c=b.add(b.parents()),d=!1;return c.each(function(){return"fixed"===$(this).css("position")?(d=!0,!1):void 0}),d};var Vel;Vel=jQuery?jQuery.Velocity:$?$.Velocity:Velocity,function(a){a.fn.collapsible=function(b){var c={accordion:void 0,onOpen:void 0,onClose:void 0};return b=a.extend(c,b),this.each(function(){function c(b){j=i.find("> li > .collapsible-header"),b.hasClass("active")?b.parent().addClass("active"):b.parent().removeClass("active"),b.parent().hasClass("active")?b.siblings(".collapsible-body").stop(!0,!1).slideDown({duration:350,easing:"easeOutQuart",queue:!1,complete:function(){a(this).css("height","")}}):b.siblings(".collapsible-body").stop(!0,!1).slideUp({duration:350,easing:"easeOutQuart",queue:!1,complete:function(){a(this).css("height","")}}),j.not(b).removeClass("active").parent().removeClass("active"),j.not(b).parent().children(".collapsible-body").stop(!0,!1).each(function(){a(this).is(":visible")&&a(this).slideUp({duration:350,easing:"easeOutQuart",queue:!1,complete:function(){a(this).css("height",""),f(a(this).siblings(".collapsible-header"))}})})}function d(b){b.hasClass("active")?b.parent().addClass("active"):b.parent().removeClass("active"),b.parent().hasClass("active")?b.siblings(".collapsible-body").stop(!0,!1).slideDown({duration:350,easing:"easeOutQuart",queue:!1,complete:function(){a(this).css("height","")}}):b.siblings(".collapsible-body").stop(!0,!1).slideUp({duration:350,easing:"easeOutQuart",queue:!1,complete:function(){a(this).css("height","")}})}function e(a){b.accordion||"accordion"===k||void 0===k?c(a):d(a),f(a)}function f(a){a.hasClass("active")?"function"==typeof b.onOpen&&b.onOpen.call(this,a.parent()):"function"==typeof b.onClose&&b.onClose.call(this,a.parent())}function g(a){var b=h(a);return b.length>0}function h(a){return a.closest("li > .collapsible-header")}var i=a(this),j=a(this).find("> li > .collapsible-header"),k=i.data("collapsible");i.off("click.collapse","> li > .collapsible-header"),j.off("click.collapse"),i.on("click.collapse","> li > .collapsible-header",function(b){var c=a(b.target);g(c)&&(c=h(c)),c.toggleClass("active"),e(c)}),b.accordion||"accordion"===k||void 0===k?e(j.filter(".active").first()):j.filter(".active").each(function(){e(a(this))})})},a(document).ready(function(){a(".collapsible").collapsible()})}(jQuery),function(a){a.fn.scrollTo=function(b){return a(this).scrollTop(a(this).scrollTop()-a(this).offset().top+a(b).offset().top),this},a.fn.dropdown=function(b){var c={inDuration:300,outDuration:225,constrain_width:!0,hover:!1,gutter:0,belowOrigin:!1,alignment:"left",stopPropagation:!1};return"open"===b?(this.each(function(){a(this).trigger("open")}),!1):"close"===b?(this.each(function(){a(this).trigger("close")}),!1):void this.each(function(){function d(){void 0!==g.data("induration")&&(h.inDuration=g.data("induration")),void 0!==g.data("outduration")&&(h.outDuration=g.data("outduration")),void 0!==g.data("constrainwidth")&&(h.constrain_width=g.data("constrainwidth")),void 0!==g.data("hover")&&(h.hover=g.data("hover")),void 0!==g.data("gutter")&&(h.gutter=g.data("gutter")),void 0!==g.data("beloworigin")&&(h.belowOrigin=g.data("beloworigin")),void 0!==g.data("alignment")&&(h.alignment=g.data("alignment")),void 0!==g.data("stoppropagation")&&(h.stopPropagation=g.data("stoppropagation"))}function e(b){"focus"===b&&(i=!0),d(),j.addClass("active"),g.addClass("active"),h.constrain_width===!0?j.css("width",g.outerWidth()):j.css("white-space","nowrap");var c=window.innerHeight,e=g.innerHeight(),f=g.offset().left,k=g.offset().top-a(window).scrollTop(),l=h.alignment,m=0,n=0,o=0;h.belowOrigin===!0&&(o=e);var p=0,q=0,r=g.parent();if(r.is("body")||(r[0].scrollHeight>r[0].clientHeight&&(p=r[0].scrollTop),r[0].scrollWidth>r[0].clientWidth&&(q=r[0].scrollLeft)),f+j.innerWidth()>a(window).width()?l="right":f-j.innerWidth()+g.innerWidth()<0&&(l="left"),k+j.innerHeight()>c)if(k+e-j.innerHeight()<0){var s=c-k-o;j.css("max-height",s)}else o||(o+=e),o-=j.innerHeight();if("left"===l)m=h.gutter,n=g.position().left+m;else if("right"===l){var t=g.position().left+g.outerWidth()-j.outerWidth();m=-h.gutter,n=t+m}j.css({position:"absolute",top:g.position().top+o+p,left:n+q}),j.stop(!0,!0).css("opacity",0).slideDown({queue:!1,duration:h.inDuration,easing:"easeOutCubic",complete:function(){a(this).css("height","")}}).animate({opacity:1},{queue:!1,duration:h.inDuration,easing:"easeOutSine"})}function f(){i=!1,j.fadeOut(h.outDuration),j.removeClass("active"),g.removeClass("active"),setTimeout(function(){j.css("max-height","")},h.outDuration)}var g=a(this),h=a.extend({},c,b),i=!1,j=a("#"+g.attr("data-activates"));if(d(),g.after(j),h.hover){var k=!1;g.unbind("click."+g.attr("id")),g.on("mouseenter",function(a){k===!1&&(e(),k=!0)}),g.on("mouseleave",function(b){var c=b.toElement||b.relatedTarget;a(c).closest(".dropdown-content").is(j)||(j.stop(!0,!0),f(),k=!1)}),j.on("mouseleave",function(b){var c=b.toElement||b.relatedTarget;a(c).closest(".dropdown-button").is(g)||(j.stop(!0,!0),f(),k=!1)})}else g.unbind("click."+g.attr("id")),g.bind("click."+g.attr("id"),function(b){i||(g[0]!=b.currentTarget||g.hasClass("active")||0!==a(b.target).closest(".dropdown-content").length?g.hasClass("active")&&(f(),a(document).unbind("click."+j.attr("id")+" touchstart."+j.attr("id"))):(b.preventDefault(),h.stopPropagation&&b.stopPropagation(),e("click")),j.hasClass("active")&&a(document).bind("click."+j.attr("id")+" touchstart."+j.attr("id"),function(b){j.is(b.target)||g.is(b.target)||g.find(b.target).length||(f(),a(document).unbind("click."+j.attr("id")+" touchstart."+j.attr("id")))}))});g.on("open",function(a,b){e(b)}),g.on("close",f)})},a(document).ready(function(){a(".dropdown-button").dropdown()})}(jQuery),function(a){var b=0,c=0,d=function(){return c++,"materialize-modal-overlay-"+c},e={init:function(c){var e={opacity:.5,in_duration:350,out_duration:250,ready:void 0,complete:void 0,dismissible:!0,starting_top:"4%",ending_top:"10%"};return c=a.extend(e,c),this.each(function(){var e=a(this),f=a(this).attr("id")||"#"+a(this).data("target"),g=function(){var d=e.data("overlay-id"),f=a("#"+d);e.removeClass("open"),a("body").css({overflow:"",width:""}),e.find(".modal-close").off("click.close"),a(document).off("keyup.modal"+d),f.velocity({opacity:0},{duration:c.out_duration,queue:!1,ease:"easeOutQuart"});var g={
	duration:c.out_duration,queue:!1,ease:"easeOutCubic",complete:function(){a(this).css({display:"none"}),"function"==typeof c.complete&&c.complete.call(this,e),f.remove(),b--}};e.hasClass("bottom-sheet")?e.velocity({bottom:"-100%",opacity:0},g):e.velocity({top:c.starting_top,opacity:0,scaleX:.7},g)},h=function(f){var h=a("body"),i=h.innerWidth();if(h.css("overflow","hidden"),h.width(i),!e.hasClass("open")){var j=d(),k=a('<div class="modal-overlay"></div>');lStack=++b,k.attr("id",j).css("z-index",1e3+2*lStack),e.data("overlay-id",j).css("z-index",1e3+2*lStack+1),e.addClass("open"),a("body").append(k),c.dismissible&&(k.click(function(){g()}),a(document).on("keyup.modal"+j,function(a){27===a.keyCode&&g()})),e.find(".modal-close").on("click.close",function(a){g()}),k.css({display:"block",opacity:0}),e.css({display:"block",opacity:0}),k.velocity({opacity:c.opacity},{duration:c.in_duration,queue:!1,ease:"easeOutCubic"}),e.data("associated-overlay",k[0]);var l={duration:c.in_duration,queue:!1,ease:"easeOutCubic",complete:function(){"function"==typeof c.ready&&c.ready.call(this,e,f)}};e.hasClass("bottom-sheet")?e.velocity({bottom:"0",opacity:1},l):(a.Velocity.hook(e,"scaleX",.7),e.css({top:c.starting_top}),e.velocity({top:c.ending_top,opacity:1,scaleX:"1"},l))}};a(document).off("click.modalTrigger",'a[href="#'+f+'"], [data-target="'+f+'"]'),a(this).off("openModal"),a(this).off("closeModal"),a(document).on("click.modalTrigger",'a[href="#'+f+'"], [data-target="'+f+'"]',function(b){c.starting_top=(a(this).offset().top-a(window).scrollTop())/1.15,h(a(this)),b.preventDefault()}),a(this).on("openModal",function(){a(this).attr("href")||"#"+a(this).data("target");h()}),a(this).on("closeModal",function(){g()})})},open:function(){a(this).trigger("openModal")},close:function(){a(this).trigger("closeModal")}};a.fn.modal=function(b){return e[b]?e[b].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof b&&b?void a.error("Method "+b+" does not exist on jQuery.modal"):e.init.apply(this,arguments)}}(jQuery),function(a){a.fn.materialbox=function(){return this.each(function(){function b(){f=!1;var b=i.parent(".material-placeholder"),d=(window.innerWidth,window.innerHeight,i.data("width")),g=i.data("height");i.velocity("stop",!0),a("#materialbox-overlay").velocity("stop",!0),a(".materialbox-caption").velocity("stop",!0),a("#materialbox-overlay").velocity({opacity:0},{duration:h,queue:!1,easing:"easeOutQuad",complete:function(){e=!1,a(this).remove()}}),i.velocity({width:d,height:g,left:0,top:0},{duration:h,queue:!1,easing:"easeOutQuad"}),a(".materialbox-caption").velocity({opacity:0},{duration:h,queue:!1,easing:"easeOutQuad",complete:function(){b.css({height:"",width:"",position:"",top:"",left:""}),i.css({height:"",top:"",left:"",width:"","max-width":"",position:"","z-index":""}),i.removeClass("active"),f=!0,a(this).remove(),c&&c.css("overflow","")}})}if(!a(this).hasClass("initialized")){a(this).addClass("initialized");var c,d,e=!1,f=!0,g=275,h=200,i=a(this),j=a("<div></div>").addClass("material-placeholder");i.wrap(j),i.on("click",function(){var h=i.parent(".material-placeholder"),j=window.innerWidth,k=window.innerHeight,l=i.width(),m=i.height();if(f===!1)return b(),!1;if(e&&f===!0)return b(),!1;f=!1,i.addClass("active"),e=!0,h.css({width:h[0].getBoundingClientRect().width,height:h[0].getBoundingClientRect().height,position:"relative",top:0,left:0}),c=void 0,d=h[0].parentNode;for(;null!==d&&!a(d).is(document);){var n=a(d);"visible"!==n.css("overflow")&&(n.css("overflow","visible"),c=void 0===c?n:c.add(n)),d=d.parentNode}i.css({position:"absolute","z-index":1e3}).data("width",l).data("height",m);var o=a('<div id="materialbox-overlay"></div>').css({opacity:0}).click(function(){f===!0&&b()});if(i.before(o),o.velocity({opacity:1},{duration:g,queue:!1,easing:"easeOutQuad"}),""!==i.data("caption")){var p=a('<div class="materialbox-caption"></div>');p.text(i.data("caption")),a("body").append(p),p.css({display:"inline"}),p.velocity({opacity:1},{duration:g,queue:!1,easing:"easeOutQuad"})}var q=0,r=l/j,s=m/k,t=0,u=0;r>s?(q=m/l,t=.9*j,u=.9*j*q):(q=l/m,t=.9*k*q,u=.9*k),i.hasClass("responsive-img")?i.velocity({"max-width":t,width:l},{duration:0,queue:!1,complete:function(){i.css({left:0,top:0}).velocity({height:u,width:t,left:a(document).scrollLeft()+j/2-i.parent(".material-placeholder").offset().left-t/2,top:a(document).scrollTop()+k/2-i.parent(".material-placeholder").offset().top-u/2},{duration:g,queue:!1,easing:"easeOutQuad",complete:function(){f=!0}})}}):i.css("left",0).css("top",0).velocity({height:u,width:t,left:a(document).scrollLeft()+j/2-i.parent(".material-placeholder").offset().left-t/2,top:a(document).scrollTop()+k/2-i.parent(".material-placeholder").offset().top-u/2},{duration:g,queue:!1,easing:"easeOutQuad",complete:function(){f=!0}})}),a(window).scroll(function(){e&&b()}),a(document).keyup(function(a){27===a.keyCode&&f===!0&&e&&b()})}})},a(document).ready(function(){a(".materialboxed").materialbox()})}(jQuery),function(a){a.fn.parallax=function(){var b=a(window).width();return this.each(function(c){function d(c){var d;d=601>b?e.height()>0?e.height():e.children("img").height():e.height()>0?e.height():500;var f=e.children("img").first(),g=f.height(),h=g-d,i=e.offset().top+d,j=e.offset().top,k=a(window).scrollTop(),l=window.innerHeight,m=k+l,n=(m-j)/(d+l),o=Math.round(h*n);c&&f.css("display","block"),i>k&&k+l>j&&f.css("transform","translate3D(-50%,"+o+"px, 0)")}var e=a(this);e.addClass("parallax"),e.children("img").one("load",function(){d(!0)}).each(function(){this.complete&&a(this).trigger("load")}),a(window).scroll(function(){b=a(window).width(),d(!1)}),a(window).resize(function(){b=a(window).width(),d(!1)})})}}(jQuery),function(a){var b={init:function(b){var c={onShow:null};return b=a.extend(c,b),this.each(function(){var c,d,e=a(this),f=(a(window).width(),e.find("li.tab a")),g=e.width(),h=Math.max(g,e[0].scrollWidth)/f.length,i=0,j=function(a){return g-a.position().left-a.outerWidth()-e.scrollLeft()},k=function(a){return a.position().left+e.scrollLeft()};c=a(f.filter('[href="'+location.hash+'"]')),0===c.length&&(c=a(this).find("li.tab a.active").first()),0===c.length&&(c=a(this).find("li.tab a").first()),c.addClass("active"),i=f.index(c),0>i&&(i=0),void 0!==c[0]&&(d=a(c[0].hash)),e.append('<div class="indicator"></div>');var l=e.find(".indicator");e.is(":visible")&&setTimeout(function(){l.css({right:j(c)}),l.css({left:k(c)})},0),a(window).resize(function(){g=e.width(),h=Math.max(g,e[0].scrollWidth)/f.length,0>i&&(i=0),0!==h&&0!==g&&(l.css({right:j(c)}),l.css({left:k(c)}))}),f.not(c).each(function(){a(Materialize.escapeHash(this.hash)).hide()}),e.on("click","a",function(m){if(a(this).parent().hasClass("disabled"))return void m.preventDefault();if(!a(this).attr("target")){g=e.width(),h=Math.max(g,e[0].scrollWidth)/f.length,c.removeClass("active"),void 0!==d&&d.hide(),c=a(this),d=a(Materialize.escapeHash(this.hash)),f=e.find("li.tab a");c.position();c.addClass("active");var n=i;i=f.index(a(this)),0>i&&(i=0),void 0!==d&&(d.show(),"function"==typeof b.onShow&&b.onShow.call(this,d)),i-n>=0?(l.velocity({right:j(c)},{duration:300,queue:!1,easing:"easeOutQuad"}),l.velocity({left:k(c)},{duration:300,queue:!1,easing:"easeOutQuad",delay:90})):(l.velocity({left:k(c)},{duration:300,queue:!1,easing:"easeOutQuad"}),l.velocity({right:j(c)},{duration:300,queue:!1,easing:"easeOutQuad",delay:90})),m.preventDefault()}})})},select_tab:function(a){this.find('a[href="#'+a+'"]').trigger("click")}};a.fn.tabs=function(c){return b[c]?b[c].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof c&&c?void a.error("Method "+c+" does not exist on jQuery.tabs"):b.init.apply(this,arguments)},a(document).ready(function(){a("ul.tabs").tabs()})}(jQuery),function(a){a.fn.tooltip=function(c){var d=5,e={delay:350,tooltip:"",position:"bottom",html:!1};return"remove"===c?(this.each(function(){a("#"+a(this).attr("data-tooltip-id")).remove(),a(this).off("mouseenter.tooltip mouseleave.tooltip")}),!1):(c=a.extend(e,c),this.each(function(){var e=Materialize.guid(),f=a(this);f.attr("data-tooltip-id")&&a("#"+f.attr("data-tooltip-id")).remove(),f.attr("data-tooltip-id",e);var g,h,i,j,k,l,m=function(){g=f.attr("data-html")?"true"===f.attr("data-html"):c.html,h=f.attr("data-delay"),h=void 0===h||""===h?c.delay:h,i=f.attr("data-position"),i=void 0===i||""===i?c.position:i,j=f.attr("data-tooltip"),j=void 0===j||""===j?c.tooltip:j};m();var n=function(){var b=a('<div class="material-tooltip"></div>');return j=g?a("<span></span>").html(j):a("<span></span>").text(j),b.append(j).appendTo(a("body")).attr("id",e),l=a('<div class="backdrop"></div>'),l.appendTo(b),b};k=n(),f.off("mouseenter.tooltip mouseleave.tooltip");var o,p=!1;f.on({"mouseenter.tooltip":function(a){var c=function(){m(),p=!0,k.velocity("stop"),l.velocity("stop"),k.css({display:"block",left:"0px",top:"0px"});var a,c,e,g=f.outerWidth(),h=f.outerHeight(),j=k.outerHeight(),n=k.outerWidth(),o="0px",q="0px",r=8,s=8;"top"===i?(a=f.offset().top-j-d,c=f.offset().left+g/2-n/2,e=b(c,a,n,j),o="-10px",l.css({bottom:0,left:0,borderRadius:"14px 14px 0 0",transformOrigin:"50% 100%",marginTop:j,marginLeft:n/2-l.width()/2})):"left"===i?(a=f.offset().top+h/2-j/2,c=f.offset().left-n-d,e=b(c,a,n,j),q="-10px",l.css({top:"-7px",right:0,width:"14px",height:"14px",borderRadius:"14px 0 0 14px",transformOrigin:"95% 50%",marginTop:j/2,marginLeft:n})):"right"===i?(a=f.offset().top+h/2-j/2,c=f.offset().left+g+d,e=b(c,a,n,j),q="+10px",l.css({top:"-7px",left:0,width:"14px",height:"14px",borderRadius:"0 14px 14px 0",transformOrigin:"5% 50%",marginTop:j/2,marginLeft:"0px"})):(a=f.offset().top+f.outerHeight()+d,c=f.offset().left+g/2-n/2,e=b(c,a,n,j),o="+10px",l.css({top:0,left:0,marginLeft:n/2-l.width()/2})),k.css({top:e.y,left:e.x}),r=Math.SQRT2*n/parseInt(l.css("width")),s=Math.SQRT2*j/parseInt(l.css("height")),k.velocity({marginTop:o,marginLeft:q},{duration:350,queue:!1}).velocity({opacity:1},{duration:300,delay:50,queue:!1}),l.css({display:"block"}).velocity({opacity:1},{duration:55,delay:0,queue:!1}).velocity({scaleX:r,scaleY:s},{duration:300,delay:0,queue:!1,easing:"easeInOutQuad"})};o=setTimeout(c,h)},"mouseleave.tooltip":function(){p=!1,clearTimeout(o),setTimeout(function(){p!==!0&&(k.velocity({opacity:0,marginTop:0,marginLeft:0},{duration:225,queue:!1}),l.velocity({opacity:0,scaleX:1,scaleY:1},{duration:225,queue:!1,complete:function(){l.css("display","none"),k.css("display","none"),p=!1}}))},225)}})}))};var b=function(b,c,d,e){var f=b,g=c;return 0>f?f=4:f+d>window.innerWidth&&(f-=f+d-window.innerWidth),0>g?g=4:g+e>window.innerHeight+a(window).scrollTop&&(g-=g+e-window.innerHeight),{x:f,y:g}};a(document).ready(function(){a(".tooltipped").tooltip()})}(jQuery),function(a){"use strict";function b(a){return null!==a&&a===a.window}function c(a){return b(a)?a:9===a.nodeType&&a.defaultView}function d(a){var b,d,e={top:0,left:0},f=a&&a.ownerDocument;return b=f.documentElement,"undefined"!=typeof a.getBoundingClientRect&&(e=a.getBoundingClientRect()),d=c(f),{top:e.top+d.pageYOffset-b.clientTop,left:e.left+d.pageXOffset-b.clientLeft}}function e(a){var b="";for(var c in a)a.hasOwnProperty(c)&&(b+=c+":"+a[c]+";");return b}function f(a){if(k.allowEvent(a)===!1)return null;for(var b=null,c=a.target||a.srcElement;null!==c.parentElement;){if(!(c instanceof SVGElement||-1===c.className.indexOf("waves-effect"))){b=c;break}if(c.classList.contains("waves-effect")){b=c;break}c=c.parentElement}return b}function g(b){var c=f(b);null!==c&&(j.show(b,c),"ontouchstart"in a&&(c.addEventListener("touchend",j.hide,!1),c.addEventListener("touchcancel",j.hide,!1)),c.addEventListener("mouseup",j.hide,!1),c.addEventListener("mouseleave",j.hide,!1))}var h=h||{},i=document.querySelectorAll.bind(document),j={duration:750,show:function(a,b){if(2===a.button)return!1;var c=b||this,f=document.createElement("div");f.className="waves-ripple",c.appendChild(f);var g=d(c),h=a.pageY-g.top,i=a.pageX-g.left,k="scale("+c.clientWidth/100*10+")";"touches"in a&&(h=a.touches[0].pageY-g.top,i=a.touches[0].pageX-g.left),f.setAttribute("data-hold",Date.now()),f.setAttribute("data-scale",k),f.setAttribute("data-x",i),f.setAttribute("data-y",h);var l={top:h+"px",left:i+"px"};f.className=f.className+" waves-notransition",f.setAttribute("style",e(l)),f.className=f.className.replace("waves-notransition",""),l["-webkit-transform"]=k,l["-moz-transform"]=k,l["-ms-transform"]=k,l["-o-transform"]=k,l.transform=k,l.opacity="1",l["-webkit-transition-duration"]=j.duration+"ms",l["-moz-transition-duration"]=j.duration+"ms",l["-o-transition-duration"]=j.duration+"ms",l["transition-duration"]=j.duration+"ms",l["-webkit-transition-timing-function"]="cubic-bezier(0.250, 0.460, 0.450, 0.940)",l["-moz-transition-timing-function"]="cubic-bezier(0.250, 0.460, 0.450, 0.940)",l["-o-transition-timing-function"]="cubic-bezier(0.250, 0.460, 0.450, 0.940)",l["transition-timing-function"]="cubic-bezier(0.250, 0.460, 0.450, 0.940)",f.setAttribute("style",e(l))},hide:function(a){k.touchup(a);var b=this,c=(1.4*b.clientWidth,null),d=b.getElementsByClassName("waves-ripple");if(!(d.length>0))return!1;c=d[d.length-1];var f=c.getAttribute("data-x"),g=c.getAttribute("data-y"),h=c.getAttribute("data-scale"),i=Date.now()-Number(c.getAttribute("data-hold")),l=350-i;0>l&&(l=0),setTimeout(function(){var a={top:g+"px",left:f+"px",opacity:"0","-webkit-transition-duration":j.duration+"ms","-moz-transition-duration":j.duration+"ms","-o-transition-duration":j.duration+"ms","transition-duration":j.duration+"ms","-webkit-transform":h,"-moz-transform":h,"-ms-transform":h,"-o-transform":h,transform:h};c.setAttribute("style",e(a)),setTimeout(function(){try{b.removeChild(c)}catch(a){return!1}},j.duration)},l)},wrapInput:function(a){for(var b=0;b<a.length;b++){var c=a[b];if("input"===c.tagName.toLowerCase()){var d=c.parentNode;if("i"===d.tagName.toLowerCase()&&-1!==d.className.indexOf("waves-effect"))continue;var e=document.createElement("i");e.className=c.className+" waves-input-wrapper";var f=c.getAttribute("style");f||(f=""),e.setAttribute("style",f),c.className="waves-button-input",c.removeAttribute("style"),d.replaceChild(e,c),e.appendChild(c)}}}},k={touches:0,allowEvent:function(a){var b=!0;return"touchstart"===a.type?k.touches+=1:"touchend"===a.type||"touchcancel"===a.type?setTimeout(function(){k.touches>0&&(k.touches-=1)},500):"mousedown"===a.type&&k.touches>0&&(b=!1),b},touchup:function(a){k.allowEvent(a)}};h.displayEffect=function(b){b=b||{},"duration"in b&&(j.duration=b.duration),j.wrapInput(i(".waves-effect")),"ontouchstart"in a&&document.body.addEventListener("touchstart",g,!1),document.body.addEventListener("mousedown",g,!1)},h.attach=function(b){"input"===b.tagName.toLowerCase()&&(j.wrapInput([b]),b=b.parentElement),"ontouchstart"in a&&b.addEventListener("touchstart",g,!1),b.addEventListener("mousedown",g,!1)},a.Waves=h,document.addEventListener("DOMContentLoaded",function(){h.displayEffect()},!1)}(window),Materialize.toast=function(a,b,c,d){function e(a){var b=document.createElement("div");if(b.classList.add("toast"),c)for(var e=c.split(" "),f=0,g=e.length;g>f;f++)b.classList.add(e[f]);("object"==typeof HTMLElement?a instanceof HTMLElement:a&&"object"==typeof a&&null!==a&&1===a.nodeType&&"string"==typeof a.nodeName)?b.appendChild(a):a instanceof jQuery?b.appendChild(a[0]):b.innerHTML=a;var h=new Hammer(b,{prevent_default:!1});return h.on("pan",function(a){var c=a.deltaX,d=80;b.classList.contains("panning")||b.classList.add("panning");var e=1-Math.abs(c/d);0>e&&(e=0),Vel(b,{left:c,opacity:e},{duration:50,queue:!1,easing:"easeOutQuad"})}),h.on("panend",function(a){var c=a.deltaX,e=80;Math.abs(c)>e?Vel(b,{marginTop:"-40px"},{duration:375,easing:"easeOutExpo",queue:!1,complete:function(){"function"==typeof d&&d(),b.parentNode.removeChild(b)}}):(b.classList.remove("panning"),Vel(b,{left:0,opacity:1},{duration:300,easing:"easeOutExpo",queue:!1}))}),b}c=c||"";var f=document.getElementById("toast-container");null===f&&(f=document.createElement("div"),f.id="toast-container",document.body.appendChild(f));var g=e(a);a&&f.appendChild(g),g.style.top="35px",g.style.opacity=0,Vel(g,{top:"0px",opacity:1},{duration:300,easing:"easeOutCubic",queue:!1});var h,i=b;null!=i&&(h=setInterval(function(){null===g.parentNode&&window.clearInterval(h),g.classList.contains("panning")||(i-=20),0>=i&&(Vel(g,{opacity:0,marginTop:"-40px"},{duration:375,easing:"easeOutExpo",queue:!1,complete:function(){"function"==typeof d&&d(),this[0].parentNode.removeChild(this[0])}}),window.clearInterval(h))},20))},function(a){var b={init:function(b){var c={menuWidth:300,edge:"left",closeOnClick:!1,draggable:!0};b=a.extend(c,b),a(this).each(function(){var c=a(this),d=a("#"+c.attr("data-activates"));300!=b.menuWidth&&d.css("width",b.menuWidth);var e;b.draggable?(e=a('<div class="drag-target"></div>').attr("data-sidenav",c.attr("data-activates")),a("body").append(e)):e=a(),"left"==b.edge?(d.css("transform","translateX(-100%)"),e.css({left:0})):(d.addClass("right-aligned").css("transform","translateX(100%)"),e.css({right:0})),d.hasClass("fixed")&&window.innerWidth>992&&d.css("transform","translateX(0)"),d.hasClass("fixed")&&a(window).resize(function(){window.innerWidth>992?0!==a("#sidenav-overlay").length&&h?f(!0):d.css("transform","translateX(0%)"):h===!1&&("left"===b.edge?d.css("transform","translateX(-100%)"):d.css("transform","translateX(100%)"))}),b.closeOnClick===!0&&d.on("click.itemclick","a:not(.collapsible-header)",function(){f()});var f=function(c){g=!1,h=!1,a("body").css({overflow:"",width:""}),a("#sidenav-overlay").velocity({opacity:0},{duration:200,queue:!1,easing:"easeOutQuad",complete:function(){a(this).remove()}}),"left"===b.edge?(e.css({width:"",right:"",left:"0"}),d.velocity({translateX:"-100%"},{duration:200,queue:!1,easing:"easeOutCubic",complete:function(){c===!0&&(d.removeAttr("style"),d.css("width",b.menuWidth))}})):(e.css({width:"",right:"0",left:""}),d.velocity({translateX:"100%"},{duration:200,queue:!1,easing:"easeOutCubic",complete:function(){c===!0&&(d.removeAttr("style"),d.css("width",b.menuWidth))}}))},g=!1,h=!1;b.draggable&&(e.on("click",function(){h&&f()}),e.hammer({prevent_default:!1}).bind("pan",function(c){if("touch"==c.gesture.pointerType){var e=(c.gesture.direction,c.gesture.center.x),g=(c.gesture.center.y,c.gesture.velocityX,a("body")),i=a("#sidenav-overlay"),j=g.innerWidth();if(g.css("overflow","hidden"),g.width(j),0===i.length&&(i=a('<div id="sidenav-overlay"></div>'),i.css("opacity",0).click(function(){f()}),a("body").append(i)),"left"===b.edge&&(e>b.menuWidth?e=b.menuWidth:0>e&&(e=0)),"left"===b.edge)e<b.menuWidth/2?h=!1:e>=b.menuWidth/2&&(h=!0),d.css("transform","translateX("+(e-b.menuWidth)+"px)");else{e<window.innerWidth-b.menuWidth/2?h=!0:e>=window.innerWidth-b.menuWidth/2&&(h=!1);var k=e-b.menuWidth/2;0>k&&(k=0),d.css("transform","translateX("+k+"px)")}var l;"left"===b.edge?(l=e/b.menuWidth,i.velocity({opacity:l},{duration:10,queue:!1,easing:"easeOutQuad"})):(l=Math.abs((e-window.innerWidth)/b.menuWidth),i.velocity({opacity:l},{duration:10,queue:!1,easing:"easeOutQuad"}))}}).bind("panend",function(c){if("touch"==c.gesture.pointerType){var f=a('<div id="sidenav-overlay"></div>'),i=c.gesture.velocityX,j=c.gesture.center.x,k=j-b.menuWidth,l=j-b.menuWidth/2;k>0&&(k=0),0>l&&(l=0),g=!1,"left"===b.edge?h&&.3>=i||-.5>i?(0!==k&&d.velocity({translateX:[0,k]},{duration:300,queue:!1,easing:"easeOutQuad"}),f.velocity({opacity:1},{duration:50,queue:!1,easing:"easeOutQuad"}),e.css({width:"50%",right:0,left:""}),h=!0):(!h||i>.3)&&(a("body").css({overflow:"",width:""}),d.velocity({translateX:[-1*b.menuWidth-10,k]},{duration:200,queue:!1,easing:"easeOutQuad"}),f.velocity({opacity:0},{duration:200,queue:!1,easing:"easeOutQuad",complete:function(){a(this).remove()}}),e.css({width:"10px",right:"",left:0})):h&&i>=-.3||i>.5?(0!==l&&d.velocity({translateX:[0,l]},{duration:300,queue:!1,easing:"easeOutQuad"}),f.velocity({opacity:1},{duration:50,queue:!1,easing:"easeOutQuad"}),e.css({width:"50%",right:"",left:0}),h=!0):(!h||-.3>i)&&(a("body").css({overflow:"",width:""}),d.velocity({translateX:[b.menuWidth+10,l]},{duration:200,queue:!1,easing:"easeOutQuad"}),f.velocity({opacity:0},{duration:200,queue:!1,easing:"easeOutQuad",complete:function(){a(this).remove()}}),e.css({width:"10px",right:0,left:""}))}})),c.click(function(){if(h===!0)h=!1,g=!1,f();else{var c=a("body"),i=a('<div id="sidenav-overlay"></div>'),j=c.innerWidth();c.css("overflow","hidden"),c.width(j),a("body").append(e),"left"===b.edge?(e.css({width:"50%",right:0,left:""}),d.velocity({translateX:[0,-1*b.menuWidth]},{duration:300,queue:!1,easing:"easeOutQuad"})):(e.css({width:"50%",right:"",left:0}),d.velocity({translateX:[0,b.menuWidth]},{duration:300,queue:!1,easing:"easeOutQuad"})),i.css("opacity",0).click(function(){h=!1,g=!1,f(),i.velocity({opacity:0},{duration:300,queue:!1,easing:"easeOutQuad",complete:function(){a(this).remove()}})}),a("body").append(i),i.velocity({opacity:1},{duration:300,queue:!1,easing:"easeOutQuad",complete:function(){h=!0,g=!1}})}return!1})})},destroy:function(){var b=a("#sidenav-overlay"),c=a('.drag-target[data-sidenav="'+a(this).attr("data-activates")+'"]');b.trigger("click"),c.remove(),a(this).off("click"),b.remove()},show:function(){this.trigger("click")},hide:function(){a("#sidenav-overlay").trigger("click")}};a.fn.sideNav=function(c){return b[c]?b[c].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof c&&c?void a.error("Method "+c+" does not exist on jQuery.sideNav"):b.init.apply(this,arguments)}}(jQuery),function(a){function b(b,c,d,e){var f=a();return a.each(g,function(a,g){if(g.height()>0){var h=g.offset().top,i=g.offset().left,j=i+g.width(),k=h+g.height(),l=!(i>c||e>j||h>d||b>k);l&&f.push(g)}}),f}function c(c){++j;var d=f.scrollTop(),e=f.scrollLeft(),g=e+f.width(),i=d+f.height(),l=b(d+k.top+c||200,g+k.right,i+k.bottom,e+k.left);a.each(l,function(a,b){var c=b.data("scrollSpy:ticks");"number"!=typeof c&&b.triggerHandler("scrollSpy:enter"),b.data("scrollSpy:ticks",j)}),a.each(h,function(a,b){var c=b.data("scrollSpy:ticks");"number"==typeof c&&c!==j&&(b.triggerHandler("scrollSpy:exit"),b.data("scrollSpy:ticks",null))}),h=l}function d(){f.trigger("scrollSpy:winSize")}function e(a,b,c){var d,e,f,g=null,h=0;c||(c={});var i=function(){h=c.leading===!1?0:l(),g=null,f=a.apply(d,e),d=e=null};return function(){var j=l();h||c.leading!==!1||(h=j);var k=b-(j-h);return d=this,e=arguments,0>=k?(clearTimeout(g),g=null,h=j,f=a.apply(d,e),d=e=null):g||c.trailing===!1||(g=setTimeout(i,k)),f}}var f=a(window),g=[],h=[],i=!1,j=0,k={top:0,right:0,bottom:0,left:0},l=Date.now||function(){return(new Date).getTime()};a.scrollSpy=function(b,d){var h={throttle:100,scrollOffset:200};d=a.extend(h,d);var j=[];b=a(b),b.each(function(b,c){g.push(a(c)),a(c).data("scrollSpy:id",b),a('a[href="#'+a(c).attr("id")+'"]').click(function(b){b.preventDefault();var c=a(Materialize.escapeHash(this.hash)).offset().top+1;a("html, body").animate({scrollTop:c-d.scrollOffset},{duration:400,queue:!1,easing:"easeOutCubic"})})}),k.top=d.offsetTop||0,k.right=d.offsetRight||0,k.bottom=d.offsetBottom||0,k.left=d.offsetLeft||0;var l=e(function(){c(d.scrollOffset)},d.throttle||100),m=function(){a(document).ready(l)};return i||(f.on("scroll",m),f.on("resize",m),i=!0),setTimeout(m,0),b.on("scrollSpy:enter",function(){j=a.grep(j,function(a){return 0!=a.height()});var b=a(this);j[0]?(a('a[href="#'+j[0].attr("id")+'"]').removeClass("active"),b.data("scrollSpy:id")<j[0].data("scrollSpy:id")?j.unshift(a(this)):j.push(a(this))):j.push(a(this)),a('a[href="#'+j[0].attr("id")+'"]').addClass("active")}),b.on("scrollSpy:exit",function(){if(j=a.grep(j,function(a){return 0!=a.height()}),j[0]){a('a[href="#'+j[0].attr("id")+'"]').removeClass("active");var b=a(this);j=a.grep(j,function(a){return a.attr("id")!=b.attr("id")}),j[0]&&a('a[href="#'+j[0].attr("id")+'"]').addClass("active")}}),b},a.winSizeSpy=function(b){return a.winSizeSpy=function(){return f},b=b||{throttle:100},f.on("resize",e(d,b.throttle||100))},a.fn.scrollSpy=function(b){return a.scrollSpy(a(this),b)}}(jQuery),function(a){a(document).ready(function(){function b(b){var c=b.css("font-family"),d=b.css("font-size"),f=b.css("line-height");d&&e.css("font-size",d),c&&e.css("font-family",c),f&&e.css("line-height",f),"off"===b.attr("wrap")&&e.css("overflow-wrap","normal").css("white-space","pre"),e.text(b.val()+"\n");var g=e.html().replace(/\n/g,"<br>");e.html(g),b.is(":visible")?e.css("width",b.width()):e.css("width",a(window).width()/2),b.css("height",e.height())}Materialize.updateTextFields=function(){var b="input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea";a(b).each(function(b,c){a(c).val().length>0||c.autofocus||void 0!==a(this).attr("placeholder")||a(c)[0].validity.badInput===!0?a(this).siblings("label").addClass("active"):a(this).siblings("label").removeClass("active")})};var c="input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea";a(document).on("change",c,function(){(0!==a(this).val().length||void 0!==a(this).attr("placeholder"))&&a(this).siblings("label").addClass("active"),validate_field(a(this))}),a(document).ready(function(){Materialize.updateTextFields()}),a(document).on("reset",function(b){var d=a(b.target);d.is("form")&&(d.find(c).removeClass("valid").removeClass("invalid"),d.find(c).each(function(){""===a(this).attr("value")&&a(this).siblings("label").removeClass("active")}),d.find("select.initialized").each(function(){var a=d.find("option[selected]").text();d.siblings("input.select-dropdown").val(a)}))}),a(document).on("focus",c,function(){a(this).siblings("label, .prefix").addClass("active")}),a(document).on("blur",c,function(){var b=a(this),c=".prefix";0===b.val().length&&b[0].validity.badInput!==!0&&void 0===b.attr("placeholder")&&(c+=", label"),b.siblings(c).removeClass("active"),validate_field(b)}),window.validate_field=function(a){var b=void 0!==a.attr("length"),c=parseInt(a.attr("length")),d=a.val().length;0===a.val().length&&a[0].validity.badInput===!1?a.hasClass("validate")&&(a.removeClass("valid"),a.removeClass("invalid")):a.hasClass("validate")&&(a.is(":valid")&&b&&c>=d||a.is(":valid")&&!b?(a.removeClass("invalid"),a.addClass("valid")):(a.removeClass("valid"),a.addClass("invalid")))};var d="input[type=radio], input[type=checkbox]";a(document).on("keyup.radio",d,function(b){if(9===b.which){a(this).addClass("tabbed");var c=a(this);return void c.one("blur",function(b){a(this).removeClass("tabbed")})}});var e=a(".hiddendiv").first();e.length||(e=a('<div class="hiddendiv common"></div>'),a("body").append(e));var f=".materialize-textarea";a(f).each(function(){var c=a(this);c.val().length&&b(c)}),a("body").on("keyup keydown autoresize",f,function(){b(a(this))}),a(document).on("change",'.file-field input[type="file"]',function(){for(var b=a(this).closest(".file-field"),c=b.find("input.file-path"),d=a(this)[0].files,e=[],f=0;f<d.length;f++)e.push(d[f].name);c.val(e.join(", ")),c.trigger("change")});var g,h="input[type=range]",i=!1;a(h).each(function(){var b=a('<span class="thumb"><span class="value"></span></span>');a(this).after(b)});var j=".range-field";a(document).on("change",h,function(b){var c=a(this).siblings(".thumb");c.find(".value").html(a(this).val())}),a(document).on("input mousedown touchstart",h,function(b){var c=a(this).siblings(".thumb"),d=a(this).outerWidth();c.length<=0&&(c=a('<span class="thumb"><span class="value"></span></span>'),a(this).after(c)),c.find(".value").html(a(this).val()),i=!0,a(this).addClass("active"),c.hasClass("active")||c.velocity({height:"30px",width:"30px",top:"-20px",marginLeft:"-15px"},{duration:300,easing:"easeOutExpo"}),"input"!==b.type&&(g=void 0===b.pageX||null===b.pageX?b.originalEvent.touches[0].pageX-a(this).offset().left:b.pageX-a(this).offset().left,0>g?g=0:g>d&&(g=d),c.addClass("active").css("left",g)),c.find(".value").html(a(this).val())}),a(document).on("mouseup touchend",j,function(){i=!1,a(this).removeClass("active")}),a(document).on("mousemove touchmove",j,function(b){var c,d=a(this).children(".thumb");if(i){d.hasClass("active")||d.velocity({height:"30px",width:"30px",top:"-20px",marginLeft:"-15px"},{duration:300,easing:"easeOutExpo"}),c=void 0===b.pageX||null===b.pageX?b.originalEvent.touches[0].pageX-a(this).offset().left:b.pageX-a(this).offset().left;var e=a(this).outerWidth();0>c?c=0:c>e&&(c=e),d.addClass("active").css("left",c),d.find(".value").html(d.siblings(h).val())}}),a(document).on("mouseout touchleave",j,function(){if(!i){var b=a(this).children(".thumb");b.hasClass("active")&&b.velocity({height:"0",width:"0",top:"10px",marginLeft:"-6px"},{duration:100}),b.removeClass("active")}}),a.fn.autocomplete=function(b){var c={data:{}};return b=a.extend(c,b),this.each(function(){var c=a(this),d=b.data,e=c.closest(".input-field");if(!a.isEmptyObject(d)){var f=a('<ul class="autocomplete-content dropdown-content"></ul>');e.length?e.append(f):c.after(f);var g=function(a,b){var c=b.find("img"),d=b.text().toLowerCase().indexOf(""+a.toLowerCase()),e=d+a.length-1,f=b.text().slice(0,d),g=b.text().slice(d,e+1),h=b.text().slice(e+1);b.html("<span>"+f+"<span class='highlight'>"+g+"</span>"+h+"</span>"),c.length&&b.prepend(c)};c.on("keyup",function(b){if(13===b.which)return void f.find("li").first().click();var e=c.val().toLowerCase();if(f.empty(),""!==e)for(var h in d)if(d.hasOwnProperty(h)&&-1!==h.toLowerCase().indexOf(e)&&h.toLowerCase()!==e){var i=a("<li></li>");d[h]?i.append('<img src="'+d[h]+'" class="right circle"><span>'+h+"</span>"):i.append("<span>"+h+"</span>"),f.append(i),g(e,i)}}),f.on("click","li",function(){c.val(a(this).text().trim()),c.trigger("change"),f.empty()})}})}}),a.fn.material_select=function(b){function c(a,b,c){var e=a.indexOf(b),f=-1===e;return f?a.push(b):a.splice(e,1),c.siblings("ul.dropdown-content").find("li").eq(b).toggleClass("active"),c.find("option").eq(b).prop("selected",f),d(a,c),f}function d(a,b){for(var c="",d=0,e=a.length;e>d;d++){var f=b.find("option").eq(a[d]).text();c+=0===d?f:", "+f}""===c&&(c=b.find("option:disabled").eq(0).text()),b.siblings("input.select-dropdown").val(c)}a(this).each(function(){var d=a(this);if(!d.hasClass("browser-default")){var e=d.attr("multiple")?!0:!1,f=d.data("select-id");if(f&&(d.parent().find("span.caret").remove(),d.parent().find("input").remove(),d.unwrap(),a("ul#select-options-"+f).remove()),"destroy"===b)return void d.data("select-id",null).removeClass("initialized");var g=Materialize.guid();d.data("select-id",g);var h=a('<div class="select-wrapper"></div>');h.addClass(d.attr("class"));var i=a('<ul id="select-options-'+g+'" class="dropdown-content select-dropdown '+(e?"multiple-select-dropdown":"")+'"></ul>'),j=d.children("option, optgroup"),k=[],l=!1,m=d.find("option:selected").html()||d.find("option:first").html()||"",n=function(b,c,d){var e=c.is(":disabled")?"disabled ":"",f="optgroup-option"===d?"optgroup-option ":"",g=c.data("icon"),h=c.attr("class");if(g){var j="";return h&&(j=' class="'+h+'"'),"multiple"===d?i.append(a('<li class="'+e+'"><img alt="" src="'+g+'"'+j+'><span><input type="checkbox"'+e+"/><label></label>"+c.html()+"</span></li>")):i.append(a('<li class="'+e+f+'"><img alt="" src="'+g+'"'+j+"><span>"+c.html()+"</span></li>")),!0}"multiple"===d?i.append(a('<li class="'+e+'"><span><input type="checkbox"'+e+"/><label></label>"+c.html()+"</span></li>")):i.append(a('<li class="'+e+f+'"><span>'+c.html()+"</span></li>"))};j.length&&j.each(function(){if(a(this).is("option"))e?n(d,a(this),"multiple"):n(d,a(this));else if(a(this).is("optgroup")){var b=a(this).children("option");i.append(a('<li class="optgroup"><span>'+a(this).attr("label")+"</span></li>")),b.each(function(){n(d,a(this),"optgroup-option")})}}),i.find("li:not(.optgroup)").each(function(f){a(this).click(function(g){if(!a(this).hasClass("disabled")&&!a(this).hasClass("optgroup")){
	var h=!0;e?(a('input[type="checkbox"]',this).prop("checked",function(a,b){return!b}),h=c(k,a(this).index(),d),q.trigger("focus")):(i.find("li").removeClass("active"),a(this).toggleClass("active"),q.val(a(this).text())),r(i,a(this)),d.find("option").eq(f).prop("selected",h),d.trigger("change"),"undefined"!=typeof b&&b()}g.stopPropagation()})}),d.wrap(h);var o=a('<span class="caret">&#9660;</span>');d.is(":disabled")&&o.addClass("disabled");var p=m.replace(/"/g,"&quot;"),q=a('<input type="text" class="select-dropdown" readonly="true" '+(d.is(":disabled")?"disabled":"")+' data-activates="select-options-'+g+'" value="'+p+'"/>');d.before(q),q.before(o),q.after(i),d.is(":disabled")||q.dropdown({hover:!1,closeOnClick:!1}),d.attr("tabindex")&&a(q[0]).attr("tabindex",d.attr("tabindex")),d.addClass("initialized"),q.on({focus:function(){if(a("ul.select-dropdown").not(i[0]).is(":visible")&&a("input.select-dropdown").trigger("close"),!i.is(":visible")){a(this).trigger("open",["focus"]);var b=a(this).val(),c=i.find("li").filter(function(){return a(this).text().toLowerCase()===b.toLowerCase()})[0];r(i,c)}},click:function(a){a.stopPropagation()}}),q.on("blur",function(){e||a(this).trigger("close"),i.find("li.selected").removeClass("selected")}),i.hover(function(){l=!0},function(){l=!1}),a(window).on({click:function(){e&&(l||q.trigger("close"))}}),e&&d.find("option:selected:not(:disabled)").each(function(){var b=a(this).index();c(k,b,d),i.find("li").eq(b).find(":checkbox").prop("checked",!0)});var r=function(b,c){if(c){b.find("li.selected").removeClass("selected");var d=a(c);d.addClass("selected"),i.scrollTo(d)}},s=[],t=function(b){if(9==b.which)return void q.trigger("close");if(40==b.which&&!i.is(":visible"))return void q.trigger("open");if(13!=b.which||i.is(":visible")){b.preventDefault();var c=String.fromCharCode(b.which).toLowerCase(),d=[9,13,27,38,40];if(c&&-1===d.indexOf(b.which)){s.push(c);var f=s.join(""),g=i.find("li").filter(function(){return 0===a(this).text().toLowerCase().indexOf(f)})[0];g&&r(i,g)}if(13==b.which){var h=i.find("li.selected:not(.disabled)")[0];h&&(a(h).trigger("click"),e||q.trigger("close"))}40==b.which&&(g=i.find("li.selected").length?i.find("li.selected").next("li:not(.disabled)")[0]:i.find("li:not(.disabled)")[0],r(i,g)),27==b.which&&q.trigger("close"),38==b.which&&(g=i.find("li.selected").prev("li:not(.disabled)")[0],g&&r(i,g)),setTimeout(function(){s=[]},1e3)}};q.on("keydown",t)}})}}(jQuery),function(a){var b={init:function(b){var c={indicators:!0,height:400,transition:500,interval:6e3};return b=a.extend(c,b),this.each(function(){function c(a,b){a.hasClass("center-align")?a.velocity({opacity:0,translateY:-100},{duration:b,queue:!1}):a.hasClass("right-align")?a.velocity({opacity:0,translateX:100},{duration:b,queue:!1}):a.hasClass("left-align")&&a.velocity({opacity:0,translateX:-100},{duration:b,queue:!1})}function d(a){a>=j.length?a=0:0>a&&(a=j.length-1),k=i.find(".active").index(),k!=a&&(e=j.eq(k),$caption=e.find(".caption"),e.removeClass("active"),e.velocity({opacity:0},{duration:b.transition,queue:!1,easing:"easeOutQuad",complete:function(){j.not(".active").velocity({opacity:0,translateX:0,translateY:0},{duration:0,queue:!1})}}),c($caption,b.transition),b.indicators&&f.eq(k).removeClass("active"),j.eq(a).velocity({opacity:1},{duration:b.transition,queue:!1,easing:"easeOutQuad"}),j.eq(a).find(".caption").velocity({opacity:1,translateX:0,translateY:0},{duration:b.transition,delay:b.transition,queue:!1,easing:"easeOutQuad"}),j.eq(a).addClass("active"),b.indicators&&f.eq(a).addClass("active"))}var e,f,g,h=a(this),i=h.find("ul.slides").first(),j=i.find("> li"),k=i.find(".active").index();-1!=k&&(e=j.eq(k)),h.hasClass("fullscreen")||(b.indicators?h.height(b.height+40):h.height(b.height),i.height(b.height)),j.find(".caption").each(function(){c(a(this),0)}),j.find("img").each(function(){var b="data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";a(this).attr("src")!==b&&(a(this).css("background-image","url("+a(this).attr("src")+")"),a(this).attr("src",b))}),b.indicators&&(f=a('<ul class="indicators"></ul>'),j.each(function(c){var e=a('<li class="indicator-item"></li>');e.click(function(){var c=i.parent(),e=c.find(a(this)).index();d(e),clearInterval(g),g=setInterval(function(){k=i.find(".active").index(),j.length==k+1?k=0:k+=1,d(k)},b.transition+b.interval)}),f.append(e)}),h.append(f),f=h.find("ul.indicators").find("li.indicator-item")),e?e.show():(j.first().addClass("active").velocity({opacity:1},{duration:b.transition,queue:!1,easing:"easeOutQuad"}),k=0,e=j.eq(k),b.indicators&&f.eq(k).addClass("active")),e.find("img").each(function(){e.find(".caption").velocity({opacity:1,translateX:0,translateY:0},{duration:b.transition,queue:!1,easing:"easeOutQuad"})}),g=setInterval(function(){k=i.find(".active").index(),d(k+1)},b.transition+b.interval);var l=!1,m=!1,n=!1;h.hammer({prevent_default:!1}).bind("pan",function(a){if("touch"===a.gesture.pointerType){clearInterval(g);var b=a.gesture.direction,c=a.gesture.deltaX,d=a.gesture.velocityX;$curr_slide=i.find(".active"),$curr_slide.velocity({translateX:c},{duration:50,queue:!1,easing:"easeOutQuad"}),4===b&&(c>h.innerWidth()/2||-.65>d)?n=!0:2===b&&(c<-1*h.innerWidth()/2||d>.65)&&(m=!0);var e;m&&(e=$curr_slide.next(),0===e.length&&(e=j.first()),e.velocity({opacity:1},{duration:300,queue:!1,easing:"easeOutQuad"})),n&&(e=$curr_slide.prev(),0===e.length&&(e=j.last()),e.velocity({opacity:1},{duration:300,queue:!1,easing:"easeOutQuad"}))}}).bind("panend",function(a){"touch"===a.gesture.pointerType&&($curr_slide=i.find(".active"),l=!1,curr_index=i.find(".active").index(),!n&&!m||j.length<=1?$curr_slide.velocity({translateX:0},{duration:300,queue:!1,easing:"easeOutQuad"}):m?(d(curr_index+1),$curr_slide.velocity({translateX:-1*h.innerWidth()},{duration:300,queue:!1,easing:"easeOutQuad",complete:function(){$curr_slide.velocity({opacity:0,translateX:0},{duration:0,queue:!1})}})):n&&(d(curr_index-1),$curr_slide.velocity({translateX:h.innerWidth()},{duration:300,queue:!1,easing:"easeOutQuad",complete:function(){$curr_slide.velocity({opacity:0,translateX:0},{duration:0,queue:!1})}})),m=!1,n=!1,clearInterval(g),g=setInterval(function(){k=i.find(".active").index(),j.length==k+1?k=0:k+=1,d(k)},b.transition+b.interval))}),h.on("sliderPause",function(){clearInterval(g)}),h.on("sliderStart",function(){clearInterval(g),g=setInterval(function(){k=i.find(".active").index(),j.length==k+1?k=0:k+=1,d(k)},b.transition+b.interval)}),h.on("sliderNext",function(){k=i.find(".active").index(),d(k+1)}),h.on("sliderPrev",function(){k=i.find(".active").index(),d(k-1)})})},pause:function(){a(this).trigger("sliderPause")},start:function(){a(this).trigger("sliderStart")},next:function(){a(this).trigger("sliderNext")},prev:function(){a(this).trigger("sliderPrev")}};a.fn.slider=function(c){return b[c]?b[c].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof c&&c?void a.error("Method "+c+" does not exist on jQuery.tooltip"):b.init.apply(this,arguments)}}(jQuery),function(a){a(document).ready(function(){a(document).on("click.card",".card",function(b){a(this).find("> .card-reveal").length&&(a(b.target).is(a(".card-reveal .card-title"))||a(b.target).is(a(".card-reveal .card-title i"))?a(this).find(".card-reveal").velocity({translateY:0},{duration:225,queue:!1,easing:"easeInOutQuad",complete:function(){a(this).css({display:"none"})}}):(a(b.target).is(a(".card .activator"))||a(b.target).is(a(".card .activator i")))&&(a(b.target).closest(".card").css("overflow","hidden"),a(this).find(".card-reveal").css({display:"block"}).velocity("stop",!1).velocity({translateY:"-100%"},{duration:300,queue:!1,easing:"easeInOutQuad"})))})})}(jQuery),function(a){var b=!1,c={data:[],placeholder:"",secondaryPlaceholder:""};a(document).ready(function(){a(document).on("click",".chip .close",function(b){var c=a(this).closest(".chips");c.attr("data-initialized")||a(this).closest(".chip").remove()})}),a.fn.material_chip=function(d){var e=this;if(this.$el=a(this),this.$document=a(document),this.SELS={CHIPS:".chips",CHIP:".chip",INPUT:"input",DELETE:".material-icons",SELECTED_CHIP:".selected"},"data"===d)return this.$el.data("chips");var f=a.extend({},c,d);this.init=function(){var b=0;e.$el.each(function(){var c=a(this),d=Materialize.guid();f.data&&f.data instanceof Array||(f.data=[]),c.data("chips",f.data),c.attr("data-index",b),c.attr("data-initialized",!0),c.hasClass(e.SELS.CHIPS)||c.addClass("chips"),e.chips(c,d),b++})},this.handleEvents=function(){var b=e.SELS;e.$document.off("click.chips-focus",b.CHIPS).on("click.chips-focus",b.CHIPS,function(c){a(c.target).find(b.INPUT).focus()}),e.$document.off("click.chips-select",b.CHIP).on("click.chips-select",b.CHIP,function(c){a(b.CHIP).removeClass("selected"),a(this).toggleClass("selected")}),e.$document.off("keydown.chips").on("keydown.chips",function(c){if(!a(c.target).is("input, textarea")){var d,f=e.$document.find(b.CHIP+b.SELECTED_CHIP),g=f.closest(b.CHIPS),h=f.siblings(b.CHIP).length;if(f.length)if(8===c.which||46===c.which){c.preventDefault(),d=f.index(),e.deleteChip(d,g);var i=null;h>d+1?i=d:(d===h||d+1===h)&&(i=h-1),0>i&&(i=null),null!==i&&e.selectChip(i,g),h||g.find("input").focus()}else if(37===c.which){if(d=f.index()-1,0>d)return;a(b.CHIP).removeClass("selected"),e.selectChip(d,g)}else if(39===c.which){if(d=f.index()+1,a(b.CHIP).removeClass("selected"),d>h)return void g.find("input").focus();e.selectChip(d,g)}}}),e.$document.off("focusin.chips",b.CHIPS+" "+b.INPUT).on("focusin.chips",b.CHIPS+" "+b.INPUT,function(c){var d=a(c.target).closest(b.CHIPS);d.addClass("focus"),d.siblings("label, .prefix").addClass("active"),a(b.CHIP).removeClass("selected")}),e.$document.off("focusout.chips",b.CHIPS+" "+b.INPUT).on("focusout.chips",b.CHIPS+" "+b.INPUT,function(c){var d=a(c.target).closest(b.CHIPS);d.removeClass("focus"),d.data("chips").length||d.siblings("label").removeClass("active"),d.siblings(".prefix").removeClass("active")}),e.$document.off("keydown.chips-add",b.CHIPS+" "+b.INPUT).on("keydown.chips-add",b.CHIPS+" "+b.INPUT,function(c){var d=a(c.target),f=d.closest(b.CHIPS),g=f.children(b.CHIP).length;return 13===c.which?(c.preventDefault(),e.addChip({tag:d.val()},f),void d.val("")):8!==c.keyCode&&37!==c.keyCode||""!==d.val()||!g?void 0:(e.selectChip(g-1,f),void d.blur())}),e.$document.off("click.chips-delete",b.CHIPS+" "+b.DELETE).on("click.chips-delete",b.CHIPS+" "+b.DELETE,function(c){var d=a(c.target),f=d.closest(b.CHIPS),g=d.closest(b.CHIP);c.stopPropagation(),e.deleteChip(g.index(),f),f.find("input").focus()})},this.chips=function(a,b){var c="";a.data("chips").forEach(function(a){c+=e.renderChip(a)}),c+='<input id="'+b+'" class="input" placeholder="">',a.html(c),e.setPlaceholder(a);var d=a.next("label");d.length&&(d.attr("for",b),a.data("chips").length&&d.addClass("active"))},this.renderChip=function(a){if(a.tag){var b='<div class="chip">'+a.tag;return a.image&&(b+=' <img src="'+a.image+'"> '),b+='<i class="material-icons close">close</i>',b+="</div>"}},this.setPlaceholder=function(a){a.data("chips").length&&f.placeholder?a.find("input").prop("placeholder",f.placeholder):!a.data("chips").length&&f.secondaryPlaceholder&&a.find("input").prop("placeholder",f.secondaryPlaceholder)},this.isValid=function(a,b){for(var c=a.data("chips"),d=!1,e=0;e<c.length;e++)if(c[e].tag===b.tag)return void(d=!0);return""!==b.tag&&!d},this.addChip=function(b,c){if(e.isValid(c,b)){for(var d=e.renderChip(b),f=[],g=c.data("chips"),h=0;h<g.length;h++)f.push(g[h]);f.push(b),c.data("chips",f),a(d).insertBefore(c.find("input")),c.trigger("chip.add",b),e.setPlaceholder(c)}},this.deleteChip=function(a,b){var c=b.data("chips")[a];b.find(".chip").eq(a).remove();for(var d=[],f=b.data("chips"),g=0;g<f.length;g++)g!==a&&d.push(f[g]);b.data("chips",d),b.trigger("chip.delete",c),e.setPlaceholder(b)},this.selectChip=function(a,b){var c=b.find(".chip").eq(a);c&&!1===c.hasClass("selected")&&(c.addClass("selected"),b.trigger("chip.select",b.data("chips")[a]))},this.getChipsElement=function(a,b){return b.eq(a)},this.init(),b||(this.handleEvents(),b=!0)}}(jQuery),function(a){a.fn.pushpin=function(b){var c={top:0,bottom:1/0,offset:0};return"remove"===b?(this.each(function(){(id=a(this).data("pushpin-id"))&&(a(window).off("scroll."+id),a(this).removeData("pushpin-id").removeClass("pin-top pinned pin-bottom").removeAttr("style"))}),!1):(b=a.extend(c,b),$index=0,this.each(function(){function c(a){a.removeClass("pin-top"),a.removeClass("pinned"),a.removeClass("pin-bottom")}function d(d,e){d.each(function(){b.top<=e&&b.bottom>=e&&!a(this).hasClass("pinned")&&(c(a(this)),a(this).css("top",b.offset),a(this).addClass("pinned")),e<b.top&&!a(this).hasClass("pin-top")&&(c(a(this)),a(this).css("top",0),a(this).addClass("pin-top")),e>b.bottom&&!a(this).hasClass("pin-bottom")&&(c(a(this)),a(this).addClass("pin-bottom"),a(this).css("top",b.bottom-g))})}var e=Materialize.guid(),f=a(this),g=a(this).offset().top;a(this).data("pushpin-id",e),d(f,a(window).scrollTop()),a(window).on("scroll."+e,function(){var c=a(window).scrollTop()+b.offset;d(f,c)})}))}}(jQuery),function(a){a(document).ready(function(){a.fn.reverse=[].reverse,a(document).on("mouseenter.fixedActionBtn",".fixed-action-btn:not(.click-to-toggle):not(.toolbar)",function(c){var d=a(this);b(d)}),a(document).on("mouseleave.fixedActionBtn",".fixed-action-btn:not(.click-to-toggle):not(.toolbar)",function(b){var d=a(this);c(d)}),a(document).on("click.fabClickToggle",".fixed-action-btn.click-to-toggle > a",function(d){var e=a(this),f=e.parent();f.hasClass("active")?c(f):b(f)}),a(document).on("click.fabToolbar",".fixed-action-btn.toolbar > a",function(b){var c=a(this),e=c.parent();d(e)})}),a.fn.extend({openFAB:function(){b(a(this))},closeFAB:function(){c(a(this))},openToolbar:function(){d(a(this))},closeToolbar:function(){e(a(this))}});var b=function(b){var c=b;if(c.hasClass("active")===!1){var d,e,f=c.hasClass("horizontal");f===!0?e=40:d=40,c.addClass("active"),c.find("ul .btn-floating").velocity({scaleY:".4",scaleX:".4",translateY:d+"px",translateX:e+"px"},{duration:0});var g=0;c.find("ul .btn-floating").reverse().each(function(){a(this).velocity({opacity:"1",scaleX:"1",scaleY:"1",translateY:"0",translateX:"0"},{duration:80,delay:g}),g+=40})}},c=function(a){var b,c,d=a,e=d.hasClass("horizontal");e===!0?c=40:b=40,d.removeClass("active");d.find("ul .btn-floating").velocity("stop",!0),d.find("ul .btn-floating").velocity({opacity:"0",scaleX:".4",scaleY:".4",translateY:b+"px",translateX:c+"px"},{duration:80})},d=function(b){if("true"!==b.attr("data-open")){var c,d,f,g=window.innerWidth,h=window.innerHeight,i=b[0].getBoundingClientRect(),j=b.find("> a").first(),k=b.find("> ul").first(),l=a('<div class="fab-backdrop"></div>'),m=j.css("background-color");j.append(l),c=i.left-g/2+i.width/2,d=h-i.bottom,f=g/l.width(),b.attr("data-origin-bottom",i.bottom),b.attr("data-origin-left",i.left),b.attr("data-origin-width",i.width),b.addClass("active"),b.attr("data-open",!0),b.css({"text-align":"center",width:"100%",bottom:0,left:0,transform:"translateX("+c+"px)",transition:"none"}),j.css({transform:"translateY("+-d+"px)",transition:"none"}),l.css({"background-color":m}),setTimeout(function(){b.css({transform:"",transition:"transform .2s cubic-bezier(0.550, 0.085, 0.680, 0.530), background-color 0s linear .2s"}),j.css({overflow:"visible",transform:"",transition:"transform .2s"}),setTimeout(function(){b.css({overflow:"hidden","background-color":m}),l.css({transform:"scale("+f+")",transition:"transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)"}),k.find("> li > a").css({opacity:1}),a(window).on("scroll.fabToolbarClose",function(){e(b),a(window).off("scroll.fabToolbarClose"),a(document).off("click.fabToolbarClose")}),a(document).on("click.fabToolbarClose",function(c){a(c.target).closest(k).length||(e(b),a(window).off("scroll.fabToolbarClose"),a(document).off("click.fabToolbarClose"))})},100)},0)}},e=function(a){if("true"===a.attr("data-open")){var b,c,d,e=window.innerWidth,f=window.innerHeight,g=a.attr("data-origin-width"),h=a.attr("data-origin-bottom"),i=a.attr("data-origin-left"),j=a.find("> .btn-floating").first(),k=a.find("> ul").first(),l=a.find(".fab-backdrop"),m=j.css("background-color");b=i-e/2+g/2,c=f-h,d=e/l.width(),a.removeClass("active"),a.attr("data-open",!1),a.css({"background-color":"transparent",transition:"none"}),j.css({transition:"none"}),l.css({transform:"scale(0)","background-color":m}),k.find("> li > a").css({opacity:""}),setTimeout(function(){l.remove(),a.css({"text-align":"",width:"",bottom:"",left:"",overflow:"","background-color":"",transform:"translate3d("+-b+"px,0,0)"}),j.css({overflow:"",transform:"translate3d(0,"+c+"px,0)"}),setTimeout(function(){a.css({transform:"translate3d(0,0,0)",transition:"transform .2s"}),j.css({transform:"translate3d(0,0,0)",transition:"transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)"})},20)},200)}}}(jQuery),function(a){Materialize.fadeInImage=function(b){var c;if("string"==typeof b)c=a(b);else{if("object"!=typeof b)return;c=b}c.css({opacity:0}),a(c).velocity({opacity:1},{duration:650,queue:!1,easing:"easeOutSine"}),a(c).velocity({opacity:1},{duration:1300,queue:!1,easing:"swing",step:function(b,c){c.start=100;var d=b/100,e=150-(100-b)/1.75;100>e&&(e=100),b>=0&&a(this).css({"-webkit-filter":"grayscale("+d+")brightness("+e+"%)",filter:"grayscale("+d+")brightness("+e+"%)"})}})},Materialize.showStaggeredList=function(b){var c;if("string"==typeof b)c=a(b);else{if("object"!=typeof b)return;c=b}var d=0;c.find("li").velocity({translateX:"-100px"},{duration:0}),c.find("li").each(function(){a(this).velocity({opacity:"1",translateX:"0"},{duration:800,delay:d,easing:[60,10]}),d+=120})},a(document).ready(function(){var b=!1,c=!1;a(".dismissable").each(function(){a(this).hammer({prevent_default:!1}).bind("pan",function(d){if("touch"===d.gesture.pointerType){var e=a(this),f=d.gesture.direction,g=d.gesture.deltaX,h=d.gesture.velocityX;e.velocity({translateX:g},{duration:50,queue:!1,easing:"easeOutQuad"}),4===f&&(g>e.innerWidth()/2||-.75>h)&&(b=!0),2===f&&(g<-1*e.innerWidth()/2||h>.75)&&(c=!0)}}).bind("panend",function(d){if(Math.abs(d.gesture.deltaX)<a(this).innerWidth()/2&&(c=!1,b=!1),"touch"===d.gesture.pointerType){var e=a(this);if(b||c){var f;f=b?e.innerWidth():-1*e.innerWidth(),e.velocity({translateX:f},{duration:100,queue:!1,easing:"easeOutQuad",complete:function(){e.css("border","none"),e.velocity({height:0,padding:0},{duration:200,queue:!1,easing:"easeOutQuad",complete:function(){e.remove()}})}})}else e.velocity({translateX:0},{duration:100,queue:!1,easing:"easeOutQuad"});b=!1,c=!1}})})})}(jQuery),function(a){Materialize.scrollFire=function(a){var b=!1;window.addEventListener("scroll",function(){b=!0}),setInterval(function(){if(b){b=!1;for(var c=window.pageYOffset+window.innerHeight,d=0;d<a.length;d++){var e=a[d],f=e.selector,g=e.offset,h=e.callback,i=document.querySelector(f);if(null!==i){var j=i.getBoundingClientRect().top+window.pageYOffset;if(c>j+g&&e.done!==!0){if("function"==typeof h)h.call(this,i);else if("string"==typeof h){var k=new Function(h);k(i)}e.done=!0}}}}},100)}}(jQuery),function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_LOCAL_MODULE_0__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__)):"object"==typeof exports?module.exports=a(require("jquery")):this.Picker=a(jQuery)}(function(a){function b(f,g,i,l){function m(){return b._.node("div",b._.node("div",b._.node("div",b._.node("div",y.component.nodes(t.open),v.box),v.wrap),v.frame),v.holder)}function n(){w.data(g,y).addClass(v.input).attr("tabindex",-1).val(w.data("value")?y.get("select",u.format):f.value),u.editable||w.on("focus."+t.id+" click."+t.id,function(a){a.preventDefault(),y.$root.eq(0).focus()}).on("keydown."+t.id,q),e(f,{haspopup:!0,expanded:!1,readonly:!1,owns:f.id+"_root"})}function o(){y.$root.on({keydown:q,focusin:function(a){y.$root.removeClass(v.focused),a.stopPropagation()},"mousedown click":function(b){var c=b.target;c!=y.$root.children()[0]&&(b.stopPropagation(),"mousedown"!=b.type||a(c).is("input, select, textarea, button, option")||(b.preventDefault(),y.$root.eq(0).focus()))}}).on({focus:function(){w.addClass(v.target)},blur:function(){w.removeClass(v.target)}}).on("focus.toOpen",r).on("click","[data-pick], [data-nav], [data-clear], [data-close]",function(){var b=a(this),c=b.data(),d=b.hasClass(v.navDisabled)||b.hasClass(v.disabled),e=h();e=e&&(e.type||e.href),(d||e&&!a.contains(y.$root[0],e))&&y.$root.eq(0).focus(),!d&&c.nav?y.set("highlight",y.component.item.highlight,{nav:c.nav}):!d&&"pick"in c?y.set("select",c.pick):c.clear?y.clear().close(!0):c.close&&y.close(!0)}),e(y.$root[0],"hidden",!0)}function p(){var b;u.hiddenName===!0?(b=f.name,f.name=""):(b=["string"==typeof u.hiddenPrefix?u.hiddenPrefix:"","string"==typeof u.hiddenSuffix?u.hiddenSuffix:"_submit"],b=b[0]+f.name+b[1]),y._hidden=a('<input type=hidden name="'+b+'"'+(w.data("value")||f.value?' value="'+y.get("select",u.formatSubmit)+'"':"")+">")[0],w.on("change."+t.id,function(){y._hidden.value=f.value?y.get("select",u.formatSubmit):""}),u.container?a(u.container).append(y._hidden):w.after(y._hidden)}function q(a){var b=a.keyCode,c=/^(8|46)$/.test(b);return 27==b?(y.close(),!1):void((32==b||c||!t.open&&y.component.key[b])&&(a.preventDefault(),a.stopPropagation(),c?y.clear().close():y.open()))}function r(a){a.stopPropagation(),"focus"==a.type&&y.$root.addClass(v.focused),y.open()}if(!f)return b;var s=!1,t={id:f.id||"P"+Math.abs(~~(Math.random()*new Date))},u=i?a.extend(!0,{},i.defaults,l):l||{},v=a.extend({},b.klasses(),u.klass),w=a(f),x=function(){return this.start()},y=x.prototype={constructor:x,$node:w,start:function(){return t&&t.start?y:(t.methods={},t.start=!0,t.open=!1,t.type=f.type,f.autofocus=f==h(),f.readOnly=!u.editable,f.id=f.id||t.id,"text"!=f.type&&(f.type="text"),y.component=new i(y,u),y.$root=a(b._.node("div",m(),v.picker,'id="'+f.id+'_root" tabindex="0"')),o(),u.formatSubmit&&p(),n(),u.container?a(u.container).append(y.$root):w.after(y.$root),y.on({start:y.component.onStart,render:y.component.onRender,stop:y.component.onStop,open:y.component.onOpen,close:y.component.onClose,set:y.component.onSet}).on({start:u.onStart,render:u.onRender,stop:u.onStop,open:u.onOpen,close:u.onClose,set:u.onSet}),s=c(y.$root.children()[0]),f.autofocus&&y.open(),y.trigger("start").trigger("render"))},render:function(a){return a?y.$root.html(m()):y.$root.find("."+v.box).html(y.component.nodes(t.open)),y.trigger("render")},stop:function(){return t.start?(y.close(),y._hidden&&y._hidden.parentNode.removeChild(y._hidden),y.$root.remove(),w.removeClass(v.input).removeData(g),setTimeout(function(){w.off("."+t.id)},0),f.type=t.type,f.readOnly=!1,y.trigger("stop"),t.methods={},t.start=!1,y):y},open:function(c){return t.open?y:(w.addClass(v.active),e(f,"expanded",!0),setTimeout(function(){y.$root.addClass(v.opened),e(y.$root[0],"hidden",!1)},0),c!==!1&&(t.open=!0,s&&k.css("overflow","hidden").css("padding-right","+="+d()),y.$root.eq(0).focus(),j.on("click."+t.id+" focusin."+t.id,function(a){var b=a.target;b!=f&&b!=document&&3!=a.which&&y.close(b===y.$root.children()[0])}).on("keydown."+t.id,function(c){var d=c.keyCode,e=y.component.key[d],f=c.target;27==d?y.close(!0):f!=y.$root[0]||!e&&13!=d?a.contains(y.$root[0],f)&&13==d&&(c.preventDefault(),f.click()):(c.preventDefault(),e?b._.trigger(y.component.key.go,y,[b._.trigger(e)]):y.$root.find("."+v.highlighted).hasClass(v.disabled)||y.set("select",y.component.item.highlight).close())})),y.trigger("open"))},close:function(a){return a&&(y.$root.off("focus.toOpen").eq(0).focus(),setTimeout(function(){y.$root.on("focus.toOpen",r)},0)),w.removeClass(v.active),e(f,"expanded",!1),setTimeout(function(){y.$root.removeClass(v.opened+" "+v.focused),e(y.$root[0],"hidden",!0)},0),t.open?(t.open=!1,s&&k.css("overflow","").css("padding-right","-="+d()),j.off("."+t.id),y.trigger("close")):y},clear:function(a){return y.set("clear",null,a)},set:function(b,c,d){var e,f,g=a.isPlainObject(b),h=g?b:{};if(d=g&&a.isPlainObject(c)?c:d||{},b){g||(h[b]=c);for(e in h)f=h[e],e in y.component.item&&(void 0===f&&(f=null),y.component.set(e,f,d)),("select"==e||"clear"==e)&&w.val("clear"==e?"":y.get(e,u.format)).trigger("change");y.render()}return d.muted?y:y.trigger("set",h)},get:function(a,c){if(a=a||"value",null!=t[a])return t[a];if("valueSubmit"==a){if(y._hidden)return y._hidden.value;a="value"}if("value"==a)return f.value;if(a in y.component.item){if("string"==typeof c){var d=y.component.get(a);return d?b._.trigger(y.component.formats.toString,y.component,[c,d]):""}return y.component.get(a)}},on:function(b,c,d){var e,f,g=a.isPlainObject(b),h=g?b:{};if(b){g||(h[b]=c);for(e in h)f=h[e],d&&(e="_"+e),t.methods[e]=t.methods[e]||[],t.methods[e].push(f)}return y},off:function(){var a,b,c=arguments;for(a=0,namesCount=c.length;a<namesCount;a+=1)b=c[a],b in t.methods&&delete t.methods[b];return y},trigger:function(a,c){var d=function(a){var d=t.methods[a];d&&d.map(function(a){b._.trigger(a,y,[c])})};return d("_"+a),d(a),y}};return new x}function c(a){var b,c="position";return a.currentStyle?b=a.currentStyle[c]:window.getComputedStyle&&(b=getComputedStyle(a)[c]),"fixed"==b}function d(){if(k.height()<=i.height())return 0;var b=a('<div style="visibility:hidden;width:100px" />').appendTo("body"),c=b[0].offsetWidth;b.css("overflow","scroll");var d=a('<div style="width:100%" />').appendTo(b),e=d[0].offsetWidth;return b.remove(),c-e}function e(b,c,d){if(a.isPlainObject(c))for(var e in c)f(b,e,c[e]);else f(b,c,d)}function f(a,b,c){a.setAttribute(("role"==b?"":"aria-")+b,c)}function g(b,c){a.isPlainObject(b)||(b={attribute:c}),c="";for(var d in b){var e=("role"==d?"":"aria-")+d,f=b[d];c+=null==f?"":e+'="'+b[d]+'"'}return c}function h(){try{return document.activeElement}catch(a){}}var i=a(window),j=a(document),k=a(document.documentElement);return b.klasses=function(a){return a=a||"picker",{picker:a,opened:a+"--opened",focused:a+"--focused",input:a+"__input",active:a+"__input--active",target:a+"__input--target",holder:a+"__holder",frame:a+"__frame",wrap:a+"__wrap",box:a+"__box"}},b._={group:function(a){for(var c,d="",e=b._.trigger(a.min,a);e<=b._.trigger(a.max,a,[e]);e+=a.i)c=b._.trigger(a.item,a,[e]),d+=b._.node(a.node,c[0],c[1],c[2]);return d},node:function(b,c,d,e){return c?(c=a.isArray(c)?c.join(""):c,d=d?' class="'+d+'"':"",e=e?" "+e:"","<"+b+d+e+">"+c+"</"+b+">"):""},lead:function(a){return(10>a?"0":"")+a},trigger:function(a,b,c){return"function"==typeof a?a.apply(b,c||[]):a},digits:function(a){return/\d/.test(a[1])?2:1},isDate:function(a){return{}.toString.call(a).indexOf("Date")>-1&&this.isInteger(a.getDate())},isInteger:function(a){return{}.toString.call(a).indexOf("Number")>-1&&a%1===0},ariaAttr:g},b.extend=function(c,d){a.fn[c]=function(e,f){var g=this.data(c);return"picker"==e?g:g&&"string"==typeof e?b._.trigger(g[e],g,[f]):this.each(function(){var f=a(this);f.data(c)||new b(this,c,d,e)})},a.fn[c].defaults=d.defaults},b}),function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__WEBPACK_LOCAL_MODULE_0__,__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=a(require("./picker.js"),require("jquery")):a(Picker,jQuery)}(function(a,b){function c(a,b){var c=this,d=a.$node[0],e=d.value,f=a.$node.data("value"),g=f||e,h=f?b.formatSubmit:b.format,i=function(){return d.currentStyle?"rtl"==d.currentStyle.direction:"rtl"==getComputedStyle(a.$root[0]).direction};c.settings=b,c.$node=a.$node,c.queue={min:"measure create",max:"measure create",now:"now create",select:"parse create validate",highlight:"parse navigate create validate",view:"parse create validate viewset",disable:"deactivate",enable:"activate"},c.item={},c.item.clear=null,c.item.disable=(b.disable||[]).slice(0),c.item.enable=-function(a){return a[0]===!0?a.shift():-1}(c.item.disable),c.set("min",b.min).set("max",b.max).set("now"),g?c.set("select",g,{format:h}):c.set("select",null).set("highlight",c.item.now),c.key={40:7,38:-7,39:function(){return i()?-1:1},37:function(){return i()?1:-1},go:function(a){var b=c.item.highlight,d=new Date(b.year,b.month,b.date+a);c.set("highlight",d,{interval:a}),this.render()}},a.on("render",function(){a.$root.find("."+b.klass.selectMonth).on("change",function(){var c=this.value;c&&(a.set("highlight",[a.get("view").year,c,a.get("highlight").date]),a.$root.find("."+b.klass.selectMonth).trigger("focus"))}),a.$root.find("."+b.klass.selectYear).on("change",function(){var c=this.value;c&&(a.set("highlight",[c,a.get("view").month,a.get("highlight").date]),a.$root.find("."+b.klass.selectYear).trigger("focus"))})},1).on("open",function(){var d="";c.disabled(c.get("now"))&&(d=":not(."+b.klass.buttonToday+")"),a.$root.find("button"+d+", select").attr("disabled",!1)},1).on("close",function(){a.$root.find("button, select").attr("disabled",!0)},1)}var d=7,e=6,f=a._;c.prototype.set=function(a,b,c){var d=this,e=d.item;return null===b?("clear"==a&&(a="select"),e[a]=b,d):(e["enable"==a?"disable":"flip"==a?"enable":a]=d.queue[a].split(" ").map(function(e){return b=d[e](a,b,c)}).pop(),"select"==a?d.set("highlight",e.select,c):"highlight"==a?d.set("view",e.highlight,c):a.match(/^(flip|min|max|disable|enable)$/)&&(e.select&&d.disabled(e.select)&&d.set("select",e.select,c),e.highlight&&d.disabled(e.highlight)&&d.set("highlight",e.highlight,c)),d)},c.prototype.get=function(a){return this.item[a]},c.prototype.create=function(a,c,d){var e,g=this;return c=void 0===c?a:c,c==-(1/0)||c==1/0?e=c:b.isPlainObject(c)&&f.isInteger(c.pick)?c=c.obj:b.isArray(c)?(c=new Date(c[0],c[1],c[2]),c=f.isDate(c)?c:g.create().obj):c=f.isInteger(c)||f.isDate(c)?g.normalize(new Date(c),d):g.now(a,c,d),{year:e||c.getFullYear(),month:e||c.getMonth(),date:e||c.getDate(),day:e||c.getDay(),obj:e||c,pick:e||c.getTime()}},c.prototype.createRange=function(a,c){var d=this,e=function(a){return a===!0||b.isArray(a)||f.isDate(a)?d.create(a):a};return f.isInteger(a)||(a=e(a)),f.isInteger(c)||(c=e(c)),f.isInteger(a)&&b.isPlainObject(c)?a=[c.year,c.month,c.date+a]:f.isInteger(c)&&b.isPlainObject(a)&&(c=[a.year,a.month,a.date+c]),{from:e(a),to:e(c)}},c.prototype.withinRange=function(a,b){return a=this.createRange(a.from,a.to),b.pick>=a.from.pick&&b.pick<=a.to.pick},c.prototype.overlapRanges=function(a,b){var c=this;return a=c.createRange(a.from,a.to),b=c.createRange(b.from,b.to),c.withinRange(a,b.from)||c.withinRange(a,b.to)||c.withinRange(b,a.from)||c.withinRange(b,a.to)},c.prototype.now=function(a,b,c){return b=new Date,c&&c.rel&&b.setDate(b.getDate()+c.rel),this.normalize(b,c)},c.prototype.navigate=function(a,c,d){var e,f,g,h,i=b.isArray(c),j=b.isPlainObject(c),k=this.item.view;if(i||j){for(j?(f=c.year,g=c.month,h=c.date):(f=+c[0],g=+c[1],h=+c[2]),d&&d.nav&&k&&k.month!==g&&(f=k.year,g=k.month),e=new Date(f,g+(d&&d.nav?d.nav:0),1),f=e.getFullYear(),g=e.getMonth();new Date(f,g,h).getMonth()!==g;)h-=1;c=[f,g,h]}return c},c.prototype.normalize=function(a){return a.setHours(0,0,0,0),a},c.prototype.measure=function(a,b){var c=this;return b?"string"==typeof b?b=c.parse(a,b):f.isInteger(b)&&(b=c.now(a,b,{rel:b})):b="min"==a?-(1/0):1/0,b},c.prototype.viewset=function(a,b){return this.create([b.year,b.month,1])},c.prototype.validate=function(a,c,d){var e,g,h,i,j=this,k=c,l=d&&d.interval?d.interval:1,m=-1===j.item.enable,n=j.item.min,o=j.item.max,p=m&&j.item.disable.filter(function(a){if(b.isArray(a)){var d=j.create(a).pick;d<c.pick?e=!0:d>c.pick&&(g=!0)}return f.isInteger(a)}).length;if((!d||!d.nav)&&(!m&&j.disabled(c)||m&&j.disabled(c)&&(p||e||g)||!m&&(c.pick<=n.pick||c.pick>=o.pick)))for(m&&!p&&(!g&&l>0||!e&&0>l)&&(l*=-1);j.disabled(c)&&(Math.abs(l)>1&&(c.month<k.month||c.month>k.month)&&(c=k,l=l>0?1:-1),c.pick<=n.pick?(h=!0,l=1,c=j.create([n.year,n.month,n.date+(c.pick===n.pick?0:-1)])):c.pick>=o.pick&&(i=!0,l=-1,c=j.create([o.year,o.month,o.date+(c.pick===o.pick?0:1)])),!h||!i);)c=j.create([c.year,c.month,c.date+l]);return c},c.prototype.disabled=function(a){var c=this,d=c.item.disable.filter(function(d){return f.isInteger(d)?a.day===(c.settings.firstDay?d:d-1)%7:b.isArray(d)||f.isDate(d)?a.pick===c.create(d).pick:b.isPlainObject(d)?c.withinRange(d,a):void 0;
	});return d=d.length&&!d.filter(function(a){return b.isArray(a)&&"inverted"==a[3]||b.isPlainObject(a)&&a.inverted}).length,-1===c.item.enable?!d:d||a.pick<c.item.min.pick||a.pick>c.item.max.pick},c.prototype.parse=function(a,b,c){var d=this,e={};return b&&"string"==typeof b?(c&&c.format||(c=c||{},c.format=d.settings.format),d.formats.toArray(c.format).map(function(a){var c=d.formats[a],g=c?f.trigger(c,d,[b,e]):a.replace(/^!/,"").length;c&&(e[a]=b.substr(0,g)),b=b.substr(g)}),[e.yyyy||e.yy,+(e.mm||e.m)-1,e.dd||e.d]):b},c.prototype.formats=function(){function a(a,b,c){var d=a.match(/\w+/)[0];return c.mm||c.m||(c.m=b.indexOf(d)+1),d.length}function b(a){return a.match(/\w+/)[0].length}return{d:function(a,b){return a?f.digits(a):b.date},dd:function(a,b){return a?2:f.lead(b.date)},ddd:function(a,c){return a?b(a):this.settings.weekdaysShort[c.day]},dddd:function(a,c){return a?b(a):this.settings.weekdaysFull[c.day]},m:function(a,b){return a?f.digits(a):b.month+1},mm:function(a,b){return a?2:f.lead(b.month+1)},mmm:function(b,c){var d=this.settings.monthsShort;return b?a(b,d,c):d[c.month]},mmmm:function(b,c){var d=this.settings.monthsFull;return b?a(b,d,c):d[c.month]},yy:function(a,b){return a?2:(""+b.year).slice(2)},yyyy:function(a,b){return a?4:b.year},toArray:function(a){return a.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g)},toString:function(a,b){var c=this;return c.formats.toArray(a).map(function(a){return f.trigger(c.formats[a],c,[0,b])||a.replace(/^!/,"")}).join("")}}}(),c.prototype.isDateExact=function(a,c){var d=this;return f.isInteger(a)&&f.isInteger(c)||"boolean"==typeof a&&"boolean"==typeof c?a===c:(f.isDate(a)||b.isArray(a))&&(f.isDate(c)||b.isArray(c))?d.create(a).pick===d.create(c).pick:b.isPlainObject(a)&&b.isPlainObject(c)?d.isDateExact(a.from,c.from)&&d.isDateExact(a.to,c.to):!1},c.prototype.isDateOverlap=function(a,c){var d=this,e=d.settings.firstDay?1:0;return f.isInteger(a)&&(f.isDate(c)||b.isArray(c))?(a=a%7+e,a===d.create(c).day+1):f.isInteger(c)&&(f.isDate(a)||b.isArray(a))?(c=c%7+e,c===d.create(a).day+1):b.isPlainObject(a)&&b.isPlainObject(c)?d.overlapRanges(a,c):!1},c.prototype.flipEnable=function(a){var b=this.item;b.enable=a||(-1==b.enable?1:-1)},c.prototype.deactivate=function(a,c){var d=this,e=d.item.disable.slice(0);return"flip"==c?d.flipEnable():c===!1?(d.flipEnable(1),e=[]):c===!0?(d.flipEnable(-1),e=[]):c.map(function(a){for(var c,g=0;g<e.length;g+=1)if(d.isDateExact(a,e[g])){c=!0;break}c||(f.isInteger(a)||f.isDate(a)||b.isArray(a)||b.isPlainObject(a)&&a.from&&a.to)&&e.push(a)}),e},c.prototype.activate=function(a,c){var d=this,e=d.item.disable,g=e.length;return"flip"==c?d.flipEnable():c===!0?(d.flipEnable(1),e=[]):c===!1?(d.flipEnable(-1),e=[]):c.map(function(a){var c,h,i,j;for(i=0;g>i;i+=1){if(h=e[i],d.isDateExact(h,a)){c=e[i]=null,j=!0;break}if(d.isDateOverlap(h,a)){b.isPlainObject(a)?(a.inverted=!0,c=a):b.isArray(a)?(c=a,c[3]||c.push("inverted")):f.isDate(a)&&(c=[a.getFullYear(),a.getMonth(),a.getDate(),"inverted"]);break}}if(c)for(i=0;g>i;i+=1)if(d.isDateExact(e[i],a)){e[i]=null;break}if(j)for(i=0;g>i;i+=1)if(d.isDateOverlap(e[i],a)){e[i]=null;break}c&&e.push(c)}),e.filter(function(a){return null!=a})},c.prototype.nodes=function(a){var b=this,c=b.settings,g=b.item,h=g.now,i=g.select,j=g.highlight,k=g.view,l=g.disable,m=g.min,n=g.max,o=function(a,b){return c.firstDay&&(a.push(a.shift()),b.push(b.shift())),f.node("thead",f.node("tr",f.group({min:0,max:d-1,i:1,node:"th",item:function(d){return[a[d],c.klass.weekdays,'scope=col title="'+b[d]+'"']}})))}((c.showWeekdaysFull?c.weekdaysFull:c.weekdaysLetter).slice(0),c.weekdaysFull.slice(0)),p=function(a){return f.node("div"," ",c.klass["nav"+(a?"Next":"Prev")]+(a&&k.year>=n.year&&k.month>=n.month||!a&&k.year<=m.year&&k.month<=m.month?" "+c.klass.navDisabled:""),"data-nav="+(a||-1)+" "+f.ariaAttr({role:"button",controls:b.$node[0].id+"_table"})+' title="'+(a?c.labelMonthNext:c.labelMonthPrev)+'"')},q=function(d){var e=c.showMonthsShort?c.monthsShort:c.monthsFull;return"short_months"==d&&(e=c.monthsShort),c.selectMonths&&void 0==d?f.node("select",f.group({min:0,max:11,i:1,node:"option",item:function(a){return[e[a],0,"value="+a+(k.month==a?" selected":"")+(k.year==m.year&&a<m.month||k.year==n.year&&a>n.month?" disabled":"")]}}),c.klass.selectMonth+" browser-default",(a?"":"disabled")+" "+f.ariaAttr({controls:b.$node[0].id+"_table"})+' title="'+c.labelMonthSelect+'"'):"short_months"==d?null!=i?f.node("div",e[i.month]):f.node("div",e[k.month]):f.node("div",e[k.month],c.klass.month)},r=function(d){var e=k.year,g=c.selectYears===!0?5:~~(c.selectYears/2);if(g){var h=m.year,i=n.year,j=e-g,l=e+g;if(h>j&&(l+=h-j,j=h),l>i){var o=j-h,p=l-i;j-=o>p?p:o,l=i}if(c.selectYears&&void 0==d)return f.node("select",f.group({min:j,max:l,i:1,node:"option",item:function(a){return[a,0,"value="+a+(e==a?" selected":"")]}}),c.klass.selectYear+" browser-default",(a?"":"disabled")+" "+f.ariaAttr({controls:b.$node[0].id+"_table"})+' title="'+c.labelYearSelect+'"')}return"raw"==d?f.node("div",e):f.node("div",e,c.klass.year)};return createDayLabel=function(){return null!=i?f.node("div",i.date):f.node("div",h.date)},createWeekdayLabel=function(){var a;a=null!=i?i.day:h.day;var b=c.weekdaysFull[a];return b},f.node("div",f.node("div",createWeekdayLabel(),"picker__weekday-display")+f.node("div",q("short_months"),c.klass.month_display)+f.node("div",createDayLabel(),c.klass.day_display)+f.node("div",r("raw"),c.klass.year_display),c.klass.date_display)+f.node("div",f.node("div",(c.selectYears?q()+r():q()+r())+p()+p(1),c.klass.header)+f.node("table",o+f.node("tbody",f.group({min:0,max:e-1,i:1,node:"tr",item:function(a){var e=c.firstDay&&0===b.create([k.year,k.month,1]).day?-7:0;return[f.group({min:d*a-k.day+e+1,max:function(){return this.min+d-1},i:1,node:"td",item:function(a){a=b.create([k.year,k.month,a+(c.firstDay?1:0)]);var d=i&&i.pick==a.pick,e=j&&j.pick==a.pick,g=l&&b.disabled(a)||a.pick<m.pick||a.pick>n.pick,o=f.trigger(b.formats.toString,b,[c.format,a]);return[f.node("div",a.date,function(b){return b.push(k.month==a.month?c.klass.infocus:c.klass.outfocus),h.pick==a.pick&&b.push(c.klass.now),d&&b.push(c.klass.selected),e&&b.push(c.klass.highlighted),g&&b.push(c.klass.disabled),b.join(" ")}([c.klass.day]),"data-pick="+a.pick+" "+f.ariaAttr({role:"gridcell",label:o,selected:d&&b.$node.val()===o?!0:null,activedescendant:e?!0:null,disabled:g?!0:null})),"",f.ariaAttr({role:"presentation"})]}})]}})),c.klass.table,'id="'+b.$node[0].id+'_table" '+f.ariaAttr({role:"grid",controls:b.$node[0].id,readonly:!0})),c.klass.calendar_container)+f.node("div",f.node("button",c.today,"btn-flat picker__today","type=button data-pick="+h.pick+(a&&!b.disabled(h)?"":" disabled")+" "+f.ariaAttr({controls:b.$node[0].id}))+f.node("button",c.clear,"btn-flat picker__clear","type=button data-clear=1"+(a?"":" disabled")+" "+f.ariaAttr({controls:b.$node[0].id}))+f.node("button",c.close,"btn-flat picker__close","type=button data-close=true "+(a?"":" disabled")+" "+f.ariaAttr({controls:b.$node[0].id})),c.klass.footer)},c.defaults=function(a){return{labelMonthNext:"Next month",labelMonthPrev:"Previous month",labelMonthSelect:"Select a month",labelYearSelect:"Select a year",monthsFull:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],weekdaysFull:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],weekdaysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],weekdaysLetter:["S","M","T","W","T","F","S"],today:"Today",clear:"Clear",close:"Close",format:"d mmmm, yyyy",klass:{table:a+"table",header:a+"header",date_display:a+"date-display",day_display:a+"day-display",month_display:a+"month-display",year_display:a+"year-display",calendar_container:a+"calendar-container",navPrev:a+"nav--prev",navNext:a+"nav--next",navDisabled:a+"nav--disabled",month:a+"month",year:a+"year",selectMonth:a+"select--month",selectYear:a+"select--year",weekdays:a+"weekday",day:a+"day",disabled:a+"day--disabled",selected:a+"day--selected",highlighted:a+"day--highlighted",now:a+"day--today",infocus:a+"day--infocus",outfocus:a+"day--outfocus",footer:a+"footer",buttonClear:a+"button--clear",buttonToday:a+"button--today",buttonClose:a+"button--close"}}}(a.klasses().picker+"__"),a.extend("pickadate",c)}),function(a){function b(){var b=+a(this).attr("length"),c=+a(this).val().length,d=b>=c;a(this).parent().find('span[class="character-counter"]').html(c+"/"+b),e(d,a(this))}function c(b){var c=b.parent().find('span[class="character-counter"]');c.length||(c=a("<span/>").addClass("character-counter").css("float","right").css("font-size","12px").css("height",1),b.parent().append(c))}function d(){a(this).parent().find('span[class="character-counter"]').html("")}function e(a,b){var c=b.hasClass("invalid");a&&c?b.removeClass("invalid"):a||c||(b.removeClass("valid"),b.addClass("invalid"))}a.fn.characterCounter=function(){return this.each(function(){var e=a(this),f=e.parent().find('span[class="character-counter"]');if(!f.length){var g=void 0!==e.attr("length");g&&(e.on("input",b),e.on("focus",b),e.on("blur",d),c(e))}})},a(document).ready(function(){a("input, textarea").characterCounter()})}(jQuery),function(a){var b={init:function(b){var c={time_constant:200,dist:-100,shift:0,padding:0,full_width:!1,indicators:!1,no_wrap:!1};return b=a.extend(c,b),this.each(function(){function c(){"undefined"!=typeof window.ontouchstart&&(H[0].addEventListener("touchstart",l),H[0].addEventListener("touchmove",m),H[0].addEventListener("touchend",n)),H[0].addEventListener("mousedown",l),H[0].addEventListener("mousemove",m),H[0].addEventListener("mouseup",n),H[0].addEventListener("mouseleave",n),H[0].addEventListener("click",j)}function d(a){return a.targetTouches&&a.targetTouches.length>=1?a.targetTouches[0].clientX:a.clientX}function e(a){return a.targetTouches&&a.targetTouches.length>=1?a.targetTouches[0].clientY:a.clientY}function f(a){return a>=t?a%t:0>a?f(t+a%t):a}function g(a){var c,d,e,g,h,i,j;if(p="number"==typeof a?a:p,q=Math.floor((p+s/2)/s),e=p-q*s,g=0>e?1:-1,h=-g*e*2/s,d=t>>1,b.full_width?j="translateX(0)":(j="translateX("+(H[0].clientWidth-item_width)/2+"px) ",j+="translateY("+(H[0].clientHeight-item_width)/2+"px)"),I){var k=q%t,l=G.find(".indicator-item.active");l.index()!==k&&(l.removeClass("active"),G.find(".indicator-item").eq(k).addClass("active"))}for((!b.no_wrap||q>=0&&t>q)&&(i=o[f(q)],i.style[A]=j+" translateX("+-e/2+"px) translateX("+g*b.shift*h*c+"px) translateZ("+b.dist*h+"px)",i.style.zIndex=0,b.full_width?tweenedOpacity=1:tweenedOpacity=1-.2*h,i.style.opacity=tweenedOpacity,i.style.display="block"),c=1;d>=c;++c)b.full_width?(zTranslation=b.dist,tweenedOpacity=c===d&&0>e?1-h:1):(zTranslation=b.dist*(2*c+h*g),tweenedOpacity=1-.2*(2*c+h*g)),(!b.no_wrap||t>q+c)&&(i=o[f(q+c)],i.style[A]=j+" translateX("+(b.shift+(s*c-e)/2)+"px) translateZ("+zTranslation+"px)",i.style.zIndex=-c,i.style.opacity=tweenedOpacity,i.style.display="block"),b.full_width?(zTranslation=b.dist,tweenedOpacity=c===d&&e>0?1-h:1):(zTranslation=b.dist*(2*c-h*g),tweenedOpacity=1-.2*(2*c-h*g)),(!b.no_wrap||q-c>=0)&&(i=o[f(q-c)],i.style[A]=j+" translateX("+(-b.shift+(-s*c-e)/2)+"px) translateZ("+zTranslation+"px)",i.style.zIndex=-c,i.style.opacity=tweenedOpacity,i.style.display="block");(!b.no_wrap||q>=0&&t>q)&&(i=o[f(q)],i.style[A]=j+" translateX("+-e/2+"px) translateX("+g*b.shift*h+"px) translateZ("+b.dist*h+"px)",i.style.zIndex=0,b.full_width?tweenedOpacity=1:tweenedOpacity=1-.2*h,i.style.opacity=tweenedOpacity,i.style.display="block")}function h(){var a,b,c,d;a=Date.now(),b=a-C,C=a,c=p-B,B=p,d=1e3*c/(1+b),z=.8*d+.2*z}function i(){var a,c;w&&(a=Date.now()-C,c=w*Math.exp(-a/b.time_constant),c>2||-2>c?(g(x-c),requestAnimationFrame(i)):g(x))}function j(c){if(E)return c.preventDefault(),c.stopPropagation(),!1;if(!b.full_width){var d=a(c.target).closest(".carousel-item").index(),e=q%t-d;0!==e&&(c.preventDefault(),c.stopPropagation()),k(d)}}function k(a){var c=q%t-a;b.no_wrap||(0>c?Math.abs(c+t)<Math.abs(c)&&(c+=t):c>0&&Math.abs(c-t)<c&&(c-=t)),0>c?H.trigger("carouselNext",[Math.abs(c)]):c>0&&H.trigger("carouselPrev",[c])}function l(a){r=!0,E=!1,F=!1,u=d(a),v=e(a),z=w=0,B=p,C=Date.now(),clearInterval(D),D=setInterval(h,100)}function m(a){var b,c,f;if(r)if(b=d(a),y=e(a),c=u-b,f=Math.abs(v-y),30>f&&!F)(c>2||-2>c)&&(E=!0,u=b,g(p+c));else{if(E)return a.preventDefault(),a.stopPropagation(),!1;F=!0}return E?(a.preventDefault(),a.stopPropagation(),!1):void 0}function n(a){return r?(r=!1,clearInterval(D),x=p,(z>10||-10>z)&&(w=.9*z,x=p+w),x=Math.round(x/s)*s,b.no_wrap&&(x>=s*(t-1)?x=s*(t-1):0>x&&(x=0)),w=x-p,C=Date.now(),requestAnimationFrame(i),E&&(a.preventDefault(),a.stopPropagation()),!1):void 0}var o,p,q,r,s,t,u,v,w,x,z,A,B,C,D,E,F,G=a('<ul class="indicators"></ul>'),H=a(this),I=H.attr("data-indicators")||b.indicators;if(H.hasClass("initialized"))return a(this).trigger("carouselNext",[1e-6]),!0;if(b.full_width){b.dist=0;var J=H.find(".carousel-item img").first();J.length?imageHeight=J.on("load",function(){H.css("height",a(this).height())}):(imageHeight=H.find(".carousel-item").first().height(),H.css("height",imageHeight)),I&&H.find(".carousel-fixed-item").addClass("with-indicators")}H.addClass("initialized"),r=!1,p=x=0,o=[],item_width=H.find(".carousel-item").first().innerWidth(),s=2*item_width+b.padding,H.find(".carousel-item").each(function(b){if(o.push(a(this)[0]),I){var c=a('<li class="indicator-item"></li>');0===b&&c.addClass("active"),c.click(function(){var b=a(this).index();k(b)}),G.append(c)}}),I&&H.append(G),t=o.length,A="transform",["webkit","Moz","O","ms"].every(function(a){var b=a+"Transform";return"undefined"!=typeof document.body.style[b]?(A=b,!1):!0}),window.onresize=g,c(),g(p),a(this).on("carouselNext",function(a,b){void 0===b&&(b=1),x=p+s*b,p!==x&&(w=x-p,C=Date.now(),requestAnimationFrame(i))}),a(this).on("carouselPrev",function(a,b){void 0===b&&(b=1),x=p-s*b,p!==x&&(w=x-p,C=Date.now(),requestAnimationFrame(i))}),a(this).on("carouselSet",function(a,b){void 0===b&&(b=0),k(b)})})},next:function(b){a(this).trigger("carouselNext",[b])},prev:function(b){a(this).trigger("carouselPrev",[b])},set:function(b){a(this).trigger("carouselSet",[b])}};a.fn.carousel=function(c){return b[c]?b[c].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof c&&c?void a.error("Method "+c+" does not exist on jQuery.carousel"):b.init.apply(this,arguments)}}(jQuery);

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 3 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	     _ _      _       _
	 ___| (_) ___| | __  (_)___
	/ __| | |/ __| |/ /  | / __|
	\__ \ | | (__|   < _ | \__ \
	|___/_|_|\___|_|\_(_)/ |___/
	                   |__/
	
	 Version: 1.8.1
	  Author: Ken Wheeler
	 Website: http://kenwheeler.github.io
	    Docs: http://kenwheeler.github.io/slick
	    Repo: http://github.com/kenwheeler/slick
	  Issues: http://github.com/kenwheeler/slick/issues
	
	 */
	/* global window, document, define, jQuery, setInterval, clearInterval */
	;(function(factory) {
	    'use strict';
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	
	}(function($) {
	    'use strict';
	    var Slick = window.Slick || {};
	
	    Slick = (function() {
	
	        var instanceUid = 0;
	
	        function Slick(element, settings) {
	
	            var _ = this, dataSettings;
	
	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
	                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function(slider, i) {
	                    return $('<button type="button" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                focusOnChange: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };
	
	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                scrolling: false,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                swiping: false,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };
	
	            $.extend(_, _.initials);
	
	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;
	
	            dataSettings = $(element).data('slick') || {};
	
	            _.options = $.extend({}, _.defaults, settings, dataSettings);
	
	            _.currentSlide = _.options.initialSlide;
	
	            _.originalSettings = _.options;
	
	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }
	
	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);
	
	            _.instanceUid = instanceUid++;
	
	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
	
	
	            _.registerBreakpoints();
	            _.init(true);
	
	        }
	
	        return Slick;
	
	    }());
	
	    Slick.prototype.activateADA = function() {
	        var _ = this;
	
	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });
	
	    };
	
	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || (index >= _.slideCount)) {
	            return false;
	        }
	
	        _.unload();
	
	        if (typeof(index) === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slides.each(function(index, element) {
	            $(element).attr('data-slick-index', index);
	        });
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.animateHeight = function() {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };
	
	    Slick.prototype.animateSlide = function(targetLeft, callback) {
	
	        var animProps = {},
	            _ = this;
	
	        _.animateHeight();
	
	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }
	
	        } else {
	
	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -(_.currentLeft);
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' +
	                                now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' +
	                                now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });
	
	            } else {
	
	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);
	
	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);
	
	                if (callback) {
	                    setTimeout(function() {
	
	                        _.disableTransition();
	
	                        callback.call();
	                    }, _.options.speed);
	                }
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.getNavTarget = function() {
	
	        var _ = this,
	            asNavFor = _.options.asNavFor;
	
	        if ( asNavFor && asNavFor !== null ) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }
	
	        return asNavFor;
	
	    };
	
	    Slick.prototype.asNavFor = function(index) {
	
	        var _ = this,
	            asNavFor = _.getNavTarget();
	
	        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
	            asNavFor.each(function() {
	                var target = $(this).slick('getSlick');
	                if(!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }
	
	    };
	
	    Slick.prototype.applyTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.autoPlay = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        if ( _.slideCount > _.options.slidesToShow ) {
	            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
	        }
	
	    };
	
	    Slick.prototype.autoPlayClear = function() {
	
	        var _ = this;
	
	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	    };
	
	    Slick.prototype.autoPlayIterator = function() {
	
	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;
	
	        if ( !_.paused && !_.interrupted && !_.focussed ) {
	
	            if ( _.options.infinite === false ) {
	
	                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
	                    _.direction = 0;
	                }
	
	                else if ( _.direction === 0 ) {
	
	                    slideTo = _.currentSlide - _.options.slidesToScroll;
	
	                    if ( _.currentSlide - 1 === 0 ) {
	                        _.direction = 1;
	                    }
	
	                }
	
	            }
	
	            _.slideHandler( slideTo );
	
	        }
	
	    };
	
	    Slick.prototype.buildArrows = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true ) {
	
	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
	
	            if( _.slideCount > _.options.slidesToShow ) {
	
	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	
	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }
	
	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }
	
	                if (_.options.infinite !== true) {
	                    _.$prevArrow
	                        .addClass('slick-disabled')
	                        .attr('aria-disabled', 'true');
	                }
	
	            } else {
	
	                _.$prevArrow.add( _.$nextArrow )
	
	                    .addClass('slick-hidden')
	                    .attr({
	                        'aria-disabled': 'true',
	                        'tabindex': '-1'
	                    });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.buildDots = function() {
	
	        var _ = this,
	            i, dot;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$slider.addClass('slick-dotted');
	
	            dot = $('<ul />').addClass(_.options.dotsClass);
	
	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }
	
	            _.$dots = dot.appendTo(_.options.appendDots);
	
	            _.$dots.find('li').first().addClass('slick-active');
	
	        }
	
	    };
	
	    Slick.prototype.buildOut = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slider
	                .children( _.options.slide + ':not(.slick-cloned)')
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        _.$slides.each(function(index, element) {
	            $(element)
	                .attr('data-slick-index', index)
	                .data('originalStyling', $(element).attr('style') || '');
	        });
	
	        _.$slider.addClass('slick-slider');
	
	        _.$slideTrack = (_.slideCount === 0) ?
	            $('<div class="slick-track"/>').appendTo(_.$slider) :
	            _.$slides.wrapAll('<div class="slick-track"/>').parent();
	
	        _.$list = _.$slideTrack.wrap(
	            '<div class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);
	
	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }
	
	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
	
	        _.setupInfinite();
	
	        _.buildArrows();
	
	        _.buildDots();
	
	        _.updateDots();
	
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }
	
	    };
	
	    Slick.prototype.buildRows = function() {
	
	        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;
	
	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();
	
	        if(_.options.rows > 0) {
	
	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(
	                originalSlides.length / slidesPerSection
	            );
	
	            for(a = 0; a < numOfSlides; a++){
	                var slide = document.createElement('div');
	                for(b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for(c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }
	
	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children()
	                .css({
	                    'width':(100 / _.options.slidesPerRow) + '%',
	                    'display': 'inline-block'
	                });
	
	        }
	
	    };
	
	    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
	
	        var _ = this,
	            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();
	
	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }
	
	        if ( _.options.responsive &&
	            _.options.responsive.length &&
	            _.options.responsive !== null) {
	
	            targetBreakpoint = null;
	
	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }
	
	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint =
	                            targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings,
	                                _.breakpointSettings[
	                                    targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings,
	                            _.breakpointSettings[
	                                targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }
	
	            // only trigger breakpoints during an actual break. not on initialize.
	            if( !initial && triggerBreakpoint !== false ) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }
	
	    };
	
	    Slick.prototype.changeSlide = function(event, dontAnimate) {
	
	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset, slideOffset, unevenOffset;
	
	        // If target is a link, prevent default action.
	        if($target.is('a')) {
	            event.preventDefault();
	        }
	
	        // If target is not the <li> element (ie: a child), find the <li>.
	        if(!$target.is('li')) {
	            $target = $target.closest('li');
	        }
	
	        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
	
	        switch (event.data.message) {
	
	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'index':
	                var index = event.data.index === 0 ? 0 :
	                    event.data.index || $target.index() * _.options.slidesToScroll;
	
	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;
	
	            default:
	                return;
	        }
	
	    };
	
	    Slick.prototype.checkNavigable = function(index) {
	
	        var _ = this,
	            navigables, prevNavigable;
	
	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }
	
	        return index;
	    };
	
	    Slick.prototype.cleanUpEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots && _.$dots !== null) {
	
	            $('li', _.$dots)
	                .off('click.slick', _.changeSlide)
	                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	            if (_.options.accessibility === true) {
	                _.$dots.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$slider.off('focus.slick blur.slick');
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
	                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
	
	        _.$list.off('click.slick', _.clickHandler);
	
	        $(document).off(_.visibilityChange, _.visibility);
	
	        _.cleanUpSlideEvents();
	
	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }
	
	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
	
	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
	
	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
	
	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.cleanUpSlideEvents = function() {
	
	        var _ = this;
	
	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	    };
	
	    Slick.prototype.cleanUpRows = function() {
	
	        var _ = this, originalSlides;
	
	        if(_.options.rows > 0) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }
	
	    };
	
	    Slick.prototype.clickHandler = function(event) {
	
	        var _ = this;
	
	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }
	
	    };
	
	    Slick.prototype.destroy = function(refresh) {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        _.touchObject = {};
	
	        _.cleanUpEvents();
	
	        $('.slick-cloned', _.$slider).detach();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if ( _.$prevArrow && _.$prevArrow.length ) {
	
	            _.$prevArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.prevArrow )) {
	                _.$prevArrow.remove();
	            }
	        }
	
	        if ( _.$nextArrow && _.$nextArrow.length ) {
	
	            _.$nextArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.nextArrow )) {
	                _.$nextArrow.remove();
	            }
	        }
	
	
	        if (_.$slides) {
	
	            _.$slides
	                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
	                .removeAttr('aria-hidden')
	                .removeAttr('data-slick-index')
	                .each(function(){
	                    $(this).attr('style', $(this).data('originalStyling'));
	                });
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slideTrack.detach();
	
	            _.$list.detach();
	
	            _.$slider.append(_.$slides);
	        }
	
	        _.cleanUpRows();
	
	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');
	
	        _.unslicked = true;
	
	        if(!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }
	
	    };
	
	    Slick.prototype.disableTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        transition[_.transitionType] = '';
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.fadeSlide = function(slideIndex, callback) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });
	
	            if (callback) {
	                setTimeout(function() {
	
	                    _.disableTransition(slideIndex);
	
	                    callback.call();
	                }, _.options.speed);
	            }
	
	        }
	
	    };
	
	    Slick.prototype.fadeSlideOut = function(slideIndex) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });
	
	        }
	
	    };
	
	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
	
	        var _ = this;
	
	        if (filter !== null) {
	
	            _.$slidesCache = _.$slides;
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.focusHandler = function() {
	
	        var _ = this;
	
	        _.$slider
	            .off('focus.slick blur.slick')
	            .on('focus.slick blur.slick', '*', function(event) {
	
	            event.stopImmediatePropagation();
	            var $sf = $(this);
	
	            setTimeout(function() {
	
	                if( _.options.pauseOnFocus ) {
	                    _.focussed = $sf.is(':focus');
	                    _.autoPlay();
	                }
	
	            }, 0);
	
	        });
	    };
	
	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
	
	        var _ = this;
	        return _.currentSlide;
	
	    };
	
	    Slick.prototype.getDotCount = function() {
	
	        var _ = this;
	
	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;
	
	        if (_.options.infinite === true) {
	            if (_.slideCount <= _.options.slidesToShow) {
	                 ++pagerQty;
	            } else {
	                while (breakPoint < _.slideCount) {
	                    ++pagerQty;
	                    breakPoint = counter + _.options.slidesToScroll;
	                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	                }
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if(!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        }else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }
	
	        return pagerQty - 1;
	
	    };
	
	    Slick.prototype.getLeft = function(slideIndex) {
	
	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide,
	            coef;
	
	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);
	
	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
	                coef = -1
	
	                if (_.options.vertical === true && _.options.centerMode === true) {
	                    if (_.options.slidesToShow === 2) {
	                        coef = -1.5;
	                    } else if (_.options.slidesToShow === 1) {
	                        coef = -2
	                    }
	                }
	                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
	                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
	                    } else {
	                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
	                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
	                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
	            }
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }
	
	        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
	        } else if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }
	
	        if (_.options.vertical === false) {
	            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
	        } else {
	            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
	        }
	
	        if (_.options.variableWidth === true) {
	
	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }
	
	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft =  0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }
	
	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }
	
	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft =  0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }
	
	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }
	
	        return targetLeft;
	
	    };
	
	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
	
	        var _ = this;
	
	        return _.options[option];
	
	    };
	
	    Slick.prototype.getNavigableIndexes = function() {
	
	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;
	
	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }
	
	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }
	
	        return indexes;
	
	    };
	
	    Slick.prototype.getSlick = function() {
	
	        return this;
	
	    };
	
	    Slick.prototype.getSlideCount = function() {
	
	        var _ = this,
	            slidesTraversed, swipedSlide, centerOffset;
	
	        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
	
	        if (_.options.swipeToSlide === true) {
	            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
	                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });
	
	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
	
	            return slidesTraversed;
	
	        } else {
	            return _.options.slidesToScroll;
	        }
	
	    };
	
	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);
	
	    };
	
	    Slick.prototype.init = function(creation) {
	
	        var _ = this;
	
	        if (!$(_.$slider).hasClass('slick-initialized')) {
	
	            $(_.$slider).addClass('slick-initialized');
	
	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();
	
	        }
	
	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }
	
	        if (_.options.accessibility === true) {
	            _.initADA();
	        }
	
	        if ( _.options.autoplay ) {
	
	            _.paused = false;
	            _.autoPlay();
	
	        }
	
	    };
	
	    Slick.prototype.initADA = function() {
	        var _ = this,
	                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
	                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
	                    return (val >= 0) && (val < _.slideCount);
	                });
	
	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });
	
	        if (_.$dots !== null) {
	            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
	                var slideControlIndex = tabControlIndexes.indexOf(i);
	
	                $(this).attr({
	                    'role': 'tabpanel',
	                    'id': 'slick-slide' + _.instanceUid + i,
	                    'tabindex': -1
	                });
	
	                if (slideControlIndex !== -1) {
	                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
	                   if ($('#' + ariaButtonControl).length) {
	                     $(this).attr({
	                         'aria-describedby': ariaButtonControl
	                     });
	                   }
	                }
	            });
	
	            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
	                var mappedSlideIndex = tabControlIndexes[i];
	
	                $(this).attr({
	                    'role': 'presentation'
	                });
	
	                $(this).find('button').first().attr({
	                    'role': 'tab',
	                    'id': 'slick-slide-control' + _.instanceUid + i,
	                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
	                    'aria-label': (i + 1) + ' of ' + numDotGroups,
	                    'aria-selected': null,
	                    'tabindex': '-1'
	                });
	
	            }).eq(_.currentSlide).find('button').attr({
	                'aria-selected': 'true',
	                'tabindex': '0'
	            }).end();
	        }
	
	        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
	          if (_.options.focusOnChange) {
	            _.$slides.eq(i).attr({'tabindex': '0'});
	          } else {
	            _.$slides.eq(i).removeAttr('tabindex');
	          }
	        }
	
	        _.activateADA();
	
	    };
	
	    Slick.prototype.initArrowEvents = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'previous'
	               }, _.changeSlide);
	            _.$nextArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'next'
	               }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow.on('keydown.slick', _.keyHandler);
	                _.$nextArrow.on('keydown.slick', _.keyHandler);
	            }
	        }
	
	    };
	
	    Slick.prototype.initDotEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$dots.on('keydown.slick', _.keyHandler);
	            }
	        }
	
	        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
	
	            $('li', _.$dots)
	                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initSlideEvents = function() {
	
	        var _ = this;
	
	        if ( _.options.pauseOnHover ) {
	
	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initializeEvents = function() {
	
	        var _ = this;
	
	        _.initArrowEvents();
	
	        _.initDotEvents();
	        _.initSlideEvents();
	
	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	
	        _.$list.on('click.slick', _.clickHandler);
	
	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
	
	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
	
	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
	
	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
	
	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(_.setPosition);
	
	    };
	
	    Slick.prototype.initUI = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.show();
	            _.$nextArrow.show();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.show();
	
	        }
	
	    };
	
	    Slick.prototype.keyHandler = function(event) {
	
	        var _ = this;
	         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' :  'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }
	
	    };
	
	    Slick.prototype.lazyLoad = function() {
	
	        var _ = this,
	            loadRange, cloneRange, rangeStart, rangeEnd;
	
	        function loadImages(imagesScope) {
	
	            $('img[data-lazy]', imagesScope).each(function() {
	
	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageSrcSet = $(this).attr('data-srcset'),
	                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
	                    imageToLoad = document.createElement('img');
	
	                imageToLoad.onload = function() {
	
	                    image
	                        .animate({ opacity: 0 }, 100, function() {
	
	                            if (imageSrcSet) {
	                                image
	                                    .attr('srcset', imageSrcSet );
	
	                                if (imageSizes) {
	                                    image
	                                        .attr('sizes', imageSizes );
	                                }
	                            }
	
	                            image
	                                .attr('src', imageSource)
	                                .animate({ opacity: 1 }, 200, function() {
	                                    image
	                                        .removeAttr('data-lazy data-srcset data-sizes')
	                                        .removeClass('slick-loading');
	                                });
	                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                        });
	
	                };
	
	                imageToLoad.onerror = function() {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                };
	
	                imageToLoad.src = imageSource;
	
	            });
	
	        }
	
	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }
	
	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
	
	        if (_.options.lazyLoad === 'anticipated') {
	            var prevSlide = rangeStart - 1,
	                nextSlide = rangeEnd,
	                $slides = _.$slider.find('.slick-slide');
	
	            for (var i = 0; i < _.options.slidesToScroll; i++) {
	                if (prevSlide < 0) prevSlide = _.slideCount - 1;
	                loadRange = loadRange.add($slides.eq(prevSlide));
	                loadRange = loadRange.add($slides.eq(nextSlide));
	                prevSlide--;
	                nextSlide++;
	            }
	        }
	
	        loadImages(loadRange);
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else
	        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }
	
	    };
	
	    Slick.prototype.loadSlider = function() {
	
	        var _ = this;
	
	        _.setPosition();
	
	        _.$slideTrack.css({
	            opacity: 1
	        });
	
	        _.$slider.removeClass('slick-loading');
	
	        _.initUI();
	
	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }
	
	    };
	
	    Slick.prototype.next = Slick.prototype.slickNext = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });
	
	    };
	
	    Slick.prototype.orientationChange = function() {
	
	        var _ = this;
	
	        _.checkResponsive();
	        _.setPosition();
	
	    };
	
	    Slick.prototype.pause = Slick.prototype.slickPause = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	        _.paused = true;
	
	    };
	
	    Slick.prototype.play = Slick.prototype.slickPlay = function() {
	
	        var _ = this;
	
	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;
	
	    };
	
	    Slick.prototype.postSlide = function(index) {
	
	        var _ = this;
	
	        if( !_.unslicked ) {
	
	            _.$slider.trigger('afterChange', [_, index]);
	
	            _.animating = false;
	
	            if (_.slideCount > _.options.slidesToShow) {
	                _.setPosition();
	            }
	
	            _.swipeLeft = null;
	
	            if ( _.options.autoplay ) {
	                _.autoPlay();
	            }
	
	            if (_.options.accessibility === true) {
	                _.initADA();
	
	                if (_.options.focusOnChange) {
	                    var $currentSlide = $(_.$slides.get(_.currentSlide));
	                    $currentSlide.attr('tabindex', 0).focus();
	                }
	            }
	
	        }
	
	    };
	
	    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });
	
	    };
	
	    Slick.prototype.preventDefault = function(event) {
	
	        event.preventDefault();
	
	    };
	
	    Slick.prototype.progressiveLazyLoad = function( tryCount ) {
	
	        tryCount = tryCount || 1;
	
	        var _ = this,
	            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
	            image,
	            imageSource,
	            imageSrcSet,
	            imageSizes,
	            imageToLoad;
	
	        if ( $imgsToLoad.length ) {
	
	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageSrcSet = image.attr('data-srcset');
	            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
	            imageToLoad = document.createElement('img');
	
	            imageToLoad.onload = function() {
	
	                if (imageSrcSet) {
	                    image
	                        .attr('srcset', imageSrcSet );
	
	                    if (imageSizes) {
	                        image
	                            .attr('sizes', imageSizes );
	                    }
	                }
	
	                image
	                    .attr( 'src', imageSource )
	                    .removeAttr('data-lazy data-srcset data-sizes')
	                    .removeClass('slick-loading');
	
	                if ( _.options.adaptiveHeight === true ) {
	                    _.setPosition();
	                }
	
	                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
	                _.progressiveLazyLoad();
	
	            };
	
	            imageToLoad.onerror = function() {
	
	                if ( tryCount < 3 ) {
	
	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout( function() {
	                        _.progressiveLazyLoad( tryCount + 1 );
	                    }, 500 );
	
	                } else {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                    _.progressiveLazyLoad();
	
	                }
	
	            };
	
	            imageToLoad.src = imageSource;
	
	        } else {
	
	            _.$slider.trigger('allImagesLoaded', [ _ ]);
	
	        }
	
	    };
	
	    Slick.prototype.refresh = function( initializing ) {
	
	        var _ = this, currentSlide, lastVisibleIndex;
	
	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
	
	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
	            _.currentSlide = lastVisibleIndex;
	        }
	
	        // if less slides than to show, go to start.
	        if ( _.slideCount <= _.options.slidesToShow ) {
	            _.currentSlide = 0;
	
	        }
	
	        currentSlide = _.currentSlide;
	
	        _.destroy(true);
	
	        $.extend(_, _.initials, { currentSlide: currentSlide });
	
	        _.init();
	
	        if( !initializing ) {
	
	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);
	
	        }
	
	    };
	
	    Slick.prototype.registerBreakpoints = function() {
	
	        var _ = this, breakpoint, currentBreakpoint, l,
	            responsiveSettings = _.options.responsive || null;
	
	        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {
	
	            _.respondTo = _.options.respondTo || 'window';
	
	            for ( breakpoint in responsiveSettings ) {
	
	                l = _.breakpoints.length-1;
	
	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
	
	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while( l >= 0 ) {
	                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
	                            _.breakpoints.splice(l,1);
	                        }
	                        l--;
	                    }
	
	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
	
	                }
	
	            }
	
	            _.breakpoints.sort(function(a, b) {
	                return ( _.options.mobileFirst ) ? a-b : b-a;
	            });
	
	        }
	
	    };
	
	    Slick.prototype.reinit = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slideTrack
	                .children(_.options.slide)
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }
	
	        _.registerBreakpoints();
	
	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();
	
	        _.checkResponsive(false, true);
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        _.setPosition();
	        _.focusHandler();
	
	        _.paused = !_.options.autoplay;
	        _.autoPlay();
	
	        _.$slider.trigger('reInit', [_]);
	
	    };
	
	    Slick.prototype.resize = function() {
	
	        var _ = this;
	
	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function() {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if( !_.unslicked ) { _.setPosition(); }
	            }, 50);
	        }
	    };
	
	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }
	
	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }
	
	        _.unload();
	
	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.setCSS = function(position) {
	
	        var _ = this,
	            positionProps = {},
	            x, y;
	
	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
	
	        positionProps[_.positionProp] = position;
	
	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }
	
	    };
	
	    Slick.prototype.setDimensions = function() {
	
	        var _ = this;
	
	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: ('0px ' + _.options.centerPadding)
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: (_.options.centerPadding + ' 0px')
	                });
	            }
	        }
	
	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();
	
	
	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));
	
	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
	        }
	
	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
	
	    };
	
	    Slick.prototype.setFade = function() {
	
	        var _ = this,
	            targetLeft;
	
	        _.$slides.each(function(index, element) {
	            targetLeft = (_.slideWidth * index) * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });
	
	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });
	
	    };
	
	    Slick.prototype.setHeight = function() {
	
	        var _ = this;
	
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }
	
	    };
	
	    Slick.prototype.setOption =
	    Slick.prototype.slickSetOption = function() {
	
	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */
	
	        var _ = this, l, item, option, value, refresh = false, type;
	
	        if( $.type( arguments[0] ) === 'object' ) {
	
	            option =  arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';
	
	        } else if ( $.type( arguments[0] ) === 'string' ) {
	
	            option =  arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];
	
	            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {
	
	                type = 'responsive';
	
	            } else if ( typeof arguments[1] !== 'undefined' ) {
	
	                type = 'single';
	
	            }
	
	        }
	
	        if ( type === 'single' ) {
	
	            _.options[option] = value;
	
	
	        } else if ( type === 'multiple' ) {
	
	            $.each( option , function( opt, val ) {
	
	                _.options[opt] = val;
	
	            });
	
	
	        } else if ( type === 'responsive' ) {
	
	            for ( item in value ) {
	
	                if( $.type( _.options.responsive ) !== 'array' ) {
	
	                    _.options.responsive = [ value[item] ];
	
	                } else {
	
	                    l = _.options.responsive.length-1;
	
	                    // loop through the responsive object and splice out duplicates.
	                    while( l >= 0 ) {
	
	                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {
	
	                            _.options.responsive.splice(l,1);
	
	                        }
	
	                        l--;
	
	                    }
	
	                    _.options.responsive.push( value[item] );
	
	                }
	
	            }
	
	        }
	
	        if ( refresh ) {
	
	            _.unload();
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.setPosition = function() {
	
	        var _ = this;
	
	        _.setDimensions();
	
	        _.setHeight();
	
	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }
	
	        _.$slider.trigger('setPosition', [_]);
	
	    };
	
	    Slick.prototype.setProps = function() {
	
	        var _ = this,
	            bodyStyle = document.body.style;
	
	        _.positionProp = _.options.vertical === true ? 'top' : 'left';
	
	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }
	
	        if (bodyStyle.WebkitTransition !== undefined ||
	            bodyStyle.MozTransition !== undefined ||
	            bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }
	
	        if ( _.options.fade ) {
	            if ( typeof _.options.zIndex === 'number' ) {
	                if( _.options.zIndex < 3 ) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }
	
	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
	    };
	
	
	    Slick.prototype.setSlideClasses = function(index) {
	
	        var _ = this,
	            centerOffset, allSlides, indexOffset, remainder;
	
	        allSlides = _.$slider
	            .find('.slick-slide')
	            .removeClass('slick-active slick-center slick-current')
	            .attr('aria-hidden', 'true');
	
	        _.$slides
	            .eq(index)
	            .addClass('slick-current');
	
	        if (_.options.centerMode === true) {
	
	            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
	
	            centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	            if (_.options.infinite === true) {
	
	                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
	                    _.$slides
	                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides
	                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	                if (index === 0) {
	
	                    allSlides
	                        .eq(allSlides.length - 1 - _.options.slidesToShow)
	                        .addClass('slick-center');
	
	                } else if (index === _.slideCount - 1) {
	
	                    allSlides
	                        .eq(_.options.slidesToShow)
	                        .addClass('slick-center');
	
	                }
	
	            }
	
	            _.$slides
	                .eq(index)
	                .addClass('slick-center');
	
	        } else {
	
	            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
	
	                _.$slides
	                    .slice(index, index + _.options.slidesToShow)
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else if (allSlides.length <= _.options.slidesToShow) {
	
	                allSlides
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else {
	
	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
	
	                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {
	
	                    allSlides
	                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    allSlides
	                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	            }
	
	        }
	
	        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
	            _.lazyLoad();
	        }
	    };
	
	    Slick.prototype.setupInfinite = function() {
	
	        var _ = this,
	            i, slideIndex, infiniteCount;
	
	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }
	
	        if (_.options.infinite === true && _.options.fade === false) {
	
	            slideIndex = null;
	
	            if (_.slideCount > _.options.slidesToShow) {
	
	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }
	
	                for (i = _.slideCount; i > (_.slideCount -
	                        infiniteCount); i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex - _.slideCount)
	                        .prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex + _.slideCount)
	                        .appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
	                    $(this).attr('id', '');
	                });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.interrupt = function( toggle ) {
	
	        var _ = this;
	
	        if( !toggle ) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;
	
	    };
	
	    Slick.prototype.selectHandler = function(event) {
	
	        var _ = this;
	
	        var targetElement =
	            $(event.target).is('.slick-slide') ?
	                $(event.target) :
	                $(event.target).parents('.slick-slide');
	
	        var index = parseInt(targetElement.attr('data-slick-index'));
	
	        if (!index) index = 0;
	
	        if (_.slideCount <= _.options.slidesToShow) {
	
	            _.slideHandler(index, false, true);
	            return;
	
	        }
	
	        _.slideHandler(index);
	
	    };
	
	    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
	
	        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
	            _ = this, navTarget;
	
	        sync = sync || false;
	
	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }
	
	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }
	
	        if (sync === false) {
	            _.asNavFor(index);
	        }
	
	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);
	
	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
	
	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }
	
	        if ( _.options.autoplay ) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }
	
	        _.animating = true;
	
	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
	
	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;
	
	        _.setSlideClasses(_.currentSlide);
	
	        if ( _.options.asNavFor ) {
	
	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');
	
	            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }
	
	        }
	
	        _.updateDots();
	        _.updateArrows();
	
	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {
	
	                _.fadeSlideOut(oldSlide);
	
	                _.fadeSlide(animSlide, function() {
	                    _.postSlide(animSlide);
	                });
	
	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }
	
	        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	            _.animateSlide(targetLeft, function() {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }
	
	    };
	
	    Slick.prototype.startLoad = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.hide();
	            _.$nextArrow.hide();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.hide();
	
	        }
	
	        _.$slider.addClass('slick-loading');
	
	    };
	
	    Slick.prototype.swipeDirection = function() {
	
	        var xDist, yDist, r, swipeAngle, _ = this;
	
	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);
	
	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }
	
	        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
	            return (_.options.rtl === false ? 'right' : 'left');
	        }
	        if (_.options.verticalSwiping === true) {
	            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }
	
	        return 'vertical';
	
	    };
	
	    Slick.prototype.swipeEnd = function(event) {
	
	        var _ = this,
	            slideCount,
	            direction;
	
	        _.dragging = false;
	        _.swiping = false;
	
	        if (_.scrolling) {
	            _.scrolling = false;
	            return false;
	        }
	
	        _.interrupted = false;
	        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;
	
	        if ( _.touchObject.curX === undefined ) {
	            return false;
	        }
	
	        if ( _.touchObject.edgeHit === true ) {
	            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
	        }
	
	        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {
	
	            direction = _.swipeDirection();
	
	            switch ( direction ) {
	
	                case 'left':
	                case 'down':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
	                            _.currentSlide + _.getSlideCount();
	
	                    _.currentDirection = 0;
	
	                    break;
	
	                case 'right':
	                case 'up':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
	                            _.currentSlide - _.getSlideCount();
	
	                    _.currentDirection = 1;
	
	                    break;
	
	                default:
	
	
	            }
	
	            if( direction != 'vertical' ) {
	
	                _.slideHandler( slideCount );
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction ]);
	
	            }
	
	        } else {
	
	            if ( _.touchObject.startX !== _.touchObject.curX ) {
	
	                _.slideHandler( _.currentSlide );
	                _.touchObject = {};
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.swipeHandler = function(event) {
	
	        var _ = this;
	
	        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }
	
	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
	            event.originalEvent.touches.length : 1;
	
	        _.touchObject.minSwipe = _.listWidth / _.options
	            .touchThreshold;
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options
	                .touchThreshold;
	        }
	
	        switch (event.data.action) {
	
	            case 'start':
	                _.swipeStart(event);
	                break;
	
	            case 'move':
	                _.swipeMove(event);
	                break;
	
	            case 'end':
	                _.swipeEnd(event);
	                break;
	
	        }
	
	    };
	
	    Slick.prototype.swipeMove = function(event) {
	
	        var _ = this,
	            edgeWasHit = false,
	            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
	
	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
	
	        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
	            return false;
	        }
	
	        curLeft = _.getLeft(_.currentSlide);
	
	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
	
	        _.touchObject.swipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
	
	        verticalSwipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
	
	        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
	            _.scrolling = true;
	            return false;
	        }
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = verticalSwipeLength;
	        }
	
	        swipeDirection = _.swipeDirection();
	
	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            _.swiping = true;
	            event.preventDefault();
	        }
	
	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }
	
	
	        swipeLength = _.touchObject.swipeLength;
	
	        _.touchObject.edgeHit = false;
	
	        if (_.options.infinite === false) {
	            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }
	
	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }
	
	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }
	
	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }
	
	        _.setCSS(_.swipeLeft);
	
	    };
	
	    Slick.prototype.swipeStart = function(event) {
	
	        var _ = this,
	            touches;
	
	        _.interrupted = true;
	
	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }
	
	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }
	
	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
	
	        _.dragging = true;
	
	    };
	
	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
	
	        var _ = this;
	
	        if (_.$slidesCache !== null) {
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.unload = function() {
	
	        var _ = this;
	
	        $('.slick-cloned', _.$slider).remove();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }
	
	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }
	
	        _.$slides
	            .removeClass('slick-slide slick-active slick-visible slick-current')
	            .attr('aria-hidden', 'true')
	            .css('width', '');
	
	    };
	
	    Slick.prototype.unslick = function(fromBreakpoint) {
	
	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();
	
	    };
	
	    Slick.prototype.updateArrows = function() {
	
	        var _ = this,
	            centerOffset;
	
	        centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	        if ( _.options.arrows === true &&
	            _.slideCount > _.options.slidesToShow &&
	            !_.options.infinite ) {
	
	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            if (_.currentSlide === 0) {
	
	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.updateDots = function() {
	
	        var _ = this;
	
	        if (_.$dots !== null) {
	
	            _.$dots
	                .find('li')
	                    .removeClass('slick-active')
	                    .end();
	
	            _.$dots
	                .find('li')
	                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
	                .addClass('slick-active');
	
	        }
	
	    };
	
	    Slick.prototype.visibility = function() {
	
	        var _ = this;
	
	        if ( _.options.autoplay ) {
	
	            if ( document[_.hidden] ) {
	
	                _.interrupted = true;
	
	            } else {
	
	                _.interrupted = false;
	
	            }
	
	        }
	
	    };
	
	    $.fn.slick = function() {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if (typeof opt == 'object' || typeof opt == 'undefined')
	                _[i].slick = new Slick(_[i], opt);
	            else
	                ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };
	
	}));


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	/*
	 *
	 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
	 *
	 * Copyright (c) 2012, Matias Meno
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 *
	 */
	
	// The Emitter class provides the ability to call `.on()` on Dropzone to listen
	// to events.
	// It is strongly based on component's emitter class, and I removed the
	// functionality because of the dependency hell with different frameworks.
	var Emitter = function () {
	  function Emitter() {
	    _classCallCheck(this, Emitter);
	  }
	
	  _createClass(Emitter, [{
	    key: "on",
	
	    // Add an event listener for given event
	    value: function on(event, fn) {
	      this._callbacks = this._callbacks || {};
	      // Create namespace for this event
	      if (!this._callbacks[event]) {
	        this._callbacks[event] = [];
	      }
	      this._callbacks[event].push(fn);
	      return this;
	    }
	  }, {
	    key: "emit",
	    value: function emit(event) {
	      this._callbacks = this._callbacks || {};
	      var callbacks = this._callbacks[event];
	
	      if (callbacks) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        for (var _iterator = callbacks, _isArray = true, _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var callback = _ref;
	
	          callback.apply(this, args);
	        }
	      }
	
	      return this;
	    }
	
	    // Remove event listener for given event. If fn is not provided, all event
	    // listeners for that event will be removed. If neither is provided, all
	    // event listeners will be removed.
	
	  }, {
	    key: "off",
	    value: function off(event, fn) {
	      if (!this._callbacks || arguments.length === 0) {
	        this._callbacks = {};
	        return this;
	      }
	
	      // specific event
	      var callbacks = this._callbacks[event];
	      if (!callbacks) {
	        return this;
	      }
	
	      // remove all handlers
	      if (arguments.length === 1) {
	        delete this._callbacks[event];
	        return this;
	      }
	
	      // remove specific handler
	      for (var i = 0; i < callbacks.length; i++) {
	        var callback = callbacks[i];
	        if (callback === fn) {
	          callbacks.splice(i, 1);
	          break;
	        }
	      }
	
	      return this;
	    }
	  }]);
	
	  return Emitter;
	}();
	
	var Dropzone = function (_Emitter) {
	  _inherits(Dropzone, _Emitter);
	
	  _createClass(Dropzone, null, [{
	    key: "initClass",
	    value: function initClass() {
	
	      // Exposing the emitter class, mainly for tests
	      this.prototype.Emitter = Emitter;
	
	      /*
	       This is a list of all available events you can register on a dropzone object.
	        You can register an event handler like this:
	        dropzone.on("dragEnter", function() { });
	        */
	      this.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];
	
	      this.prototype.defaultOptions = {
	        /**
	         * Has to be specified on elements other than form (or when the form
	         * doesn't have an `action` attribute). You can also
	         * provide a function that will be called with `files` and
	         * must return the url (since `v3.12.0`)
	         */
	        url: null,
	
	        /**
	         * Can be changed to `"put"` if necessary. You can also provide a function
	         * that will be called with `files` and must return the method (since `v3.12.0`).
	         */
	        method: "post",
	
	        /**
	         * Will be set on the XHRequest.
	         */
	        withCredentials: false,
	
	        /**
	         * The timeout for the XHR requests in milliseconds (since `v4.4.0`).
	         */
	        timeout: 30000,
	
	        /**
	         * How many file uploads to process in parallel (See the
	         * Enqueuing file uploads* documentation section for more info)
	         */
	        parallelUploads: 2,
	
	        /**
	         * Whether to send multiple files in one request. If
	         * this it set to true, then the fallback file input element will
	         * have the `multiple` attribute as well. This option will
	         * also trigger additional events (like `processingmultiple`). See the events
	         * documentation section for more information.
	         */
	        uploadMultiple: false,
	
	        /**
	         * Whether you want files to be uploaded in chunks to your server. This can't be
	         * used in combination with `uploadMultiple`.
	         *
	         * See [chunksUploaded](#config-chunksUploaded) for the callback to finalise an upload.
	         */
	        chunking: false,
	
	        /**
	         * If `chunking` is enabled, this defines whether **every** file should be chunked,
	         * even if the file size is below chunkSize. This means, that the additional chunk
	         * form data will be submitted and the `chunksUploaded` callback will be invoked.
	         */
	        forceChunking: false,
	
	        /**
	         * If `chunking` is `true`, then this defines the chunk size in bytes.
	         */
	        chunkSize: 2000000,
	
	        /**
	         * If `true`, the individual chunks of a file are being uploaded simultaneously.
	         */
	        parallelChunkUploads: false,
	
	        /**
	         * Whether a chunk should be retried if it fails.
	         */
	        retryChunks: false,
	
	        /**
	         * If `retryChunks` is true, how many times should it be retried.
	         */
	        retryChunksLimit: 3,
	
	        /**
	         * If not `null` defines how many files this Dropzone handles. If it exceeds,
	         * the event `maxfilesexceeded` will be called. The dropzone element gets the
	         * class `dz-max-files-reached` accordingly so you can provide visual feedback.
	         */
	        maxFilesize: 256,
	
	        /**
	         * The name of the file param that gets transferred.
	         * **NOTE**: If you have the option  `uploadMultiple` set to `true`, then
	         * Dropzone will append `[]` to the name.
	         */
	        paramName: "file",
	
	        /**
	         * Whether thumbnails for images should be generated
	         */
	        createImageThumbnails: true,
	
	        /**
	         * In MB. When the filename exceeds this limit, the thumbnail will not be generated.
	         */
	        maxThumbnailFilesize: 10,
	
	        /**
	         * If `null`, the ratio of the image will be used to calculate it.
	         */
	        thumbnailWidth: 120,
	
	        /**
	         * The same as `thumbnailWidth`. If both are null, images will not be resized.
	         */
	        thumbnailHeight: 120,
	
	        /**
	         * How the images should be scaled down in case both, `thumbnailWidth` and `thumbnailHeight` are provided.
	         * Can be either `contain` or `crop`.
	         */
	        thumbnailMethod: 'crop',
	
	        /**
	         * If set, images will be resized to these dimensions before being **uploaded**.
	         * If only one, `resizeWidth` **or** `resizeHeight` is provided, the original aspect
	         * ratio of the file will be preserved.
	         *
	         * The `options.transformFile` function uses these options, so if the `transformFile` function
	         * is overridden, these options don't do anything.
	         */
	        resizeWidth: null,
	
	        /**
	         * See `resizeWidth`.
	         */
	        resizeHeight: null,
	
	        /**
	         * The mime type of the resized image (before it gets uploaded to the server).
	         * If `null` the original mime type will be used. To force jpeg, for example, use `image/jpeg`.
	         * See `resizeWidth` for more information.
	         */
	        resizeMimeType: null,
	
	        /**
	         * The quality of the resized images. See `resizeWidth`.
	         */
	        resizeQuality: 0.8,
	
	        /**
	         * How the images should be scaled down in case both, `resizeWidth` and `resizeHeight` are provided.
	         * Can be either `contain` or `crop`.
	         */
	        resizeMethod: 'contain',
	
	        /**
	         * The base that is used to calculate the filesize. You can change this to
	         * 1024 if you would rather display kibibytes, mebibytes, etc...
	         * 1024 is technically incorrect, because `1024 bytes` are `1 kibibyte` not `1 kilobyte`.
	         * You can change this to `1024` if you don't care about validity.
	         */
	        filesizeBase: 1000,
	
	        /**
	         * Can be used to limit the maximum number of files that will be handled by this Dropzone
	         */
	        maxFiles: null,
	
	        /**
	         * An optional object to send additional headers to the server. Eg:
	         * `{ "My-Awesome-Header": "header value" }`
	         */
	        headers: null,
	
	        /**
	         * If `true`, the dropzone element itself will be clickable, if `false`
	         * nothing will be clickable.
	         *
	         * You can also pass an HTML element, a CSS selector (for multiple elements)
	         * or an array of those. In that case, all of those elements will trigger an
	         * upload when clicked.
	         */
	        clickable: true,
	
	        /**
	         * Whether hidden files in directories should be ignored.
	         */
	        ignoreHiddenFiles: true,
	
	        /**
	         * The default implementation of `accept` checks the file's mime type or
	         * extension against this list. This is a comma separated list of mime
	         * types or file extensions.
	         *
	         * Eg.: `image/*,application/pdf,.psd`
	         *
	         * If the Dropzone is `clickable` this option will also be used as
	         * [`accept`](https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept)
	         * parameter on the hidden file input as well.
	         */
	        acceptedFiles: null,
	
	        /**
	         * **Deprecated!**
	         * Use acceptedFiles instead.
	         */
	        acceptedMimeTypes: null,
	
	        /**
	         * If false, files will be added to the queue but the queue will not be
	         * processed automatically.
	         * This can be useful if you need some additional user input before sending
	         * files (or if you want want all files sent at once).
	         * If you're ready to send the file simply call `myDropzone.processQueue()`.
	         *
	         * See the [enqueuing file uploads](#enqueuing-file-uploads) documentation
	         * section for more information.
	         */
	        autoProcessQueue: true,
	
	        /**
	         * If false, files added to the dropzone will not be queued by default.
	         * You'll have to call `enqueueFile(file)` manually.
	         */
	        autoQueue: true,
	
	        /**
	         * If `true`, this will add a link to every file preview to remove or cancel (if
	         * already uploading) the file. The `dictCancelUpload`, `dictCancelUploadConfirmation`
	         * and `dictRemoveFile` options are used for the wording.
	         */
	        addRemoveLinks: false,
	
	        /**
	         * Defines where to display the file previews – if `null` the
	         * Dropzone element itself is used. Can be a plain `HTMLElement` or a CSS
	         * selector. The element should have the `dropzone-previews` class so
	         * the previews are displayed properly.
	         */
	        previewsContainer: null,
	
	        /**
	         * This is the element the hidden input field (which is used when clicking on the
	         * dropzone to trigger file selection) will be appended to. This might
	         * be important in case you use frameworks to switch the content of your page.
	         */
	        hiddenInputContainer: "body",
	
	        /**
	         * If null, no capture type will be specified
	         * If camera, mobile devices will skip the file selection and choose camera
	         * If microphone, mobile devices will skip the file selection and choose the microphone
	         * If camcorder, mobile devices will skip the file selection and choose the camera in video mode
	         * On apple devices multiple must be set to false.  AcceptedFiles may need to
	         * be set to an appropriate mime type (e.g. "image/*", "audio/*", or "video/*").
	         */
	        capture: null,
	
	        /**
	         * **Deprecated**. Use `renameFile` instead.
	         */
	        renameFilename: null,
	
	        /**
	         * A function that is invoked before the file is uploaded to the server and renames the file.
	         * This function gets the `File` as argument and can use the `file.name`. The actual name of the
	         * file that gets used during the upload can be accessed through `file.upload.filename`.
	         */
	        renameFile: null,
	
	        /**
	         * If `true` the fallback will be forced. This is very useful to test your server
	         * implementations first and make sure that everything works as
	         * expected without dropzone if you experience problems, and to test
	         * how your fallbacks will look.
	         */
	        forceFallback: false,
	
	        /**
	         * The text used before any files are dropped.
	         */
	        dictDefaultMessage: "Drop files here to upload",
	
	        /**
	         * The text that replaces the default message text it the browser is not supported.
	         */
	        dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
	
	        /**
	         * The text that will be added before the fallback form.
	         * If you provide a  fallback element yourself, or if this option is `null` this will
	         * be ignored.
	         */
	        dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
	
	        /**
	         * If the filesize is too big.
	         * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
	         */
	        dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
	
	        /**
	         * If the file doesn't match the file type.
	         */
	        dictInvalidFileType: "You can't upload files of this type.",
	
	        /**
	         * If the server response was invalid.
	         * `{{statusCode}}` will be replaced with the servers status code.
	         */
	        dictResponseError: "Server responded with {{statusCode}} code.",
	
	        /**
	         * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
	         */
	        dictCancelUpload: "Cancel upload",
	
	        /**
	         * The text that is displayed if an upload was manually canceled
	         */
	        dictUploadCanceled: "Upload canceled.",
	
	        /**
	         * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
	         */
	        dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
	
	        /**
	         * If `addRemoveLinks` is true, the text to be used to remove a file.
	         */
	        dictRemoveFile: "Remove file",
	
	        /**
	         * If this is not null, then the user will be prompted before removing a file.
	         */
	        dictRemoveFileConfirmation: null,
	
	        /**
	         * Displayed if `maxFiles` is st and exceeded.
	         * The string `{{maxFiles}}` will be replaced by the configuration value.
	         */
	        dictMaxFilesExceeded: "You can not upload any more files.",
	
	        /**
	         * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
	         * `b` for bytes.
	         */
	        dictFileSizeUnits: { tb: "TB", gb: "GB", mb: "MB", kb: "KB", b: "b" },
	        /**
	         * Called when dropzone initialized
	         * You can add event listeners here
	         */
	        init: function init() {},
	
	        /**
	         * Can be an **object** of additional parameters to transfer to the server, **or** a `Function`
	         * that gets invoked with the `files`, `xhr` and, if it's a chunked upload, `chunk` arguments. In case
	         * of a function, this needs to return a map.
	         *
	         * The default implementation does nothing for normal uploads, but adds relevant information for
	         * chunked uploads.
	         *
	         * This is the same as adding hidden input fields in the form element.
	         */
	        params: function params(files, xhr, chunk) {
	          if (chunk) {
	            return {
	              dzuuid: chunk.file.upload.uuid,
	              dzchunkindex: chunk.index,
	              dztotalfilesize: chunk.file.size,
	              dzchunksize: this.options.chunkSize,
	              dztotalchunkcount: chunk.file.upload.totalChunkCount,
	              dzchunkbyteoffset: chunk.index * this.options.chunkSize
	            };
	          }
	        },
	
	        /**
	         * A function that gets a [file](https://developer.mozilla.org/en-US/docs/DOM/File)
	         * and a `done` function as parameters.
	         *
	         * If the done function is invoked without arguments, the file is "accepted" and will
	         * be processed. If you pass an error message, the file is rejected, and the error
	         * message will be displayed.
	         * This function will not be called if the file is too big or doesn't match the mime types.
	         */
	        accept: function accept(file, done) {
	          return done();
	        },
	
	        /**
	         * The callback that will be invoked when all chunks have been uploaded for a file.
	         * It gets the file for which the chunks have been uploaded as the first parameter,
	         * and the `done` function as second. `done()` needs to be invoked when everything
	         * needed to finish the upload process is done.
	         */
	        chunksUploaded: function chunksUploaded(file, done) {
	          done();
	        },
	
	        /**
	         * Gets called when the browser is not supported.
	         * The default implementation shows the fallback input field and adds
	         * a text.
	         */
	        fallback: function fallback() {
	          // This code should pass in IE7... :(
	          var messageElement = void 0;
	          this.element.className = this.element.className + " dz-browser-not-supported";
	
	          for (var _iterator2 = this.element.getElementsByTagName("div"), _isArray2 = true, _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	            var _ref2;
	
	            if (_isArray2) {
	              if (_i2 >= _iterator2.length) break;
	              _ref2 = _iterator2[_i2++];
	            } else {
	              _i2 = _iterator2.next();
	              if (_i2.done) break;
	              _ref2 = _i2.value;
	            }
	
	            var child = _ref2;
	
	            if (/(^| )dz-message($| )/.test(child.className)) {
	              messageElement = child;
	              child.className = "dz-message"; // Removes the 'dz-default' class
	              break;
	            }
	          }
	          if (!messageElement) {
	            messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
	            this.element.appendChild(messageElement);
	          }
	
	          var span = messageElement.getElementsByTagName("span")[0];
	          if (span) {
	            if (span.textContent != null) {
	              span.textContent = this.options.dictFallbackMessage;
	            } else if (span.innerText != null) {
	              span.innerText = this.options.dictFallbackMessage;
	            }
	          }
	
	          return this.element.appendChild(this.getFallbackForm());
	        },
	
	        /**
	         * Gets called to calculate the thumbnail dimensions.
	         *
	         * It gets `file`, `width` and `height` (both may be `null`) as parameters and must return an object containing:
	         *
	         *  - `srcWidth` & `srcHeight` (required)
	         *  - `trgWidth` & `trgHeight` (required)
	         *  - `srcX` & `srcY` (optional, default `0`)
	         *  - `trgX` & `trgY` (optional, default `0`)
	         *
	         * Those values are going to be used by `ctx.drawImage()`.
	         */
	        resize: function resize(file, width, height, resizeMethod) {
	          var info = {
	            srcX: 0,
	            srcY: 0,
	            srcWidth: file.width,
	            srcHeight: file.height
	          };
	
	          var srcRatio = file.width / file.height;
	
	          // Automatically calculate dimensions if not specified
	          if (width == null && height == null) {
	            width = info.srcWidth;
	            height = info.srcHeight;
	          } else if (width == null) {
	            width = height * srcRatio;
	          } else if (height == null) {
	            height = width / srcRatio;
	          }
	
	          // Make sure images aren't upscaled
	          width = Math.min(width, info.srcWidth);
	          height = Math.min(height, info.srcHeight);
	
	          var trgRatio = width / height;
	
	          if (info.srcWidth > width || info.srcHeight > height) {
	            // Image is bigger and needs rescaling
	            if (resizeMethod === 'crop') {
	              if (srcRatio > trgRatio) {
	                info.srcHeight = file.height;
	                info.srcWidth = info.srcHeight * trgRatio;
	              } else {
	                info.srcWidth = file.width;
	                info.srcHeight = info.srcWidth / trgRatio;
	              }
	            } else if (resizeMethod === 'contain') {
	              // Method 'contain'
	              if (srcRatio > trgRatio) {
	                height = width / srcRatio;
	              } else {
	                width = height * srcRatio;
	              }
	            } else {
	              throw new Error("Unknown resizeMethod '" + resizeMethod + "'");
	            }
	          }
	
	          info.srcX = (file.width - info.srcWidth) / 2;
	          info.srcY = (file.height - info.srcHeight) / 2;
	
	          info.trgWidth = width;
	          info.trgHeight = height;
	
	          return info;
	        },
	
	        /**
	         * Can be used to transform the file (for example, resize an image if necessary).
	         *
	         * The default implementation uses `resizeWidth` and `resizeHeight` (if provided) and resizes
	         * images according to those dimensions.
	         *
	         * Gets the `file` as the first parameter, and a `done()` function as the second, that needs
	         * to be invoked with the file when the transformation is done.
	         */
	        transformFile: function transformFile(file, done) {
	          if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) {
	            return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
	          } else {
	            return done(file);
	          }
	        },
	
	        /**
	         * A string that contains the template used for each dropped
	         * file. Change it to fulfill your needs but make sure to properly
	         * provide all elements.
	         *
	         * If you want to use an actual HTML element instead of providing a String
	         * as a config option, you could create a div with the id `tpl`,
	         * put the template inside it and provide the element like this:
	         *
	         *     document
	         *       .querySelector('#tpl')
	         *       .innerHTML
	         *
	         */
	        previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>",
	
	        // END OPTIONS
	        // (Required by the dropzone documentation parser)
	
	
	        /*
	         Those functions register themselves to the events on init and handle all
	         the user interface specific stuff. Overwriting them won't break the upload
	         but can break the way it's displayed.
	         You can overwrite them if you don't like the default behavior. If you just
	         want to add an additional event handler, register it on the dropzone object
	         and don't overwrite those options.
	         */
	
	        // Those are self explanatory and simply concern the DragnDrop.
	        drop: function drop(e) {
	          return this.element.classList.remove("dz-drag-hover");
	        },
	        dragstart: function dragstart(e) {},
	        dragend: function dragend(e) {
	          return this.element.classList.remove("dz-drag-hover");
	        },
	        dragenter: function dragenter(e) {
	          return this.element.classList.add("dz-drag-hover");
	        },
	        dragover: function dragover(e) {
	          return this.element.classList.add("dz-drag-hover");
	        },
	        dragleave: function dragleave(e) {
	          return this.element.classList.remove("dz-drag-hover");
	        },
	        paste: function paste(e) {},
	
	        // Called whenever there are no files left in the dropzone anymore, and the
	        // dropzone should be displayed as if in the initial state.
	        reset: function reset() {
	          return this.element.classList.remove("dz-started");
	        },
	
	        // Called when a file is added to the queue
	        // Receives `file`
	        addedfile: function addedfile(file) {
	          var _this2 = this;
	
	          if (this.element === this.previewsContainer) {
	            this.element.classList.add("dz-started");
	          }
	
	          if (this.previewsContainer) {
	            file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
	            file.previewTemplate = file.previewElement; // Backwards compatibility
	
	            this.previewsContainer.appendChild(file.previewElement);
	            for (var _iterator3 = file.previewElement.querySelectorAll("[data-dz-name]"), _isArray3 = true, _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	              var _ref3;
	
	              if (_isArray3) {
	                if (_i3 >= _iterator3.length) break;
	                _ref3 = _iterator3[_i3++];
	              } else {
	                _i3 = _iterator3.next();
	                if (_i3.done) break;
	                _ref3 = _i3.value;
	              }
	
	              var node = _ref3;
	
	              node.textContent = file.name;
	            }
	            for (var _iterator4 = file.previewElement.querySelectorAll("[data-dz-size]"), _isArray4 = true, _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	              if (_isArray4) {
	                if (_i4 >= _iterator4.length) break;
	                node = _iterator4[_i4++];
	              } else {
	                _i4 = _iterator4.next();
	                if (_i4.done) break;
	                node = _i4.value;
	              }
	
	              node.innerHTML = this.filesize(file.size);
	            }
	
	            if (this.options.addRemoveLinks) {
	              file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
	              file.previewElement.appendChild(file._removeLink);
	            }
	
	            var removeFileEvent = function removeFileEvent(e) {
	              e.preventDefault();
	              e.stopPropagation();
	              if (file.status === Dropzone.UPLOADING) {
	                return Dropzone.confirm(_this2.options.dictCancelUploadConfirmation, function () {
	                  return _this2.removeFile(file);
	                });
	              } else {
	                if (_this2.options.dictRemoveFileConfirmation) {
	                  return Dropzone.confirm(_this2.options.dictRemoveFileConfirmation, function () {
	                    return _this2.removeFile(file);
	                  });
	                } else {
	                  return _this2.removeFile(file);
	                }
	              }
	            };
	
	            for (var _iterator5 = file.previewElement.querySelectorAll("[data-dz-remove]"), _isArray5 = true, _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
	              var _ref4;
	
	              if (_isArray5) {
	                if (_i5 >= _iterator5.length) break;
	                _ref4 = _iterator5[_i5++];
	              } else {
	                _i5 = _iterator5.next();
	                if (_i5.done) break;
	                _ref4 = _i5.value;
	              }
	
	              var removeLink = _ref4;
	
	              removeLink.addEventListener("click", removeFileEvent);
	            }
	          }
	        },
	
	        // Called whenever a file is removed.
	        removedfile: function removedfile(file) {
	          if (file.previewElement != null && file.previewElement.parentNode != null) {
	            file.previewElement.parentNode.removeChild(file.previewElement);
	          }
	          return this._updateMaxFilesReachedClass();
	        },
	
	        // Called when a thumbnail has been generated
	        // Receives `file` and `dataUrl`
	        thumbnail: function thumbnail(file, dataUrl) {
	          if (file.previewElement) {
	            file.previewElement.classList.remove("dz-file-preview");
	            for (var _iterator6 = file.previewElement.querySelectorAll("[data-dz-thumbnail]"), _isArray6 = true, _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
	              var _ref5;
	
	              if (_isArray6) {
	                if (_i6 >= _iterator6.length) break;
	                _ref5 = _iterator6[_i6++];
	              } else {
	                _i6 = _iterator6.next();
	                if (_i6.done) break;
	                _ref5 = _i6.value;
	              }
	
	              var thumbnailElement = _ref5;
	
	              thumbnailElement.alt = file.name;
	              thumbnailElement.src = dataUrl;
	            }
	
	            return setTimeout(function () {
	              return file.previewElement.classList.add("dz-image-preview");
	            }, 1);
	          }
	        },
	
	        // Called whenever an error occurs
	        // Receives `file` and `message`
	        error: function error(file, message) {
	          if (file.previewElement) {
	            file.previewElement.classList.add("dz-error");
	            if (typeof message !== "String" && message.error) {
	              message = message.error;
	            }
	            for (var _iterator7 = file.previewElement.querySelectorAll("[data-dz-errormessage]"), _isArray7 = true, _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
	              var _ref6;
	
	              if (_isArray7) {
	                if (_i7 >= _iterator7.length) break;
	                _ref6 = _iterator7[_i7++];
	              } else {
	                _i7 = _iterator7.next();
	                if (_i7.done) break;
	                _ref6 = _i7.value;
	              }
	
	              var node = _ref6;
	
	              node.textContent = message;
	            }
	          }
	        },
	        errormultiple: function errormultiple() {},
	
	        // Called when a file gets processed. Since there is a cue, not all added
	        // files are processed immediately.
	        // Receives `file`
	        processing: function processing(file) {
	          if (file.previewElement) {
	            file.previewElement.classList.add("dz-processing");
	            if (file._removeLink) {
	              return file._removeLink.textContent = this.options.dictCancelUpload;
	            }
	          }
	        },
	        processingmultiple: function processingmultiple() {},
	
	        // Called whenever the upload progress gets updated.
	        // Receives `file`, `progress` (percentage 0-100) and `bytesSent`.
	        // To get the total number of bytes of the file, use `file.size`
	        uploadprogress: function uploadprogress(file, progress, bytesSent) {
	          if (file.previewElement) {
	            for (var _iterator8 = file.previewElement.querySelectorAll("[data-dz-uploadprogress]"), _isArray8 = true, _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
	              var _ref7;
	
	              if (_isArray8) {
	                if (_i8 >= _iterator8.length) break;
	                _ref7 = _iterator8[_i8++];
	              } else {
	                _i8 = _iterator8.next();
	                if (_i8.done) break;
	                _ref7 = _i8.value;
	              }
	
	              var node = _ref7;
	
	              node.nodeName === 'PROGRESS' ? node.value = progress : node.style.width = progress + "%";
	            }
	          }
	        },
	
	        // Called whenever the total upload progress gets updated.
	        // Called with totalUploadProgress (0-100), totalBytes and totalBytesSent
	        totaluploadprogress: function totaluploadprogress() {},
	
	        // Called just before the file is sent. Gets the `xhr` object as second
	        // parameter, so you can modify it (for example to add a CSRF token) and a
	        // `formData` object to add additional information.
	        sending: function sending() {},
	        sendingmultiple: function sendingmultiple() {},
	
	        // When the complete upload is finished and successful
	        // Receives `file`
	        success: function success(file) {
	          if (file.previewElement) {
	            return file.previewElement.classList.add("dz-success");
	          }
	        },
	        successmultiple: function successmultiple() {},
	
	        // When the upload is canceled.
	        canceled: function canceled(file) {
	          return this.emit("error", file, this.options.dictUploadCanceled);
	        },
	        canceledmultiple: function canceledmultiple() {},
	
	        // When the upload is finished, either with success or an error.
	        // Receives `file`
	        complete: function complete(file) {
	          if (file._removeLink) {
	            file._removeLink.textContent = this.options.dictRemoveFile;
	          }
	          if (file.previewElement) {
	            return file.previewElement.classList.add("dz-complete");
	          }
	        },
	        completemultiple: function completemultiple() {},
	        maxfilesexceeded: function maxfilesexceeded() {},
	        maxfilesreached: function maxfilesreached() {},
	        queuecomplete: function queuecomplete() {},
	        addedfiles: function addedfiles() {}
	      };
	
	      this.prototype._thumbnailQueue = [];
	      this.prototype._processingThumbnail = false;
	    }
	
	    // global utility
	
	  }, {
	    key: "extend",
	    value: function extend(target) {
	      for (var _len2 = arguments.length, objects = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        objects[_key2 - 1] = arguments[_key2];
	      }
	
	      for (var _iterator9 = objects, _isArray9 = true, _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
	        var _ref8;
	
	        if (_isArray9) {
	          if (_i9 >= _iterator9.length) break;
	          _ref8 = _iterator9[_i9++];
	        } else {
	          _i9 = _iterator9.next();
	          if (_i9.done) break;
	          _ref8 = _i9.value;
	        }
	
	        var object = _ref8;
	
	        for (var key in object) {
	          var val = object[key];
	          target[key] = val;
	        }
	      }
	      return target;
	    }
	  }]);
	
	  function Dropzone(el, options) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this));
	
	    var fallback = void 0,
	        left = void 0;
	    _this.element = el;
	    // For backwards compatibility since the version was in the prototype previously
	    _this.version = Dropzone.version;
	
	    _this.defaultOptions.previewTemplate = _this.defaultOptions.previewTemplate.replace(/\n*/g, "");
	
	    _this.clickableElements = [];
	    _this.listeners = [];
	    _this.files = []; // All files
	
	    if (typeof _this.element === "string") {
	      _this.element = document.querySelector(_this.element);
	    }
	
	    // Not checking if instance of HTMLElement or Element since IE9 is extremely weird.
	    if (!_this.element || _this.element.nodeType == null) {
	      throw new Error("Invalid dropzone element.");
	    }
	
	    if (_this.element.dropzone) {
	      throw new Error("Dropzone already attached.");
	    }
	
	    // Now add this dropzone to the instances.
	    Dropzone.instances.push(_this);
	
	    // Put the dropzone inside the element itself.
	    _this.element.dropzone = _this;
	
	    var elementOptions = (left = Dropzone.optionsForElement(_this.element)) != null ? left : {};
	
	    _this.options = Dropzone.extend({}, _this.defaultOptions, elementOptions, options != null ? options : {});
	
	    // If the browser failed, just call the fallback and leave
	    if (_this.options.forceFallback || !Dropzone.isBrowserSupported()) {
	      var _ret;
	
	      return _ret = _this.options.fallback.call(_this), _possibleConstructorReturn(_this, _ret);
	    }
	
	    // @options.url = @element.getAttribute "action" unless @options.url?
	    if (_this.options.url == null) {
	      _this.options.url = _this.element.getAttribute("action");
	    }
	
	    if (!_this.options.url) {
	      throw new Error("No URL provided.");
	    }
	
	    if (_this.options.acceptedFiles && _this.options.acceptedMimeTypes) {
	      throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
	    }
	
	    if (_this.options.uploadMultiple && _this.options.chunking) {
	      throw new Error('You cannot set both: uploadMultiple and chunking.');
	    }
	
	    // Backwards compatibility
	    if (_this.options.acceptedMimeTypes) {
	      _this.options.acceptedFiles = _this.options.acceptedMimeTypes;
	      delete _this.options.acceptedMimeTypes;
	    }
	
	    // Backwards compatibility
	    if (_this.options.renameFilename != null) {
	      _this.options.renameFile = function (file) {
	        return _this.options.renameFilename.call(_this, file.name, file);
	      };
	    }
	
	    _this.options.method = _this.options.method.toUpperCase();
	
	    if ((fallback = _this.getExistingFallback()) && fallback.parentNode) {
	      // Remove the fallback
	      fallback.parentNode.removeChild(fallback);
	    }
	
	    // Display previews in the previewsContainer element or the Dropzone element unless explicitly set to false
	    if (_this.options.previewsContainer !== false) {
	      if (_this.options.previewsContainer) {
	        _this.previewsContainer = Dropzone.getElement(_this.options.previewsContainer, "previewsContainer");
	      } else {
	        _this.previewsContainer = _this.element;
	      }
	    }
	
	    if (_this.options.clickable) {
	      if (_this.options.clickable === true) {
	        _this.clickableElements = [_this.element];
	      } else {
	        _this.clickableElements = Dropzone.getElements(_this.options.clickable, "clickable");
	      }
	    }
	
	    _this.init();
	    return _this;
	  }
	
	  // Returns all files that have been accepted
	
	
	  _createClass(Dropzone, [{
	    key: "getAcceptedFiles",
	    value: function getAcceptedFiles() {
	      return this.files.filter(function (file) {
	        return file.accepted;
	      }).map(function (file) {
	        return file;
	      });
	    }
	
	    // Returns all files that have been rejected
	    // Not sure when that's going to be useful, but added for completeness.
	
	  }, {
	    key: "getRejectedFiles",
	    value: function getRejectedFiles() {
	      return this.files.filter(function (file) {
	        return !file.accepted;
	      }).map(function (file) {
	        return file;
	      });
	    }
	  }, {
	    key: "getFilesWithStatus",
	    value: function getFilesWithStatus(status) {
	      return this.files.filter(function (file) {
	        return file.status === status;
	      }).map(function (file) {
	        return file;
	      });
	    }
	
	    // Returns all files that are in the queue
	
	  }, {
	    key: "getQueuedFiles",
	    value: function getQueuedFiles() {
	      return this.getFilesWithStatus(Dropzone.QUEUED);
	    }
	  }, {
	    key: "getUploadingFiles",
	    value: function getUploadingFiles() {
	      return this.getFilesWithStatus(Dropzone.UPLOADING);
	    }
	  }, {
	    key: "getAddedFiles",
	    value: function getAddedFiles() {
	      return this.getFilesWithStatus(Dropzone.ADDED);
	    }
	
	    // Files that are either queued or uploading
	
	  }, {
	    key: "getActiveFiles",
	    value: function getActiveFiles() {
	      return this.files.filter(function (file) {
	        return file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED;
	      }).map(function (file) {
	        return file;
	      });
	    }
	
	    // The function that gets called when Dropzone is initialized. You
	    // can (and should) setup event listeners inside this function.
	
	  }, {
	    key: "init",
	    value: function init() {
	      var _this3 = this;
	
	      // In case it isn't set already
	      if (this.element.tagName === "form") {
	        this.element.setAttribute("enctype", "multipart/form-data");
	      }
	
	      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
	        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
	      }
	
	      if (this.clickableElements.length) {
	        var setupHiddenFileInput = function setupHiddenFileInput() {
	          if (_this3.hiddenFileInput) {
	            _this3.hiddenFileInput.parentNode.removeChild(_this3.hiddenFileInput);
	          }
	          _this3.hiddenFileInput = document.createElement("input");
	          _this3.hiddenFileInput.setAttribute("type", "file");
	          if (_this3.options.maxFiles === null || _this3.options.maxFiles > 1) {
	            _this3.hiddenFileInput.setAttribute("multiple", "multiple");
	          }
	          _this3.hiddenFileInput.className = "dz-hidden-input";
	
	          if (_this3.options.acceptedFiles !== null) {
	            _this3.hiddenFileInput.setAttribute("accept", _this3.options.acceptedFiles);
	          }
	          if (_this3.options.capture !== null) {
	            _this3.hiddenFileInput.setAttribute("capture", _this3.options.capture);
	          }
	
	          // Not setting `display="none"` because some browsers don't accept clicks
	          // on elements that aren't displayed.
	          _this3.hiddenFileInput.style.visibility = "hidden";
	          _this3.hiddenFileInput.style.position = "absolute";
	          _this3.hiddenFileInput.style.top = "0";
	          _this3.hiddenFileInput.style.left = "0";
	          _this3.hiddenFileInput.style.height = "0";
	          _this3.hiddenFileInput.style.width = "0";
	          document.querySelector(_this3.options.hiddenInputContainer).appendChild(_this3.hiddenFileInput);
	          return _this3.hiddenFileInput.addEventListener("change", function () {
	            var files = _this3.hiddenFileInput.files;
	
	            if (files.length) {
	              for (var _iterator10 = files, _isArray10 = true, _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
	                var _ref9;
	
	                if (_isArray10) {
	                  if (_i10 >= _iterator10.length) break;
	                  _ref9 = _iterator10[_i10++];
	                } else {
	                  _i10 = _iterator10.next();
	                  if (_i10.done) break;
	                  _ref9 = _i10.value;
	                }
	
	                var file = _ref9;
	
	                _this3.addFile(file);
	              }
	            }
	            _this3.emit("addedfiles", files);
	            return setupHiddenFileInput();
	          });
	        };
	        setupHiddenFileInput();
	      }
	
	      this.URL = window.URL !== null ? window.URL : window.webkitURL;
	
	      // Setup all event listeners on the Dropzone object itself.
	      // They're not in @setupEventListeners() because they shouldn't be removed
	      // again when the dropzone gets disabled.
	      for (var _iterator11 = this.events, _isArray11 = true, _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
	        var _ref10;
	
	        if (_isArray11) {
	          if (_i11 >= _iterator11.length) break;
	          _ref10 = _iterator11[_i11++];
	        } else {
	          _i11 = _iterator11.next();
	          if (_i11.done) break;
	          _ref10 = _i11.value;
	        }
	
	        var eventName = _ref10;
	
	        this.on(eventName, this.options[eventName]);
	      }
	
	      this.on("uploadprogress", function () {
	        return _this3.updateTotalUploadProgress();
	      });
	
	      this.on("removedfile", function () {
	        return _this3.updateTotalUploadProgress();
	      });
	
	      this.on("canceled", function (file) {
	        return _this3.emit("complete", file);
	      });
	
	      // Emit a `queuecomplete` event if all files finished uploading.
	      this.on("complete", function (file) {
	        if (_this3.getAddedFiles().length === 0 && _this3.getUploadingFiles().length === 0 && _this3.getQueuedFiles().length === 0) {
	          // This needs to be deferred so that `queuecomplete` really triggers after `complete`
	          return setTimeout(function () {
	            return _this3.emit("queuecomplete");
	          }, 0);
	        }
	      });
	
	      var noPropagation = function noPropagation(e) {
	        e.stopPropagation();
	        if (e.preventDefault) {
	          return e.preventDefault();
	        } else {
	          return e.returnValue = false;
	        }
	      };
	
	      // Create the listeners
	      this.listeners = [{
	        element: this.element,
	        events: {
	          "dragstart": function dragstart(e) {
	            return _this3.emit("dragstart", e);
	          },
	          "dragenter": function dragenter(e) {
	            noPropagation(e);
	            return _this3.emit("dragenter", e);
	          },
	          "dragover": function dragover(e) {
	            // Makes it possible to drag files from chrome's download bar
	            // http://stackoverflow.com/questions/19526430/drag-and-drop-file-uploads-from-chrome-downloads-bar
	            // Try is required to prevent bug in Internet Explorer 11 (SCRIPT65535 exception)
	            var efct = void 0;
	            try {
	              efct = e.dataTransfer.effectAllowed;
	            } catch (error) {}
	            e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
	
	            noPropagation(e);
	            return _this3.emit("dragover", e);
	          },
	          "dragleave": function dragleave(e) {
	            return _this3.emit("dragleave", e);
	          },
	          "drop": function drop(e) {
	            noPropagation(e);
	            return _this3.drop(e);
	          },
	          "dragend": function dragend(e) {
	            return _this3.emit("dragend", e);
	          }
	
	          // This is disabled right now, because the browsers don't implement it properly.
	          // "paste": (e) =>
	          //   noPropagation e
	          //   @paste e
	        } }];
	
	      this.clickableElements.forEach(function (clickableElement) {
	        return _this3.listeners.push({
	          element: clickableElement,
	          events: {
	            "click": function click(evt) {
	              // Only the actual dropzone or the message element should trigger file selection
	              if (clickableElement !== _this3.element || evt.target === _this3.element || Dropzone.elementInside(evt.target, _this3.element.querySelector(".dz-message"))) {
	                _this3.hiddenFileInput.click(); // Forward the click
	              }
	              return true;
	            }
	          }
	        });
	      });
	
	      this.enable();
	
	      return this.options.init.call(this);
	    }
	
	    // Not fully tested yet
	
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.disable();
	      this.removeAllFiles(true);
	      if (this.hiddenFileInput != null ? this.hiddenFileInput.parentNode : undefined) {
	        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
	        this.hiddenFileInput = null;
	      }
	      delete this.element.dropzone;
	      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
	    }
	  }, {
	    key: "updateTotalUploadProgress",
	    value: function updateTotalUploadProgress() {
	      var totalUploadProgress = void 0;
	      var totalBytesSent = 0;
	      var totalBytes = 0;
	
	      var activeFiles = this.getActiveFiles();
	
	      if (activeFiles.length) {
	        for (var _iterator12 = this.getActiveFiles(), _isArray12 = true, _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
	          var _ref11;
	
	          if (_isArray12) {
	            if (_i12 >= _iterator12.length) break;
	            _ref11 = _iterator12[_i12++];
	          } else {
	            _i12 = _iterator12.next();
	            if (_i12.done) break;
	            _ref11 = _i12.value;
	          }
	
	          var file = _ref11;
	
	          totalBytesSent += file.upload.bytesSent;
	          totalBytes += file.upload.total;
	        }
	        totalUploadProgress = 100 * totalBytesSent / totalBytes;
	      } else {
	        totalUploadProgress = 100;
	      }
	
	      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
	    }
	
	    // @options.paramName can be a function taking one parameter rather than a string.
	    // A parameter name for a file is obtained simply by calling this with an index number.
	
	  }, {
	    key: "_getParamName",
	    value: function _getParamName(n) {
	      if (typeof this.options.paramName === "function") {
	        return this.options.paramName(n);
	      } else {
	        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
	      }
	    }
	
	    // If @options.renameFile is a function,
	    // the function will be used to rename the file.name before appending it to the formData
	
	  }, {
	    key: "_renameFile",
	    value: function _renameFile(file) {
	      if (typeof this.options.renameFile !== "function") {
	        return file.name;
	      }
	      return this.options.renameFile(file);
	    }
	
	    // Returns a form that can be used as fallback if the browser does not support DragnDrop
	    //
	    // If the dropzone is already a form, only the input field and button are returned. Otherwise a complete form element is provided.
	    // This code has to pass in IE7 :(
	
	  }, {
	    key: "getFallbackForm",
	    value: function getFallbackForm() {
	      var existingFallback = void 0,
	          form = void 0;
	      if (existingFallback = this.getExistingFallback()) {
	        return existingFallback;
	      }
	
	      var fieldsString = "<div class=\"dz-fallback\">";
	      if (this.options.dictFallbackText) {
	        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
	      }
	      fieldsString += "<input type=\"file\" name=\"" + this._getParamName(0) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : undefined) + " /><input type=\"submit\" value=\"Upload!\"></div>";
	
	      var fields = Dropzone.createElement(fieldsString);
	      if (this.element.tagName !== "FORM") {
	        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
	        form.appendChild(fields);
	      } else {
	        // Make sure that the enctype and method attributes are set properly
	        this.element.setAttribute("enctype", "multipart/form-data");
	        this.element.setAttribute("method", this.options.method);
	      }
	      return form != null ? form : fields;
	    }
	
	    // Returns the fallback elements if they exist already
	    //
	    // This code has to pass in IE7 :(
	
	  }, {
	    key: "getExistingFallback",
	    value: function getExistingFallback() {
	      var getFallback = function getFallback(elements) {
	        for (var _iterator13 = elements, _isArray13 = true, _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
	          var _ref12;
	
	          if (_isArray13) {
	            if (_i13 >= _iterator13.length) break;
	            _ref12 = _iterator13[_i13++];
	          } else {
	            _i13 = _iterator13.next();
	            if (_i13.done) break;
	            _ref12 = _i13.value;
	          }
	
	          var el = _ref12;
	
	          if (/(^| )fallback($| )/.test(el.className)) {
	            return el;
	          }
	        }
	      };
	
	      var _arr = ["div", "form"];
	      for (var _i14 = 0; _i14 < _arr.length; _i14++) {
	        var tagName = _arr[_i14];
	        var fallback;
	        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
	          return fallback;
	        }
	      }
	    }
	
	    // Activates all listeners stored in @listeners
	
	  }, {
	    key: "setupEventListeners",
	    value: function setupEventListeners() {
	      return this.listeners.map(function (elementListeners) {
	        return function () {
	          var result = [];
	          for (var event in elementListeners.events) {
	            var listener = elementListeners.events[event];
	            result.push(elementListeners.element.addEventListener(event, listener, false));
	          }
	          return result;
	        }();
	      });
	    }
	
	    // Deactivates all listeners stored in @listeners
	
	  }, {
	    key: "removeEventListeners",
	    value: function removeEventListeners() {
	      return this.listeners.map(function (elementListeners) {
	        return function () {
	          var result = [];
	          for (var event in elementListeners.events) {
	            var listener = elementListeners.events[event];
	            result.push(elementListeners.element.removeEventListener(event, listener, false));
	          }
	          return result;
	        }();
	      });
	    }
	
	    // Removes all event listeners and cancels all files in the queue or being processed.
	
	  }, {
	    key: "disable",
	    value: function disable() {
	      var _this4 = this;
	
	      this.clickableElements.forEach(function (element) {
	        return element.classList.remove("dz-clickable");
	      });
	      this.removeEventListeners();
	      this.disabled = true;
	
	      return this.files.map(function (file) {
	        return _this4.cancelUpload(file);
	      });
	    }
	  }, {
	    key: "enable",
	    value: function enable() {
	      delete this.disabled;
	      this.clickableElements.forEach(function (element) {
	        return element.classList.add("dz-clickable");
	      });
	      return this.setupEventListeners();
	    }
	
	    // Returns a nicely formatted filesize
	
	  }, {
	    key: "filesize",
	    value: function filesize(size) {
	      var selectedSize = 0;
	      var selectedUnit = "b";
	
	      if (size > 0) {
	        var units = ['tb', 'gb', 'mb', 'kb', 'b'];
	
	        for (var i = 0; i < units.length; i++) {
	          var unit = units[i];
	          var cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
	
	          if (size >= cutoff) {
	            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
	            selectedUnit = unit;
	            break;
	          }
	        }
	
	        selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
	      }
	
	      return "<strong>" + selectedSize + "</strong> " + this.options.dictFileSizeUnits[selectedUnit];
	    }
	
	    // Adds or removes the `dz-max-files-reached` class from the form.
	
	  }, {
	    key: "_updateMaxFilesReachedClass",
	    value: function _updateMaxFilesReachedClass() {
	      if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
	        if (this.getAcceptedFiles().length === this.options.maxFiles) {
	          this.emit('maxfilesreached', this.files);
	        }
	        return this.element.classList.add("dz-max-files-reached");
	      } else {
	        return this.element.classList.remove("dz-max-files-reached");
	      }
	    }
	  }, {
	    key: "drop",
	    value: function drop(e) {
	      if (!e.dataTransfer) {
	        return;
	      }
	      this.emit("drop", e);
	
	      var files = e.dataTransfer.files;
	
	      this.emit("addedfiles", files);
	
	      // Even if it's a folder, files.length will contain the folders.
	      if (files.length) {
	        var items = e.dataTransfer.items;
	
	        if (items && items.length && items[0].webkitGetAsEntry != null) {
	          // The browser supports dropping of folders, so handle items instead of files
	          this._addFilesFromItems(items);
	        } else {
	          this.handleFiles(files);
	        }
	      }
	    }
	  }, {
	    key: "paste",
	    value: function paste(e) {
	      if (__guard__(e != null ? e.clipboardData : undefined, function (x) {
	        return x.items;
	      }) == null) {
	        return;
	      }
	
	      this.emit("paste", e);
	      var items = e.clipboardData.items;
	
	      if (items.length) {
	        return this._addFilesFromItems(items);
	      }
	    }
	  }, {
	    key: "handleFiles",
	    value: function handleFiles(files) {
	      for (var _iterator14 = files, _isArray14 = true, _i15 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
	        var _ref13;
	
	        if (_isArray14) {
	          if (_i15 >= _iterator14.length) break;
	          _ref13 = _iterator14[_i15++];
	        } else {
	          _i15 = _iterator14.next();
	          if (_i15.done) break;
	          _ref13 = _i15.value;
	        }
	
	        var file = _ref13;
	
	        this.addFile(file);
	      }
	    }
	
	    // When a folder is dropped (or files are pasted), items must be handled
	    // instead of files.
	
	  }, {
	    key: "_addFilesFromItems",
	    value: function _addFilesFromItems(items) {
	      var _this5 = this;
	
	      return function () {
	        var result = [];
	        for (var _iterator15 = items, _isArray15 = true, _i16 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
	          var _ref14;
	
	          if (_isArray15) {
	            if (_i16 >= _iterator15.length) break;
	            _ref14 = _iterator15[_i16++];
	          } else {
	            _i16 = _iterator15.next();
	            if (_i16.done) break;
	            _ref14 = _i16.value;
	          }
	
	          var item = _ref14;
	
	          var entry;
	          if (item.webkitGetAsEntry != null && (entry = item.webkitGetAsEntry())) {
	            if (entry.isFile) {
	              result.push(_this5.addFile(item.getAsFile()));
	            } else if (entry.isDirectory) {
	              // Append all files from that directory to files
	              result.push(_this5._addFilesFromDirectory(entry, entry.name));
	            } else {
	              result.push(undefined);
	            }
	          } else if (item.getAsFile != null) {
	            if (item.kind == null || item.kind === "file") {
	              result.push(_this5.addFile(item.getAsFile()));
	            } else {
	              result.push(undefined);
	            }
	          } else {
	            result.push(undefined);
	          }
	        }
	        return result;
	      }();
	    }
	
	    // Goes through the directory, and adds each file it finds recursively
	
	  }, {
	    key: "_addFilesFromDirectory",
	    value: function _addFilesFromDirectory(directory, path) {
	      var _this6 = this;
	
	      var dirReader = directory.createReader();
	
	      var errorHandler = function errorHandler(error) {
	        return __guardMethod__(console, 'log', function (o) {
	          return o.log(error);
	        });
	      };
	
	      var readEntries = function readEntries() {
	        return dirReader.readEntries(function (entries) {
	          if (entries.length > 0) {
	            for (var _iterator16 = entries, _isArray16 = true, _i17 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
	              var _ref15;
	
	              if (_isArray16) {
	                if (_i17 >= _iterator16.length) break;
	                _ref15 = _iterator16[_i17++];
	              } else {
	                _i17 = _iterator16.next();
	                if (_i17.done) break;
	                _ref15 = _i17.value;
	              }
	
	              var entry = _ref15;
	
	              if (entry.isFile) {
	                entry.file(function (file) {
	                  if (_this6.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
	                    return;
	                  }
	                  file.fullPath = path + "/" + file.name;
	                  return _this6.addFile(file);
	                });
	              } else if (entry.isDirectory) {
	                _this6._addFilesFromDirectory(entry, path + "/" + entry.name);
	              }
	            }
	
	            // Recursively call readEntries() again, since browser only handle
	            // the first 100 entries.
	            // See: https://developer.mozilla.org/en-US/docs/Web/API/DirectoryReader#readEntries
	            readEntries();
	          }
	          return null;
	        }, errorHandler);
	      };
	
	      return readEntries();
	    }
	
	    // If `done()` is called without argument the file is accepted
	    // If you call it with an error message, the file is rejected
	    // (This allows for asynchronous validation)
	    //
	    // This function checks the filesize, and if the file.type passes the
	    // `acceptedFiles` check.
	
	  }, {
	    key: "accept",
	    value: function accept(file, done) {
	      if (file.size > this.options.maxFilesize * 1024 * 1024) {
	        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
	      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
	        return done(this.options.dictInvalidFileType);
	      } else if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
	        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
	        return this.emit("maxfilesexceeded", file);
	      } else {
	        return this.options.accept.call(this, file, done);
	      }
	    }
	  }, {
	    key: "addFile",
	    value: function addFile(file) {
	      var _this7 = this;
	
	      file.upload = {
	        uuid: Dropzone.uuidv4(),
	        progress: 0,
	        // Setting the total upload size to file.size for the beginning
	        // It's actual different than the size to be transmitted.
	        total: file.size,
	        bytesSent: 0,
	        filename: this._renameFile(file),
	        chunked: this.options.chunking && (this.options.forceChunking || file.size > this.options.chunkSize),
	        totalChunkCount: Math.ceil(file.size / this.options.chunkSize)
	      };
	      this.files.push(file);
	
	      file.status = Dropzone.ADDED;
	
	      this.emit("addedfile", file);
	
	      this._enqueueThumbnail(file);
	
	      return this.accept(file, function (error) {
	        if (error) {
	          file.accepted = false;
	          _this7._errorProcessing([file], error); // Will set the file.status
	        } else {
	          file.accepted = true;
	          if (_this7.options.autoQueue) {
	            _this7.enqueueFile(file);
	          } // Will set .accepted = true
	        }
	        return _this7._updateMaxFilesReachedClass();
	      });
	    }
	
	    // Wrapper for enqueueFile
	
	  }, {
	    key: "enqueueFiles",
	    value: function enqueueFiles(files) {
	      for (var _iterator17 = files, _isArray17 = true, _i18 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();;) {
	        var _ref16;
	
	        if (_isArray17) {
	          if (_i18 >= _iterator17.length) break;
	          _ref16 = _iterator17[_i18++];
	        } else {
	          _i18 = _iterator17.next();
	          if (_i18.done) break;
	          _ref16 = _i18.value;
	        }
	
	        var file = _ref16;
	
	        this.enqueueFile(file);
	      }
	      return null;
	    }
	  }, {
	    key: "enqueueFile",
	    value: function enqueueFile(file) {
	      var _this8 = this;
	
	      if (file.status === Dropzone.ADDED && file.accepted === true) {
	        file.status = Dropzone.QUEUED;
	        if (this.options.autoProcessQueue) {
	          return setTimeout(function () {
	            return _this8.processQueue();
	          }, 0); // Deferring the call
	        }
	      } else {
	        throw new Error("This file can't be queued because it has already been processed or was rejected.");
	      }
	    }
	  }, {
	    key: "_enqueueThumbnail",
	    value: function _enqueueThumbnail(file) {
	      var _this9 = this;
	
	      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
	        this._thumbnailQueue.push(file);
	        return setTimeout(function () {
	          return _this9._processThumbnailQueue();
	        }, 0); // Deferring the call
	      }
	    }
	  }, {
	    key: "_processThumbnailQueue",
	    value: function _processThumbnailQueue() {
	      var _this10 = this;
	
	      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
	        return;
	      }
	
	      this._processingThumbnail = true;
	      var file = this._thumbnailQueue.shift();
	      return this.createThumbnail(file, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, true, function (dataUrl) {
	        _this10.emit("thumbnail", file, dataUrl);
	        _this10._processingThumbnail = false;
	        return _this10._processThumbnailQueue();
	      });
	    }
	
	    // Can be called by the user to remove a file
	
	  }, {
	    key: "removeFile",
	    value: function removeFile(file) {
	      if (file.status === Dropzone.UPLOADING) {
	        this.cancelUpload(file);
	      }
	      this.files = without(this.files, file);
	
	      this.emit("removedfile", file);
	      if (this.files.length === 0) {
	        return this.emit("reset");
	      }
	    }
	
	    // Removes all files that aren't currently processed from the list
	
	  }, {
	    key: "removeAllFiles",
	    value: function removeAllFiles(cancelIfNecessary) {
	      // Create a copy of files since removeFile() changes the @files array.
	      if (cancelIfNecessary == null) {
	        cancelIfNecessary = false;
	      }
	      for (var _iterator18 = this.files.slice(), _isArray18 = true, _i19 = 0, _iterator18 = _isArray18 ? _iterator18 : _iterator18[Symbol.iterator]();;) {
	        var _ref17;
	
	        if (_isArray18) {
	          if (_i19 >= _iterator18.length) break;
	          _ref17 = _iterator18[_i19++];
	        } else {
	          _i19 = _iterator18.next();
	          if (_i19.done) break;
	          _ref17 = _i19.value;
	        }
	
	        var file = _ref17;
	
	        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
	          this.removeFile(file);
	        }
	      }
	      return null;
	    }
	
	    // Resizes an image before it gets sent to the server. This function is the default behavior of
	    // `options.transformFile` if `resizeWidth` or `resizeHeight` are set. The callback is invoked with
	    // the resized blob.
	
	  }, {
	    key: "resizeImage",
	    value: function resizeImage(file, width, height, resizeMethod, callback) {
	      var _this11 = this;
	
	      return this.createThumbnail(file, width, height, resizeMethod, false, function (dataUrl, canvas) {
	        if (canvas == null) {
	          // The image has not been resized
	          return callback(file);
	        } else {
	          var resizeMimeType = _this11.options.resizeMimeType;
	
	          if (resizeMimeType == null) {
	            resizeMimeType = file.type;
	          }
	          var resizedDataURL = canvas.toDataURL(resizeMimeType, _this11.options.resizeQuality);
	          if (resizeMimeType === 'image/jpeg' || resizeMimeType === 'image/jpg') {
	            // Now add the original EXIF information
	            resizedDataURL = ExifRestore.restore(file.dataURL, resizedDataURL);
	          }
	          return callback(Dropzone.dataURItoBlob(resizedDataURL));
	        }
	      });
	    }
	  }, {
	    key: "createThumbnail",
	    value: function createThumbnail(file, width, height, resizeMethod, fixOrientation, callback) {
	      var _this12 = this;
	
	      var fileReader = new FileReader();
	
	      fileReader.onload = function () {
	
	        file.dataURL = fileReader.result;
	
	        // Don't bother creating a thumbnail for SVG images since they're vector
	        if (file.type === "image/svg+xml") {
	          if (callback != null) {
	            callback(fileReader.result);
	          }
	          return;
	        }
	
	        return _this12.createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback);
	      };
	
	      return fileReader.readAsDataURL(file);
	    }
	  }, {
	    key: "createThumbnailFromUrl",
	    value: function createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
	      var _this13 = this;
	
	      // Not using `new Image` here because of a bug in latest Chrome versions.
	      // See https://github.com/enyo/dropzone/pull/226
	      var img = document.createElement("img");
	
	      if (crossOrigin) {
	        img.crossOrigin = crossOrigin;
	      }
	
	      img.onload = function () {
	        var loadExif = function loadExif(callback) {
	          return callback(1);
	        };
	        if (typeof EXIF !== 'undefined' && EXIF !== null && fixOrientation) {
	          loadExif = function loadExif(callback) {
	            return EXIF.getData(img, function () {
	              return callback(EXIF.getTag(this, 'Orientation'));
	            });
	          };
	        }
	
	        return loadExif(function (orientation) {
	          file.width = img.width;
	          file.height = img.height;
	
	          var resizeInfo = _this13.options.resize.call(_this13, file, width, height, resizeMethod);
	
	          var canvas = document.createElement("canvas");
	          var ctx = canvas.getContext("2d");
	
	          canvas.width = resizeInfo.trgWidth;
	          canvas.height = resizeInfo.trgHeight;
	
	          if (orientation > 4) {
	            canvas.width = resizeInfo.trgHeight;
	            canvas.height = resizeInfo.trgWidth;
	          }
	
	          switch (orientation) {
	            case 2:
	              // horizontal flip
	              ctx.translate(canvas.width, 0);
	              ctx.scale(-1, 1);
	              break;
	            case 3:
	              // 180° rotate left
	              ctx.translate(canvas.width, canvas.height);
	              ctx.rotate(Math.PI);
	              break;
	            case 4:
	              // vertical flip
	              ctx.translate(0, canvas.height);
	              ctx.scale(1, -1);
	              break;
	            case 5:
	              // vertical flip + 90 rotate right
	              ctx.rotate(0.5 * Math.PI);
	              ctx.scale(1, -1);
	              break;
	            case 6:
	              // 90° rotate right
	              ctx.rotate(0.5 * Math.PI);
	              ctx.translate(0, -canvas.height);
	              break;
	            case 7:
	              // horizontal flip + 90 rotate right
	              ctx.rotate(0.5 * Math.PI);
	              ctx.translate(canvas.width, -canvas.height);
	              ctx.scale(-1, 1);
	              break;
	            case 8:
	              // 90° rotate left
	              ctx.rotate(-0.5 * Math.PI);
	              ctx.translate(-canvas.width, 0);
	              break;
	          }
	
	          // This is a bugfix for iOS' scaling bug.
	          drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
	
	          var thumbnail = canvas.toDataURL("image/png");
	
	          if (callback != null) {
	            return callback(thumbnail, canvas);
	          }
	        });
	      };
	
	      if (callback != null) {
	        img.onerror = callback;
	      }
	
	      return img.src = file.dataURL;
	    }
	
	    // Goes through the queue and processes files if there aren't too many already.
	
	  }, {
	    key: "processQueue",
	    value: function processQueue() {
	      var parallelUploads = this.options.parallelUploads;
	
	      var processingLength = this.getUploadingFiles().length;
	      var i = processingLength;
	
	      // There are already at least as many files uploading than should be
	      if (processingLength >= parallelUploads) {
	        return;
	      }
	
	      var queuedFiles = this.getQueuedFiles();
	
	      if (!(queuedFiles.length > 0)) {
	        return;
	      }
	
	      if (this.options.uploadMultiple) {
	        // The files should be uploaded in one request
	        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
	      } else {
	        while (i < parallelUploads) {
	          if (!queuedFiles.length) {
	            return;
	          } // Nothing left to process
	          this.processFile(queuedFiles.shift());
	          i++;
	        }
	      }
	    }
	
	    // Wrapper for `processFiles`
	
	  }, {
	    key: "processFile",
	    value: function processFile(file) {
	      return this.processFiles([file]);
	    }
	
	    // Loads the file, then calls finishedLoading()
	
	  }, {
	    key: "processFiles",
	    value: function processFiles(files) {
	      for (var _iterator19 = files, _isArray19 = true, _i20 = 0, _iterator19 = _isArray19 ? _iterator19 : _iterator19[Symbol.iterator]();;) {
	        var _ref18;
	
	        if (_isArray19) {
	          if (_i20 >= _iterator19.length) break;
	          _ref18 = _iterator19[_i20++];
	        } else {
	          _i20 = _iterator19.next();
	          if (_i20.done) break;
	          _ref18 = _i20.value;
	        }
	
	        var file = _ref18;
	
	        file.processing = true; // Backwards compatibility
	        file.status = Dropzone.UPLOADING;
	
	        this.emit("processing", file);
	      }
	
	      if (this.options.uploadMultiple) {
	        this.emit("processingmultiple", files);
	      }
	
	      return this.uploadFiles(files);
	    }
	  }, {
	    key: "_getFilesWithXhr",
	    value: function _getFilesWithXhr(xhr) {
	      var files = void 0;
	      return files = this.files.filter(function (file) {
	        return file.xhr === xhr;
	      }).map(function (file) {
	        return file;
	      });
	    }
	
	    // Cancels the file upload and sets the status to CANCELED
	    // **if** the file is actually being uploaded.
	    // If it's still in the queue, the file is being removed from it and the status
	    // set to CANCELED.
	
	  }, {
	    key: "cancelUpload",
	    value: function cancelUpload(file) {
	      if (file.status === Dropzone.UPLOADING) {
	        var groupedFiles = this._getFilesWithXhr(file.xhr);
	        for (var _iterator20 = groupedFiles, _isArray20 = true, _i21 = 0, _iterator20 = _isArray20 ? _iterator20 : _iterator20[Symbol.iterator]();;) {
	          var _ref19;
	
	          if (_isArray20) {
	            if (_i21 >= _iterator20.length) break;
	            _ref19 = _iterator20[_i21++];
	          } else {
	            _i21 = _iterator20.next();
	            if (_i21.done) break;
	            _ref19 = _i21.value;
	          }
	
	          var groupedFile = _ref19;
	
	          groupedFile.status = Dropzone.CANCELED;
	        }
	        if (typeof file.xhr !== 'undefined') {
	          file.xhr.abort();
	        }
	        for (var _iterator21 = groupedFiles, _isArray21 = true, _i22 = 0, _iterator21 = _isArray21 ? _iterator21 : _iterator21[Symbol.iterator]();;) {
	          var _ref20;
	
	          if (_isArray21) {
	            if (_i22 >= _iterator21.length) break;
	            _ref20 = _iterator21[_i22++];
	          } else {
	            _i22 = _iterator21.next();
	            if (_i22.done) break;
	            _ref20 = _i22.value;
	          }
	
	          var _groupedFile = _ref20;
	
	          this.emit("canceled", _groupedFile);
	        }
	        if (this.options.uploadMultiple) {
	          this.emit("canceledmultiple", groupedFiles);
	        }
	      } else if (file.status === Dropzone.ADDED || file.status === Dropzone.QUEUED) {
	        file.status = Dropzone.CANCELED;
	        this.emit("canceled", file);
	        if (this.options.uploadMultiple) {
	          this.emit("canceledmultiple", [file]);
	        }
	      }
	
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    }
	  }, {
	    key: "resolveOption",
	    value: function resolveOption(option) {
	      if (typeof option === 'function') {
	        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	          args[_key3 - 1] = arguments[_key3];
	        }
	
	        return option.apply(this, args);
	      }
	      return option;
	    }
	  }, {
	    key: "uploadFile",
	    value: function uploadFile(file) {
	      return this.uploadFiles([file]);
	    }
	  }, {
	    key: "uploadFiles",
	    value: function uploadFiles(files) {
	      var _this14 = this;
	
	      this._transformFiles(files, function (transformedFiles) {
	        if (files[0].upload.chunked) {
	          // This file should be sent in chunks!
	
	          // If the chunking option is set, we **know** that there can only be **one** file, since
	          // uploadMultiple is not allowed with this option.
	          var file = files[0];
	          var transformedFile = transformedFiles[0];
	          var startedChunkCount = 0;
	
	          file.upload.chunks = [];
	
	          var handleNextChunk = function handleNextChunk() {
	            var chunkIndex = 0;
	
	            // Find the next item in file.upload.chunks that is not defined yet.
	            while (file.upload.chunks[chunkIndex] !== undefined) {
	              chunkIndex++;
	            }
	
	            // This means, that all chunks have already been started.
	            if (chunkIndex >= file.upload.totalChunkCount) return;
	
	            startedChunkCount++;
	
	            var start = chunkIndex * _this14.options.chunkSize;
	            var end = Math.min(start + _this14.options.chunkSize, file.size);
	
	            var dataBlock = {
	              name: _this14._getParamName(0),
	              data: transformedFile.webkitSlice ? transformedFile.webkitSlice(start, end) : transformedFile.slice(start, end),
	              filename: file.upload.filename,
	              chunkIndex: chunkIndex
	            };
	
	            file.upload.chunks[chunkIndex] = {
	              file: file,
	              index: chunkIndex,
	              dataBlock: dataBlock, // In case we want to retry.
	              status: Dropzone.UPLOADING,
	              progress: 0,
	              retries: 0 // The number of times this block has been retried.
	            };
	
	            _this14._uploadData(files, [dataBlock]);
	          };
	
	          file.upload.finishedChunkUpload = function (chunk) {
	            var allFinished = true;
	            chunk.status = Dropzone.SUCCESS;
	
	            // Clear the data from the chunk
	            chunk.dataBlock = null;
	
	            for (var i = 0; i < file.upload.totalChunkCount; i++) {
	              if (file.upload.chunks[i] === undefined) {
	                return handleNextChunk();
	              }
	              if (file.upload.chunks[i].status !== Dropzone.SUCCESS) {
	                allFinished = false;
	              }
	            }
	
	            if (allFinished) {
	              _this14.options.chunksUploaded(file, function () {
	                _this14._finished(files, '', null);
	              });
	            }
	          };
	
	          if (_this14.options.parallelChunkUploads) {
	            for (var i = 0; i < file.upload.totalChunkCount; i++) {
	              handleNextChunk();
	            }
	          } else {
	            handleNextChunk();
	          }
	        } else {
	          var dataBlocks = [];
	          for (var _i23 = 0; _i23 < files.length; _i23++) {
	            dataBlocks[_i23] = {
	              name: _this14._getParamName(_i23),
	              data: transformedFiles[_i23],
	              filename: files[_i23].upload.filename
	            };
	          }
	          _this14._uploadData(files, dataBlocks);
	        }
	      });
	    }
	
	    /// Returns the right chunk for given file and xhr
	
	  }, {
	    key: "_getChunk",
	    value: function _getChunk(file, xhr) {
	      for (var i = 0; i < file.upload.totalChunkCount; i++) {
	        if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].xhr === xhr) {
	          return file.upload.chunks[i];
	        }
	      }
	    }
	
	    // This function actually uploads the file(s) to the server.
	    // If dataBlocks contains the actual data to upload (meaning, that this could either be transformed
	    // files, or individual chunks for chunked upload).
	
	  }, {
	    key: "_uploadData",
	    value: function _uploadData(files, dataBlocks) {
	      var _this15 = this;
	
	      var xhr = new XMLHttpRequest();
	
	      // Put the xhr object in the file objects to be able to reference it later.
	      for (var _iterator22 = files, _isArray22 = true, _i24 = 0, _iterator22 = _isArray22 ? _iterator22 : _iterator22[Symbol.iterator]();;) {
	        var _ref21;
	
	        if (_isArray22) {
	          if (_i24 >= _iterator22.length) break;
	          _ref21 = _iterator22[_i24++];
	        } else {
	          _i24 = _iterator22.next();
	          if (_i24.done) break;
	          _ref21 = _i24.value;
	        }
	
	        var file = _ref21;
	
	        file.xhr = xhr;
	      }
	      if (files[0].upload.chunked) {
	        // Put the xhr object in the right chunk object, so it can be associated later, and found with _getChunk
	        files[0].upload.chunks[dataBlocks[0].chunkIndex].xhr = xhr;
	      }
	
	      var method = this.resolveOption(this.options.method, files);
	      var url = this.resolveOption(this.options.url, files);
	      xhr.open(method, url, true);
	
	      // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
	      xhr.timeout = this.resolveOption(this.options.timeout, files);
	
	      // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
	      xhr.withCredentials = !!this.options.withCredentials;
	
	      xhr.onload = function (e) {
	        _this15._finishedUploading(files, xhr, e);
	      };
	
	      xhr.onerror = function () {
	        _this15._handleUploadError(files, xhr);
	      };
	
	      // Some browsers do not have the .upload property
	      var progressObj = xhr.upload != null ? xhr.upload : xhr;
	      progressObj.onprogress = function (e) {
	        return _this15._updateFilesUploadProgress(files, xhr, e);
	      };
	
	      var headers = {
	        "Accept": "application/json",
	        "Cache-Control": "no-cache",
	        "X-Requested-With": "XMLHttpRequest"
	      };
	
	      if (this.options.headers) {
	        Dropzone.extend(headers, this.options.headers);
	      }
	
	      for (var headerName in headers) {
	        var headerValue = headers[headerName];
	        if (headerValue) {
	          xhr.setRequestHeader(headerName, headerValue);
	        }
	      }
	
	      var formData = new FormData();
	
	      // Adding all @options parameters
	      if (this.options.params) {
	        var additionalParams = this.options.params;
	        if (typeof additionalParams === 'function') {
	          additionalParams = additionalParams.call(this, files, xhr, files[0].upload.chunked ? this._getChunk(files[0], xhr) : null);
	        }
	
	        for (var key in additionalParams) {
	          var value = additionalParams[key];
	          formData.append(key, value);
	        }
	      }
	
	      // Let the user add additional data if necessary
	      for (var _iterator23 = files, _isArray23 = true, _i25 = 0, _iterator23 = _isArray23 ? _iterator23 : _iterator23[Symbol.iterator]();;) {
	        var _ref22;
	
	        if (_isArray23) {
	          if (_i25 >= _iterator23.length) break;
	          _ref22 = _iterator23[_i25++];
	        } else {
	          _i25 = _iterator23.next();
	          if (_i25.done) break;
	          _ref22 = _i25.value;
	        }
	
	        var _file = _ref22;
	
	        this.emit("sending", _file, xhr, formData);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("sendingmultiple", files, xhr, formData);
	      }
	
	      this._addFormElementData(formData);
	
	      // Finally add the files
	      // Has to be last because some servers (eg: S3) expect the file to be the last parameter
	      for (var i = 0; i < dataBlocks.length; i++) {
	        var dataBlock = dataBlocks[i];
	        formData.append(dataBlock.name, dataBlock.data, dataBlock.filename);
	      }
	
	      this.submitRequest(xhr, formData, files);
	    }
	
	    // Transforms all files with this.options.transformFile and invokes done with the transformed files when done.
	
	  }, {
	    key: "_transformFiles",
	    value: function _transformFiles(files, done) {
	      var _this16 = this;
	
	      var transformedFiles = [];
	      // Clumsy way of handling asynchronous calls, until I get to add a proper Future library.
	      var doneCounter = 0;
	
	      var _loop = function _loop(i) {
	        _this16.options.transformFile.call(_this16, files[i], function (transformedFile) {
	          transformedFiles[i] = transformedFile;
	          if (++doneCounter === files.length) {
	            done(transformedFiles);
	          }
	        });
	      };
	
	      for (var i = 0; i < files.length; i++) {
	        _loop(i);
	      }
	    }
	
	    // Takes care of adding other input elements of the form to the AJAX request
	
	  }, {
	    key: "_addFormElementData",
	    value: function _addFormElementData(formData) {
	      // Take care of other input elements
	      if (this.element.tagName === "FORM") {
	        for (var _iterator24 = this.element.querySelectorAll("input, textarea, select, button"), _isArray24 = true, _i26 = 0, _iterator24 = _isArray24 ? _iterator24 : _iterator24[Symbol.iterator]();;) {
	          var _ref23;
	
	          if (_isArray24) {
	            if (_i26 >= _iterator24.length) break;
	            _ref23 = _iterator24[_i26++];
	          } else {
	            _i26 = _iterator24.next();
	            if (_i26.done) break;
	            _ref23 = _i26.value;
	          }
	
	          var input = _ref23;
	
	          var inputName = input.getAttribute("name");
	          var inputType = input.getAttribute("type");
	          if (inputType) inputType = inputType.toLowerCase();
	
	          // If the input doesn't have a name, we can't use it.
	          if (typeof inputName === 'undefined' || inputName === null) continue;
	
	          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
	            // Possibly multiple values
	            for (var _iterator25 = input.options, _isArray25 = true, _i27 = 0, _iterator25 = _isArray25 ? _iterator25 : _iterator25[Symbol.iterator]();;) {
	              var _ref24;
	
	              if (_isArray25) {
	                if (_i27 >= _iterator25.length) break;
	                _ref24 = _iterator25[_i27++];
	              } else {
	                _i27 = _iterator25.next();
	                if (_i27.done) break;
	                _ref24 = _i27.value;
	              }
	
	              var option = _ref24;
	
	              if (option.selected) {
	                formData.append(inputName, option.value);
	              }
	            }
	          } else if (!inputType || inputType !== "checkbox" && inputType !== "radio" || input.checked) {
	            formData.append(inputName, input.value);
	          }
	        }
	      }
	    }
	
	    // Invoked when there is new progress information about given files.
	    // If e is not provided, it is assumed that the upload is finished.
	
	  }, {
	    key: "_updateFilesUploadProgress",
	    value: function _updateFilesUploadProgress(files, xhr, e) {
	      var progress = void 0;
	      if (typeof e !== 'undefined') {
	        progress = 100 * e.loaded / e.total;
	
	        if (files[0].upload.chunked) {
	          var file = files[0];
	          // Since this is a chunked upload, we need to update the appropriate chunk progress.
	          var chunk = this._getChunk(file, xhr);
	          chunk.progress = progress;
	          chunk.total = e.total;
	          chunk.bytesSent = e.loaded;
	          var fileProgress = 0,
	              fileTotal = void 0,
	              fileBytesSent = void 0;
	          file.upload.progress = 0;
	          file.upload.total = 0;
	          file.upload.bytesSent = 0;
	          for (var i = 0; i < file.upload.totalChunkCount; i++) {
	            if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].progress !== undefined) {
	              file.upload.progress += file.upload.chunks[i].progress;
	              file.upload.total += file.upload.chunks[i].total;
	              file.upload.bytesSent += file.upload.chunks[i].bytesSent;
	            }
	          }
	          file.upload.progress = file.upload.progress / file.upload.totalChunkCount;
	        } else {
	          for (var _iterator26 = files, _isArray26 = true, _i28 = 0, _iterator26 = _isArray26 ? _iterator26 : _iterator26[Symbol.iterator]();;) {
	            var _ref25;
	
	            if (_isArray26) {
	              if (_i28 >= _iterator26.length) break;
	              _ref25 = _iterator26[_i28++];
	            } else {
	              _i28 = _iterator26.next();
	              if (_i28.done) break;
	              _ref25 = _i28.value;
	            }
	
	            var _file2 = _ref25;
	
	            _file2.upload.progress = progress;
	            _file2.upload.total = e.total;
	            _file2.upload.bytesSent = e.loaded;
	          }
	        }
	        for (var _iterator27 = files, _isArray27 = true, _i29 = 0, _iterator27 = _isArray27 ? _iterator27 : _iterator27[Symbol.iterator]();;) {
	          var _ref26;
	
	          if (_isArray27) {
	            if (_i29 >= _iterator27.length) break;
	            _ref26 = _iterator27[_i29++];
	          } else {
	            _i29 = _iterator27.next();
	            if (_i29.done) break;
	            _ref26 = _i29.value;
	          }
	
	          var _file3 = _ref26;
	
	          this.emit("uploadprogress", _file3, _file3.upload.progress, _file3.upload.bytesSent);
	        }
	      } else {
	        // Called when the file finished uploading
	
	        var allFilesFinished = true;
	
	        progress = 100;
	
	        for (var _iterator28 = files, _isArray28 = true, _i30 = 0, _iterator28 = _isArray28 ? _iterator28 : _iterator28[Symbol.iterator]();;) {
	          var _ref27;
	
	          if (_isArray28) {
	            if (_i30 >= _iterator28.length) break;
	            _ref27 = _iterator28[_i30++];
	          } else {
	            _i30 = _iterator28.next();
	            if (_i30.done) break;
	            _ref27 = _i30.value;
	          }
	
	          var _file4 = _ref27;
	
	          if (_file4.upload.progress !== 100 || _file4.upload.bytesSent !== _file4.upload.total) {
	            allFilesFinished = false;
	          }
	          _file4.upload.progress = progress;
	          _file4.upload.bytesSent = _file4.upload.total;
	        }
	
	        // Nothing to do, all files already at 100%
	        if (allFilesFinished) {
	          return;
	        }
	
	        for (var _iterator29 = files, _isArray29 = true, _i31 = 0, _iterator29 = _isArray29 ? _iterator29 : _iterator29[Symbol.iterator]();;) {
	          var _ref28;
	
	          if (_isArray29) {
	            if (_i31 >= _iterator29.length) break;
	            _ref28 = _iterator29[_i31++];
	          } else {
	            _i31 = _iterator29.next();
	            if (_i31.done) break;
	            _ref28 = _i31.value;
	          }
	
	          var _file5 = _ref28;
	
	          this.emit("uploadprogress", _file5, progress, _file5.upload.bytesSent);
	        }
	      }
	    }
	  }, {
	    key: "_finishedUploading",
	    value: function _finishedUploading(files, xhr, e) {
	      var response = void 0;
	
	      if (files[0].status === Dropzone.CANCELED) {
	        return;
	      }
	
	      if (xhr.readyState !== 4) {
	        return;
	      }
	
	      if (xhr.responseType !== 'arraybuffer' && xhr.responseType !== 'blob') {
	        response = xhr.responseText;
	
	        if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
	          try {
	            response = JSON.parse(response);
	          } catch (error) {
	            e = error;
	            response = "Invalid JSON response from server.";
	          }
	        }
	      }
	
	      this._updateFilesUploadProgress(files);
	
	      if (!(200 <= xhr.status && xhr.status < 300)) {
	        this._handleUploadError(files, xhr, response);
	      } else {
	        if (files[0].upload.chunked) {
	          files[0].upload.finishedChunkUpload(this._getChunk(files[0], xhr));
	        } else {
	          this._finished(files, response, e);
	        }
	      }
	    }
	  }, {
	    key: "_handleUploadError",
	    value: function _handleUploadError(files, xhr, response) {
	      if (files[0].status === Dropzone.CANCELED) {
	        return;
	      }
	
	      if (files[0].upload.chunked && this.options.retryChunks) {
	        var chunk = this._getChunk(files[0], xhr);
	        if (chunk.retries++ < this.options.retryChunksLimit) {
	          this._uploadData(files, [chunk.dataBlock]);
	          return;
	        } else {
	          console.warn('Retried this chunk too often. Giving up.');
	        }
	      }
	
	      for (var _iterator30 = files, _isArray30 = true, _i32 = 0, _iterator30 = _isArray30 ? _iterator30 : _iterator30[Symbol.iterator]();;) {
	        var _ref29;
	
	        if (_isArray30) {
	          if (_i32 >= _iterator30.length) break;
	          _ref29 = _iterator30[_i32++];
	        } else {
	          _i32 = _iterator30.next();
	          if (_i32.done) break;
	          _ref29 = _i32.value;
	        }
	
	        var file = _ref29;
	
	        this._errorProcessing(files, response || this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr);
	      }
	    }
	  }, {
	    key: "submitRequest",
	    value: function submitRequest(xhr, formData, files) {
	      xhr.send(formData);
	    }
	
	    // Called internally when processing is finished.
	    // Individual callbacks have to be called in the appropriate sections.
	
	  }, {
	    key: "_finished",
	    value: function _finished(files, responseText, e) {
	      for (var _iterator31 = files, _isArray31 = true, _i33 = 0, _iterator31 = _isArray31 ? _iterator31 : _iterator31[Symbol.iterator]();;) {
	        var _ref30;
	
	        if (_isArray31) {
	          if (_i33 >= _iterator31.length) break;
	          _ref30 = _iterator31[_i33++];
	        } else {
	          _i33 = _iterator31.next();
	          if (_i33.done) break;
	          _ref30 = _i33.value;
	        }
	
	        var file = _ref30;
	
	        file.status = Dropzone.SUCCESS;
	        this.emit("success", file, responseText, e);
	        this.emit("complete", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("successmultiple", files, responseText, e);
	        this.emit("completemultiple", files);
	      }
	
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    }
	
	    // Called internally when processing is finished.
	    // Individual callbacks have to be called in the appropriate sections.
	
	  }, {
	    key: "_errorProcessing",
	    value: function _errorProcessing(files, message, xhr) {
	      for (var _iterator32 = files, _isArray32 = true, _i34 = 0, _iterator32 = _isArray32 ? _iterator32 : _iterator32[Symbol.iterator]();;) {
	        var _ref31;
	
	        if (_isArray32) {
	          if (_i34 >= _iterator32.length) break;
	          _ref31 = _iterator32[_i34++];
	        } else {
	          _i34 = _iterator32.next();
	          if (_i34.done) break;
	          _ref31 = _i34.value;
	        }
	
	        var file = _ref31;
	
	        file.status = Dropzone.ERROR;
	        this.emit("error", file, message, xhr);
	        this.emit("complete", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("errormultiple", files, message, xhr);
	        this.emit("completemultiple", files);
	      }
	
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    }
	  }], [{
	    key: "uuidv4",
	    value: function uuidv4() {
	      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16 | 0,
	            v = c === 'x' ? r : r & 0x3 | 0x8;
	        return v.toString(16);
	      });
	    }
	  }]);
	
	  return Dropzone;
	}(Emitter);
	
	Dropzone.initClass();
	
	Dropzone.version = "5.3.1";
	
	// This is a map of options for your different dropzones. Add configurations
	// to this object for your different dropzone elemens.
	//
	// Example:
	//
	//     Dropzone.options.myDropzoneElementId = { maxFilesize: 1 };
	//
	// To disable autoDiscover for a specific element, you can set `false` as an option:
	//
	//     Dropzone.options.myDisabledElementId = false;
	//
	// And in html:
	//
	//     <form action="/upload" id="my-dropzone-element-id" class="dropzone"></form>
	Dropzone.options = {};
	
	// Returns the options for an element or undefined if none available.
	Dropzone.optionsForElement = function (element) {
	  // Get the `Dropzone.options.elementId` for this element if it exists
	  if (element.getAttribute("id")) {
	    return Dropzone.options[camelize(element.getAttribute("id"))];
	  } else {
	    return undefined;
	  }
	};
	
	// Holds a list of all dropzone instances
	Dropzone.instances = [];
	
	// Returns the dropzone for given element if any
	Dropzone.forElement = function (element) {
	  if (typeof element === "string") {
	    element = document.querySelector(element);
	  }
	  if ((element != null ? element.dropzone : undefined) == null) {
	    throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
	  }
	  return element.dropzone;
	};
	
	// Set to false if you don't want Dropzone to automatically find and attach to .dropzone elements.
	Dropzone.autoDiscover = true;
	
	// Looks for all .dropzone elements and creates a dropzone for them
	Dropzone.discover = function () {
	  var dropzones = void 0;
	  if (document.querySelectorAll) {
	    dropzones = document.querySelectorAll(".dropzone");
	  } else {
	    dropzones = [];
	    // IE :(
	    var checkElements = function checkElements(elements) {
	      return function () {
	        var result = [];
	        for (var _iterator33 = elements, _isArray33 = true, _i35 = 0, _iterator33 = _isArray33 ? _iterator33 : _iterator33[Symbol.iterator]();;) {
	          var _ref32;
	
	          if (_isArray33) {
	            if (_i35 >= _iterator33.length) break;
	            _ref32 = _iterator33[_i35++];
	          } else {
	            _i35 = _iterator33.next();
	            if (_i35.done) break;
	            _ref32 = _i35.value;
	          }
	
	          var el = _ref32;
	
	          if (/(^| )dropzone($| )/.test(el.className)) {
	            result.push(dropzones.push(el));
	          } else {
	            result.push(undefined);
	          }
	        }
	        return result;
	      }();
	    };
	    checkElements(document.getElementsByTagName("div"));
	    checkElements(document.getElementsByTagName("form"));
	  }
	
	  return function () {
	    var result = [];
	    for (var _iterator34 = dropzones, _isArray34 = true, _i36 = 0, _iterator34 = _isArray34 ? _iterator34 : _iterator34[Symbol.iterator]();;) {
	      var _ref33;
	
	      if (_isArray34) {
	        if (_i36 >= _iterator34.length) break;
	        _ref33 = _iterator34[_i36++];
	      } else {
	        _i36 = _iterator34.next();
	        if (_i36.done) break;
	        _ref33 = _i36.value;
	      }
	
	      var dropzone = _ref33;
	
	      // Create a dropzone unless auto discover has been disabled for specific element
	      if (Dropzone.optionsForElement(dropzone) !== false) {
	        result.push(new Dropzone(dropzone));
	      } else {
	        result.push(undefined);
	      }
	    }
	    return result;
	  }();
	};
	
	// Since the whole Drag'n'Drop API is pretty new, some browsers implement it,
	// but not correctly.
	// So I created a blacklist of userAgents. Yes, yes. Browser sniffing, I know.
	// But what to do when browsers *theoretically* support an API, but crash
	// when using it.
	//
	// This is a list of regular expressions tested against navigator.userAgent
	//
	// ** It should only be used on browser that *do* support the API, but
	// incorrectly **
	//
	Dropzone.blacklistedBrowsers = [
	// The mac os and windows phone version of opera 12 seems to have a problem with the File drag'n'drop API.
	/opera.*(Macintosh|Windows Phone).*version\/12/i];
	
	// Checks if the browser is supported
	Dropzone.isBrowserSupported = function () {
	  var capableBrowser = true;
	
	  if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
	    if (!("classList" in document.createElement("a"))) {
	      capableBrowser = false;
	    } else {
	      // The browser supports the API, but may be blacklisted.
	      for (var _iterator35 = Dropzone.blacklistedBrowsers, _isArray35 = true, _i37 = 0, _iterator35 = _isArray35 ? _iterator35 : _iterator35[Symbol.iterator]();;) {
	        var _ref34;
	
	        if (_isArray35) {
	          if (_i37 >= _iterator35.length) break;
	          _ref34 = _iterator35[_i37++];
	        } else {
	          _i37 = _iterator35.next();
	          if (_i37.done) break;
	          _ref34 = _i37.value;
	        }
	
	        var regex = _ref34;
	
	        if (regex.test(navigator.userAgent)) {
	          capableBrowser = false;
	          continue;
	        }
	      }
	    }
	  } else {
	    capableBrowser = false;
	  }
	
	  return capableBrowser;
	};
	
	Dropzone.dataURItoBlob = function (dataURI) {
	  // convert base64 to raw binary data held in a string
	  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
	  var byteString = atob(dataURI.split(',')[1]);
	
	  // separate out the mime component
	  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
	
	  // write the bytes of the string to an ArrayBuffer
	  var ab = new ArrayBuffer(byteString.length);
	  var ia = new Uint8Array(ab);
	  for (var i = 0, end = byteString.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
	    ia[i] = byteString.charCodeAt(i);
	  }
	
	  // write the ArrayBuffer to a blob
	  return new Blob([ab], { type: mimeString });
	};
	
	// Returns an array without the rejected item
	var without = function without(list, rejectedItem) {
	  return list.filter(function (item) {
	    return item !== rejectedItem;
	  }).map(function (item) {
	    return item;
	  });
	};
	
	// abc-def_ghi -> abcDefGhi
	var camelize = function camelize(str) {
	  return str.replace(/[\-_](\w)/g, function (match) {
	    return match.charAt(1).toUpperCase();
	  });
	};
	
	// Creates an element from string
	Dropzone.createElement = function (string) {
	  var div = document.createElement("div");
	  div.innerHTML = string;
	  return div.childNodes[0];
	};
	
	// Tests if given element is inside (or simply is) the container
	Dropzone.elementInside = function (element, container) {
	  if (element === container) {
	    return true;
	  } // Coffeescript doesn't support do/while loops
	  while (element = element.parentNode) {
	    if (element === container) {
	      return true;
	    }
	  }
	  return false;
	};
	
	Dropzone.getElement = function (el, name) {
	  var element = void 0;
	  if (typeof el === "string") {
	    element = document.querySelector(el);
	  } else if (el.nodeType != null) {
	    element = el;
	  }
	  if (element == null) {
	    throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
	  }
	  return element;
	};
	
	Dropzone.getElements = function (els, name) {
	  var el = void 0,
	      elements = void 0;
	  if (els instanceof Array) {
	    elements = [];
	    try {
	      for (var _iterator36 = els, _isArray36 = true, _i38 = 0, _iterator36 = _isArray36 ? _iterator36 : _iterator36[Symbol.iterator]();;) {
	        if (_isArray36) {
	          if (_i38 >= _iterator36.length) break;
	          el = _iterator36[_i38++];
	        } else {
	          _i38 = _iterator36.next();
	          if (_i38.done) break;
	          el = _i38.value;
	        }
	
	        elements.push(this.getElement(el, name));
	      }
	    } catch (e) {
	      elements = null;
	    }
	  } else if (typeof els === "string") {
	    elements = [];
	    for (var _iterator37 = document.querySelectorAll(els), _isArray37 = true, _i39 = 0, _iterator37 = _isArray37 ? _iterator37 : _iterator37[Symbol.iterator]();;) {
	      if (_isArray37) {
	        if (_i39 >= _iterator37.length) break;
	        el = _iterator37[_i39++];
	      } else {
	        _i39 = _iterator37.next();
	        if (_i39.done) break;
	        el = _i39.value;
	      }
	
	      elements.push(el);
	    }
	  } else if (els.nodeType != null) {
	    elements = [els];
	  }
	
	  if (elements == null || !elements.length) {
	    throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
	  }
	
	  return elements;
	};
	
	// Asks the user the question and calls accepted or rejected accordingly
	//
	// The default implementation just uses `window.confirm` and then calls the
	// appropriate callback.
	Dropzone.confirm = function (question, accepted, rejected) {
	  if (window.confirm(question)) {
	    return accepted();
	  } else if (rejected != null) {
	    return rejected();
	  }
	};
	
	// Validates the mime type like this:
	//
	// https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept
	Dropzone.isValidFile = function (file, acceptedFiles) {
	  if (!acceptedFiles) {
	    return true;
	  } // If there are no accepted mime types, it's OK
	  acceptedFiles = acceptedFiles.split(",");
	
	  var mimeType = file.type;
	  var baseMimeType = mimeType.replace(/\/.*$/, "");
	
	  for (var _iterator38 = acceptedFiles, _isArray38 = true, _i40 = 0, _iterator38 = _isArray38 ? _iterator38 : _iterator38[Symbol.iterator]();;) {
	    var _ref35;
	
	    if (_isArray38) {
	      if (_i40 >= _iterator38.length) break;
	      _ref35 = _iterator38[_i40++];
	    } else {
	      _i40 = _iterator38.next();
	      if (_i40.done) break;
	      _ref35 = _i40.value;
	    }
	
	    var validType = _ref35;
	
	    validType = validType.trim();
	    if (validType.charAt(0) === ".") {
	      if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
	        return true;
	      }
	    } else if (/\/\*$/.test(validType)) {
	      // This is something like a image/* mime type
	      if (baseMimeType === validType.replace(/\/.*$/, "")) {
	        return true;
	      }
	    } else {
	      if (mimeType === validType) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};
	
	// Augment jQuery
	if (typeof jQuery !== 'undefined' && jQuery !== null) {
	  jQuery.fn.dropzone = function (options) {
	    return this.each(function () {
	      return new Dropzone(this, options);
	    });
	  };
	}
	
	if (typeof module !== 'undefined' && module !== null) {
	  module.exports = Dropzone;
	} else {
	  window.Dropzone = Dropzone;
	}
	
	// Dropzone file status codes
	Dropzone.ADDED = "added";
	
	Dropzone.QUEUED = "queued";
	// For backwards compatibility. Now, if a file is accepted, it's either queued
	// or uploading.
	Dropzone.ACCEPTED = Dropzone.QUEUED;
	
	Dropzone.UPLOADING = "uploading";
	Dropzone.PROCESSING = Dropzone.UPLOADING; // alias
	
	Dropzone.CANCELED = "canceled";
	Dropzone.ERROR = "error";
	Dropzone.SUCCESS = "success";
	
	/*
	
	 Bugfix for iOS 6 and 7
	 Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
	 based on the work of https://github.com/stomita/ios-imagefile-megapixel
	
	 */
	
	// Detecting vertical squash in loaded image.
	// Fixes a bug which squash image vertically while drawing into canvas for some images.
	// This is a bug in iOS6 devices. This function from https://github.com/stomita/ios-imagefile-megapixel
	var detectVerticalSquash = function detectVerticalSquash(img) {
	  var iw = img.naturalWidth;
	  var ih = img.naturalHeight;
	  var canvas = document.createElement("canvas");
	  canvas.width = 1;
	  canvas.height = ih;
	  var ctx = canvas.getContext("2d");
	  ctx.drawImage(img, 0, 0);
	
	  var _ctx$getImageData = ctx.getImageData(1, 0, 1, ih),
	      data = _ctx$getImageData.data;
	
	  // search image edge pixel position in case it is squashed vertically.
	
	
	  var sy = 0;
	  var ey = ih;
	  var py = ih;
	  while (py > sy) {
	    var alpha = data[(py - 1) * 4 + 3];
	
	    if (alpha === 0) {
	      ey = py;
	    } else {
	      sy = py;
	    }
	
	    py = ey + sy >> 1;
	  }
	  var ratio = py / ih;
	
	  if (ratio === 0) {
	    return 1;
	  } else {
	    return ratio;
	  }
	};
	
	// A replacement for context.drawImage
	// (args are for source and destination).
	var drawImageIOSFix = function drawImageIOSFix(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
	  var vertSquashRatio = detectVerticalSquash(img);
	  return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
	};
	
	// Based on MinifyJpeg
	// Source: http://www.perry.cz/files/ExifRestorer.js
	// http://elicon.blog57.fc2.com/blog-entry-206.html
	
	var ExifRestore = function () {
	  function ExifRestore() {
	    _classCallCheck(this, ExifRestore);
	  }
	
	  _createClass(ExifRestore, null, [{
	    key: "initClass",
	    value: function initClass() {
	      this.KEY_STR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    }
	  }, {
	    key: "encode64",
	    value: function encode64(input) {
	      var output = '';
	      var chr1 = undefined;
	      var chr2 = undefined;
	      var chr3 = '';
	      var enc1 = undefined;
	      var enc2 = undefined;
	      var enc3 = undefined;
	      var enc4 = '';
	      var i = 0;
	      while (true) {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	        output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	        if (!(i < input.length)) {
	          break;
	        }
	      }
	      return output;
	    }
	  }, {
	    key: "restore",
	    value: function restore(origFileBase64, resizedFileBase64) {
	      if (!origFileBase64.match('data:image/jpeg;base64,')) {
	        return resizedFileBase64;
	      }
	      var rawImage = this.decode64(origFileBase64.replace('data:image/jpeg;base64,', ''));
	      var segments = this.slice2Segments(rawImage);
	      var image = this.exifManipulation(resizedFileBase64, segments);
	      return "data:image/jpeg;base64," + this.encode64(image);
	    }
	  }, {
	    key: "exifManipulation",
	    value: function exifManipulation(resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments);
	      var newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      var aBuffer = new Uint8Array(newImageArray);
	      return aBuffer;
	    }
	  }, {
	    key: "getExifArray",
	    value: function getExifArray(segments) {
	      var seg = undefined;
	      var x = 0;
	      while (x < segments.length) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) {
	          return seg;
	        }
	        x++;
	      }
	      return [];
	    }
	  }, {
	    key: "insertExif",
	    value: function insertExif(resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', '');
	      var buf = this.decode64(imageData);
	      var separatePoint = buf.indexOf(255, 3);
	      var mae = buf.slice(0, separatePoint);
	      var ato = buf.slice(separatePoint);
	      var array = mae;
	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    }
	  }, {
	    key: "slice2Segments",
	    value: function slice2Segments(rawImageArray) {
	      var head = 0;
	      var segments = [];
	      while (true) {
	        var length;
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        } else {
	          length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3];
	          var endPoint = head + length + 2;
	          var seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }
	      return segments;
	    }
	  }, {
	    key: "decode64",
	    value: function decode64(input) {
	      var output = '';
	      var chr1 = undefined;
	      var chr2 = undefined;
	      var chr3 = '';
	      var enc1 = undefined;
	      var enc2 = undefined;
	      var enc3 = undefined;
	      var enc4 = '';
	      var i = 0;
	      var buf = [];
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.warn('There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, \'+\', \'/\',and \'=\'\nExpect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	      while (true) {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	        buf.push(chr1);
	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	        if (!(i < input.length)) {
	          break;
	        }
	      }
	      return buf;
	    }
	  }]);
	
	  return ExifRestore;
	}();
	
	ExifRestore.initClass();
	
	/*
	 * contentloaded.js
	 *
	 * Author: Diego Perini (diego.perini at gmail.com)
	 * Summary: cross-browser wrapper for DOMContentLoaded
	 * Updated: 20101020
	 * License: MIT
	 * Version: 1.2
	 *
	 * URL:
	 * http://javascript.nwbox.com/ContentLoaded/
	 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
	 */
	
	// @win window reference
	// @fn function reference
	var contentLoaded = function contentLoaded(win, fn) {
	  var done = false;
	  var top = true;
	  var doc = win.document;
	  var root = doc.documentElement;
	  var add = doc.addEventListener ? "addEventListener" : "attachEvent";
	  var rem = doc.addEventListener ? "removeEventListener" : "detachEvent";
	  var pre = doc.addEventListener ? "" : "on";
	  var init = function init(e) {
	    if (e.type === "readystatechange" && doc.readyState !== "complete") {
	      return;
	    }
	    (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
	    if (!done && (done = true)) {
	      return fn.call(win, e.type || e);
	    }
	  };
	
	  var poll = function poll() {
	    try {
	      root.doScroll("left");
	    } catch (e) {
	      setTimeout(poll, 50);
	      return;
	    }
	    return init("poll");
	  };
	
	  if (doc.readyState !== "complete") {
	    if (doc.createEventObject && root.doScroll) {
	      try {
	        top = !win.frameElement;
	      } catch (error) {}
	      if (top) {
	        poll();
	      }
	    }
	    doc[add](pre + "DOMContentLoaded", init, false);
	    doc[add](pre + "readystatechange", init, false);
	    return win[add](pre + "load", init, false);
	  }
	};
	
	// As a single function to be able to write tests.
	Dropzone._autoDiscoverFunction = function () {
	  if (Dropzone.autoDiscover) {
	    return Dropzone.discover();
	  }
	};
	contentLoaded(window, Dropzone._autoDiscoverFunction);
	
	function __guard__(value, transform) {
	  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
	}
	function __guardMethod__(obj, methodName, transform) {
	  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
	    return transform(obj, methodName);
	  } else {
	    return undefined;
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)(module)))

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(9)($);
	
	$(function () {
		$('.fancybox').fancybox({
			autoScale: true,
			maxWidth: 1280,
			maxHeight: 1280,
			padding: $(window).width() < 768 ? 20 : 80,
	
			tpl: {
				closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"><div class="cssicon close"></div></a>',
				next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><div class="cssicon arrow arrow-right"></div></a>',
				prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><div class="cssicon arrow arrow-left"></div></a>'
			}
		});
	});

/***/ },
/* 9 */
/***/ function(module, exports) {

	/*!
	 * fancyBox - jQuery Plugin
	 * version: 2.1.5 (Fri, 14 Jun 2013)
	 * requires jQuery v1.6 or later
	 *
	 * Examples at http://fancyapps.com/fancybox/
	 * License: www.fancyapps.com/fancybox/#license
	 *
	 * Copyright 2012 Janis Skarnelis - janis@fancyapps.com
	 *
	 */
	
	module.exports = function(jQuery) {
	    "use strict";
	
	    var H = jQuery("html"),
	        W = jQuery(window),
	        D = jQuery(document),
	        F = jQuery.fancybox = function() {
	            F.open.apply(this, arguments);
	        },
	        IE = navigator.userAgent.match(/msie/i),
	        didUpdate = null,
	        isTouch = document.createTouch !== undefined,
	
	        isQuery = function(obj) {
	            return obj && obj.hasOwnProperty && obj instanceof jQuery;
	        },
	        isString = function(str) {
	            return str && jQuery.type(str) === "string";
	        },
	        isPercentage = function(str) {
	            return isString(str) && str.indexOf('%') > 0;
	        },
	        isScrollable = function(el) {
	            return (el && !(el.style.overflow && el.style.overflow === 'hidden') && ((el.clientWidth && el.scrollWidth > el.clientWidth) || (el.clientHeight && el.scrollHeight > el.clientHeight)));
	        },
	        getScalar = function(orig, dim) {
	            var value = parseInt(orig, 10) || 0;
	
	            if (dim && isPercentage(orig)) {
	                value = F.getViewport()[dim] / 100 * value;
	            }
	
	            return Math.ceil(value);
	        },
	        getValue = function(value, dim) {
	            return getScalar(value, dim) + 'px';
	        };
	
	    jQuery.extend(F, {
	        // The current version of fancyBox
	        version: '2.1.5',
	
	        defaults: {
	            padding: 15,
	            margin: 20,
	
	            width: 800,
	            height: 600,
	            minWidth: 100,
	            minHeight: 100,
	            maxWidth: 9999,
	            maxHeight: 9999,
	            pixelRatio: 1, // Set to 2 for retina display support
	
	            autoSize: true,
	            autoHeight: false,
	            autoWidth: false,
	
	            autoResize: true,
	            autoCenter: !isTouch,
	            fitToView: true,
	            aspectRatio: false,
	            topRatio: 0.5,
	            leftRatio: 0.5,
	
	            scrolling: 'auto', // 'auto', 'yes' or 'no'
	            wrapCSS: '',
	
	            arrows: true,
	            closeBtn: true,
	            closeClick: false,
	            nextClick: false,
	            mouseWheel: true,
	            autoPlay: false,
	            playSpeed: 3000,
	            preload: 3,
	            modal: false,
	            loop: true,
	
	            ajax: {
	                dataType: 'html',
	                headers: {
	                    'X-fancyBox': true
	                }
	            },
	            iframe: {
	                scrolling: 'auto',
	                preload: true
	            },
	            swf: {
	                wmode: 'transparent',
	                allowfullscreen: 'true',
	                allowscriptaccess: 'always'
	            },
	
	            keys: {
	                next: {
	                    13: 'left', // enter
	                    34: 'up', // page down
	                    39: 'left', // right arrow
	                    40: 'up' // down arrow
	                },
	                prev: {
	                    8: 'right', // backspace
	                    33: 'down', // page up
	                    37: 'right', // left arrow
	                    38: 'down' // up arrow
	                },
	                close: [27], // escape key
	                play: [32], // space - start/stop slideshow
	                toggle: [70] // letter "f" - toggle fullscreen
	            },
	
	            direction: {
	                next: 'left',
	                prev: 'right'
	            },
	
	            scrollOutside: true,
	
	            // Override some properties
	            index: 0,
	            type: null,
	            href: null,
	            content: null,
	            title: null,
	
	            // HTML templates
	            tpl: {
	                wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
	                image: '<img class="fancybox-image" src="{href}" alt="" />',
	                iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (IE ? ' allowtransparency="true"' : '') + '></iframe>',
	                error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
	                closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
	                next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
	                prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
	                loading: '<div id="fancybox-loading"><div></div></div>'
	            },
	
	            // Properties for each animation type
	            // Opening fancyBox
	            openEffect: 'fade', // 'elastic', 'fade' or 'none'
	            openSpeed: 250,
	            openEasing: 'swing',
	            openOpacity: true,
	            openMethod: 'zoomIn',
	
	            // Closing fancyBox
	            closeEffect: 'fade', // 'elastic', 'fade' or 'none'
	            closeSpeed: 250,
	            closeEasing: 'swing',
	            closeOpacity: true,
	            closeMethod: 'zoomOut',
	
	            // Changing next gallery item
	            nextEffect: 'elastic', // 'elastic', 'fade' or 'none'
	            nextSpeed: 250,
	            nextEasing: 'swing',
	            nextMethod: 'changeIn',
	
	            // Changing previous gallery item
	            prevEffect: 'elastic', // 'elastic', 'fade' or 'none'
	            prevSpeed: 250,
	            prevEasing: 'swing',
	            prevMethod: 'changeOut',
	
	            // Enable default helpers
	            helpers: {
	                overlay: true,
	                title: true
	            },
	
	            // Callbacks
	            onCancel: jQuery.noop, // If canceling
	            beforeLoad: jQuery.noop, // Before loading
	            afterLoad: jQuery.noop, // After loading
	            beforeShow: jQuery.noop, // Before changing in current item
	            afterShow: jQuery.noop, // After opening
	            beforeChange: jQuery.noop, // Before changing gallery item
	            beforeClose: jQuery.noop, // Before closing
	            afterClose: jQuery.noop // After closing
	        },
	
	        //Current state
	        group: {}, // Selected group
	        opts: {}, // Group options
	        previous: null, // Previous element
	        coming: null, // Element being loaded
	        current: null, // Currently loaded element
	        isActive: false, // Is activated
	        isOpen: false, // Is currently open
	        isOpened: false, // Have been fully opened at least once
	
	        wrap: null,
	        skin: null,
	        outer: null,
	        inner: null,
	
	        player: {
	            timer: null,
	            isActive: false
	        },
	
	        // Loaders
	        ajaxLoad: null,
	        imgPreload: null,
	
	        // Some collections
	        transitions: {},
	        helpers: {},
	
	        /*
	         *	Static methods
	         */
	
	        open: function(group, opts) {
	            if (!group) {
	                return;
	            }
	
	            if (!jQuery.isPlainObject(opts)) {
	                opts = {};
	            }
	
	            // Close if already active
	            if (false === F.close(true)) {
	                return;
	            }
	
	            // Normalize group
	            if (!jQuery.isArray(group)) {
	                group = isQuery(group) ? jQuery(group).get() : [group];
	            }
	
	            // Recheck if the type of each element is `object` and set content type (image, ajax, etc)
	            jQuery.each(group, function(i, element) {
	                var obj = {},
	                    href,
	                    title,
	                    content,
	                    type,
	                    rez,
	                    hrefParts,
	                    selector;
	
	                if (jQuery.type(element) === "object") {
	                    // Check if is DOM element
	                    if (element.nodeType) {
	                        element = jQuery(element);
	                    }
	
	                    if (isQuery(element)) {
	                        obj = {
	                            href: element.data('fancybox-href') || element.attr('href'),
	                            title: jQuery('<div/>').text(element.data('fancybox-title') || element.attr('title') || '').html(),
	                            isDom: true,
	                            element: element
	                        };
	
	                        if (jQuery.metadata) {
	                            jQuery.extend(true, obj, element.metadata());
	                        }
	
	                    } else {
	                        obj = element;
	                    }
	                }
	
	                href = opts.href || obj.href || (isString(element) ? element : null);
	                title = opts.title !== undefined ? opts.title : obj.title || '';
	
	                content = opts.content || obj.content;
	                type = content ? 'html' : (opts.type || obj.type);
	
	                if (!type && obj.isDom) {
	                    type = element.data('fancybox-type');
	
	                    if (!type) {
	                        rez = element.prop('class').match(/fancybox\.(\w+)/);
	                        type = rez ? rez[1] : null;
	                    }
	                }
	
	                if (isString(href)) {
	                    // Try to guess the content type
	                    if (!type) {
	                        if (F.isImage(href)) {
	                            type = 'image';
	
	                        } else if (F.isSWF(href)) {
	                            type = 'swf';
	
	                        } else if (href.charAt(0) === '#') {
	                            type = 'inline';
	
	                        } else if (isString(element)) {
	                            type = 'html';
	                            content = element;
	                        }
	                    }
	
	                    // Split url into two pieces with source url and content selector, e.g,
	                    // "/mypage.html #my_id" will load "/mypage.html" and display element having id "my_id"
	                    if (type === 'ajax') {
	                        hrefParts = href.split(/\s+/, 2);
	                        href = hrefParts.shift();
	                        selector = hrefParts.shift();
	                    }
	                }
	
	                if (!content) {
	                    if (type === 'inline') {
	                        if (href) {
	                            content = jQuery(isString(href) ? href.replace(/.*(?=#[^\s]+$)/, '') : href); //strip for ie7
	
	                        } else if (obj.isDom) {
	                            content = element;
	                        }
	
	                    } else if (type === 'html') {
	                        content = href;
	
	                    } else if (!type && !href && obj.isDom) {
	                        type = 'inline';
	                        content = element;
	                    }
	                }
	
	                jQuery.extend(obj, {
	                    href: href,
	                    type: type,
	                    content: content,
	                    title: title,
	                    selector: selector
	                });
	
	                group[i] = obj;
	            });
	
	            // Extend the defaults
	            F.opts = jQuery.extend(true, {}, F.defaults, opts);
	
	            // All options are merged recursive except keys
	            if (opts.keys !== undefined) {
	                F.opts.keys = opts.keys ? jQuery.extend({}, F.defaults.keys, opts.keys) : false;
	            }
	
	            F.group = group;
	
	            return F._start(F.opts.index);
	        },
	
	        // Cancel image loading or abort ajax request
	        cancel: function() {
	            var coming = F.coming;
	
	            if (coming && false === F.trigger('onCancel')) {
	                return;
	            }
	
	            F.hideLoading();
	
	            if (!coming) {
	                return;
	            }
	
	            if (F.ajaxLoad) {
	                F.ajaxLoad.abort();
	            }
	
	            F.ajaxLoad = null;
	
	            if (F.imgPreload) {
	                F.imgPreload.onload = F.imgPreload.onerror = null;
	            }
	
	            if (coming.wrap) {
	                coming.wrap.stop(true, true).trigger('onReset').remove();
	            }
	
	            F.coming = null;
	
	            // If the first item has been canceled, then clear everything
	            if (!F.current) {
	                F._afterZoomOut(coming);
	            }
	        },
	
	        // Start closing animation if is open; remove immediately if opening/closing
	        close: function(event) {
	            F.cancel();
	
	            if (false === F.trigger('beforeClose')) {
	                return;
	            }
	
	            F.unbindEvents();
	
	            if (!F.isActive) {
	                return;
	            }
	
	            if (!F.isOpen || event === true) {
	                jQuery('.fancybox-wrap').stop(true).trigger('onReset').remove();
	
	                F._afterZoomOut();
	
	            } else {
	                F.isOpen = F.isOpened = false;
	                F.isClosing = true;
	
	                jQuery('.fancybox-item, .fancybox-nav').remove();
	
	                F.wrap.stop(true, true).removeClass('fancybox-opened');
	
	                F.transitions[F.current.closeMethod]();
	            }
	        },
	
	        // Manage slideshow:
	        //   jQuery.fancybox.play(); - toggle slideshow
	        //   jQuery.fancybox.play( true ); - start
	        //   jQuery.fancybox.play( false ); - stop
	        play: function(action) {
	            var clear = function() {
	                    clearTimeout(F.player.timer);
	                },
	                set = function() {
	                    clear();
	
	                    if (F.current && F.player.isActive) {
	                        F.player.timer = setTimeout(F.next, F.current.playSpeed);
	                    }
	                },
	                stop = function() {
	                    clear();
	
	                    D.unbind('.player');
	
	                    F.player.isActive = false;
	
	                    F.trigger('onPlayEnd');
	                },
	                start = function() {
	                    if (F.current && (F.current.loop || F.current.index < F.group.length - 1)) {
	                        F.player.isActive = true;
	
	                        D.bind({
	                            'onCancel.player beforeClose.player': stop,
	                            'onUpdate.player': set,
	                            'beforeLoad.player': clear
	                        });
	
	                        set();
	
	                        F.trigger('onPlayStart');
	                    }
	                };
	
	            if (action === true || (!F.player.isActive && action !== false)) {
	                start();
	            } else {
	                stop();
	            }
	        },
	
	        // Navigate to next gallery item
	        next: function(direction) {
	            var current = F.current;
	
	            if (current) {
	                if (!isString(direction)) {
	                    direction = current.direction.next;
	                }
	
	                F.jumpto(current.index + 1, direction, 'next');
	            }
	        },
	
	        // Navigate to previous gallery item
	        prev: function(direction) {
	            var current = F.current;
	
	            if (current) {
	                if (!isString(direction)) {
	                    direction = current.direction.prev;
	                }
	
	                F.jumpto(current.index - 1, direction, 'prev');
	            }
	        },
	
	        // Navigate to gallery item by index
	        jumpto: function(index, direction, router) {
	            var current = F.current;
	
	            if (!current) {
	                return;
	            }
	
	            index = getScalar(index);
	
	            F.direction = direction || current.direction[(index >= current.index ? 'next' : 'prev')];
	            F.router = router || 'jumpto';
	
	            if (current.loop) {
	                if (index < 0) {
	                    index = current.group.length + (index % current.group.length);
	                }
	
	                index = index % current.group.length;
	            }
	
	            if (current.group[index] !== undefined) {
	                F.cancel();
	
	                F._start(index);
	            }
	        },
	
	        // Center inside viewport and toggle position type to fixed or absolute if needed
	        reposition: function(e, onlyAbsolute) {
	            var current = F.current,
	                wrap = current ? current.wrap : null,
	                pos;
	
	            if (wrap) {
	                pos = F._getPosition(onlyAbsolute);
	
	                if (e && e.type === 'scroll') {
	                    delete pos.position;
	
	                    wrap.stop(true, true).animate(pos, 200);
	
	                } else {
	                    wrap.css(pos);
	
	                    current.pos = jQuery.extend({}, current.dim, pos);
	                }
	            }
	        },
	
	        update: function(e) {
	            var type = (e && e.originalEvent && e.originalEvent.type),
	                anyway = !type || type === 'orientationchange';
	
	            if (anyway) {
	                clearTimeout(didUpdate);
	
	                didUpdate = null;
	            }
	
	            if (!F.isOpen || didUpdate) {
	                return;
	            }
	
	            didUpdate = setTimeout(function() {
	                var current = F.current;
	
	                if (!current || F.isClosing) {
	                    return;
	                }
	
	                F.wrap.removeClass('fancybox-tmp');
	
	                if (anyway || type === 'load' || (type === 'resize' && current.autoResize)) {
	                    F._setDimension();
	                }
	
	                if (!(type === 'scroll' && current.canShrink)) {
	                    F.reposition(e);
	                }
	
	                F.trigger('onUpdate');
	
	                didUpdate = null;
	
	            }, (anyway && !isTouch ? 0 : 300));
	        },
	
	        // Shrink content to fit inside viewport or restore if resized
	        toggle: function(action) {
	            if (F.isOpen) {
	                F.current.fitToView = jQuery.type(action) === "boolean" ? action : !F.current.fitToView;
	
	                // Help browser to restore document dimensions
	                if (isTouch) {
	                    F.wrap.removeAttr('style').addClass('fancybox-tmp');
	
	                    F.trigger('onUpdate');
	                }
	
	                F.update();
	            }
	        },
	
	        hideLoading: function() {
	            D.unbind('.loading');
	
	            jQuery('#fancybox-loading').remove();
	        },
	
	        showLoading: function() {
	            var el, viewport;
	
	            F.hideLoading();
	
	            el = jQuery(F.opts.tpl.loading).click(F.cancel).appendTo('body');
	
	            // If user will press the escape-button, the request will be canceled
	            D.bind('keydown.loading', function(e) {
	                if ((e.which || e.keyCode) === 27) {
	                    e.preventDefault();
	
	                    F.cancel();
	                }
	            });
	
	            if (!F.defaults.fixed) {
	                viewport = F.getViewport();
	
	                el.css({
	                    position: 'absolute',
	                    top: (viewport.h * 0.5) + viewport.y,
	                    left: (viewport.w * 0.5) + viewport.x
	                });
	            }
	
	            F.trigger('onLoading');
	        },
	
	        getViewport: function() {
	            var locked = (F.current && F.current.locked) || false,
	                rez = {
	                    x: W.scrollLeft(),
	                    y: W.scrollTop()
	                };
	
	            if (locked && locked.length) {
	                rez.w = locked[0].clientWidth;
	                rez.h = locked[0].clientHeight;
	
	            } else {
	                // See http://bugs.jquery.com/ticket/6724
	                rez.w = isTouch && window.innerWidth ? window.innerWidth : W.width();
	                rez.h = isTouch && window.innerHeight ? window.innerHeight : W.height();
	            }
	
	            return rez;
	        },
	
	        // Unbind the keyboard / clicking actions
	        unbindEvents: function() {
	            if (F.wrap && isQuery(F.wrap)) {
	                F.wrap.unbind('.fb');
	            }
	
	            D.unbind('.fb');
	            W.unbind('.fb');
	        },
	
	        bindEvents: function() {
	            var current = F.current,
	                keys;
	
	            if (!current) {
	                return;
	            }
	
	            // Changing document height on iOS devices triggers a 'resize' event,
	            // that can change document height... repeating infinitely
	            W.bind('orientationchange.fb' + (isTouch ? '' : ' resize.fb') + (current.autoCenter && !current.locked ? ' scroll.fb' : ''), F.update);
	
	            keys = current.keys;
	
	            if (keys) {
	                D.bind('keydown.fb', function(e) {
	                    var code = e.which || e.keyCode,
	                        target = e.target || e.srcElement;
	
	                    // Skip esc key if loading, because showLoading will cancel preloading
	                    if (code === 27 && F.coming) {
	                        return false;
	                    }
	
	                    // Ignore key combinations and key events within form elements
	                    if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey && !(target && (target.type || jQuery(target).is('[contenteditable]')))) {
	                        jQuery.each(keys, function(i, val) {
	                            if (current.group.length > 1 && val[code] !== undefined) {
	                                F[i](val[code]);
	
	                                e.preventDefault();
	                                return false;
	                            }
	
	                            if (jQuery.inArray(code, val) > -1) {
	                                F[i]();
	
	                                e.preventDefault();
	                                return false;
	                            }
	                        });
	                    }
	                });
	            }
	
	            if (jQuery.fn.mousewheel && current.mouseWheel) {
	                F.wrap.bind('mousewheel.fb', function(e, delta, deltaX, deltaY) {
	                    var target = e.target || null,
	                        parent = jQuery(target),
	                        canScroll = false;
	
	                    while (parent.length) {
	                        if (canScroll || parent.is('.fancybox-skin') || parent.is('.fancybox-wrap')) {
	                            break;
	                        }
	
	                        canScroll = isScrollable(parent[0]);
	                        parent = jQuery(parent).parent();
	                    }
	
	                    if (delta !== 0 && !canScroll) {
	                        if (F.group.length > 1 && !current.canShrink) {
	                            if (deltaY > 0 || deltaX > 0) {
	                                F.prev(deltaY > 0 ? 'down' : 'left');
	
	                            } else if (deltaY < 0 || deltaX < 0) {
	                                F.next(deltaY < 0 ? 'up' : 'right');
	                            }
	
	                            e.preventDefault();
	                        }
	                    }
	                });
	            }
	        },
	
	        trigger: function(event, o) {
	            var ret, obj = o || F.coming || F.current;
	
	            if (obj) {
	                if (jQuery.isFunction(obj[event])) {
	                    ret = obj[event].apply(obj, Array.prototype.slice.call(arguments, 1));
	                }
	
	                if (ret === false) {
	                    return false;
	                }
	
	                if (obj.helpers) {
	                    jQuery.each(obj.helpers, function(helper, opts) {
	                        if (opts && F.helpers[helper] && jQuery.isFunction(F.helpers[helper][event])) {
	                            F.helpers[helper][event](jQuery.extend(true, {}, F.helpers[helper].defaults, opts), obj);
	                        }
	                    });
	                }
	            }
	
	            D.trigger(event);
	        },
	
	        isImage: function(str) {
	            return isString(str) && str.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);
	        },
	
	        isSWF: function(str) {
	            return isString(str) && str.match(/\.(swf)((\?|#).*)?$/i);
	        },
	
	        _start: function(index) {
	            var coming = {},
	                obj,
	                href,
	                type,
	                margin,
	                padding;
	
	            index = getScalar(index);
	            obj = F.group[index] || null;
	
	            if (!obj) {
	                return false;
	            }
	
	            coming = jQuery.extend(true, {}, F.opts, obj);
	
	            // Convert margin and padding properties to array - top, right, bottom, left
	            margin = coming.margin;
	            padding = coming.padding;
	
	            if (jQuery.type(margin) === 'number') {
	                coming.margin = [margin, margin, margin, margin];
	            }
	
	            if (jQuery.type(padding) === 'number') {
	                coming.padding = [padding, padding, padding, padding];
	            }
	
	            // 'modal' propery is just a shortcut
	            if (coming.modal) {
	                jQuery.extend(true, coming, {
	                    closeBtn: false,
	                    closeClick: false,
	                    nextClick: false,
	                    arrows: false,
	                    mouseWheel: false,
	                    keys: null,
	                    helpers: {
	                        overlay: {
	                            closeClick: false
	                        }
	                    }
	                });
	            }
	
	            // 'autoSize' property is a shortcut, too
	            if (coming.autoSize) {
	                coming.autoWidth = coming.autoHeight = true;
	            }
	
	            if (coming.width === 'auto') {
	                coming.autoWidth = true;
	            }
	
	            if (coming.height === 'auto') {
	                coming.autoHeight = true;
	            }
	
	            /*
	             * Add reference to the group, so it`s possible to access from callbacks, example:
	             * afterLoad : function() {
	             *     this.title = 'Image ' + (this.index + 1) + ' of ' + this.group.length + (this.title ? ' - ' + this.title : '');
	             * }
	             */
	
	            coming.group = F.group;
	            coming.index = index;
	
	            // Give a chance for callback or helpers to update coming item (type, title, etc)
	            F.coming = coming;
	
	            if (false === F.trigger('beforeLoad')) {
	                F.coming = null;
	
	                return;
	            }
	
	            type = coming.type;
	            href = coming.href;
	
	            if (!type) {
	                F.coming = null;
	
	                //If we can not determine content type then drop silently or display next/prev item if looping through gallery
	                if (F.current && F.router && F.router !== 'jumpto') {
	                    F.current.index = index;
	
	                    return F[F.router](F.direction);
	                }
	
	                return false;
	            }
	
	            F.isActive = true;
	
	            if (type === 'image' || type === 'swf') {
	                coming.autoHeight = coming.autoWidth = false;
	                coming.scrolling = 'visible';
	            }
	
	            if (type === 'image') {
	                coming.aspectRatio = true;
	            }
	
	            if (type === 'iframe' && isTouch) {
	                coming.scrolling = 'scroll';
	            }
	
	            // Build the neccessary markup
	            coming.wrap = jQuery(coming.tpl.wrap).addClass('fancybox-' + (isTouch ? 'mobile' : 'desktop') + ' fancybox-type-' + type + ' fancybox-tmp ' + coming.wrapCSS).appendTo(coming.parent || 'body');
	
	            jQuery.extend(coming, {
	                skin: jQuery('.fancybox-skin', coming.wrap),
	                outer: jQuery('.fancybox-outer', coming.wrap),
	                inner: jQuery('.fancybox-inner', coming.wrap)
	            });
	
	            jQuery.each(["Top", "Right", "Bottom", "Left"], function(i, v) {
	                coming.skin.css('padding' + v, getValue(coming.padding[i]));
	            });
	
	            F.trigger('onReady');
	
	            // Check before try to load; 'inline' and 'html' types need content, others - href
	            if (type === 'inline' || type === 'html') {
	                if (!coming.content || !coming.content.length) {
	                    return F._error('content');
	                }
	
	            } else if (!href) {
	                return F._error('href');
	            }
	
	            if (type === 'image') {
	                F._loadImage();
	
	            } else if (type === 'ajax') {
	                F._loadAjax();
	
	            } else if (type === 'iframe') {
	                F._loadIframe();
	
	            } else {
	                F._afterLoad();
	            }
	        },
	
	        _error: function(type) {
	            jQuery.extend(F.coming, {
	                type: 'html',
	                autoWidth: true,
	                autoHeight: true,
	                minWidth: 0,
	                minHeight: 0,
	                scrolling: 'no',
	                hasError: type,
	                content: F.coming.tpl.error
	            });
	
	            F._afterLoad();
	        },
	
	        _loadImage: function() {
	            // Reset preload image so it is later possible to check "complete" property
	            var img = F.imgPreload = new Image();
	
	            img.onload = function() {
	                this.onload = this.onerror = null;
	
	                F.coming.width = this.width / F.opts.pixelRatio;
	                F.coming.height = this.height / F.opts.pixelRatio;
	
	                F._afterLoad();
	            };
	
	            img.onerror = function() {
	                this.onload = this.onerror = null;
	
	                F._error('image');
	            };
	
	            img.src = F.coming.href;
	
	            if (img.complete !== true) {
	                F.showLoading();
	            }
	        },
	
	        _loadAjax: function() {
	            var coming = F.coming;
	
	            F.showLoading();
	
	            F.ajaxLoad = jQuery.ajax(jQuery.extend({}, coming.ajax, {
	                url: coming.href,
	                error: function(jqXHR, textStatus) {
	                    if (F.coming && textStatus !== 'abort') {
	                        F._error('ajax', jqXHR);
	
	                    } else {
	                        F.hideLoading();
	                    }
	                },
	                success: function(data, textStatus) {
	                    if (textStatus === 'success') {
	                        coming.content = data;
	
	                        F._afterLoad();
	                    }
	                }
	            }));
	        },
	
	        _loadIframe: function() {
	            var coming = F.coming,
	                iframe = jQuery(coming.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime()))
	                .attr('scrolling', isTouch ? 'auto' : coming.iframe.scrolling)
	                .attr('src', coming.href);
	
	            // This helps IE
	            jQuery(coming.wrap).bind('onReset', function() {
	                try {
	                    jQuery(this).find('iframe').hide().attr('src', '//about:blank').end().empty();
	                } catch (e) {}
	            });
	
	            if (coming.iframe.preload) {
	                F.showLoading();
	
	                iframe.one('load', function() {
	                    jQuery(this).data('ready', 1);
	
	                    // iOS will lose scrolling if we resize
	                    if (!isTouch) {
	                        jQuery(this).bind('load.fb', F.update);
	                    }
	
	                    // Without this trick:
	                    //   - iframe won't scroll on iOS devices
	                    //   - IE7 sometimes displays empty iframe
	                    jQuery(this).parents('.fancybox-wrap').width('100%').removeClass('fancybox-tmp').show();
	
	                    F._afterLoad();
	                });
	            }
	
	            coming.content = iframe.appendTo(coming.inner);
	
	            if (!coming.iframe.preload) {
	                F._afterLoad();
	            }
	        },
	
	        _preloadImages: function() {
	            var group = F.group,
	                current = F.current,
	                len = group.length,
	                cnt = current.preload ? Math.min(current.preload, len - 1) : 0,
	                item,
	                i;
	
	            for (i = 1; i <= cnt; i += 1) {
	                item = group[(current.index + i) % len];
	
	                if (item.type === 'image' && item.href) {
	                    new Image().src = item.href;
	                }
	            }
	        },
	
	        _afterLoad: function() {
	            var coming = F.coming,
	                previous = F.current,
	                placeholder = 'fancybox-placeholder',
	                current,
	                content,
	                type,
	                scrolling,
	                href,
	                embed;
	
	            F.hideLoading();
	
	            if (!coming || F.isActive === false) {
	                return;
	            }
	
	            if (false === F.trigger('afterLoad', coming, previous)) {
	                coming.wrap.stop(true).trigger('onReset').remove();
	
	                F.coming = null;
	
	                return;
	            }
	
	            if (previous) {
	                F.trigger('beforeChange', previous);
	
	                previous.wrap.stop(true).removeClass('fancybox-opened')
	                    .find('.fancybox-item, .fancybox-nav')
	                    .remove();
	            }
	
	            F.unbindEvents();
	
	            current = coming;
	            content = coming.content;
	            type = coming.type;
	            scrolling = coming.scrolling;
	
	            jQuery.extend(F, {
	                wrap: current.wrap,
	                skin: current.skin,
	                outer: current.outer,
	                inner: current.inner,
	                current: current,
	                previous: previous
	            });
	
	            href = current.href;
	
	            switch (type) {
	                case 'inline':
	                case 'ajax':
	                case 'html':
	                    if (current.selector) {
	                        content = jQuery('<div>').html(content).find(current.selector);
	
	                    } else if (isQuery(content)) {
	                        if (!content.data(placeholder)) {
	                            content.data(placeholder, jQuery('<div class="' + placeholder + '"></div>').insertAfter(content).hide());
	                        }
	
	                        content = content.show().detach();
	
	                        current.wrap.bind('onReset', function() {
	                            if (jQuery(this).find(content).length) {
	                                content.hide().replaceAll(content.data(placeholder)).data(placeholder, false);
	                            }
	                        });
	                    }
	                    break;
	
	                case 'image':
	                    content = current.tpl.image.replace(/\{href\}/g, href);
	                    break;
	
	                case 'swf':
	                    content = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + href + '"></param>';
	                    embed = '';
	
	                    jQuery.each(current.swf, function(name, val) {
	                        content += '<param name="' + name + '" value="' + val + '"></param>';
	                        embed += ' ' + name + '="' + val + '"';
	                    });
	
	                    content += '<embed src="' + href + '" type="application/x-shockwave-flash" width="100%" height="100%"' + embed + '></embed></object>';
	                    break;
	            }
	
	            if (!(isQuery(content) && content.parent().is(current.inner))) {
	                current.inner.append(content);
	            }
	
	            // Give a chance for helpers or callbacks to update elements
	            F.trigger('beforeShow');
	
	            // Set scrolling before calculating dimensions
	            current.inner.css('overflow', scrolling === 'yes' ? 'scroll' : (scrolling === 'no' ? 'hidden' : scrolling));
	
	            // Set initial dimensions and start position
	            F._setDimension();
	
	            F.reposition();
	
	            F.isOpen = false;
	            F.coming = null;
	
	            F.bindEvents();
	
	            if (!F.isOpened) {
	                jQuery('.fancybox-wrap').not(current.wrap).stop(true).trigger('onReset').remove();
	
	            } else if (previous.prevMethod) {
	                F.transitions[previous.prevMethod]();
	            }
	
	            F.transitions[F.isOpened ? current.nextMethod : current.openMethod]();
	
	            F._preloadImages();
	        },
	
	        _setDimension: function() {
	            var viewport = F.getViewport(),
	                steps = 0,
	                canShrink = false,
	                canExpand = false,
	                wrap = F.wrap,
	                skin = F.skin,
	                inner = F.inner,
	                current = F.current,
	                width = current.width,
	                height = current.height,
	                minWidth = current.minWidth,
	                minHeight = current.minHeight,
	                maxWidth = current.maxWidth,
	                maxHeight = current.maxHeight,
	                scrolling = current.scrolling,
	                scrollOut = current.scrollOutside ? current.scrollbarWidth : 0,
	                margin = current.margin,
	                wMargin = getScalar(margin[1] + margin[3]),
	                hMargin = getScalar(margin[0] + margin[2]),
	                wPadding,
	                hPadding,
	                wSpace,
	                hSpace,
	                origWidth,
	                origHeight,
	                origMaxWidth,
	                origMaxHeight,
	                ratio,
	                width_,
	                height_,
	                maxWidth_,
	                maxHeight_,
	                iframe,
	                body;
	
	            // Reset dimensions so we could re-check actual size
	            wrap.add(skin).add(inner).width('auto').height('auto').removeClass('fancybox-tmp');
	
	            wPadding = getScalar(skin.outerWidth(true) - skin.width());
	            hPadding = getScalar(skin.outerHeight(true) - skin.height());
	
	            // Any space between content and viewport (margin, padding, border, title)
	            wSpace = wMargin + wPadding;
	            hSpace = hMargin + hPadding;
	
	            origWidth = isPercentage(width) ? (viewport.w - wSpace) * getScalar(width) / 100 : width;
	            origHeight = isPercentage(height) ? (viewport.h - hSpace) * getScalar(height) / 100 : height;
	
	            if (current.type === 'iframe') {
	                iframe = current.content;
	
	                if (current.autoHeight && iframe.data('ready') === 1) {
	                    try {
	                        if (iframe[0].contentWindow.document.location) {
	                            inner.width(origWidth).height(9999);
	
	                            body = iframe.contents().find('body');
	
	                            if (scrollOut) {
	                                body.css('overflow-x', 'hidden');
	                            }
	
	                            origHeight = body.outerHeight(true);
	                        }
	
	                    } catch (e) {}
	                }
	
	            } else if (current.autoWidth || current.autoHeight) {
	                inner.addClass('fancybox-tmp');
	
	                // Set width or height in case we need to calculate only one dimension
	                if (!current.autoWidth) {
	                    inner.width(origWidth);
	                }
	
	                if (!current.autoHeight) {
	                    inner.height(origHeight);
	                }
	
	                if (current.autoWidth) {
	                    origWidth = inner.width();
	                }
	
	                if (current.autoHeight) {
	                    origHeight = inner.height();
	                }
	
	                inner.removeClass('fancybox-tmp');
	            }
	
	            width = getScalar(origWidth);
	            height = getScalar(origHeight);
	
	            ratio = origWidth / origHeight;
	
	            // Calculations for the content
	            minWidth = getScalar(isPercentage(minWidth) ? getScalar(minWidth, 'w') - wSpace : minWidth);
	            maxWidth = getScalar(isPercentage(maxWidth) ? getScalar(maxWidth, 'w') - wSpace : maxWidth);
	
	            minHeight = getScalar(isPercentage(minHeight) ? getScalar(minHeight, 'h') - hSpace : minHeight);
	            maxHeight = getScalar(isPercentage(maxHeight) ? getScalar(maxHeight, 'h') - hSpace : maxHeight);
	
	            // These will be used to determine if wrap can fit in the viewport
	            origMaxWidth = maxWidth;
	            origMaxHeight = maxHeight;
	
	            if (current.fitToView) {
	                maxWidth = Math.min(viewport.w - wSpace, maxWidth);
	                maxHeight = Math.min(viewport.h - hSpace, maxHeight);
	            }
	
	            maxWidth_ = viewport.w - wMargin;
	            maxHeight_ = viewport.h - hMargin;
	
	            if (current.aspectRatio) {
	                if (width > maxWidth) {
	                    width = maxWidth;
	                    height = getScalar(width / ratio);
	                }
	
	                if (height > maxHeight) {
	                    height = maxHeight;
	                    width = getScalar(height * ratio);
	                }
	
	                if (width < minWidth) {
	                    width = minWidth;
	                    height = getScalar(width / ratio);
	                }
	
	                if (height < minHeight) {
	                    height = minHeight;
	                    width = getScalar(height * ratio);
	                }
	
	            } else {
	                width = Math.max(minWidth, Math.min(width, maxWidth));
	
	                if (current.autoHeight && current.type !== 'iframe') {
	                    inner.width(width);
	
	                    height = inner.height();
	                }
	
	                height = Math.max(minHeight, Math.min(height, maxHeight));
	            }
	
	            // Try to fit inside viewport (including the title)
	            if (current.fitToView) {
	                inner.width(width).height(height);
	
	                wrap.width(width + wPadding);
	
	                // Real wrap dimensions
	                width_ = wrap.width();
	                height_ = wrap.height();
	
	                if (current.aspectRatio) {
	                    while ((width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight) {
	                        if (steps++ > 19) {
	                            break;
	                        }
	
	                        height = Math.max(minHeight, Math.min(maxHeight, height - 10));
	                        width = getScalar(height * ratio);
	
	                        if (width < minWidth) {
	                            width = minWidth;
	                            height = getScalar(width / ratio);
	                        }
	
	                        if (width > maxWidth) {
	                            width = maxWidth;
	                            height = getScalar(width / ratio);
	                        }
	
	                        inner.width(width).height(height);
	
	                        wrap.width(width + wPadding);
	
	                        width_ = wrap.width();
	                        height_ = wrap.height();
	                    }
	
	                } else {
	                    width = Math.max(minWidth, Math.min(width, width - (width_ - maxWidth_)));
	                    height = Math.max(minHeight, Math.min(height, height - (height_ - maxHeight_)));
	                }
	            }
	
	            if (scrollOut && scrolling === 'auto' && height < origHeight && (width + wPadding + scrollOut) < maxWidth_) {
	                width += scrollOut;
	            }
	
	            inner.width(width).height(height);
	
	            wrap.width(width + wPadding);
	
	            width_ = wrap.width();
	            height_ = wrap.height();
	
	            canShrink = (width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight;
	            canExpand = current.aspectRatio ? (width < origMaxWidth && height < origMaxHeight && width < origWidth && height < origHeight) : ((width < origMaxWidth || height < origMaxHeight) && (width < origWidth || height < origHeight));
	
	            jQuery.extend(current, {
	                dim: {
	                    width: getValue(width_),
	                    height: getValue(height_)
	                },
	                origWidth: origWidth,
	                origHeight: origHeight,
	                canShrink: canShrink,
	                canExpand: canExpand,
	                wPadding: wPadding,
	                hPadding: hPadding,
	                wrapSpace: height_ - skin.outerHeight(true),
	                skinSpace: skin.height() - height
	            });
	
	            if (!iframe && current.autoHeight && height > minHeight && height < maxHeight && !canExpand) {
	                inner.height('auto');
	            }
	        },
	
	        _getPosition: function(onlyAbsolute) {
	            var current = F.current,
	                viewport = F.getViewport(),
	                margin = current.margin,
	                width = F.wrap.width() + margin[1] + margin[3],
	                height = F.wrap.height() + margin[0] + margin[2],
	                rez = {
	                    position: 'absolute',
	                    top: margin[0],
	                    left: margin[3]
	                };
	
	            if (current.autoCenter && current.fixed && !onlyAbsolute && height <= viewport.h && width <= viewport.w) {
	                rez.position = 'fixed';
	
	            } else if (!current.locked) {
	                rez.top += viewport.y;
	                rez.left += viewport.x;
	            }
	
	            rez.top = getValue(Math.max(rez.top, rez.top + ((viewport.h - height) * current.topRatio)));
	            rez.left = getValue(Math.max(rez.left, rez.left + ((viewport.w - width) * current.leftRatio)));
	
	            return rez;
	        },
	
	        _afterZoomIn: function() {
	            var current = F.current;
	
	            if (!current) {
	                return;
	            }
	
	            F.isOpen = F.isOpened = true;
	
	            F.wrap.css('overflow', 'visible').addClass('fancybox-opened').hide().show(0);
	
	            F.update();
	
	            // Assign a click event
	            if (current.closeClick || (current.nextClick && F.group.length > 1)) {
	                F.inner.css('cursor', 'pointer').bind('click.fb', function(e) {
	                    if (!jQuery(e.target).is('a') && !jQuery(e.target).parent().is('a')) {
	                        e.preventDefault();
	
	                        F[current.closeClick ? 'close' : 'next']();
	                    }
	                });
	            }
	
	            // Create a close button
	            if (current.closeBtn) {
	                jQuery(current.tpl.closeBtn).appendTo(F.skin).bind('click.fb', function(e) {
	                    e.preventDefault();
	
	                    F.close();
	                });
	            }
	
	            // Create navigation arrows
	            if (current.arrows && F.group.length > 1) {
	                if (current.loop || current.index > 0) {
	                    jQuery(current.tpl.prev).appendTo(F.outer).bind('click.fb', F.prev);
	                }
	
	                if (current.loop || current.index < F.group.length - 1) {
	                    jQuery(current.tpl.next).appendTo(F.outer).bind('click.fb', F.next);
	                }
	            }
	
	            F.trigger('afterShow');
	
	            // Stop the slideshow if this is the last item
	            if (!current.loop && current.index === current.group.length - 1) {
	
	                F.play(false);
	
	            } else if (F.opts.autoPlay && !F.player.isActive) {
	                F.opts.autoPlay = false;
	
	                F.play(true);
	            }
	        },
	
	        _afterZoomOut: function(obj) {
	            obj = obj || F.current;
	
	            jQuery('.fancybox-wrap').trigger('onReset').remove();
	
	            jQuery.extend(F, {
	                group: {},
	                opts: {},
	                router: false,
	                current: null,
	                isActive: false,
	                isOpened: false,
	                isOpen: false,
	                isClosing: false,
	                wrap: null,
	                skin: null,
	                outer: null,
	                inner: null
	            });
	
	            F.trigger('afterClose', obj);
	        }
	    });
	
	    /*
	     *	Default transitions
	     */
	
	    F.transitions = {
	        getOrigPosition: function() {
	            var current = F.current,
	                element = current.element,
	                orig = current.orig,
	                pos = {},
	                width = 50,
	                height = 50,
	                hPadding = current.hPadding,
	                wPadding = current.wPadding,
	                viewport = F.getViewport();
	
	            if (!orig && current.isDom && element.is(':visible')) {
	                orig = element.find('img:first');
	
	                if (!orig.length) {
	                    orig = element;
	                }
	            }
	
	            if (isQuery(orig)) {
	                pos = orig.offset();
	
	                if (orig.is('img')) {
	                    width = orig.outerWidth();
	                    height = orig.outerHeight();
	                }
	
	            } else {
	                pos.top = viewport.y + (viewport.h - height) * current.topRatio;
	                pos.left = viewport.x + (viewport.w - width) * current.leftRatio;
	            }
	
	            if (F.wrap.css('position') === 'fixed' || current.locked) {
	                pos.top -= viewport.y;
	                pos.left -= viewport.x;
	            }
	
	            pos = {
	                top: getValue(pos.top - hPadding * current.topRatio),
	                left: getValue(pos.left - wPadding * current.leftRatio),
	                width: getValue(width + wPadding),
	                height: getValue(height + hPadding)
	            };
	
	            return pos;
	        },
	
	        step: function(now, fx) {
	            var ratio,
	                padding,
	                value,
	                prop = fx.prop,
	                current = F.current,
	                wrapSpace = current.wrapSpace,
	                skinSpace = current.skinSpace;
	
	            if (prop === 'width' || prop === 'height') {
	                ratio = fx.end === fx.start ? 1 : (now - fx.start) / (fx.end - fx.start);
	
	                if (F.isClosing) {
	                    ratio = 1 - ratio;
	                }
	
	                padding = prop === 'width' ? current.wPadding : current.hPadding;
	                value = now - padding;
	
	                F.skin[prop](getScalar(prop === 'width' ? value : value - (wrapSpace * ratio)));
	                F.inner[prop](getScalar(prop === 'width' ? value : value - (wrapSpace * ratio) - (skinSpace * ratio)));
	            }
	        },
	
	        zoomIn: function() {
	            var current = F.current,
	                startPos = current.pos,
	                effect = current.openEffect,
	                elastic = effect === 'elastic',
	                endPos = jQuery.extend({
	                    opacity: 1
	                }, startPos);
	
	            // Remove "position" property that breaks older IE
	            delete endPos.position;
	
	            if (elastic) {
	                startPos = this.getOrigPosition();
	
	                if (current.openOpacity) {
	                    startPos.opacity = 0.1;
	                }
	
	            } else if (effect === 'fade') {
	                startPos.opacity = 0.1;
	            }
	
	            F.wrap.css(startPos).animate(endPos, {
	                duration: effect === 'none' ? 0 : current.openSpeed,
	                easing: current.openEasing,
	                step: elastic ? this.step : null,
	                complete: F._afterZoomIn
	            });
	        },
	
	        zoomOut: function() {
	            var current = F.current,
	                effect = current.closeEffect,
	                elastic = effect === 'elastic',
	                endPos = {
	                    opacity: 0.1
	                };
	
	            if (elastic) {
	                endPos = this.getOrigPosition();
	
	                if (current.closeOpacity) {
	                    endPos.opacity = 0.1;
	                }
	            }
	
	            F.wrap.animate(endPos, {
	                duration: effect === 'none' ? 0 : current.closeSpeed,
	                easing: current.closeEasing,
	                step: elastic ? this.step : null,
	                complete: F._afterZoomOut
	            });
	        },
	
	        changeIn: function() {
	            var current = F.current,
	                effect = current.nextEffect,
	                startPos = current.pos,
	                endPos = {
	                    opacity: 1
	                },
	                direction = F.direction,
	                distance = 200,
	                field;
	
	            startPos.opacity = 0.1;
	
	            if (effect === 'elastic') {
	                field = direction === 'down' || direction === 'up' ? 'top' : 'left';
	
	                if (direction === 'down' || direction === 'right') {
	                    startPos[field] = getValue(getScalar(startPos[field]) - distance);
	                    endPos[field] = '+=' + distance + 'px';
	
	                } else {
	                    startPos[field] = getValue(getScalar(startPos[field]) + distance);
	                    endPos[field] = '-=' + distance + 'px';
	                }
	            }
	
	            // Workaround for http://bugs.jquery.com/ticket/12273
	            if (effect === 'none') {
	                F._afterZoomIn();
	
	            } else {
	                F.wrap.css(startPos).animate(endPos, {
	                    duration: current.nextSpeed,
	                    easing: current.nextEasing,
	                    complete: F._afterZoomIn
	                });
	            }
	        },
	
	        changeOut: function() {
	            var previous = F.previous,
	                effect = previous.prevEffect,
	                endPos = {
	                    opacity: 0.1
	                },
	                direction = F.direction,
	                distance = 200;
	
	            if (effect === 'elastic') {
	                endPos[direction === 'down' || direction === 'up' ? 'top' : 'left'] = (direction === 'up' || direction === 'left' ? '-' : '+') + '=' + distance + 'px';
	            }
	
	            previous.wrap.animate(endPos, {
	                duration: effect === 'none' ? 0 : previous.prevSpeed,
	                easing: previous.prevEasing,
	                complete: function() {
	                    jQuery(this).trigger('onReset').remove();
	                }
	            });
	        }
	    };
	
	    /*
	     *	Overlay helper
	     */
	
	    F.helpers.overlay = {
	        defaults: {
	            closeClick: true, // if true, fancyBox will be closed when user clicks on the overlay
	            speedOut: 200, // duration of fadeOut animation
	            showEarly: true, // indicates if should be opened immediately or wait until the content is ready
	            css: {}, // custom CSS properties
	            locked: !isTouch, // if true, the content will be locked into overlay
	            fixed: true // if false, the overlay CSS position property will not be set to "fixed"
	        },
	
	        overlay: null, // current handle
	        fixed: false, // indicates if the overlay has position "fixed"
	        el: jQuery('html'), // element that contains "the lock"
	
	        // Public methods
	        create: function(opts) {
	            var parent;
	
	            opts = jQuery.extend({}, this.defaults, opts);
	
	            if (this.overlay) {
	                this.close();
	            }
	
	            parent = F.coming ? F.coming.parent : opts.parent;
	
	            this.overlay = jQuery('<div class="fancybox-overlay"></div>').appendTo(parent && parent.length ? parent : 'body');
	            this.fixed = false;
	
	            if (opts.fixed && F.defaults.fixed) {
	                this.overlay.addClass('fancybox-overlay-fixed');
	
	                this.fixed = true;
	            }
	        },
	
	        open: function(opts) {
	            var that = this;
	
	            opts = jQuery.extend({}, this.defaults, opts);
	
	            if (this.overlay) {
	                this.overlay.unbind('.overlay').width('auto').height('auto');
	
	            } else {
	                this.create(opts);
	            }
	
	            if (!this.fixed) {
	                W.bind('resize.overlay', jQuery.proxy(this.update, this));
	
	                this.update();
	            }
	
	            if (opts.closeClick) {
	                this.overlay.bind('click.overlay', function(e) {
	                    if (jQuery(e.target).hasClass('fancybox-overlay')) {
	                        if (F.isActive) {
	                            F.close();
	                        } else {
	                            that.close();
	                        }
	
	                        return false;
	                    }
	                });
	            }
	
	            this.overlay.css(opts.css).show();
	        },
	
	        close: function() {
	            W.unbind('resize.overlay');
	
	            if (this.el.hasClass('fancybox-lock')) {
	                jQuery('.fancybox-margin').removeClass('fancybox-margin');
	
	                this.el.removeClass('fancybox-lock');
	
	                W.scrollTop(this.scrollV).scrollLeft(this.scrollH);
	            }
	
	            jQuery('.fancybox-overlay').remove().hide();
	
	            jQuery.extend(this, {
	                overlay: null,
	                fixed: false
	            });
	        },
	
	        // Private, callbacks
	
	        update: function() {
	            var width = '100%', offsetWidth;
	
	            // Reset width/height so it will not mess
	            this.overlay.width(width).height('100%');
	
	            // jQuery does not return reliable result for IE
	            if (IE) {
	                offsetWidth = Math.max(document.documentElement.offsetWidth, document.body.offsetWidth);
	
	                if (D.width() > offsetWidth) {
	                    width = D.width();
	                }
	
	            } else if (D.width() > W.width()) {
	                width = D.width();
	            }
	
	            this.overlay.width(width).height(D.height());
	        },
	
	        // This is where we can manipulate DOM, because later it would cause iframes to reload
	        onReady: function(opts, obj) {
	            var overlay = this.overlay;
	
	            jQuery('.fancybox-overlay').stop(true, true);
	
	            if (!overlay) {
	                this.create(opts);
	            }
	
	            if (opts.locked && this.fixed && obj.fixed) {
	                obj.locked = this.overlay.append(obj.wrap);
	                obj.fixed = false;
	            }
	
	            if (opts.showEarly === true) {
	                this.beforeShow.apply(this, arguments);
	            }
	        },
	
	        beforeShow: function(opts, obj) {
	            if (obj.locked && !this.el.hasClass('fancybox-lock')) {
	                if (this.fixPosition !== false) {
	                    jQuery('*').filter(function() {
	                        return (jQuery(this).css('position') === 'fixed' && !jQuery(this).hasClass("fancybox-overlay") && !jQuery(this).hasClass("fancybox-wrap"));
	                    }).addClass('fancybox-margin');
	                }
	
	                this.el.addClass('fancybox-margin');
	
	                this.scrollV = W.scrollTop();
	                this.scrollH = W.scrollLeft();
	
	                this.el.addClass('fancybox-lock');
	
	                W.scrollTop(this.scrollV).scrollLeft(this.scrollH);
	            }
	
	            this.open(opts);
	        },
	
	        onUpdate: function() {
	            if (!this.fixed) {
	                this.update();
	            }
	        },
	
	        afterClose: function(opts) {
	            // Remove overlay if exists and fancyBox is not opening
	            // (e.g., it is not being open using afterClose callback)
	            if (this.overlay && !F.coming) {
	                this.overlay.fadeOut(opts.speedOut, jQuery.proxy(this.close, this));
	            }
	        }
	    };
	
	    /*
	     *	Title helper
	     */
	
	    F.helpers.title = {
	        defaults: {
	            type: 'float', // 'float', 'inside', 'outside' or 'over',
	            position: 'bottom' // 'top' or 'bottom'
	        },
	
	        beforeShow: function(opts) {
	            var current = F.current,
	                text = current.title,
	                type = opts.type,
	                title,
	                target;
	
	            if (jQuery.isFunction(text)) {
	                text = text.call(current.element, current);
	            }
	
	            if (!isString(text) || jQuery.trim(text) === '') {
	                return;
	            }
	
	            title = jQuery('<div class="fancybox-title fancybox-title-' + type + '-wrap">' + text + '</div>');
	
	            switch (type) {
	                case 'inside':
	                    target = F.skin;
	                    break;
	
	                case 'outside':
	                    target = F.wrap;
	                    break;
	
	                case 'over':
	                    target = F.inner;
	                    break;
	
	                default: // 'float'
	                    target = F.skin;
	
	                    title.appendTo('body');
	
	                    if (IE) {
	                        title.width(title.width());
	                    }
	
	                    title.wrapInner('<span class="child"></span>');
	
	                    //Increase bottom margin so this title will also fit into viewport
	                    F.current.margin[2] += Math.abs(getScalar(title.css('margin-bottom')));
	                    break;
	            }
	
	            title[(opts.position === 'top' ? 'prependTo' : 'appendTo')](target);
	        }
	    };
	
	    // jQuery plugin initialization
	    jQuery.fn.fancybox = function(options) {
	        var index,
	            that = jQuery(this),
	            selector = this.selector || '',
	            run = function(e) {
	                var what = jQuery(this).blur(), idx = index, relType, relVal;
	
	                if (!(e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && !what.is('.fancybox-wrap')) {
	                    relType = options.groupAttr || 'data-fancybox-group';
	                    relVal = what.attr(relType);
	
	                    if (!relVal) {
	                        relType = 'rel';
	                        relVal = what.get(0)[relType];
	                    }
	
	                    if (relVal && relVal !== '' && relVal !== 'nofollow') {
	                        what = selector.length ? jQuery(selector) : that;
	                        what = what.filter('[' + relType + '="' + relVal + '"]');
	                        idx = what.index(this);
	                    }
	
	                    options.index = idx;
	
	                    // Stop an event from bubbling if everything is fine
	                    if (F.open(what, options) !== false) {
	                        e.preventDefault();
	                    }
	                }
	            };
	
	        options = options || {};
	        index = options.index || 0;
	
	        if (!selector || options.live === false) {
	            that.unbind('click.fb-start').bind('click.fb-start', run);
	
	        } else {
	            D.undelegate(selector, 'click.fb-start').delegate(selector + ":not('.fancybox-item, .fancybox-nav')", 'click.fb-start', run);
	        }
	
	        this.filter('[data-fancybox-start=1]').trigger('click');
	
	        return this;
	    };
	
	    // Tests that need a body at doc ready
	    D.ready(function() {
	        var w1, w2;
	
	        if (jQuery.scrollbarWidth === undefined) {
	            // http://benalman.com/projects/jquery-misc-plugins/#scrollbarwidth
	            jQuery.scrollbarWidth = function() {
	                var parent = jQuery('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body'),
	                    child = parent.children(),
	                    width = child.innerWidth() - child.height(99).innerWidth();
	
	                parent.remove();
	
	                return width;
	            };
	        }
	
	        if (jQuery.support.fixedPosition === undefined) {
	            jQuery.support.fixedPosition = (function() {
	                var elem = jQuery('<div style="position:fixed;top:20px;"></div>').appendTo('body'),
	                    fixed = (elem[0].offsetTop === 20 || elem[0].offsetTop === 15);
	
	                elem.remove();
	
	                return fixed;
	            }());
	        }
	
	        jQuery.extend(F.defaults, {
	            scrollbarWidth: jQuery.scrollbarWidth(),
	            fixed: jQuery.support.fixedPosition,
	            parent: jQuery('body')
	        });
	
	        //Get real width of page scroll-bar
	        w1 = jQuery(window).width();
	
	        H.addClass('fancybox-lock-test');
	
	        w2 = jQuery(window).width();
	
	        H.removeClass('fancybox-lock-test');
	
	        jQuery("<style type='text/css'>.fancybox-margin{margin-right:" + (w2 - w1) + "px;}</style>").appendTo("head");
	    });
	}


/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * jquery-confirm v3.3.0 (http://craftpip.github.io/jquery-confirm/)
	 * Author: Boniface Pereira
	 * Website: www.craftpip.com
	 * Contact: hey@craftpip.com
	 *
	 * Copyright 2013-2017 jquery-confirm
	 * Licensed under MIT (https://github.com/craftpip/jquery-confirm/blob/master/LICENSE)
	 */
	if (typeof jQuery === "undefined") {
	  throw new Error("jquery-confirm requires jQuery");
	}var _jconfirm, Jconfirm;(function ($, window) {
	  $.fn.confirm = function (options, option2) {
	    if (typeof options === "undefined") {
	      options = {};
	    }if (typeof options === "string") {
	      options = { content: options, title: option2 ? option2 : false };
	    }$(this).each(function () {
	      var $this = $(this);if ($this.attr("jc-attached")) {
	        console.warn("jConfirm has already been attached to this element ", $this[0]);return;
	      }$this.on("click", function (e) {
	        e.preventDefault();var jcOption = $.extend({}, options);if ($this.attr("data-title")) {
	          jcOption.title = $this.attr("data-title");
	        }if ($this.attr("data-content")) {
	          jcOption.content = $this.attr("data-content");
	        }if (typeof jcOption.buttons == "undefined") {
	          jcOption.buttons = {};
	        }jcOption["$target"] = $this;if ($this.attr("href") && Object.keys(jcOption.buttons).length == 0) {
	          var buttons = $.extend(true, {}, _jconfirm.pluginDefaults.defaultButtons, (_jconfirm.defaults || {}).defaultButtons || {});var firstBtn = Object.keys(buttons)[0];jcOption.buttons = buttons;jcOption.buttons[firstBtn].action = function () {
	            location.href = $this.attr("href");
	          };
	        }jcOption.closeIcon = false;var instance = $.confirm(jcOption);
	      });$this.attr("jc-attached", true);
	    });return $(this);
	  };$.confirm = function (options, option2) {
	    if (typeof options === "undefined") {
	      options = {};
	    }if (typeof options === "string") {
	      options = { content: options, title: option2 ? option2 : false };
	    }if (_typeof(options.buttons) != "object") {
	      options.buttons = {};
	    }if (Object.keys(options.buttons).length == 0) {
	      var buttons = $.extend(true, {}, _jconfirm.pluginDefaults.defaultButtons, (_jconfirm.defaults || {}).defaultButtons || {});options.buttons = buttons;
	    }return _jconfirm(options);
	  };$.alert = function (options, option2) {
	    if (typeof options === "undefined") {
	      options = {};
	    }if (typeof options === "string") {
	      options = { content: options, title: option2 ? option2 : false };
	    }if (_typeof(options.buttons) != "object") {
	      options.buttons = {};
	    }if (Object.keys(options.buttons).length == 0) {
	      var buttons = $.extend(true, {}, _jconfirm.pluginDefaults.defaultButtons, (_jconfirm.defaults || {}).defaultButtons || {});var firstBtn = Object.keys(buttons)[0];options.buttons[firstBtn] = buttons[firstBtn];
	    }return _jconfirm(options);
	  };$.dialog = function (options, option2) {
	    if (typeof options === "undefined") {
	      options = {};
	    }if (typeof options === "string") {
	      options = { content: options, title: option2 ? option2 : false, closeIcon: function closeIcon() {} };
	    }options.buttons = {};if (typeof options.closeIcon == "undefined") {
	      options.closeIcon = function () {};
	    }options.confirmKeys = [13];return _jconfirm(options);
	  };_jconfirm = function jconfirm(options) {
	    if (typeof options === "undefined") {
	      options = {};
	    }var pluginOptions = $.extend(true, {}, _jconfirm.pluginDefaults);if (_jconfirm.defaults) {
	      pluginOptions = $.extend(true, pluginOptions, _jconfirm.defaults);
	    }pluginOptions = $.extend(true, {}, pluginOptions, options);var instance = new Jconfirm(pluginOptions);_jconfirm.instances.push(instance);return instance;
	  };Jconfirm = function Jconfirm(options) {
	    $.extend(this, options);this._init();
	  };Jconfirm.prototype = { _init: function _init() {
	      var that = this;if (!_jconfirm.instances.length) {
	        _jconfirm.lastFocused = $("body").find(":focus");
	      }this._id = Math.round(Math.random() * 99999);this.contentParsed = $(document.createElement("div"));if (!this.lazyOpen) {
	        setTimeout(function () {
	          that.open();
	        }, 0);
	      }
	    }, _buildHTML: function _buildHTML() {
	      var that = this;this._parseAnimation(this.animation, "o");this._parseAnimation(this.closeAnimation, "c");this._parseBgDismissAnimation(this.backgroundDismissAnimation);this._parseColumnClass(this.columnClass);this._parseTheme(this.theme);this._parseType(this.type);var template = $(this.template);template.find(".jconfirm-box").addClass(this.animationParsed).addClass(this.backgroundDismissAnimationParsed).addClass(this.typeParsed);if (this.typeAnimated) {
	        template.find(".jconfirm-box").addClass("jconfirm-type-animated");
	      }if (this.useBootstrap) {
	        template.find(".jc-bs3-row").addClass(this.bootstrapClasses.row);template.find(".jc-bs3-row").addClass("justify-content-md-center justify-content-sm-center justify-content-xs-center justify-content-lg-center");template.find(".jconfirm-box-container").addClass(this.columnClassParsed);if (this.containerFluid) {
	          template.find(".jc-bs3-container").addClass(this.bootstrapClasses.containerFluid);
	        } else {
	          template.find(".jc-bs3-container").addClass(this.bootstrapClasses.container);
	        }
	      } else {
	        template.find(".jconfirm-box").css("width", this.boxWidth);
	      }if (this.titleClass) {
	        template.find(".jconfirm-title-c").addClass(this.titleClass);
	      }template.addClass(this.themeParsed);var ariaLabel = "jconfirm-box" + this._id;template.find(".jconfirm-box").attr("aria-labelledby", ariaLabel).attr("tabindex", -1);template.find(".jconfirm-content").attr("id", ariaLabel);if (this.bgOpacity !== null) {
	        template.find(".jconfirm-bg").css("opacity", this.bgOpacity);
	      }if (this.rtl) {
	        template.addClass("jconfirm-rtl");
	      }this.$el = template.appendTo(this.container);this.$jconfirmBoxContainer = this.$el.find(".jconfirm-box-container");this.$jconfirmBox = this.$body = this.$el.find(".jconfirm-box");this.$jconfirmBg = this.$el.find(".jconfirm-bg");this.$title = this.$el.find(".jconfirm-title");this.$titleContainer = this.$el.find(".jconfirm-title-c");this.$content = this.$el.find("div.jconfirm-content");this.$contentPane = this.$el.find(".jconfirm-content-pane");this.$icon = this.$el.find(".jconfirm-icon-c");this.$closeIcon = this.$el.find(".jconfirm-closeIcon");this.$holder = this.$el.find(".jconfirm-holder");this.$btnc = this.$el.find(".jconfirm-buttons");this.$scrollPane = this.$el.find(".jconfirm-scrollpane");that.setStartingPoint();this._contentReady = $.Deferred();this._modalReady = $.Deferred();this.$holder.css({ "padding-top": this.offsetTop, "padding-bottom": this.offsetBottom });this.setTitle();this.setIcon();this._setButtons();this._parseContent();this.initDraggable();if (this.isAjax) {
	        this.showLoading(false);
	      }$.when(this._contentReady, this._modalReady).then(function () {
	        if (that.isAjaxLoading) {
	          setTimeout(function () {
	            that.isAjaxLoading = false;that.setContent();that.setTitle();that.setIcon();setTimeout(function () {
	              that.hideLoading(false);that._updateContentMaxHeight();
	            }, 100);if (typeof that.onContentReady === "function") {
	              that.onContentReady();
	            }
	          }, 50);
	        } else {
	          that._updateContentMaxHeight();that.setTitle();that.setIcon();if (typeof that.onContentReady === "function") {
	            that.onContentReady();
	          }
	        }if (that.autoClose) {
	          that._startCountDown();
	        }
	      });this._watchContent();if (this.animation === "none") {
	        this.animationSpeed = 1;this.animationBounce = 1;
	      }this.$body.css(this._getCSS(this.animationSpeed, this.animationBounce));this.$contentPane.css(this._getCSS(this.animationSpeed, 1));this.$jconfirmBg.css(this._getCSS(this.animationSpeed, 1));this.$jconfirmBoxContainer.css(this._getCSS(this.animationSpeed, 1));
	    }, _typePrefix: "jconfirm-type-", typeParsed: "", _parseType: function _parseType(type) {
	      this.typeParsed = this._typePrefix + type;
	    }, setType: function setType(type) {
	      var oldClass = this.typeParsed;this._parseType(type);this.$jconfirmBox.removeClass(oldClass).addClass(this.typeParsed);
	    }, themeParsed: "", _themePrefix: "jconfirm-", setTheme: function setTheme(theme) {
	      var previous = this.theme;this.theme = theme || this.theme;this._parseTheme(this.theme);if (previous) {
	        this.$el.removeClass(previous);
	      }this.$el.addClass(this.themeParsed);this.theme = theme;
	    }, _parseTheme: function _parseTheme(theme) {
	      var that = this;theme = theme.split(",");$.each(theme, function (k, a) {
	        if (a.indexOf(that._themePrefix) === -1) {
	          theme[k] = that._themePrefix + $.trim(a);
	        }
	      });this.themeParsed = theme.join(" ").toLowerCase();
	    }, backgroundDismissAnimationParsed: "", _bgDismissPrefix: "jconfirm-hilight-", _parseBgDismissAnimation: function _parseBgDismissAnimation(bgDismissAnimation) {
	      var animation = bgDismissAnimation.split(",");var that = this;$.each(animation, function (k, a) {
	        if (a.indexOf(that._bgDismissPrefix) === -1) {
	          animation[k] = that._bgDismissPrefix + $.trim(a);
	        }
	      });this.backgroundDismissAnimationParsed = animation.join(" ").toLowerCase();
	    }, animationParsed: "", closeAnimationParsed: "", _animationPrefix: "jconfirm-animation-", setAnimation: function setAnimation(animation) {
	      this.animation = animation || this.animation;this._parseAnimation(this.animation, "o");
	    }, _parseAnimation: function _parseAnimation(animation, which) {
	      which = which || "o";var animations = animation.split(",");var that = this;$.each(animations, function (k, a) {
	        if (a.indexOf(that._animationPrefix) === -1) {
	          animations[k] = that._animationPrefix + $.trim(a);
	        }
	      });var a_string = animations.join(" ").toLowerCase();if (which === "o") {
	        this.animationParsed = a_string;
	      } else {
	        this.closeAnimationParsed = a_string;
	      }return a_string;
	    }, setCloseAnimation: function setCloseAnimation(closeAnimation) {
	      this.closeAnimation = closeAnimation || this.closeAnimation;this._parseAnimation(this.closeAnimation, "c");
	    }, setAnimationSpeed: function setAnimationSpeed(speed) {
	      this.animationSpeed = speed || this.animationSpeed;
	    }, columnClassParsed: "", setColumnClass: function setColumnClass(colClass) {
	      if (!this.useBootstrap) {
	        console.warn("cannot set columnClass, useBootstrap is set to false");return;
	      }this.columnClass = colClass || this.columnClass;this._parseColumnClass(this.columnClass);this.$jconfirmBoxContainer.addClass(this.columnClassParsed);
	    }, _updateContentMaxHeight: function _updateContentMaxHeight() {
	      var height = $(window).height() - (this.$jconfirmBox.outerHeight() - this.$contentPane.outerHeight()) - (this.offsetTop + this.offsetBottom);this.$contentPane.css({ "max-height": height + "px" });
	    }, setBoxWidth: function setBoxWidth(width) {
	      if (this.useBootstrap) {
	        console.warn("cannot set boxWidth, useBootstrap is set to true");return;
	      }this.boxWidth = width;this.$jconfirmBox.css("width", width);
	    }, _parseColumnClass: function _parseColumnClass(colClass) {
	      colClass = colClass.toLowerCase();var p;switch (colClass) {case "xl":case "xlarge":
	          p = "col-md-12";break;case "l":case "large":
	          p = "col-md-8 col-md-offset-2";break;case "m":case "medium":
	          p = "col-md-6 col-md-offset-3";break;case "s":case "small":
	          p = "col-md-4 col-md-offset-4";break;case "xs":case "xsmall":
	          p = "col-md-2 col-md-offset-5";break;default:
	          p = colClass;}this.columnClassParsed = p;
	    }, initDraggable: function initDraggable() {
	      var that = this;var $t = this.$titleContainer;this.resetDrag();if (this.draggable) {
	        $t.on("mousedown", function (e) {
	          $t.addClass("jconfirm-hand");that.mouseX = e.clientX;that.mouseY = e.clientY;that.isDrag = true;
	        });$(window).on("mousemove." + this._id, function (e) {
	          if (that.isDrag) {
	            that.movingX = e.clientX - that.mouseX + that.initialX;that.movingY = e.clientY - that.mouseY + that.initialY;that.setDrag();
	          }
	        });$(window).on("mouseup." + this._id, function () {
	          $t.removeClass("jconfirm-hand");if (that.isDrag) {
	            that.isDrag = false;that.initialX = that.movingX;that.initialY = that.movingY;
	          }
	        });
	      }
	    }, resetDrag: function resetDrag() {
	      this.isDrag = false;this.initialX = 0;this.initialY = 0;this.movingX = 0;this.movingY = 0;this.mouseX = 0;this.mouseY = 0;this.$jconfirmBoxContainer.css("transform", "translate(" + 0 + "px, " + 0 + "px)");
	    }, setDrag: function setDrag() {
	      if (!this.draggable) {
	        return;
	      }this.alignMiddle = false;var boxWidth = this.$jconfirmBox.outerWidth();var boxHeight = this.$jconfirmBox.outerHeight();var windowWidth = $(window).width();var windowHeight = $(window).height();var that = this;var dragUpdate = 1;if (that.movingX % dragUpdate === 0 || that.movingY % dragUpdate === 0) {
	        if (that.dragWindowBorder) {
	          var leftDistance = windowWidth / 2 - boxWidth / 2;var topDistance = windowHeight / 2 - boxHeight / 2;topDistance -= that.dragWindowGap;leftDistance -= that.dragWindowGap;if (leftDistance + that.movingX < 0) {
	            that.movingX = -leftDistance;
	          } else {
	            if (leftDistance - that.movingX < 0) {
	              that.movingX = leftDistance;
	            }
	          }if (topDistance + that.movingY < 0) {
	            that.movingY = -topDistance;
	          } else {
	            if (topDistance - that.movingY < 0) {
	              that.movingY = topDistance;
	            }
	          }
	        }that.$jconfirmBoxContainer.css("transform", "translate(" + that.movingX + "px, " + that.movingY + "px)");
	      }
	    }, _scrollTop: function _scrollTop() {
	      if (typeof pageYOffset !== "undefined") {
	        return pageYOffset;
	      } else {
	        var B = document.body;var D = document.documentElement;D = D.clientHeight ? D : B;return D.scrollTop;
	      }
	    }, _watchContent: function _watchContent() {
	      var that = this;if (this._timer) {
	        clearInterval(this._timer);
	      }var prevContentHeight = 0;this._timer = setInterval(function () {
	        if (that.smoothContent) {
	          var contentHeight = that.$content.outerHeight() || 0;if (contentHeight !== prevContentHeight) {
	            that.$contentPane.css({ height: contentHeight }).scrollTop(0);prevContentHeight = contentHeight;
	          }var wh = $(window).height();var total = that.offsetTop + that.offsetBottom + that.$jconfirmBox.height() - that.$contentPane.height() + that.$content.height();if (total < wh) {
	            that.$contentPane.addClass("no-scroll");
	          } else {
	            that.$contentPane.removeClass("no-scroll");
	          }
	        }
	      }, this.watchInterval);
	    }, _overflowClass: "jconfirm-overflow", _hilightAnimating: false, highlight: function highlight() {
	      this.hiLightModal();
	    }, hiLightModal: function hiLightModal() {
	      var that = this;if (this._hilightAnimating) {
	        return;
	      }that.$body.addClass("hilight");var duration = parseFloat(that.$body.css("animation-duration")) || 2;this._hilightAnimating = true;setTimeout(function () {
	        that._hilightAnimating = false;that.$body.removeClass("hilight");
	      }, duration * 1000);
	    }, _bindEvents: function _bindEvents() {
	      var that = this;this.boxClicked = false;this.$scrollPane.click(function (e) {
	        if (!that.boxClicked) {
	          var buttonName = false;var shouldClose = false;var str;if (typeof that.backgroundDismiss == "function") {
	            str = that.backgroundDismiss();
	          } else {
	            str = that.backgroundDismiss;
	          }if (typeof str == "string" && typeof that.buttons[str] != "undefined") {
	            buttonName = str;shouldClose = false;
	          } else {
	            if (typeof str == "undefined" || !!str == true) {
	              shouldClose = true;
	            } else {
	              shouldClose = false;
	            }
	          }if (buttonName) {
	            var btnResponse = that.buttons[buttonName].action.apply(that);shouldClose = typeof btnResponse == "undefined" || !!btnResponse;
	          }if (shouldClose) {
	            that.close();
	          } else {
	            that.hiLightModal();
	          }
	        }that.boxClicked = false;
	      });this.$jconfirmBox.click(function (e) {
	        that.boxClicked = true;
	      });var isKeyDown = false;$(window).on("jcKeyDown." + that._id, function (e) {
	        if (!isKeyDown) {
	          isKeyDown = true;
	        }
	      });$(window).on("keyup." + that._id, function (e) {
	        if (isKeyDown) {
	          that.reactOnKey(e);isKeyDown = false;
	        }
	      });$(window).on("resize." + this._id, function () {
	        that._updateContentMaxHeight();setTimeout(function () {
	          that.resetDrag();
	        }, 100);
	      });
	    }, _cubic_bezier: "0.36, 0.55, 0.19", _getCSS: function _getCSS(speed, bounce) {
	      return { "-webkit-transition-duration": speed / 1000 + "s", "transition-duration": speed / 1000 + "s", "-webkit-transition-timing-function": "cubic-bezier(" + this._cubic_bezier + ", " + bounce + ")", "transition-timing-function": "cubic-bezier(" + this._cubic_bezier + ", " + bounce + ")" };
	    }, _setButtons: function _setButtons() {
	      var that = this;var total_buttons = 0;if (_typeof(this.buttons) !== "object") {
	        this.buttons = {};
	      }$.each(this.buttons, function (key, button) {
	        total_buttons += 1;if (typeof button === "function") {
	          that.buttons[key] = button = { action: button };
	        }that.buttons[key].text = button.text || key;that.buttons[key].btnClass = button.btnClass || "btn-default";that.buttons[key].action = button.action || function () {};that.buttons[key].keys = button.keys || [];that.buttons[key].isHidden = button.isHidden || false;that.buttons[key].isDisabled = button.isDisabled || false;$.each(that.buttons[key].keys, function (i, a) {
	          that.buttons[key].keys[i] = a.toLowerCase();
	        });var button_element = $('<button type="button" class="btn"></button>').html(that.buttons[key].text).addClass(that.buttons[key].btnClass).prop("disabled", that.buttons[key].isDisabled).css("display", that.buttons[key].isHidden ? "none" : "").click(function (e) {
	          e.preventDefault();var res = that.buttons[key].action.apply(that, [that.buttons[key]]);that.onAction.apply(that, [key, that.buttons[key]]);that._stopCountDown();if (typeof res === "undefined" || res) {
	            that.close();
	          }
	        });that.buttons[key].el = button_element;that.buttons[key].setText = function (text) {
	          button_element.html(text);
	        };that.buttons[key].addClass = function (className) {
	          button_element.addClass(className);
	        };that.buttons[key].removeClass = function (className) {
	          button_element.removeClass(className);
	        };that.buttons[key].disable = function () {
	          that.buttons[key].isDisabled = true;button_element.prop("disabled", true);
	        };that.buttons[key].enable = function () {
	          that.buttons[key].isDisabled = false;button_element.prop("disabled", false);
	        };that.buttons[key].show = function () {
	          that.buttons[key].isHidden = false;button_element.css("display", "");
	        };that.buttons[key].hide = function () {
	          that.buttons[key].isHidden = true;button_element.css("display", "none");
	        };that["$_" + key] = that["$$" + key] = button_element;that.$btnc.append(button_element);
	      });if (total_buttons === 0) {
	        this.$btnc.hide();
	      }if (this.closeIcon === null && total_buttons === 0) {
	        this.closeIcon = true;
	      }if (this.closeIcon) {
	        if (this.closeIconClass) {
	          var closeHtml = '<i class="' + this.closeIconClass + '"></i>';this.$closeIcon.html(closeHtml);
	        }this.$closeIcon.click(function (e) {
	          e.preventDefault();var buttonName = false;var shouldClose = false;var str;if (typeof that.closeIcon == "function") {
	            str = that.closeIcon();
	          } else {
	            str = that.closeIcon;
	          }if (typeof str == "string" && typeof that.buttons[str] != "undefined") {
	            buttonName = str;shouldClose = false;
	          } else {
	            if (typeof str == "undefined" || !!str == true) {
	              shouldClose = true;
	            } else {
	              shouldClose = false;
	            }
	          }if (buttonName) {
	            var btnResponse = that.buttons[buttonName].action.apply(that);shouldClose = typeof btnResponse == "undefined" || !!btnResponse;
	          }if (shouldClose) {
	            that.close();
	          }
	        });this.$closeIcon.show();
	      } else {
	        this.$closeIcon.hide();
	      }
	    }, setTitle: function setTitle(string, force) {
	      force = force || false;if (typeof string !== "undefined") {
	        if (typeof string == "string") {
	          this.title = string;
	        } else {
	          if (typeof string == "function") {
	            if (typeof string.promise == "function") {
	              console.error("Promise was returned from title function, this is not supported.");
	            }var response = string();if (typeof response == "string") {
	              this.title = response;
	            } else {
	              this.title = false;
	            }
	          } else {
	            this.title = false;
	          }
	        }
	      }if (this.isAjaxLoading && !force) {
	        return;
	      }this.$title.html(this.title || "");this.updateTitleContainer();
	    }, setIcon: function setIcon(iconClass, force) {
	      force = force || false;if (typeof iconClass !== "undefined") {
	        if (typeof iconClass == "string") {
	          this.icon = iconClass;
	        } else {
	          if (typeof iconClass === "function") {
	            var response = iconClass();if (typeof response == "string") {
	              this.icon = response;
	            } else {
	              this.icon = false;
	            }
	          } else {
	            this.icon = false;
	          }
	        }
	      }if (this.isAjaxLoading && !force) {
	        return;
	      }this.$icon.html(this.icon ? '<i class="' + this.icon + '"></i>' : "");this.updateTitleContainer();
	    }, updateTitleContainer: function updateTitleContainer() {
	      if (!this.title && !this.icon) {
	        this.$titleContainer.hide();
	      } else {
	        this.$titleContainer.show();
	      }
	    }, setContentPrepend: function setContentPrepend(content, force) {
	      if (!content) {
	        return;
	      }this.contentParsed.prepend(content);
	    }, setContentAppend: function setContentAppend(content) {
	      if (!content) {
	        return;
	      }this.contentParsed.append(content);
	    }, setContent: function setContent(content, force) {
	      force = !!force;var that = this;if (content) {
	        this.contentParsed.html("").append(content);
	      }if (this.isAjaxLoading && !force) {
	        return;
	      }this.$content.html("");this.$content.append(this.contentParsed);setTimeout(function () {
	        that.$body.find("input[autofocus]:visible:first").focus();
	      }, 100);
	    }, loadingSpinner: false, showLoading: function showLoading(disableButtons) {
	      this.loadingSpinner = true;this.$jconfirmBox.addClass("loading");if (disableButtons) {
	        this.$btnc.find("button").prop("disabled", true);
	      }
	    }, hideLoading: function hideLoading(enableButtons) {
	      this.loadingSpinner = false;this.$jconfirmBox.removeClass("loading");if (enableButtons) {
	        this.$btnc.find("button").prop("disabled", false);
	      }
	    }, ajaxResponse: false, contentParsed: "", isAjax: false, isAjaxLoading: false, _parseContent: function _parseContent() {
	      var that = this;var e = "&nbsp;";if (typeof this.content == "function") {
	        var res = this.content.apply(this);if (typeof res == "string") {
	          this.content = res;
	        } else {
	          if ((typeof res === "undefined" ? "undefined" : _typeof(res)) == "object" && typeof res.always == "function") {
	            this.isAjax = true;this.isAjaxLoading = true;res.always(function (data, status, xhr) {
	              that.ajaxResponse = { data: data, status: status, xhr: xhr };that._contentReady.resolve(data, status, xhr);if (typeof that.contentLoaded == "function") {
	                that.contentLoaded(data, status, xhr);
	              }
	            });this.content = e;
	          } else {
	            this.content = e;
	          }
	        }
	      }if (typeof this.content == "string" && this.content.substr(0, 4).toLowerCase() === "url:") {
	        this.isAjax = true;this.isAjaxLoading = true;var u = this.content.substring(4, this.content.length);$.get(u).done(function (html) {
	          that.contentParsed.html(html);
	        }).always(function (data, status, xhr) {
	          that.ajaxResponse = { data: data, status: status, xhr: xhr };that._contentReady.resolve(data, status, xhr);if (typeof that.contentLoaded == "function") {
	            that.contentLoaded(data, status, xhr);
	          }
	        });
	      }if (!this.content) {
	        this.content = e;
	      }if (!this.isAjax) {
	        this.contentParsed.html(this.content);this.setContent();that._contentReady.resolve();
	      }
	    }, _stopCountDown: function _stopCountDown() {
	      clearInterval(this.autoCloseInterval);if (this.$cd) {
	        this.$cd.remove();
	      }
	    }, _startCountDown: function _startCountDown() {
	      var that = this;var opt = this.autoClose.split("|");if (opt.length !== 2) {
	        console.error("Invalid option for autoClose. example 'close|10000'");return false;
	      }var button_key = opt[0];var time = parseInt(opt[1]);if (typeof this.buttons[button_key] === "undefined") {
	        console.error("Invalid button key '" + button_key + "' for autoClose");return false;
	      }var seconds = Math.ceil(time / 1000);this.$cd = $('<span class="countdown"> (' + seconds + ")</span>").appendTo(this["$_" + button_key]);this.autoCloseInterval = setInterval(function () {
	        that.$cd.html(" (" + (seconds -= 1) + ") ");if (seconds <= 0) {
	          that["$$" + button_key].trigger("click");that._stopCountDown();
	        }
	      }, 1000);
	    }, _getKey: function _getKey(key) {
	      switch (key) {case 192:
	          return "tilde";case 13:
	          return "enter";case 16:
	          return "shift";case 9:
	          return "tab";case 20:
	          return "capslock";case 17:
	          return "ctrl";case 91:
	          return "win";case 18:
	          return "alt";case 27:
	          return "esc";case 32:
	          return "space";}var initial = String.fromCharCode(key);if (/^[A-z0-9]+$/.test(initial)) {
	        return initial.toLowerCase();
	      } else {
	        return false;
	      }
	    }, reactOnKey: function reactOnKey(e) {
	      var that = this;var a = $(".jconfirm");if (a.eq(a.length - 1)[0] !== this.$el[0]) {
	        return false;
	      }var key = e.which;if (this.$content.find(":input").is(":focus") && /13|32/.test(key)) {
	        return false;
	      }var keyChar = this._getKey(key);if (keyChar === "esc" && this.escapeKey) {
	        if (this.escapeKey === true) {
	          this.$scrollPane.trigger("click");
	        } else {
	          if (typeof this.escapeKey === "string" || typeof this.escapeKey === "function") {
	            var buttonKey;if (typeof this.escapeKey === "function") {
	              buttonKey = this.escapeKey();
	            } else {
	              buttonKey = this.escapeKey;
	            }if (buttonKey) {
	              if (typeof this.buttons[buttonKey] === "undefined") {
	                console.warn("Invalid escapeKey, no buttons found with key " + buttonKey);
	              } else {
	                this["$_" + buttonKey].trigger("click");
	              }
	            }
	          }
	        }
	      }$.each(this.buttons, function (key, button) {
	        if (button.keys.indexOf(keyChar) != -1) {
	          that["$_" + key].trigger("click");
	        }
	      });
	    }, setDialogCenter: function setDialogCenter() {
	      console.info("setDialogCenter is deprecated, dialogs are centered with CSS3 tables");
	    }, _unwatchContent: function _unwatchContent() {
	      clearInterval(this._timer);
	    }, close: function close() {
	      var that = this;if (typeof this.onClose === "function") {
	        this.onClose();
	      }this._unwatchContent();$(window).unbind("resize." + this._id);$(window).unbind("keyup." + this._id);$(window).unbind("jcKeyDown." + this._id);if (this.draggable) {
	        $(window).unbind("mousemove." + this._id);$(window).unbind("mouseup." + this._id);this.$titleContainer.unbind("mousedown");
	      }that.$el.removeClass(that.loadedClass);$("body").removeClass("jconfirm-no-scroll-" + that._id);that.$jconfirmBoxContainer.removeClass("jconfirm-no-transition");setTimeout(function () {
	        that.$body.addClass(that.closeAnimationParsed);that.$jconfirmBg.addClass("jconfirm-bg-h");var closeTimer = that.closeAnimation === "none" ? 1 : that.animationSpeed;setTimeout(function () {
	          that.$el.remove();var l = _jconfirm.instances;var i = _jconfirm.instances.length - 1;for (i; i >= 0; i--) {
	            if (_jconfirm.instances[i]._id === that._id) {
	              _jconfirm.instances.splice(i, 1);
	            }
	          }if (!_jconfirm.instances.length) {
	            if (that.scrollToPreviousElement && _jconfirm.lastFocused && _jconfirm.lastFocused.length && $.contains(document, _jconfirm.lastFocused[0])) {
	              var $lf = _jconfirm.lastFocused;if (that.scrollToPreviousElementAnimate) {
	                var st = $(window).scrollTop();var ot = _jconfirm.lastFocused.offset().top;var wh = $(window).height();if (!(ot > st && ot < st + wh)) {
	                  var scrollTo = ot - Math.round(wh / 3);$("html, body").animate({ scrollTop: scrollTo }, that.animationSpeed, "swing", function () {
	                    $lf.focus();
	                  });
	                } else {
	                  $lf.focus();
	                }
	              } else {
	                $lf.focus();
	              }_jconfirm.lastFocused = false;
	            }
	          }if (typeof that.onDestroy === "function") {
	            that.onDestroy();
	          }
	        }, closeTimer * 0.4);
	      }, 50);return true;
	    }, open: function open() {
	      if (this.isOpen()) {
	        return false;
	      }this._buildHTML();this._bindEvents();this._open();return true;
	    }, setStartingPoint: function setStartingPoint() {
	      var el = false;if (this.animateFromElement !== true && this.animateFromElement) {
	        el = this.animateFromElement;_jconfirm.lastClicked = false;
	      } else {
	        if (_jconfirm.lastClicked && this.animateFromElement === true) {
	          el = _jconfirm.lastClicked;_jconfirm.lastClicked = false;
	        } else {
	          return false;
	        }
	      }if (!el) {
	        return false;
	      }var offset = el.offset();var iTop = el.outerHeight() / 2;var iLeft = el.outerWidth() / 2;iTop -= this.$jconfirmBox.outerHeight() / 2;iLeft -= this.$jconfirmBox.outerWidth() / 2;var sourceTop = offset.top + iTop;sourceTop = sourceTop - this._scrollTop();var sourceLeft = offset.left + iLeft;var wh = $(window).height() / 2;var ww = $(window).width() / 2;var targetH = wh - this.$jconfirmBox.outerHeight() / 2;var targetW = ww - this.$jconfirmBox.outerWidth() / 2;sourceTop -= targetH;sourceLeft -= targetW;if (Math.abs(sourceTop) > wh || Math.abs(sourceLeft) > ww) {
	        return false;
	      }this.$jconfirmBoxContainer.css("transform", "translate(" + sourceLeft + "px, " + sourceTop + "px)");
	    }, _open: function _open() {
	      var that = this;if (typeof that.onOpenBefore === "function") {
	        that.onOpenBefore();
	      }this.$body.removeClass(this.animationParsed);this.$jconfirmBg.removeClass("jconfirm-bg-h");this.$body.focus();that.$jconfirmBoxContainer.css("transform", "translate(" + 0 + "px, " + 0 + "px)");setTimeout(function () {
	        that.$body.css(that._getCSS(that.animationSpeed, 1));that.$body.css({ "transition-property": that.$body.css("transition-property") + ", margin" });that.$jconfirmBoxContainer.addClass("jconfirm-no-transition");that._modalReady.resolve();if (typeof that.onOpen === "function") {
	          that.onOpen();
	        }that.$el.addClass(that.loadedClass);
	      }, this.animationSpeed);
	    }, loadedClass: "jconfirm-open", isClosed: function isClosed() {
	      return !this.$el || this.$el.css("display") === "";
	    }, isOpen: function isOpen() {
	      return !this.isClosed();
	    }, toggle: function toggle() {
	      if (!this.isOpen()) {
	        this.open();
	      } else {
	        this.close();
	      }
	    } };_jconfirm.instances = [];_jconfirm.lastFocused = false;_jconfirm.pluginDefaults = { template: '<div class="jconfirm"><div class="jconfirm-bg jconfirm-bg-h"></div><div class="jconfirm-scrollpane"><div class="jconfirm-row"><div class="jconfirm-cell"><div class="jconfirm-holder"><div class="jc-bs3-container"><div class="jc-bs3-row"><div class="jconfirm-box-container jconfirm-animated"><div class="jconfirm-box" role="dialog" aria-labelledby="labelled" tabindex="-1"><div class="jconfirm-closeIcon">&times;</div><div class="jconfirm-title-c"><span class="jconfirm-icon-c"></span><span class="jconfirm-title"></span></div><div class="jconfirm-content-pane"><div class="jconfirm-content"></div></div><div class="jconfirm-buttons"></div><div class="jconfirm-clear"></div></div></div></div></div></div></div></div></div></div>', title: "Hello", titleClass: "", type: "default", typeAnimated: true, draggable: true, dragWindowGap: 15, dragWindowBorder: true, animateFromElement: true, alignMiddle: true, smoothContent: true, content: "Are you sure to continue?", buttons: {}, defaultButtons: { ok: { action: function action() {} }, close: { action: function action() {} } }, contentLoaded: function contentLoaded() {}, icon: "", lazyOpen: false, bgOpacity: null, theme: "light", animation: "scale", closeAnimation: "scale", animationSpeed: 400, animationBounce: 1, escapeKey: true, rtl: false, container: "body", containerFluid: false, backgroundDismiss: false, backgroundDismissAnimation: "shake", autoClose: false, closeIcon: null, closeIconClass: false, watchInterval: 100, columnClass: "col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1", boxWidth: "50%", scrollToPreviousElement: true, scrollToPreviousElementAnimate: true, useBootstrap: true, offsetTop: 40, offsetBottom: 40, bootstrapClasses: { container: "container", containerFluid: "container-fluid", row: "row" }, onContentReady: function onContentReady() {}, onOpenBefore: function onOpenBefore() {}, onOpen: function onOpen() {}, onClose: function onClose() {}, onDestroy: function onDestroy() {}, onAction: function onAction() {} };var keyDown = false;$(window).on("keydown", function (e) {
	    if (!keyDown) {
	      var $target = $(e.target);var pass = false;if ($target.closest(".jconfirm-box").length) {
	        pass = true;
	      }if (pass) {
	        $(window).trigger("jcKeyDown");
	      }keyDown = true;
	    }
	  });$(window).on("keyup", function () {
	    keyDown = false;
	  });_jconfirm.lastClicked = false;$(document).on("mousedown", "button, a", function () {
	    _jconfirm.lastClicked = $(this);
	  });
	})(jQuery, window);

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! Select2 4.0.10 | https://github.com/select2/select2/blob/master/LICENSE.md */
	!function (n) {
	   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (n), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = function (e, t) {
	    return void 0 === t && (t = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), n(t), t;
	  } : n(jQuery);
	}(function (u) {
	  var e = function () {
	    if (u && u.fn && u.fn.select2 && u.fn.select2.amd) var e = u.fn.select2.amd;var t, n, r, h, o, _s, f, g, m, v, y, _, i, a, w;function b(e, t) {
	      return i.call(e, t);
	    }function l(e, t) {
	      var n,
	          r,
	          i,
	          o,
	          s,
	          a,
	          l,
	          c,
	          u,
	          d,
	          p,
	          h = t && t.split("/"),
	          f = y.map,
	          g = f && f["*"] || {};if (e) {
	        for (s = (e = e.split("/")).length - 1, y.nodeIdCompat && w.test(e[s]) && (e[s] = e[s].replace(w, "")), "." === e[0].charAt(0) && h && (e = h.slice(0, h.length - 1).concat(e)), u = 0; u < e.length; u++) {
	          if ("." === (p = e[u])) e.splice(u, 1), u -= 1;else if (".." === p) {
	            if (0 === u || 1 === u && ".." === e[2] || ".." === e[u - 1]) continue;0 < u && (e.splice(u - 1, 2), u -= 2);
	          }
	        }e = e.join("/");
	      }if ((h || g) && f) {
	        for (u = (n = e.split("/")).length; 0 < u; u -= 1) {
	          if (r = n.slice(0, u).join("/"), h) for (d = h.length; 0 < d; d -= 1) {
	            if (i = (i = f[h.slice(0, d).join("/")]) && i[r]) {
	              o = i, a = u;break;
	            }
	          }if (o) break;!l && g && g[r] && (l = g[r], c = u);
	        }!o && l && (o = l, a = c), o && (n.splice(0, a, o), e = n.join("/"));
	      }return e;
	    }function A(t, n) {
	      return function () {
	        var e = a.call(arguments, 0);return "string" != typeof e[0] && 1 === e.length && e.push(null), _s.apply(h, e.concat([t, n]));
	      };
	    }function x(t) {
	      return function (e) {
	        m[t] = e;
	      };
	    }function D(e) {
	      if (b(v, e)) {
	        var t = v[e];delete v[e], _[e] = !0, o.apply(h, t);
	      }if (!b(m, e) && !b(_, e)) throw new Error("No " + e);return m[e];
	    }function c(e) {
	      var t,
	          n = e ? e.indexOf("!") : -1;return -1 < n && (t = e.substring(0, n), e = e.substring(n + 1, e.length)), [t, e];
	    }function S(e) {
	      return e ? c(e) : [];
	    }return e && e.requirejs || (e ? n = e : e = {}, m = {}, v = {}, y = {}, _ = {}, i = Object.prototype.hasOwnProperty, a = [].slice, w = /\.js$/, f = function f(e, t) {
	      var n,
	          r = c(e),
	          i = r[0],
	          o = t[1];return e = r[1], i && (n = D(i = l(i, o))), i ? e = n && n.normalize ? n.normalize(e, function (t) {
	        return function (e) {
	          return l(e, t);
	        };
	      }(o)) : l(e, o) : (i = (r = c(e = l(e, o)))[0], e = r[1], i && (n = D(i))), { f: i ? i + "!" + e : e, n: e, pr: i, p: n };
	    }, g = { require: function require(e) {
	        return A(e);
	      }, exports: function exports(e) {
	        var t = m[e];return void 0 !== t ? t : m[e] = {};
	      }, module: function module(e) {
	        return { id: e, uri: "", exports: m[e], config: function (e) {
	            return function () {
	              return y && y.config && y.config[e] || {};
	            };
	          }(e) };
	      } }, o = function o(e, t, n, r) {
	      var i,
	          o,
	          s,
	          a,
	          l,
	          c,
	          u,
	          d = [],
	          p = typeof n === "undefined" ? "undefined" : _typeof(n);if (c = S(r = r || e), "undefined" == p || "function" == p) {
	        for (t = !t.length && n.length ? ["require", "exports", "module"] : t, l = 0; l < t.length; l += 1) {
	          if ("require" === (o = (a = f(t[l], c)).f)) d[l] = g.require(e);else if ("exports" === o) d[l] = g.exports(e), u = !0;else if ("module" === o) i = d[l] = g.module(e);else if (b(m, o) || b(v, o) || b(_, o)) d[l] = D(o);else {
	            if (!a.p) throw new Error(e + " missing " + o);a.p.load(a.n, A(r, !0), x(o), {}), d[l] = m[o];
	          }
	        }s = n ? n.apply(m[e], d) : void 0, e && (i && i.exports !== h && i.exports !== m[e] ? m[e] = i.exports : s === h && u || (m[e] = s));
	      } else e && (m[e] = n);
	    }, t = n = _s = function s(e, t, n, r, i) {
	      if ("string" == typeof e) return g[e] ? g[e](t) : D(f(e, S(t)).f);if (!e.splice) {
	        if ((y = e).deps && _s(y.deps, y.callback), !t) return;t.splice ? (e = t, t = n, n = null) : e = h;
	      }return t = t || function () {}, "function" == typeof n && (n = r, r = i), r ? o(h, e, t, n) : setTimeout(function () {
	        o(h, e, t, n);
	      }, 4), _s;
	    }, _s.config = function (e) {
	      return _s(e);
	    }, t._defined = m, (r = function r(e, t, n) {
	      if ("string" != typeof e) throw new Error("See almond README: incorrect module build, no module name");t.splice || (n = t, t = []), b(m, e) || b(v, e) || (v[e] = [e, t, n]);
	    }).amd = { jQuery: !0 }, e.requirejs = t, e.require = n, e.define = r), e.define("almond", function () {}), e.define("jquery", [], function () {
	      var e = u || $;return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), e;
	    }), e.define("select2/utils", ["jquery"], function (o) {
	      var i = {};function u(e) {
	        var t = e.prototype,
	            n = [];for (var r in t) {
	          "function" == typeof t[r] && "constructor" !== r && n.push(r);
	        }return n;
	      }i.Extend = function (e, t) {
	        var n = {}.hasOwnProperty;function r() {
	          this.constructor = e;
	        }for (var i in t) {
	          n.call(t, i) && (e[i] = t[i]);
	        }return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
	      }, i.Decorate = function (r, i) {
	        var e = u(i),
	            t = u(r);function o() {
	          var e = Array.prototype.unshift,
	              t = i.prototype.constructor.length,
	              n = r.prototype.constructor;0 < t && (e.call(arguments, r.prototype.constructor), n = i.prototype.constructor), n.apply(this, arguments);
	        }i.displayName = r.displayName, o.prototype = new function () {
	          this.constructor = o;
	        }();for (var n = 0; n < t.length; n++) {
	          var s = t[n];o.prototype[s] = r.prototype[s];
	        }function a(e) {
	          var t = function t() {};e in o.prototype && (t = o.prototype[e]);var n = i.prototype[e];return function () {
	            return Array.prototype.unshift.call(arguments, t), n.apply(this, arguments);
	          };
	        }for (var l = 0; l < e.length; l++) {
	          var c = e[l];o.prototype[c] = a(c);
	        }return o;
	      };function e() {
	        this.listeners = {};
	      }e.prototype.on = function (e, t) {
	        this.listeners = this.listeners || {}, e in this.listeners ? this.listeners[e].push(t) : this.listeners[e] = [t];
	      }, e.prototype.trigger = function (e) {
	        var t = Array.prototype.slice,
	            n = t.call(arguments, 1);this.listeners = this.listeners || {}, null == n && (n = []), 0 === n.length && n.push({}), (n[0]._type = e) in this.listeners && this.invoke(this.listeners[e], t.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments);
	      }, e.prototype.invoke = function (e, t) {
	        for (var n = 0, r = e.length; n < r; n++) {
	          e[n].apply(this, t);
	        }
	      }, i.Observable = e, i.generateChars = function (e) {
	        for (var t = "", n = 0; n < e; n++) {
	          t += Math.floor(36 * Math.random()).toString(36);
	        }return t;
	      }, i.bind = function (e, t) {
	        return function () {
	          e.apply(t, arguments);
	        };
	      }, i._convertData = function (e) {
	        for (var t in e) {
	          var n = t.split("-"),
	              r = e;if (1 !== n.length) {
	            for (var i = 0; i < n.length; i++) {
	              var o = n[i];(o = o.substring(0, 1).toLowerCase() + o.substring(1)) in r || (r[o] = {}), i == n.length - 1 && (r[o] = e[t]), r = r[o];
	            }delete e[t];
	          }
	        }return e;
	      }, i.hasScroll = function (e, t) {
	        var n = o(t),
	            r = t.style.overflowX,
	            i = t.style.overflowY;return (r !== i || "hidden" !== i && "visible" !== i) && ("scroll" === r || "scroll" === i || n.innerHeight() < t.scrollHeight || n.innerWidth() < t.scrollWidth);
	      }, i.escapeMarkup = function (e) {
	        var t = { "\\": "&#92;", "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#47;" };return "string" != typeof e ? e : String(e).replace(/[&<>"'\/\\]/g, function (e) {
	          return t[e];
	        });
	      }, i.appendMany = function (e, t) {
	        if ("1.7" === o.fn.jquery.substr(0, 3)) {
	          var n = o();o.map(t, function (e) {
	            n = n.add(e);
	          }), t = n;
	        }e.append(t);
	      }, i.__cache = {};var n = 0;return i.GetUniqueElementId = function (e) {
	        var t = e.getAttribute("data-select2-id");return null == t && (e.id ? (t = e.id, e.setAttribute("data-select2-id", t)) : (e.setAttribute("data-select2-id", ++n), t = n.toString())), t;
	      }, i.StoreData = function (e, t, n) {
	        var r = i.GetUniqueElementId(e);i.__cache[r] || (i.__cache[r] = {}), i.__cache[r][t] = n;
	      }, i.GetData = function (e, t) {
	        var n = i.GetUniqueElementId(e);return t ? i.__cache[n] && null != i.__cache[n][t] ? i.__cache[n][t] : o(e).data(t) : i.__cache[n];
	      }, i.RemoveData = function (e) {
	        var t = i.GetUniqueElementId(e);null != i.__cache[t] && delete i.__cache[t], e.removeAttribute("data-select2-id");
	      }, i;
	    }), e.define("select2/results", ["jquery", "./utils"], function (h, f) {
	      function r(e, t, n) {
	        this.$element = e, this.data = n, this.options = t, r.__super__.constructor.call(this);
	      }return f.Extend(r, f.Observable), r.prototype.render = function () {
	        var e = h('<ul class="select2-results__options" role="listbox"></ul>');return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), this.$results = e;
	      }, r.prototype.clear = function () {
	        this.$results.empty();
	      }, r.prototype.displayMessage = function (e) {
	        var t = this.options.get("escapeMarkup");this.clear(), this.hideLoading();var n = h('<li role="alert" aria-live="assertive" class="select2-results__option"></li>'),
	            r = this.options.get("translations").get(e.message);n.append(t(r(e.args))), n[0].className += " select2-results__message", this.$results.append(n);
	      }, r.prototype.hideMessages = function () {
	        this.$results.find(".select2-results__message").remove();
	      }, r.prototype.append = function (e) {
	        this.hideLoading();var t = [];if (null != e.results && 0 !== e.results.length) {
	          e.results = this.sort(e.results);for (var n = 0; n < e.results.length; n++) {
	            var r = e.results[n],
	                i = this.option(r);t.push(i);
	          }this.$results.append(t);
	        } else 0 === this.$results.children().length && this.trigger("results:message", { message: "noResults" });
	      }, r.prototype.position = function (e, t) {
	        t.find(".select2-results").append(e);
	      }, r.prototype.sort = function (e) {
	        return this.options.get("sorter")(e);
	      }, r.prototype.highlightFirstItem = function () {
	        var e = this.$results.find(".select2-results__option[aria-selected]"),
	            t = e.filter("[aria-selected=true]");0 < t.length ? t.first().trigger("mouseenter") : e.first().trigger("mouseenter"), this.ensureHighlightVisible();
	      }, r.prototype.setClasses = function () {
	        var t = this;this.data.current(function (e) {
	          var r = h.map(e, function (e) {
	            return e.id.toString();
	          });t.$results.find(".select2-results__option[aria-selected]").each(function () {
	            var e = h(this),
	                t = f.GetData(this, "data"),
	                n = "" + t.id;null != t.element && t.element.selected || null == t.element && -1 < h.inArray(n, r) ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false");
	          });
	        });
	      }, r.prototype.showLoading = function (e) {
	        this.hideLoading();var t = { disabled: !0, loading: !0, text: this.options.get("translations").get("searching")(e) },
	            n = this.option(t);n.className += " loading-results", this.$results.prepend(n);
	      }, r.prototype.hideLoading = function () {
	        this.$results.find(".loading-results").remove();
	      }, r.prototype.option = function (e) {
	        var t = document.createElement("li");t.className = "select2-results__option";var n = { role: "option", "aria-selected": "false" },
	            r = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;for (var i in (null != e.element && r.call(e.element, ":disabled") || null == e.element && e.disabled) && (delete n["aria-selected"], n["aria-disabled"] = "true"), null == e.id && delete n["aria-selected"], null != e._resultId && (t.id = e._resultId), e.title && (t.title = e.title), e.children && (n.role = "group", n["aria-label"] = e.text, delete n["aria-selected"]), n) {
	          var o = n[i];t.setAttribute(i, o);
	        }if (e.children) {
	          var s = h(t),
	              a = document.createElement("strong");a.className = "select2-results__group";h(a);this.template(e, a);for (var l = [], c = 0; c < e.children.length; c++) {
	            var u = e.children[c],
	                d = this.option(u);l.push(d);
	          }var p = h("<ul></ul>", { class: "select2-results__options select2-results__options--nested" });p.append(l), s.append(a), s.append(p);
	        } else this.template(e, t);return f.StoreData(t, "data", e), t;
	      }, r.prototype.bind = function (t, e) {
	        var l = this,
	            n = t.id + "-results";this.$results.attr("id", n), t.on("results:all", function (e) {
	          l.clear(), l.append(e.data), t.isOpen() && (l.setClasses(), l.highlightFirstItem());
	        }), t.on("results:append", function (e) {
	          l.append(e.data), t.isOpen() && l.setClasses();
	        }), t.on("query", function (e) {
	          l.hideMessages(), l.showLoading(e);
	        }), t.on("select", function () {
	          t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem());
	        }), t.on("unselect", function () {
	          t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem());
	        }), t.on("open", function () {
	          l.$results.attr("aria-expanded", "true"), l.$results.attr("aria-hidden", "false"), l.setClasses(), l.ensureHighlightVisible();
	        }), t.on("close", function () {
	          l.$results.attr("aria-expanded", "false"), l.$results.attr("aria-hidden", "true"), l.$results.removeAttr("aria-activedescendant");
	        }), t.on("results:toggle", function () {
	          var e = l.getHighlightedResults();0 !== e.length && e.trigger("mouseup");
	        }), t.on("results:select", function () {
	          var e = l.getHighlightedResults();if (0 !== e.length) {
	            var t = f.GetData(e[0], "data");"true" == e.attr("aria-selected") ? l.trigger("close", {}) : l.trigger("select", { data: t });
	          }
	        }), t.on("results:previous", function () {
	          var e = l.getHighlightedResults(),
	              t = l.$results.find("[aria-selected]"),
	              n = t.index(e);if (!(n <= 0)) {
	            var r = n - 1;0 === e.length && (r = 0);var i = t.eq(r);i.trigger("mouseenter");var o = l.$results.offset().top,
	                s = i.offset().top,
	                a = l.$results.scrollTop() + (s - o);0 === r ? l.$results.scrollTop(0) : s - o < 0 && l.$results.scrollTop(a);
	          }
	        }), t.on("results:next", function () {
	          var e = l.getHighlightedResults(),
	              t = l.$results.find("[aria-selected]"),
	              n = t.index(e) + 1;if (!(n >= t.length)) {
	            var r = t.eq(n);r.trigger("mouseenter");var i = l.$results.offset().top + l.$results.outerHeight(!1),
	                o = r.offset().top + r.outerHeight(!1),
	                s = l.$results.scrollTop() + o - i;0 === n ? l.$results.scrollTop(0) : i < o && l.$results.scrollTop(s);
	          }
	        }), t.on("results:focus", function (e) {
	          e.element.addClass("select2-results__option--highlighted");
	        }), t.on("results:message", function (e) {
	          l.displayMessage(e);
	        }), h.fn.mousewheel && this.$results.on("mousewheel", function (e) {
	          var t = l.$results.scrollTop(),
	              n = l.$results.get(0).scrollHeight - t + e.deltaY,
	              r = 0 < e.deltaY && t - e.deltaY <= 0,
	              i = e.deltaY < 0 && n <= l.$results.height();r ? (l.$results.scrollTop(0), e.preventDefault(), e.stopPropagation()) : i && (l.$results.scrollTop(l.$results.get(0).scrollHeight - l.$results.height()), e.preventDefault(), e.stopPropagation());
	        }), this.$results.on("mouseup", ".select2-results__option[aria-selected]", function (e) {
	          var t = h(this),
	              n = f.GetData(this, "data");"true" !== t.attr("aria-selected") ? l.trigger("select", { originalEvent: e, data: n }) : l.options.get("multiple") ? l.trigger("unselect", { originalEvent: e, data: n }) : l.trigger("close", {});
	        }), this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function (e) {
	          var t = f.GetData(this, "data");l.getHighlightedResults().removeClass("select2-results__option--highlighted"), l.trigger("results:focus", { data: t, element: h(this) });
	        });
	      }, r.prototype.getHighlightedResults = function () {
	        return this.$results.find(".select2-results__option--highlighted");
	      }, r.prototype.destroy = function () {
	        this.$results.remove();
	      }, r.prototype.ensureHighlightVisible = function () {
	        var e = this.getHighlightedResults();if (0 !== e.length) {
	          var t = this.$results.find("[aria-selected]").index(e),
	              n = this.$results.offset().top,
	              r = e.offset().top,
	              i = this.$results.scrollTop() + (r - n),
	              o = r - n;i -= 2 * e.outerHeight(!1), t <= 2 ? this.$results.scrollTop(0) : (o > this.$results.outerHeight() || o < 0) && this.$results.scrollTop(i);
	        }
	      }, r.prototype.template = function (e, t) {
	        var n = this.options.get("templateResult"),
	            r = this.options.get("escapeMarkup"),
	            i = n(e, t);null == i ? t.style.display = "none" : "string" == typeof i ? t.innerHTML = r(i) : h(t).append(i);
	      }, r;
	    }), e.define("select2/keys", [], function () {
	      return { BACKSPACE: 8, TAB: 9, ENTER: 13, SHIFT: 16, CTRL: 17, ALT: 18, ESC: 27, SPACE: 32, PAGE_UP: 33, PAGE_DOWN: 34, END: 35, HOME: 36, LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40, DELETE: 46 };
	    }), e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function (n, r, i) {
	      function o(e, t) {
	        this.$element = e, this.options = t, o.__super__.constructor.call(this);
	      }return r.Extend(o, r.Observable), o.prototype.render = function () {
	        var e = n('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');return this._tabindex = 0, null != r.GetData(this.$element[0], "old-tabindex") ? this._tabindex = r.GetData(this.$element[0], "old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), e.attr("title", this.$element.attr("title")), e.attr("tabindex", this._tabindex), e.attr("aria-disabled", "false"), this.$selection = e;
	      }, o.prototype.bind = function (e, t) {
	        var n = this,
	            r = e.id + "-results";this.container = e, this.$selection.on("focus", function (e) {
	          n.trigger("focus", e);
	        }), this.$selection.on("blur", function (e) {
	          n._handleBlur(e);
	        }), this.$selection.on("keydown", function (e) {
	          n.trigger("keypress", e), e.which === i.SPACE && e.preventDefault();
	        }), e.on("results:focus", function (e) {
	          n.$selection.attr("aria-activedescendant", e.data._resultId);
	        }), e.on("selection:update", function (e) {
	          n.update(e.data);
	        }), e.on("open", function () {
	          n.$selection.attr("aria-expanded", "true"), n.$selection.attr("aria-owns", r), n._attachCloseHandler(e);
	        }), e.on("close", function () {
	          n.$selection.attr("aria-expanded", "false"), n.$selection.removeAttr("aria-activedescendant"), n.$selection.removeAttr("aria-owns"), n.$selection.trigger("focus"), n._detachCloseHandler(e);
	        }), e.on("enable", function () {
	          n.$selection.attr("tabindex", n._tabindex), n.$selection.attr("aria-disabled", "false");
	        }), e.on("disable", function () {
	          n.$selection.attr("tabindex", "-1"), n.$selection.attr("aria-disabled", "true");
	        });
	      }, o.prototype._handleBlur = function (e) {
	        var t = this;window.setTimeout(function () {
	          document.activeElement == t.$selection[0] || n.contains(t.$selection[0], document.activeElement) || t.trigger("blur", e);
	        }, 1);
	      }, o.prototype._attachCloseHandler = function (e) {
	        n(document.body).on("mousedown.select2." + e.id, function (e) {
	          var t = n(e.target).closest(".select2");n(".select2.select2-container--open").each(function () {
	            this != t[0] && r.GetData(this, "element").select2("close");
	          });
	        });
	      }, o.prototype._detachCloseHandler = function (e) {
	        n(document.body).off("mousedown.select2." + e.id);
	      }, o.prototype.position = function (e, t) {
	        t.find(".selection").append(e);
	      }, o.prototype.destroy = function () {
	        this._detachCloseHandler(this.container);
	      }, o.prototype.update = function (e) {
	        throw new Error("The `update` method must be defined in child classes.");
	      }, o;
	    }), e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function (e, t, n, r) {
	      function i() {
	        i.__super__.constructor.apply(this, arguments);
	      }return n.Extend(i, t), i.prototype.render = function () {
	        var e = i.__super__.render.call(this);return e.addClass("select2-selection--single"), e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), e;
	      }, i.prototype.bind = function (t, e) {
	        var n = this;i.__super__.bind.apply(this, arguments);var r = t.id + "-container";this.$selection.find(".select2-selection__rendered").attr("id", r).attr("role", "textbox").attr("aria-readonly", "true"), this.$selection.attr("aria-labelledby", r), this.$selection.on("mousedown", function (e) {
	          1 === e.which && n.trigger("toggle", { originalEvent: e });
	        }), this.$selection.on("focus", function (e) {}), this.$selection.on("blur", function (e) {}), t.on("focus", function (e) {
	          t.isOpen() || n.$selection.trigger("focus");
	        });
	      }, i.prototype.clear = function () {
	        var e = this.$selection.find(".select2-selection__rendered");e.empty(), e.removeAttr("title");
	      }, i.prototype.display = function (e, t) {
	        var n = this.options.get("templateSelection");return this.options.get("escapeMarkup")(n(e, t));
	      }, i.prototype.selectionContainer = function () {
	        return e("<span></span>");
	      }, i.prototype.update = function (e) {
	        if (0 !== e.length) {
	          var t = e[0],
	              n = this.$selection.find(".select2-selection__rendered"),
	              r = this.display(t, n);n.empty().append(r);var i = t.title || t.text;i ? n.attr("title", i) : n.removeAttr("title");
	        } else this.clear();
	      }, i;
	    }), e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function (i, e, l) {
	      function n(e, t) {
	        n.__super__.constructor.apply(this, arguments);
	      }return l.Extend(n, e), n.prototype.render = function () {
	        var e = n.__super__.render.call(this);return e.addClass("select2-selection--multiple"), e.html('<ul class="select2-selection__rendered"></ul>'), e;
	      }, n.prototype.bind = function (e, t) {
	        var r = this;n.__super__.bind.apply(this, arguments), this.$selection.on("click", function (e) {
	          r.trigger("toggle", { originalEvent: e });
	        }), this.$selection.on("click", ".select2-selection__choice__remove", function (e) {
	          if (!r.options.get("disabled")) {
	            var t = i(this).parent(),
	                n = l.GetData(t[0], "data");r.trigger("unselect", { originalEvent: e, data: n });
	          }
	        });
	      }, n.prototype.clear = function () {
	        var e = this.$selection.find(".select2-selection__rendered");e.empty(), e.removeAttr("title");
	      }, n.prototype.display = function (e, t) {
	        var n = this.options.get("templateSelection");return this.options.get("escapeMarkup")(n(e, t));
	      }, n.prototype.selectionContainer = function () {
	        return i('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>');
	      }, n.prototype.update = function (e) {
	        if (this.clear(), 0 !== e.length) {
	          for (var t = [], n = 0; n < e.length; n++) {
	            var r = e[n],
	                i = this.selectionContainer(),
	                o = this.display(r, i);i.append(o);var s = r.title || r.text;s && i.attr("title", s), l.StoreData(i[0], "data", r), t.push(i);
	          }var a = this.$selection.find(".select2-selection__rendered");l.appendMany(a, t);
	        }
	      }, n;
	    }), e.define("select2/selection/placeholder", ["../utils"], function (e) {
	      function t(e, t, n) {
	        this.placeholder = this.normalizePlaceholder(n.get("placeholder")), e.call(this, t, n);
	      }return t.prototype.normalizePlaceholder = function (e, t) {
	        return "string" == typeof t && (t = { id: "", text: t }), t;
	      }, t.prototype.createPlaceholder = function (e, t) {
	        var n = this.selectionContainer();return n.html(this.display(t)), n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), n;
	      }, t.prototype.update = function (e, t) {
	        var n = 1 == t.length && t[0].id != this.placeholder.id;if (1 < t.length || n) return e.call(this, t);this.clear();var r = this.createPlaceholder(this.placeholder);this.$selection.find(".select2-selection__rendered").append(r);
	      }, t;
	    }), e.define("select2/selection/allowClear", ["jquery", "../keys", "../utils"], function (i, r, a) {
	      function e() {}return e.prototype.bind = function (e, t, n) {
	        var r = this;e.call(this, t, n), null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."), this.$selection.on("mousedown", ".select2-selection__clear", function (e) {
	          r._handleClear(e);
	        }), t.on("keypress", function (e) {
	          r._handleKeyboardClear(e, t);
	        });
	      }, e.prototype._handleClear = function (e, t) {
	        if (!this.options.get("disabled")) {
	          var n = this.$selection.find(".select2-selection__clear");if (0 !== n.length) {
	            t.stopPropagation();var r = a.GetData(n[0], "data"),
	                i = this.$element.val();this.$element.val(this.placeholder.id);var o = { data: r };if (this.trigger("clear", o), o.prevented) this.$element.val(i);else {
	              for (var s = 0; s < r.length; s++) {
	                if (o = { data: r[s] }, this.trigger("unselect", o), o.prevented) return void this.$element.val(i);
	              }this.$element.trigger("change"), this.trigger("toggle", {});
	            }
	          }
	        }
	      }, e.prototype._handleKeyboardClear = function (e, t, n) {
	        n.isOpen() || t.which != r.DELETE && t.which != r.BACKSPACE || this._handleClear(t);
	      }, e.prototype.update = function (e, t) {
	        if (e.call(this, t), !(0 < this.$selection.find(".select2-selection__placeholder").length || 0 === t.length)) {
	          var n = this.options.get("translations").get("removeAllItems"),
	              r = i('<span class="select2-selection__clear" title="' + n() + '">&times;</span>');a.StoreData(r[0], "data", t), this.$selection.find(".select2-selection__rendered").prepend(r);
	        }
	      }, e;
	    }), e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function (r, a, l) {
	      function e(e, t, n) {
	        e.call(this, t, n);
	      }return e.prototype.render = function (e) {
	        var t = r('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>');this.$searchContainer = t, this.$search = t.find("input");var n = e.call(this);return this._transferTabIndex(), n;
	      }, e.prototype.bind = function (e, t, n) {
	        var r = this,
	            i = t.id + "-results";e.call(this, t, n), t.on("open", function () {
	          r.$search.attr("aria-controls", i), r.$search.trigger("focus");
	        }), t.on("close", function () {
	          r.$search.val(""), r.$search.removeAttr("aria-controls"), r.$search.removeAttr("aria-activedescendant"), r.$search.trigger("focus");
	        }), t.on("enable", function () {
	          r.$search.prop("disabled", !1), r._transferTabIndex();
	        }), t.on("disable", function () {
	          r.$search.prop("disabled", !0);
	        }), t.on("focus", function (e) {
	          r.$search.trigger("focus");
	        }), t.on("results:focus", function (e) {
	          e.data._resultId ? r.$search.attr("aria-activedescendant", e.data._resultId) : r.$search.removeAttr("aria-activedescendant");
	        }), this.$selection.on("focusin", ".select2-search--inline", function (e) {
	          r.trigger("focus", e);
	        }), this.$selection.on("focusout", ".select2-search--inline", function (e) {
	          r._handleBlur(e);
	        }), this.$selection.on("keydown", ".select2-search--inline", function (e) {
	          if (e.stopPropagation(), r.trigger("keypress", e), r._keyUpPrevented = e.isDefaultPrevented(), e.which === l.BACKSPACE && "" === r.$search.val()) {
	            var t = r.$searchContainer.prev(".select2-selection__choice");if (0 < t.length) {
	              var n = a.GetData(t[0], "data");r.searchRemoveChoice(n), e.preventDefault();
	            }
	          }
	        }), this.$selection.on("click", ".select2-search--inline", function (e) {
	          r.$search.val() && e.stopPropagation();
	        });var o = document.documentMode,
	            s = o && o <= 11;this.$selection.on("input.searchcheck", ".select2-search--inline", function (e) {
	          s ? r.$selection.off("input.search input.searchcheck") : r.$selection.off("keyup.search");
	        }), this.$selection.on("keyup.search input.search", ".select2-search--inline", function (e) {
	          if (s && "input" === e.type) r.$selection.off("input.search input.searchcheck");else {
	            var t = e.which;t != l.SHIFT && t != l.CTRL && t != l.ALT && t != l.TAB && r.handleSearch(e);
	          }
	        });
	      }, e.prototype._transferTabIndex = function (e) {
	        this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1");
	      }, e.prototype.createPlaceholder = function (e, t) {
	        this.$search.attr("placeholder", t.text);
	      }, e.prototype.update = function (e, t) {
	        var n = this.$search[0] == document.activeElement;this.$search.attr("placeholder", ""), e.call(this, t), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), n && this.$search.trigger("focus");
	      }, e.prototype.handleSearch = function () {
	        if (this.resizeSearch(), !this._keyUpPrevented) {
	          var e = this.$search.val();this.trigger("query", { term: e });
	        }this._keyUpPrevented = !1;
	      }, e.prototype.searchRemoveChoice = function (e, t) {
	        this.trigger("unselect", { data: t }), this.$search.val(t.text), this.handleSearch();
	      }, e.prototype.resizeSearch = function () {
	        this.$search.css("width", "25px");var e = "";"" !== this.$search.attr("placeholder") ? e = this.$selection.find(".select2-selection__rendered").width() : e = .75 * (this.$search.val().length + 1) + "em";this.$search.css("width", e);
	      }, e;
	    }), e.define("select2/selection/eventRelay", ["jquery"], function (s) {
	      function e() {}return e.prototype.bind = function (e, t, n) {
	        var r = this,
	            i = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting", "clear", "clearing"],
	            o = ["opening", "closing", "selecting", "unselecting", "clearing"];e.call(this, t, n), t.on("*", function (e, t) {
	          if (-1 !== s.inArray(e, i)) {
	            t = t || {};var n = s.Event("select2:" + e, { params: t });r.$element.trigger(n), -1 !== s.inArray(e, o) && (t.prevented = n.isDefaultPrevented());
	          }
	        });
	      }, e;
	    }), e.define("select2/translation", ["jquery", "require"], function (t, n) {
	      function r(e) {
	        this.dict = e || {};
	      }return r.prototype.all = function () {
	        return this.dict;
	      }, r.prototype.get = function (e) {
	        return this.dict[e];
	      }, r.prototype.extend = function (e) {
	        this.dict = t.extend({}, e.all(), this.dict);
	      }, r._cache = {}, r.loadPath = function (e) {
	        if (!(e in r._cache)) {
	          var t = n(e);r._cache[e] = t;
	        }return new r(r._cache[e]);
	      }, r;
	    }), e.define("select2/diacritics", [], function () {
	      return { "Ⓐ": "A", "Ａ": "A", "À": "A", "Á": "A", "Â": "A", "Ầ": "A", "Ấ": "A", "Ẫ": "A", "Ẩ": "A", "Ã": "A", "Ā": "A", "Ă": "A", "Ằ": "A", "Ắ": "A", "Ẵ": "A", "Ẳ": "A", "Ȧ": "A", "Ǡ": "A", "Ä": "A", "Ǟ": "A", "Ả": "A", "Å": "A", "Ǻ": "A", "Ǎ": "A", "Ȁ": "A", "Ȃ": "A", "Ạ": "A", "Ậ": "A", "Ặ": "A", "Ḁ": "A", "Ą": "A", "Ⱥ": "A", "Ɐ": "A", "Ꜳ": "AA", "Æ": "AE", "Ǽ": "AE", "Ǣ": "AE", "Ꜵ": "AO", "Ꜷ": "AU", "Ꜹ": "AV", "Ꜻ": "AV", "Ꜽ": "AY", "Ⓑ": "B", "Ｂ": "B", "Ḃ": "B", "Ḅ": "B", "Ḇ": "B", "Ƀ": "B", "Ƃ": "B", "Ɓ": "B", "Ⓒ": "C", "Ｃ": "C", "Ć": "C", "Ĉ": "C", "Ċ": "C", "Č": "C", "Ç": "C", "Ḉ": "C", "Ƈ": "C", "Ȼ": "C", "Ꜿ": "C", "Ⓓ": "D", "Ｄ": "D", "Ḋ": "D", "Ď": "D", "Ḍ": "D", "Ḑ": "D", "Ḓ": "D", "Ḏ": "D", "Đ": "D", "Ƌ": "D", "Ɗ": "D", "Ɖ": "D", "Ꝺ": "D", "Ǳ": "DZ", "Ǆ": "DZ", "ǲ": "Dz", "ǅ": "Dz", "Ⓔ": "E", "Ｅ": "E", "È": "E", "É": "E", "Ê": "E", "Ề": "E", "Ế": "E", "Ễ": "E", "Ể": "E", "Ẽ": "E", "Ē": "E", "Ḕ": "E", "Ḗ": "E", "Ĕ": "E", "Ė": "E", "Ë": "E", "Ẻ": "E", "Ě": "E", "Ȅ": "E", "Ȇ": "E", "Ẹ": "E", "Ệ": "E", "Ȩ": "E", "Ḝ": "E", "Ę": "E", "Ḙ": "E", "Ḛ": "E", "Ɛ": "E", "Ǝ": "E", "Ⓕ": "F", "Ｆ": "F", "Ḟ": "F", "Ƒ": "F", "Ꝼ": "F", "Ⓖ": "G", "Ｇ": "G", "Ǵ": "G", "Ĝ": "G", "Ḡ": "G", "Ğ": "G", "Ġ": "G", "Ǧ": "G", "Ģ": "G", "Ǥ": "G", "Ɠ": "G", "Ꞡ": "G", "Ᵹ": "G", "Ꝿ": "G", "Ⓗ": "H", "Ｈ": "H", "Ĥ": "H", "Ḣ": "H", "Ḧ": "H", "Ȟ": "H", "Ḥ": "H", "Ḩ": "H", "Ḫ": "H", "Ħ": "H", "Ⱨ": "H", "Ⱶ": "H", "Ɥ": "H", "Ⓘ": "I", "Ｉ": "I", "Ì": "I", "Í": "I", "Î": "I", "Ĩ": "I", "Ī": "I", "Ĭ": "I", "İ": "I", "Ï": "I", "Ḯ": "I", "Ỉ": "I", "Ǐ": "I", "Ȉ": "I", "Ȋ": "I", "Ị": "I", "Į": "I", "Ḭ": "I", "Ɨ": "I", "Ⓙ": "J", "Ｊ": "J", "Ĵ": "J", "Ɉ": "J", "Ⓚ": "K", "Ｋ": "K", "Ḱ": "K", "Ǩ": "K", "Ḳ": "K", "Ķ": "K", "Ḵ": "K", "Ƙ": "K", "Ⱪ": "K", "Ꝁ": "K", "Ꝃ": "K", "Ꝅ": "K", "Ꞣ": "K", "Ⓛ": "L", "Ｌ": "L", "Ŀ": "L", "Ĺ": "L", "Ľ": "L", "Ḷ": "L", "Ḹ": "L", "Ļ": "L", "Ḽ": "L", "Ḻ": "L", "Ł": "L", "Ƚ": "L", "Ɫ": "L", "Ⱡ": "L", "Ꝉ": "L", "Ꝇ": "L", "Ꞁ": "L", "Ǉ": "LJ", "ǈ": "Lj", "Ⓜ": "M", "Ｍ": "M", "Ḿ": "M", "Ṁ": "M", "Ṃ": "M", "Ɱ": "M", "Ɯ": "M", "Ⓝ": "N", "Ｎ": "N", "Ǹ": "N", "Ń": "N", "Ñ": "N", "Ṅ": "N", "Ň": "N", "Ṇ": "N", "Ņ": "N", "Ṋ": "N", "Ṉ": "N", "Ƞ": "N", "Ɲ": "N", "Ꞑ": "N", "Ꞥ": "N", "Ǌ": "NJ", "ǋ": "Nj", "Ⓞ": "O", "Ｏ": "O", "Ò": "O", "Ó": "O", "Ô": "O", "Ồ": "O", "Ố": "O", "Ỗ": "O", "Ổ": "O", "Õ": "O", "Ṍ": "O", "Ȭ": "O", "Ṏ": "O", "Ō": "O", "Ṑ": "O", "Ṓ": "O", "Ŏ": "O", "Ȯ": "O", "Ȱ": "O", "Ö": "O", "Ȫ": "O", "Ỏ": "O", "Ő": "O", "Ǒ": "O", "Ȍ": "O", "Ȏ": "O", "Ơ": "O", "Ờ": "O", "Ớ": "O", "Ỡ": "O", "Ở": "O", "Ợ": "O", "Ọ": "O", "Ộ": "O", "Ǫ": "O", "Ǭ": "O", "Ø": "O", "Ǿ": "O", "Ɔ": "O", "Ɵ": "O", "Ꝋ": "O", "Ꝍ": "O", "Œ": "OE", "Ƣ": "OI", "Ꝏ": "OO", "Ȣ": "OU", "Ⓟ": "P", "Ｐ": "P", "Ṕ": "P", "Ṗ": "P", "Ƥ": "P", "Ᵽ": "P", "Ꝑ": "P", "Ꝓ": "P", "Ꝕ": "P", "Ⓠ": "Q", "Ｑ": "Q", "Ꝗ": "Q", "Ꝙ": "Q", "Ɋ": "Q", "Ⓡ": "R", "Ｒ": "R", "Ŕ": "R", "Ṙ": "R", "Ř": "R", "Ȑ": "R", "Ȓ": "R", "Ṛ": "R", "Ṝ": "R", "Ŗ": "R", "Ṟ": "R", "Ɍ": "R", "Ɽ": "R", "Ꝛ": "R", "Ꞧ": "R", "Ꞃ": "R", "Ⓢ": "S", "Ｓ": "S", "ẞ": "S", "Ś": "S", "Ṥ": "S", "Ŝ": "S", "Ṡ": "S", "Š": "S", "Ṧ": "S", "Ṣ": "S", "Ṩ": "S", "Ș": "S", "Ş": "S", "Ȿ": "S", "Ꞩ": "S", "Ꞅ": "S", "Ⓣ": "T", "Ｔ": "T", "Ṫ": "T", "Ť": "T", "Ṭ": "T", "Ț": "T", "Ţ": "T", "Ṱ": "T", "Ṯ": "T", "Ŧ": "T", "Ƭ": "T", "Ʈ": "T", "Ⱦ": "T", "Ꞇ": "T", "Ꜩ": "TZ", "Ⓤ": "U", "Ｕ": "U", "Ù": "U", "Ú": "U", "Û": "U", "Ũ": "U", "Ṹ": "U", "Ū": "U", "Ṻ": "U", "Ŭ": "U", "Ü": "U", "Ǜ": "U", "Ǘ": "U", "Ǖ": "U", "Ǚ": "U", "Ủ": "U", "Ů": "U", "Ű": "U", "Ǔ": "U", "Ȕ": "U", "Ȗ": "U", "Ư": "U", "Ừ": "U", "Ứ": "U", "Ữ": "U", "Ử": "U", "Ự": "U", "Ụ": "U", "Ṳ": "U", "Ų": "U", "Ṷ": "U", "Ṵ": "U", "Ʉ": "U", "Ⓥ": "V", "Ｖ": "V", "Ṽ": "V", "Ṿ": "V", "Ʋ": "V", "Ꝟ": "V", "Ʌ": "V", "Ꝡ": "VY", "Ⓦ": "W", "Ｗ": "W", "Ẁ": "W", "Ẃ": "W", "Ŵ": "W", "Ẇ": "W", "Ẅ": "W", "Ẉ": "W", "Ⱳ": "W", "Ⓧ": "X", "Ｘ": "X", "Ẋ": "X", "Ẍ": "X", "Ⓨ": "Y", "Ｙ": "Y", "Ỳ": "Y", "Ý": "Y", "Ŷ": "Y", "Ỹ": "Y", "Ȳ": "Y", "Ẏ": "Y", "Ÿ": "Y", "Ỷ": "Y", "Ỵ": "Y", "Ƴ": "Y", "Ɏ": "Y", "Ỿ": "Y", "Ⓩ": "Z", "Ｚ": "Z", "Ź": "Z", "Ẑ": "Z", "Ż": "Z", "Ž": "Z", "Ẓ": "Z", "Ẕ": "Z", "Ƶ": "Z", "Ȥ": "Z", "Ɀ": "Z", "Ⱬ": "Z", "Ꝣ": "Z", "ⓐ": "a", "ａ": "a", "ẚ": "a", "à": "a", "á": "a", "â": "a", "ầ": "a", "ấ": "a", "ẫ": "a", "ẩ": "a", "ã": "a", "ā": "a", "ă": "a", "ằ": "a", "ắ": "a", "ẵ": "a", "ẳ": "a", "ȧ": "a", "ǡ": "a", "ä": "a", "ǟ": "a", "ả": "a", "å": "a", "ǻ": "a", "ǎ": "a", "ȁ": "a", "ȃ": "a", "ạ": "a", "ậ": "a", "ặ": "a", "ḁ": "a", "ą": "a", "ⱥ": "a", "ɐ": "a", "ꜳ": "aa", "æ": "ae", "ǽ": "ae", "ǣ": "ae", "ꜵ": "ao", "ꜷ": "au", "ꜹ": "av", "ꜻ": "av", "ꜽ": "ay", "ⓑ": "b", "ｂ": "b", "ḃ": "b", "ḅ": "b", "ḇ": "b", "ƀ": "b", "ƃ": "b", "ɓ": "b", "ⓒ": "c", "ｃ": "c", "ć": "c", "ĉ": "c", "ċ": "c", "č": "c", "ç": "c", "ḉ": "c", "ƈ": "c", "ȼ": "c", "ꜿ": "c", "ↄ": "c", "ⓓ": "d", "ｄ": "d", "ḋ": "d", "ď": "d", "ḍ": "d", "ḑ": "d", "ḓ": "d", "ḏ": "d", "đ": "d", "ƌ": "d", "ɖ": "d", "ɗ": "d", "ꝺ": "d", "ǳ": "dz", "ǆ": "dz", "ⓔ": "e", "ｅ": "e", "è": "e", "é": "e", "ê": "e", "ề": "e", "ế": "e", "ễ": "e", "ể": "e", "ẽ": "e", "ē": "e", "ḕ": "e", "ḗ": "e", "ĕ": "e", "ė": "e", "ë": "e", "ẻ": "e", "ě": "e", "ȅ": "e", "ȇ": "e", "ẹ": "e", "ệ": "e", "ȩ": "e", "ḝ": "e", "ę": "e", "ḙ": "e", "ḛ": "e", "ɇ": "e", "ɛ": "e", "ǝ": "e", "ⓕ": "f", "ｆ": "f", "ḟ": "f", "ƒ": "f", "ꝼ": "f", "ⓖ": "g", "ｇ": "g", "ǵ": "g", "ĝ": "g", "ḡ": "g", "ğ": "g", "ġ": "g", "ǧ": "g", "ģ": "g", "ǥ": "g", "ɠ": "g", "ꞡ": "g", "ᵹ": "g", "ꝿ": "g", "ⓗ": "h", "ｈ": "h", "ĥ": "h", "ḣ": "h", "ḧ": "h", "ȟ": "h", "ḥ": "h", "ḩ": "h", "ḫ": "h", "ẖ": "h", "ħ": "h", "ⱨ": "h", "ⱶ": "h", "ɥ": "h", "ƕ": "hv", "ⓘ": "i", "ｉ": "i", "ì": "i", "í": "i", "î": "i", "ĩ": "i", "ī": "i", "ĭ": "i", "ï": "i", "ḯ": "i", "ỉ": "i", "ǐ": "i", "ȉ": "i", "ȋ": "i", "ị": "i", "į": "i", "ḭ": "i", "ɨ": "i", "ı": "i", "ⓙ": "j", "ｊ": "j", "ĵ": "j", "ǰ": "j", "ɉ": "j", "ⓚ": "k", "ｋ": "k", "ḱ": "k", "ǩ": "k", "ḳ": "k", "ķ": "k", "ḵ": "k", "ƙ": "k", "ⱪ": "k", "ꝁ": "k", "ꝃ": "k", "ꝅ": "k", "ꞣ": "k", "ⓛ": "l", "ｌ": "l", "ŀ": "l", "ĺ": "l", "ľ": "l", "ḷ": "l", "ḹ": "l", "ļ": "l", "ḽ": "l", "ḻ": "l", "ſ": "l", "ł": "l", "ƚ": "l", "ɫ": "l", "ⱡ": "l", "ꝉ": "l", "ꞁ": "l", "ꝇ": "l", "ǉ": "lj", "ⓜ": "m", "ｍ": "m", "ḿ": "m", "ṁ": "m", "ṃ": "m", "ɱ": "m", "ɯ": "m", "ⓝ": "n", "ｎ": "n", "ǹ": "n", "ń": "n", "ñ": "n", "ṅ": "n", "ň": "n", "ṇ": "n", "ņ": "n", "ṋ": "n", "ṉ": "n", "ƞ": "n", "ɲ": "n", "ŉ": "n", "ꞑ": "n", "ꞥ": "n", "ǌ": "nj", "ⓞ": "o", "ｏ": "o", "ò": "o", "ó": "o", "ô": "o", "ồ": "o", "ố": "o", "ỗ": "o", "ổ": "o", "õ": "o", "ṍ": "o", "ȭ": "o", "ṏ": "o", "ō": "o", "ṑ": "o", "ṓ": "o", "ŏ": "o", "ȯ": "o", "ȱ": "o", "ö": "o", "ȫ": "o", "ỏ": "o", "ő": "o", "ǒ": "o", "ȍ": "o", "ȏ": "o", "ơ": "o", "ờ": "o", "ớ": "o", "ỡ": "o", "ở": "o", "ợ": "o", "ọ": "o", "ộ": "o", "ǫ": "o", "ǭ": "o", "ø": "o", "ǿ": "o", "ɔ": "o", "ꝋ": "o", "ꝍ": "o", "ɵ": "o", "œ": "oe", "ƣ": "oi", "ȣ": "ou", "ꝏ": "oo", "ⓟ": "p", "ｐ": "p", "ṕ": "p", "ṗ": "p", "ƥ": "p", "ᵽ": "p", "ꝑ": "p", "ꝓ": "p", "ꝕ": "p", "ⓠ": "q", "ｑ": "q", "ɋ": "q", "ꝗ": "q", "ꝙ": "q", "ⓡ": "r", "ｒ": "r", "ŕ": "r", "ṙ": "r", "ř": "r", "ȑ": "r", "ȓ": "r", "ṛ": "r", "ṝ": "r", "ŗ": "r", "ṟ": "r", "ɍ": "r", "ɽ": "r", "ꝛ": "r", "ꞧ": "r", "ꞃ": "r", "ⓢ": "s", "ｓ": "s", "ß": "s", "ś": "s", "ṥ": "s", "ŝ": "s", "ṡ": "s", "š": "s", "ṧ": "s", "ṣ": "s", "ṩ": "s", "ș": "s", "ş": "s", "ȿ": "s", "ꞩ": "s", "ꞅ": "s", "ẛ": "s", "ⓣ": "t", "ｔ": "t", "ṫ": "t", "ẗ": "t", "ť": "t", "ṭ": "t", "ț": "t", "ţ": "t", "ṱ": "t", "ṯ": "t", "ŧ": "t", "ƭ": "t", "ʈ": "t", "ⱦ": "t", "ꞇ": "t", "ꜩ": "tz", "ⓤ": "u", "ｕ": "u", "ù": "u", "ú": "u", "û": "u", "ũ": "u", "ṹ": "u", "ū": "u", "ṻ": "u", "ŭ": "u", "ü": "u", "ǜ": "u", "ǘ": "u", "ǖ": "u", "ǚ": "u", "ủ": "u", "ů": "u", "ű": "u", "ǔ": "u", "ȕ": "u", "ȗ": "u", "ư": "u", "ừ": "u", "ứ": "u", "ữ": "u", "ử": "u", "ự": "u", "ụ": "u", "ṳ": "u", "ų": "u", "ṷ": "u", "ṵ": "u", "ʉ": "u", "ⓥ": "v", "ｖ": "v", "ṽ": "v", "ṿ": "v", "ʋ": "v", "ꝟ": "v", "ʌ": "v", "ꝡ": "vy", "ⓦ": "w", "ｗ": "w", "ẁ": "w", "ẃ": "w", "ŵ": "w", "ẇ": "w", "ẅ": "w", "ẘ": "w", "ẉ": "w", "ⱳ": "w", "ⓧ": "x", "ｘ": "x", "ẋ": "x", "ẍ": "x", "ⓨ": "y", "ｙ": "y", "ỳ": "y", "ý": "y", "ŷ": "y", "ỹ": "y", "ȳ": "y", "ẏ": "y", "ÿ": "y", "ỷ": "y", "ẙ": "y", "ỵ": "y", "ƴ": "y", "ɏ": "y", "ỿ": "y", "ⓩ": "z", "ｚ": "z", "ź": "z", "ẑ": "z", "ż": "z", "ž": "z", "ẓ": "z", "ẕ": "z", "ƶ": "z", "ȥ": "z", "ɀ": "z", "ⱬ": "z", "ꝣ": "z", "Ά": "Α", "Έ": "Ε", "Ή": "Η", "Ί": "Ι", "Ϊ": "Ι", "Ό": "Ο", "Ύ": "Υ", "Ϋ": "Υ", "Ώ": "Ω", "ά": "α", "έ": "ε", "ή": "η", "ί": "ι", "ϊ": "ι", "ΐ": "ι", "ό": "ο", "ύ": "υ", "ϋ": "υ", "ΰ": "υ", "ώ": "ω", "ς": "σ", "’": "'" };
	    }), e.define("select2/data/base", ["../utils"], function (r) {
	      function n(e, t) {
	        n.__super__.constructor.call(this);
	      }return r.Extend(n, r.Observable), n.prototype.current = function (e) {
	        throw new Error("The `current` method must be defined in child classes.");
	      }, n.prototype.query = function (e, t) {
	        throw new Error("The `query` method must be defined in child classes.");
	      }, n.prototype.bind = function (e, t) {}, n.prototype.destroy = function () {}, n.prototype.generateResultId = function (e, t) {
	        var n = e.id + "-result-";return n += r.generateChars(4), null != t.id ? n += "-" + t.id.toString() : n += "-" + r.generateChars(4), n;
	      }, n;
	    }), e.define("select2/data/select", ["./base", "../utils", "jquery"], function (e, a, l) {
	      function n(e, t) {
	        this.$element = e, this.options = t, n.__super__.constructor.call(this);
	      }return a.Extend(n, e), n.prototype.current = function (e) {
	        var n = [],
	            r = this;this.$element.find(":selected").each(function () {
	          var e = l(this),
	              t = r.item(e);n.push(t);
	        }), e(n);
	      }, n.prototype.select = function (i) {
	        var o = this;if (i.selected = !0, l(i.element).is("option")) return i.element.selected = !0, void this.$element.trigger("change");if (this.$element.prop("multiple")) this.current(function (e) {
	          var t = [];(i = [i]).push.apply(i, e);for (var n = 0; n < i.length; n++) {
	            var r = i[n].id;-1 === l.inArray(r, t) && t.push(r);
	          }o.$element.val(t), o.$element.trigger("change");
	        });else {
	          var e = i.id;this.$element.val(e), this.$element.trigger("change");
	        }
	      }, n.prototype.unselect = function (i) {
	        var o = this;if (this.$element.prop("multiple")) {
	          if (i.selected = !1, l(i.element).is("option")) return i.element.selected = !1, void this.$element.trigger("change");this.current(function (e) {
	            for (var t = [], n = 0; n < e.length; n++) {
	              var r = e[n].id;r !== i.id && -1 === l.inArray(r, t) && t.push(r);
	            }o.$element.val(t), o.$element.trigger("change");
	          });
	        }
	      }, n.prototype.bind = function (e, t) {
	        var n = this;(this.container = e).on("select", function (e) {
	          n.select(e.data);
	        }), e.on("unselect", function (e) {
	          n.unselect(e.data);
	        });
	      }, n.prototype.destroy = function () {
	        this.$element.find("*").each(function () {
	          a.RemoveData(this);
	        });
	      }, n.prototype.query = function (r, e) {
	        var i = [],
	            o = this;this.$element.children().each(function () {
	          var e = l(this);if (e.is("option") || e.is("optgroup")) {
	            var t = o.item(e),
	                n = o.matches(r, t);null !== n && i.push(n);
	          }
	        }), e({ results: i });
	      }, n.prototype.addOptions = function (e) {
	        a.appendMany(this.$element, e);
	      }, n.prototype.option = function (e) {
	        var t;e.children ? (t = document.createElement("optgroup")).label = e.text : void 0 !== (t = document.createElement("option")).textContent ? t.textContent = e.text : t.innerText = e.text, void 0 !== e.id && (t.value = e.id), e.disabled && (t.disabled = !0), e.selected && (t.selected = !0), e.title && (t.title = e.title);var n = l(t),
	            r = this._normalizeItem(e);return r.element = t, a.StoreData(t, "data", r), n;
	      }, n.prototype.item = function (e) {
	        var t = {};if (null != (t = a.GetData(e[0], "data"))) return t;if (e.is("option")) t = { id: e.val(), text: e.text(), disabled: e.prop("disabled"), selected: e.prop("selected"), title: e.prop("title") };else if (e.is("optgroup")) {
	          t = { text: e.prop("label"), children: [], title: e.prop("title") };for (var n = e.children("option"), r = [], i = 0; i < n.length; i++) {
	            var o = l(n[i]),
	                s = this.item(o);r.push(s);
	          }t.children = r;
	        }return (t = this._normalizeItem(t)).element = e[0], a.StoreData(e[0], "data", t), t;
	      }, n.prototype._normalizeItem = function (e) {
	        e !== Object(e) && (e = { id: e, text: e });return null != (e = l.extend({}, { text: "" }, e)).id && (e.id = e.id.toString()), null != e.text && (e.text = e.text.toString()), null == e._resultId && e.id && null != this.container && (e._resultId = this.generateResultId(this.container, e)), l.extend({}, { selected: !1, disabled: !1 }, e);
	      }, n.prototype.matches = function (e, t) {
	        return this.options.get("matcher")(e, t);
	      }, n;
	    }), e.define("select2/data/array", ["./select", "../utils", "jquery"], function (e, f, g) {
	      function r(e, t) {
	        this._dataToConvert = t.get("data") || [], r.__super__.constructor.call(this, e, t);
	      }return f.Extend(r, e), r.prototype.bind = function (e, t) {
	        r.__super__.bind.call(this, e, t), this.addOptions(this.convertToOptions(this._dataToConvert));
	      }, r.prototype.select = function (n) {
	        var e = this.$element.find("option").filter(function (e, t) {
	          return t.value == n.id.toString();
	        });0 === e.length && (e = this.option(n), this.addOptions(e)), r.__super__.select.call(this, n);
	      }, r.prototype.convertToOptions = function (e) {
	        var t = this,
	            n = this.$element.find("option"),
	            r = n.map(function () {
	          return t.item(g(this)).id;
	        }).get(),
	            i = [];function o(e) {
	          return function () {
	            return g(this).val() == e.id;
	          };
	        }for (var s = 0; s < e.length; s++) {
	          var a = this._normalizeItem(e[s]);if (0 <= g.inArray(a.id, r)) {
	            var l = n.filter(o(a)),
	                c = this.item(l),
	                u = g.extend(!0, {}, a, c),
	                d = this.option(u);l.replaceWith(d);
	          } else {
	            var p = this.option(a);if (a.children) {
	              var h = this.convertToOptions(a.children);f.appendMany(p, h);
	            }i.push(p);
	          }
	        }return i;
	      }, r;
	    }), e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function (e, t, o) {
	      function n(e, t) {
	        this.ajaxOptions = this._applyDefaults(t.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), n.__super__.constructor.call(this, e, t);
	      }return t.Extend(n, e), n.prototype._applyDefaults = function (e) {
	        var t = { data: function data(e) {
	            return o.extend({}, e, { q: e.term });
	          }, transport: function transport(e, t, n) {
	            var r = o.ajax(e);return r.then(t), r.fail(n), r;
	          } };return o.extend({}, t, e, !0);
	      }, n.prototype.processResults = function (e) {
	        return e;
	      }, n.prototype.query = function (n, r) {
	        var i = this;null != this._request && (o.isFunction(this._request.abort) && this._request.abort(), this._request = null);var t = o.extend({ type: "GET" }, this.ajaxOptions);function e() {
	          var e = t.transport(t, function (e) {
	            var t = i.processResults(e, n);i.options.get("debug") && window.console && console.error && (t && t.results && o.isArray(t.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")), r(t);
	          }, function () {
	            "status" in e && (0 === e.status || "0" === e.status) || i.trigger("results:message", { message: "errorLoading" });
	          });i._request = e;
	        }"function" == typeof t.url && (t.url = t.url.call(this.$element, n)), "function" == typeof t.data && (t.data = t.data.call(this.$element, n)), this.ajaxOptions.delay && null != n.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(e, this.ajaxOptions.delay)) : e();
	      }, n;
	    }), e.define("select2/data/tags", ["jquery"], function (u) {
	      function e(e, t, n) {
	        var r = n.get("tags"),
	            i = n.get("createTag");void 0 !== i && (this.createTag = i);var o = n.get("insertTag");if (void 0 !== o && (this.insertTag = o), e.call(this, t, n), u.isArray(r)) for (var s = 0; s < r.length; s++) {
	          var a = r[s],
	              l = this._normalizeItem(a),
	              c = this.option(l);this.$element.append(c);
	        }
	      }return e.prototype.query = function (e, c, u) {
	        var d = this;this._removeOldTags(), null != c.term && null == c.page ? e.call(this, c, function e(t, n) {
	          for (var r = t.results, i = 0; i < r.length; i++) {
	            var o = r[i],
	                s = null != o.children && !e({ results: o.children }, !0);if ((o.text || "").toUpperCase() === (c.term || "").toUpperCase() || s) return !n && (t.data = r, void u(t));
	          }if (n) return !0;var a = d.createTag(c);if (null != a) {
	            var l = d.option(a);l.attr("data-select2-tag", !0), d.addOptions([l]), d.insertTag(r, a);
	          }t.results = r, u(t);
	        }) : e.call(this, c, u);
	      }, e.prototype.createTag = function (e, t) {
	        var n = u.trim(t.term);return "" === n ? null : { id: n, text: n };
	      }, e.prototype.insertTag = function (e, t, n) {
	        t.unshift(n);
	      }, e.prototype._removeOldTags = function (e) {
	        this.$element.find("option[data-select2-tag]").each(function () {
	          this.selected || u(this).remove();
	        });
	      }, e;
	    }), e.define("select2/data/tokenizer", ["jquery"], function (d) {
	      function e(e, t, n) {
	        var r = n.get("tokenizer");void 0 !== r && (this.tokenizer = r), e.call(this, t, n);
	      }return e.prototype.bind = function (e, t, n) {
	        e.call(this, t, n), this.$search = t.dropdown.$search || t.selection.$search || n.find(".select2-search__field");
	      }, e.prototype.query = function (e, t, n) {
	        var r = this;t.term = t.term || "";var i = this.tokenizer(t, this.options, function (e) {
	          var t = r._normalizeItem(e);if (!r.$element.find("option").filter(function () {
	            return d(this).val() === t.id;
	          }).length) {
	            var n = r.option(t);n.attr("data-select2-tag", !0), r._removeOldTags(), r.addOptions([n]);
	          }!function (e) {
	            r.trigger("select", { data: e });
	          }(t);
	        });i.term !== t.term && (this.$search.length && (this.$search.val(i.term), this.$search.trigger("focus")), t.term = i.term), e.call(this, t, n);
	      }, e.prototype.tokenizer = function (e, t, n, r) {
	        for (var i = n.get("tokenSeparators") || [], o = t.term, s = 0, a = this.createTag || function (e) {
	          return { id: e.term, text: e.term };
	        }; s < o.length;) {
	          var l = o[s];if (-1 !== d.inArray(l, i)) {
	            var c = o.substr(0, s),
	                u = a(d.extend({}, t, { term: c }));null != u ? (r(u), o = o.substr(s + 1) || "", s = 0) : s++;
	          } else s++;
	        }return { term: o };
	      }, e;
	    }), e.define("select2/data/minimumInputLength", [], function () {
	      function e(e, t, n) {
	        this.minimumInputLength = n.get("minimumInputLength"), e.call(this, t, n);
	      }return e.prototype.query = function (e, t, n) {
	        t.term = t.term || "", t.term.length < this.minimumInputLength ? this.trigger("results:message", { message: "inputTooShort", args: { minimum: this.minimumInputLength, input: t.term, params: t } }) : e.call(this, t, n);
	      }, e;
	    }), e.define("select2/data/maximumInputLength", [], function () {
	      function e(e, t, n) {
	        this.maximumInputLength = n.get("maximumInputLength"), e.call(this, t, n);
	      }return e.prototype.query = function (e, t, n) {
	        t.term = t.term || "", 0 < this.maximumInputLength && t.term.length > this.maximumInputLength ? this.trigger("results:message", { message: "inputTooLong", args: { maximum: this.maximumInputLength, input: t.term, params: t } }) : e.call(this, t, n);
	      }, e;
	    }), e.define("select2/data/maximumSelectionLength", [], function () {
	      function e(e, t, n) {
	        this.maximumSelectionLength = n.get("maximumSelectionLength"), e.call(this, t, n);
	      }return e.prototype.bind = function (e, t, n) {
	        var r = this;e.call(this, t, n), t.on("select", function () {
	          r._checkIfMaximumSelected();
	        });
	      }, e.prototype.query = function (e, t, n) {
	        var r = this;this._checkIfMaximumSelected(function () {
	          e.call(r, t, n);
	        });
	      }, e.prototype._checkIfMaximumSelected = function (e, n) {
	        var r = this;this.current(function (e) {
	          var t = null != e ? e.length : 0;0 < r.maximumSelectionLength && t >= r.maximumSelectionLength ? r.trigger("results:message", { message: "maximumSelected", args: { maximum: r.maximumSelectionLength } }) : n && n();
	        });
	      }, e;
	    }), e.define("select2/dropdown", ["jquery", "./utils"], function (t, e) {
	      function n(e, t) {
	        this.$element = e, this.options = t, n.__super__.constructor.call(this);
	      }return e.Extend(n, e.Observable), n.prototype.render = function () {
	        var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');return e.attr("dir", this.options.get("dir")), this.$dropdown = e;
	      }, n.prototype.bind = function () {}, n.prototype.position = function (e, t) {}, n.prototype.destroy = function () {
	        this.$dropdown.remove();
	      }, n;
	    }), e.define("select2/dropdown/search", ["jquery", "../utils"], function (o, e) {
	      function t() {}return t.prototype.render = function (e) {
	        var t = e.call(this),
	            n = o('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>');return this.$searchContainer = n, this.$search = n.find("input"), t.prepend(n), t;
	      }, t.prototype.bind = function (e, t, n) {
	        var r = this,
	            i = t.id + "-results";e.call(this, t, n), this.$search.on("keydown", function (e) {
	          r.trigger("keypress", e), r._keyUpPrevented = e.isDefaultPrevented();
	        }), this.$search.on("input", function (e) {
	          o(this).off("keyup");
	        }), this.$search.on("keyup input", function (e) {
	          r.handleSearch(e);
	        }), t.on("open", function () {
	          r.$search.attr("tabindex", 0), r.$search.attr("aria-controls", i), r.$search.trigger("focus"), window.setTimeout(function () {
	            r.$search.trigger("focus");
	          }, 0);
	        }), t.on("close", function () {
	          r.$search.attr("tabindex", -1), r.$search.removeAttr("aria-controls"), r.$search.removeAttr("aria-activedescendant"), r.$search.val(""), r.$search.trigger("blur");
	        }), t.on("focus", function () {
	          t.isOpen() || r.$search.trigger("focus");
	        }), t.on("results:all", function (e) {
	          null != e.query.term && "" !== e.query.term || (r.showSearch(e) ? r.$searchContainer.removeClass("select2-search--hide") : r.$searchContainer.addClass("select2-search--hide"));
	        }), t.on("results:focus", function (e) {
	          e.data._resultId ? r.$search.attr("aria-activedescendant", e.data._resultId) : r.$search.removeAttr("aria-activedescendant");
	        });
	      }, t.prototype.handleSearch = function (e) {
	        if (!this._keyUpPrevented) {
	          var t = this.$search.val();this.trigger("query", { term: t });
	        }this._keyUpPrevented = !1;
	      }, t.prototype.showSearch = function (e, t) {
	        return !0;
	      }, t;
	    }), e.define("select2/dropdown/hidePlaceholder", [], function () {
	      function e(e, t, n, r) {
	        this.placeholder = this.normalizePlaceholder(n.get("placeholder")), e.call(this, t, n, r);
	      }return e.prototype.append = function (e, t) {
	        t.results = this.removePlaceholder(t.results), e.call(this, t);
	      }, e.prototype.normalizePlaceholder = function (e, t) {
	        return "string" == typeof t && (t = { id: "", text: t }), t;
	      }, e.prototype.removePlaceholder = function (e, t) {
	        for (var n = t.slice(0), r = t.length - 1; 0 <= r; r--) {
	          var i = t[r];this.placeholder.id === i.id && n.splice(r, 1);
	        }return n;
	      }, e;
	    }), e.define("select2/dropdown/infiniteScroll", ["jquery"], function (n) {
	      function e(e, t, n, r) {
	        this.lastParams = {}, e.call(this, t, n, r), this.$loadingMore = this.createLoadingMore(), this.loading = !1;
	      }return e.prototype.append = function (e, t) {
	        this.$loadingMore.remove(), this.loading = !1, e.call(this, t), this.showLoadingMore(t) && (this.$results.append(this.$loadingMore), this.loadMoreIfNeeded());
	      }, e.prototype.bind = function (e, t, n) {
	        var r = this;e.call(this, t, n), t.on("query", function (e) {
	          r.lastParams = e, r.loading = !0;
	        }), t.on("query:append", function (e) {
	          r.lastParams = e, r.loading = !0;
	        }), this.$results.on("scroll", this.loadMoreIfNeeded.bind(this));
	      }, e.prototype.loadMoreIfNeeded = function () {
	        var e = n.contains(document.documentElement, this.$loadingMore[0]);if (!this.loading && e) {
	          var t = this.$results.offset().top + this.$results.outerHeight(!1);this.$loadingMore.offset().top + this.$loadingMore.outerHeight(!1) <= t + 50 && this.loadMore();
	        }
	      }, e.prototype.loadMore = function () {
	        this.loading = !0;var e = n.extend({}, { page: 1 }, this.lastParams);e.page++, this.trigger("query:append", e);
	      }, e.prototype.showLoadingMore = function (e, t) {
	        return t.pagination && t.pagination.more;
	      }, e.prototype.createLoadingMore = function () {
	        var e = n('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),
	            t = this.options.get("translations").get("loadingMore");return e.html(t(this.lastParams)), e;
	      }, e;
	    }), e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function (f, a) {
	      function e(e, t, n) {
	        this.$dropdownParent = f(n.get("dropdownParent") || document.body), e.call(this, t, n);
	      }return e.prototype.bind = function (e, t, n) {
	        var r = this;e.call(this, t, n), t.on("open", function () {
	          r._showDropdown(), r._attachPositioningHandler(t), r._bindContainerResultHandlers(t);
	        }), t.on("close", function () {
	          r._hideDropdown(), r._detachPositioningHandler(t);
	        }), this.$dropdownContainer.on("mousedown", function (e) {
	          e.stopPropagation();
	        });
	      }, e.prototype.destroy = function (e) {
	        e.call(this), this.$dropdownContainer.remove();
	      }, e.prototype.position = function (e, t, n) {
	        t.attr("class", n.attr("class")), t.removeClass("select2"), t.addClass("select2-container--open"), t.css({ position: "absolute", top: -999999 }), this.$container = n;
	      }, e.prototype.render = function (e) {
	        var t = f("<span></span>"),
	            n = e.call(this);return t.append(n), this.$dropdownContainer = t;
	      }, e.prototype._hideDropdown = function (e) {
	        this.$dropdownContainer.detach();
	      }, e.prototype._bindContainerResultHandlers = function (e, t) {
	        if (!this._containerResultsHandlersBound) {
	          var n = this;t.on("results:all", function () {
	            n._positionDropdown(), n._resizeDropdown();
	          }), t.on("results:append", function () {
	            n._positionDropdown(), n._resizeDropdown();
	          }), t.on("results:message", function () {
	            n._positionDropdown(), n._resizeDropdown();
	          }), t.on("select", function () {
	            n._positionDropdown(), n._resizeDropdown();
	          }), t.on("unselect", function () {
	            n._positionDropdown(), n._resizeDropdown();
	          }), this._containerResultsHandlersBound = !0;
	        }
	      }, e.prototype._attachPositioningHandler = function (e, t) {
	        var n = this,
	            r = "scroll.select2." + t.id,
	            i = "resize.select2." + t.id,
	            o = "orientationchange.select2." + t.id,
	            s = this.$container.parents().filter(a.hasScroll);s.each(function () {
	          a.StoreData(this, "select2-scroll-position", { x: f(this).scrollLeft(), y: f(this).scrollTop() });
	        }), s.on(r, function (e) {
	          var t = a.GetData(this, "select2-scroll-position");f(this).scrollTop(t.y);
	        }), f(window).on(r + " " + i + " " + o, function (e) {
	          n._positionDropdown(), n._resizeDropdown();
	        });
	      }, e.prototype._detachPositioningHandler = function (e, t) {
	        var n = "scroll.select2." + t.id,
	            r = "resize.select2." + t.id,
	            i = "orientationchange.select2." + t.id;this.$container.parents().filter(a.hasScroll).off(n), f(window).off(n + " " + r + " " + i);
	      }, e.prototype._positionDropdown = function () {
	        var e = f(window),
	            t = this.$dropdown.hasClass("select2-dropdown--above"),
	            n = this.$dropdown.hasClass("select2-dropdown--below"),
	            r = null,
	            i = this.$container.offset();i.bottom = i.top + this.$container.outerHeight(!1);var o = { height: this.$container.outerHeight(!1) };o.top = i.top, o.bottom = i.top + o.height;var s = this.$dropdown.outerHeight(!1),
	            a = e.scrollTop(),
	            l = e.scrollTop() + e.height(),
	            c = a < i.top - s,
	            u = l > i.bottom + s,
	            d = { left: i.left, top: o.bottom },
	            p = this.$dropdownParent;"static" === p.css("position") && (p = p.offsetParent());var h = p.offset();d.top -= h.top, d.left -= h.left, t || n || (r = "below"), u || !c || t ? !c && u && t && (r = "below") : r = "above", ("above" == r || t && "below" !== r) && (d.top = o.top - h.top - s), null != r && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + r), this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + r)), this.$dropdownContainer.css(d);
	      }, e.prototype._resizeDropdown = function () {
	        var e = { width: this.$container.outerWidth(!1) + "px" };this.options.get("dropdownAutoWidth") && (e.minWidth = e.width, e.position = "relative", e.width = "auto"), this.$dropdown.css(e);
	      }, e.prototype._showDropdown = function (e) {
	        this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown();
	      }, e;
	    }), e.define("select2/dropdown/minimumResultsForSearch", [], function () {
	      function e(e, t, n, r) {
	        this.minimumResultsForSearch = n.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), e.call(this, t, n, r);
	      }return e.prototype.showSearch = function (e, t) {
	        return !(function e(t) {
	          for (var n = 0, r = 0; r < t.length; r++) {
	            var i = t[r];i.children ? n += e(i.children) : n++;
	          }return n;
	        }(t.data.results) < this.minimumResultsForSearch) && e.call(this, t);
	      }, e;
	    }), e.define("select2/dropdown/selectOnClose", ["../utils"], function (o) {
	      function e() {}return e.prototype.bind = function (e, t, n) {
	        var r = this;e.call(this, t, n), t.on("close", function (e) {
	          r._handleSelectOnClose(e);
	        });
	      }, e.prototype._handleSelectOnClose = function (e, t) {
	        if (t && null != t.originalSelect2Event) {
	          var n = t.originalSelect2Event;if ("select" === n._type || "unselect" === n._type) return;
	        }var r = this.getHighlightedResults();if (!(r.length < 1)) {
	          var i = o.GetData(r[0], "data");null != i.element && i.element.selected || null == i.element && i.selected || this.trigger("select", { data: i });
	        }
	      }, e;
	    }), e.define("select2/dropdown/closeOnSelect", [], function () {
	      function e() {}return e.prototype.bind = function (e, t, n) {
	        var r = this;e.call(this, t, n), t.on("select", function (e) {
	          r._selectTriggered(e);
	        }), t.on("unselect", function (e) {
	          r._selectTriggered(e);
	        });
	      }, e.prototype._selectTriggered = function (e, t) {
	        var n = t.originalEvent;n && (n.ctrlKey || n.metaKey) || this.trigger("close", { originalEvent: n, originalSelect2Event: t });
	      }, e;
	    }), e.define("select2/i18n/en", [], function () {
	      return { errorLoading: function errorLoading() {
	          return "The results could not be loaded.";
	        }, inputTooLong: function inputTooLong(e) {
	          var t = e.input.length - e.maximum,
	              n = "Please delete " + t + " character";return 1 != t && (n += "s"), n;
	        }, inputTooShort: function inputTooShort(e) {
	          return "Please enter " + (e.minimum - e.input.length) + " or more characters";
	        }, loadingMore: function loadingMore() {
	          return "Loading more results…";
	        }, maximumSelected: function maximumSelected(e) {
	          var t = "You can only select " + e.maximum + " item";return 1 != e.maximum && (t += "s"), t;
	        }, noResults: function noResults() {
	          return "No results found";
	        }, searching: function searching() {
	          return "Searching…";
	        }, removeAllItems: function removeAllItems() {
	          return "Remove all items";
	        } };
	    }), e.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function (c, u, d, p, h, f, g, m, v, y, s, t, _, $, w, b, A, x, D, S, E, C, O, T, q, L, I, j, e) {
	      function n() {
	        this.reset();
	      }return n.prototype.apply = function (e) {
	        if (null == (e = c.extend(!0, {}, this.defaults, e)).dataAdapter) {
	          if (null != e.ajax ? e.dataAdapter = w : null != e.data ? e.dataAdapter = $ : e.dataAdapter = _, 0 < e.minimumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, x)), 0 < e.maximumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, D)), 0 < e.maximumSelectionLength && (e.dataAdapter = y.Decorate(e.dataAdapter, S)), e.tags && (e.dataAdapter = y.Decorate(e.dataAdapter, b)), null == e.tokenSeparators && null == e.tokenizer || (e.dataAdapter = y.Decorate(e.dataAdapter, A)), null != e.query) {
	            var t = u(e.amdBase + "compat/query");e.dataAdapter = y.Decorate(e.dataAdapter, t);
	          }if (null != e.initSelection) {
	            var n = u(e.amdBase + "compat/initSelection");e.dataAdapter = y.Decorate(e.dataAdapter, n);
	          }
	        }if (null == e.resultsAdapter && (e.resultsAdapter = d, null != e.ajax && (e.resultsAdapter = y.Decorate(e.resultsAdapter, T)), null != e.placeholder && (e.resultsAdapter = y.Decorate(e.resultsAdapter, O)), e.selectOnClose && (e.resultsAdapter = y.Decorate(e.resultsAdapter, I))), null == e.dropdownAdapter) {
	          if (e.multiple) e.dropdownAdapter = E;else {
	            var r = y.Decorate(E, C);e.dropdownAdapter = r;
	          }if (0 !== e.minimumResultsForSearch && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, L)), e.closeOnSelect && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, j)), null != e.dropdownCssClass || null != e.dropdownCss || null != e.adaptDropdownCssClass) {
	            var i = u(e.amdBase + "compat/dropdownCss");e.dropdownAdapter = y.Decorate(e.dropdownAdapter, i);
	          }e.dropdownAdapter = y.Decorate(e.dropdownAdapter, q);
	        }if (null == e.selectionAdapter) {
	          if (e.multiple ? e.selectionAdapter = h : e.selectionAdapter = p, null != e.placeholder && (e.selectionAdapter = y.Decorate(e.selectionAdapter, f)), e.allowClear && (e.selectionAdapter = y.Decorate(e.selectionAdapter, g)), e.multiple && (e.selectionAdapter = y.Decorate(e.selectionAdapter, m)), null != e.containerCssClass || null != e.containerCss || null != e.adaptContainerCssClass) {
	            var o = u(e.amdBase + "compat/containerCss");e.selectionAdapter = y.Decorate(e.selectionAdapter, o);
	          }e.selectionAdapter = y.Decorate(e.selectionAdapter, v);
	        }e.language = this._resolveLanguage(e.language), e.language.push("en");for (var s = [], a = 0; a < e.language.length; a++) {
	          var l = e.language[a];-1 === s.indexOf(l) && s.push(l);
	        }return e.language = s, e.translations = this._processTranslations(e.language, e.debug), e;
	      }, n.prototype.reset = function () {
	        function a(e) {
	          return e.replace(/[^\u0000-\u007E]/g, function (e) {
	            return t[e] || e;
	          });
	        }this.defaults = { amdBase: "./", amdLanguageBase: "./i18n/", closeOnSelect: !0, debug: !1, dropdownAutoWidth: !1, escapeMarkup: y.escapeMarkup, language: {}, matcher: function e(t, n) {
	            if ("" === c.trim(t.term)) return n;if (n.children && 0 < n.children.length) {
	              for (var r = c.extend(!0, {}, n), i = n.children.length - 1; 0 <= i; i--) {
	                null == e(t, n.children[i]) && r.children.splice(i, 1);
	              }return 0 < r.children.length ? r : e(t, r);
	            }var o = a(n.text).toUpperCase(),
	                s = a(t.term).toUpperCase();return -1 < o.indexOf(s) ? n : null;
	          }, minimumInputLength: 0, maximumInputLength: 0, maximumSelectionLength: 0, minimumResultsForSearch: 0, selectOnClose: !1, scrollAfterSelect: !1, sorter: function sorter(e) {
	            return e;
	          }, templateResult: function templateResult(e) {
	            return e.text;
	          }, templateSelection: function templateSelection(e) {
	            return e.text;
	          }, theme: "default", width: "resolve" };
	      }, n.prototype.applyFromElement = function (e, t) {
	        var n = e.language,
	            r = this.defaults.language,
	            i = t.prop("lang"),
	            o = t.closest("[lang]").prop("lang"),
	            s = Array.prototype.concat.call(this._resolveLanguage(i), this._resolveLanguage(n), this._resolveLanguage(r), this._resolveLanguage(o));return e.language = s, e;
	      }, n.prototype._resolveLanguage = function (e) {
	        if (!e) return [];if (c.isEmptyObject(e)) return [];if (c.isPlainObject(e)) return [e];var t;t = c.isArray(e) ? e : [e];for (var n = [], r = 0; r < t.length; r++) {
	          if (n.push(t[r]), "string" == typeof t[r] && 0 < t[r].indexOf("-")) {
	            var i = t[r].split("-")[0];n.push(i);
	          }
	        }return n;
	      }, n.prototype._processTranslations = function (e, t) {
	        for (var n = new s(), r = 0; r < e.length; r++) {
	          var i = new s(),
	              o = e[r];if ("string" == typeof o) try {
	            i = s.loadPath(o);
	          } catch (e) {
	            try {
	              o = this.defaults.amdLanguageBase + o, i = s.loadPath(o);
	            } catch (e) {
	              t && window.console && console.warn && console.warn('Select2: The language file for "' + o + '" could not be automatically loaded. A fallback will be used instead.');
	            }
	          } else i = c.isPlainObject(o) ? new s(o) : o;n.extend(i);
	        }return n;
	      }, n.prototype.set = function (e, t) {
	        var n = {};n[c.camelCase(e)] = t;var r = y._convertData(n);c.extend(!0, this.defaults, r);
	      }, new n();
	    }), e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function (r, d, i, p) {
	      function e(e, t) {
	        if (this.options = e, null != t && this.fromElement(t), null != t && (this.options = i.applyFromElement(this.options, t)), this.options = i.apply(this.options), t && t.is("input")) {
	          var n = r(this.get("amdBase") + "compat/inputData");this.options.dataAdapter = p.Decorate(this.options.dataAdapter, n);
	        }
	      }return e.prototype.fromElement = function (e) {
	        var t = ["select2"];null == this.options.multiple && (this.options.multiple = e.prop("multiple")), null == this.options.disabled && (this.options.disabled = e.prop("disabled")), null == this.options.dir && (e.prop("dir") ? this.options.dir = e.prop("dir") : e.closest("[dir]").prop("dir") ? this.options.dir = e.closest("[dir]").prop("dir") : this.options.dir = "ltr"), e.prop("disabled", this.options.disabled), e.prop("multiple", this.options.multiple), p.GetData(e[0], "select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'), p.StoreData(e[0], "data", p.GetData(e[0], "select2Tags")), p.StoreData(e[0], "tags", !0)), p.GetData(e[0], "ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."), e.attr("ajax--url", p.GetData(e[0], "ajaxUrl")), p.StoreData(e[0], "ajax-Url", p.GetData(e[0], "ajaxUrl")));var n = {};function r(e, t) {
	          return t.toUpperCase();
	        }for (var i = 0; i < e[0].attributes.length; i++) {
	          var o = e[0].attributes[i].name,
	              s = "data-";if (o.substr(0, s.length) == s) {
	            var a = o.substring(s.length),
	                l = p.GetData(e[0], a);n[a.replace(/-([a-z])/g, r)] = l;
	          }
	        }d.fn.jquery && "1." == d.fn.jquery.substr(0, 2) && e[0].dataset && (n = d.extend(!0, {}, e[0].dataset, n));var c = d.extend(!0, {}, p.GetData(e[0]), n);for (var u in c = p._convertData(c)) {
	          -1 < d.inArray(u, t) || (d.isPlainObject(this.options[u]) ? d.extend(this.options[u], c[u]) : this.options[u] = c[u]);
	        }return this;
	      }, e.prototype.get = function (e) {
	        return this.options[e];
	      }, e.prototype.set = function (e, t) {
	        this.options[e] = t;
	      }, e;
	    }), e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function (i, c, u, r) {
	      var d = function d(e, t) {
	        null != u.GetData(e[0], "select2") && u.GetData(e[0], "select2").destroy(), this.$element = e, this.id = this._generateId(e), t = t || {}, this.options = new c(t, e), d.__super__.constructor.call(this);var n = e.attr("tabindex") || 0;u.StoreData(e[0], "old-tabindex", n), e.attr("tabindex", "-1");var r = this.options.get("dataAdapter");this.dataAdapter = new r(e, this.options);var i = this.render();this._placeContainer(i);var o = this.options.get("selectionAdapter");this.selection = new o(e, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, i);var s = this.options.get("dropdownAdapter");this.dropdown = new s(e, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, i);var a = this.options.get("resultsAdapter");this.results = new a(e, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown);var l = this;this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function (e) {
	          l.trigger("selection:update", { data: e });
	        }), e.addClass("select2-hidden-accessible"), e.attr("aria-hidden", "true"), this._syncAttributes(), u.StoreData(e[0], "select2", this), e.data("select2", this);
	      };return u.Extend(d, u.Observable), d.prototype._generateId = function (e) {
	        return "select2-" + (null != e.attr("id") ? e.attr("id") : null != e.attr("name") ? e.attr("name") + "-" + u.generateChars(2) : u.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "");
	      }, d.prototype._placeContainer = function (e) {
	        e.insertAfter(this.$element);var t = this._resolveWidth(this.$element, this.options.get("width"));null != t && e.css("width", t);
	      }, d.prototype._resolveWidth = function (e, t) {
	        var n = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;if ("resolve" == t) {
	          var r = this._resolveWidth(e, "style");return null != r ? r : this._resolveWidth(e, "element");
	        }if ("element" == t) {
	          var i = e.outerWidth(!1);return i <= 0 ? "auto" : i + "px";
	        }if ("style" != t) return "computedstyle" != t ? t : window.getComputedStyle(e[0]).width;var o = e.attr("style");if ("string" != typeof o) return null;for (var s = o.split(";"), a = 0, l = s.length; a < l; a += 1) {
	          var c = s[a].replace(/\s/g, "").match(n);if (null !== c && 1 <= c.length) return c[1];
	        }return null;
	      }, d.prototype._bindAdapters = function () {
	        this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container);
	      }, d.prototype._registerDomEvents = function () {
	        var t = this;this.$element.on("change.select2", function () {
	          t.dataAdapter.current(function (e) {
	            t.trigger("selection:update", { data: e });
	          });
	        }), this.$element.on("focus.select2", function (e) {
	          t.trigger("focus", e);
	        }), this._syncA = u.bind(this._syncAttributes, this), this._syncS = u.bind(this._syncSubtree, this), this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);var e = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;null != e ? (this._observer = new e(function (e) {
	          i.each(e, t._syncA), i.each(e, t._syncS);
	        }), this._observer.observe(this.$element[0], { attributes: !0, childList: !0, subtree: !1 })) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", t._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", t._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", t._syncS, !1));
	      }, d.prototype._registerDataEvents = function () {
	        var n = this;this.dataAdapter.on("*", function (e, t) {
	          n.trigger(e, t);
	        });
	      }, d.prototype._registerSelectionEvents = function () {
	        var n = this,
	            r = ["toggle", "focus"];this.selection.on("toggle", function () {
	          n.toggleDropdown();
	        }), this.selection.on("focus", function (e) {
	          n.focus(e);
	        }), this.selection.on("*", function (e, t) {
	          -1 === i.inArray(e, r) && n.trigger(e, t);
	        });
	      }, d.prototype._registerDropdownEvents = function () {
	        var n = this;this.dropdown.on("*", function (e, t) {
	          n.trigger(e, t);
	        });
	      }, d.prototype._registerResultsEvents = function () {
	        var n = this;this.results.on("*", function (e, t) {
	          n.trigger(e, t);
	        });
	      }, d.prototype._registerEvents = function () {
	        var n = this;this.on("open", function () {
	          n.$container.addClass("select2-container--open");
	        }), this.on("close", function () {
	          n.$container.removeClass("select2-container--open");
	        }), this.on("enable", function () {
	          n.$container.removeClass("select2-container--disabled");
	        }), this.on("disable", function () {
	          n.$container.addClass("select2-container--disabled");
	        }), this.on("blur", function () {
	          n.$container.removeClass("select2-container--focus");
	        }), this.on("query", function (t) {
	          n.isOpen() || n.trigger("open", {}), this.dataAdapter.query(t, function (e) {
	            n.trigger("results:all", { data: e, query: t });
	          });
	        }), this.on("query:append", function (t) {
	          this.dataAdapter.query(t, function (e) {
	            n.trigger("results:append", { data: e, query: t });
	          });
	        }), this.on("keypress", function (e) {
	          var t = e.which;n.isOpen() ? t === r.ESC || t === r.TAB || t === r.UP && e.altKey ? (n.close(), e.preventDefault()) : t === r.ENTER ? (n.trigger("results:select", {}), e.preventDefault()) : t === r.SPACE && e.ctrlKey ? (n.trigger("results:toggle", {}), e.preventDefault()) : t === r.UP ? (n.trigger("results:previous", {}), e.preventDefault()) : t === r.DOWN && (n.trigger("results:next", {}), e.preventDefault()) : (t === r.ENTER || t === r.SPACE || t === r.DOWN && e.altKey) && (n.open(), e.preventDefault());
	        });
	      }, d.prototype._syncAttributes = function () {
	        this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {});
	      }, d.prototype._syncSubtree = function (e, t) {
	        var n = !1,
	            r = this;if (!e || !e.target || "OPTION" === e.target.nodeName || "OPTGROUP" === e.target.nodeName) {
	          if (t) {
	            if (t.addedNodes && 0 < t.addedNodes.length) for (var i = 0; i < t.addedNodes.length; i++) {
	              t.addedNodes[i].selected && (n = !0);
	            } else t.removedNodes && 0 < t.removedNodes.length && (n = !0);
	          } else n = !0;n && this.dataAdapter.current(function (e) {
	            r.trigger("selection:update", { data: e });
	          });
	        }
	      }, d.prototype.trigger = function (e, t) {
	        var n = d.__super__.trigger,
	            r = { open: "opening", close: "closing", select: "selecting", unselect: "unselecting", clear: "clearing" };if (void 0 === t && (t = {}), e in r) {
	          var i = r[e],
	              o = { prevented: !1, name: e, args: t };if (n.call(this, i, o), o.prevented) return void (t.prevented = !0);
	        }n.call(this, e, t);
	      }, d.prototype.toggleDropdown = function () {
	        this.options.get("disabled") || (this.isOpen() ? this.close() : this.open());
	      }, d.prototype.open = function () {
	        this.isOpen() || this.trigger("query", {});
	      }, d.prototype.close = function () {
	        this.isOpen() && this.trigger("close", {});
	      }, d.prototype.isOpen = function () {
	        return this.$container.hasClass("select2-container--open");
	      }, d.prototype.hasFocus = function () {
	        return this.$container.hasClass("select2-container--focus");
	      }, d.prototype.focus = function (e) {
	        this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}));
	      }, d.prototype.enable = function (e) {
	        this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'), null != e && 0 !== e.length || (e = [!0]);var t = !e[0];this.$element.prop("disabled", t);
	      }, d.prototype.data = function () {
	        this.options.get("debug") && 0 < arguments.length && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');var t = [];return this.dataAdapter.current(function (e) {
	          t = e;
	        }), t;
	      }, d.prototype.val = function (e) {
	        if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'), null == e || 0 === e.length) return this.$element.val();var t = e[0];i.isArray(t) && (t = i.map(t, function (e) {
	          return e.toString();
	        })), this.$element.val(t).trigger("change");
	      }, d.prototype.destroy = function () {
	        this.$container.remove(), this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA), null != this._observer ? (this._observer.disconnect(), this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1), this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1), this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)), this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", u.GetData(this.$element[0], "old-tabindex")), this.$element.removeClass("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), u.RemoveData(this.$element[0]), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null;
	      }, d.prototype.render = function () {
	        var e = i('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');return e.attr("dir", this.options.get("dir")), this.$container = e, this.$container.addClass("select2-container--" + this.options.get("theme")), u.StoreData(e[0], "element", this.$element), e;
	      }, d;
	    }), e.define("jquery-mousewheel", ["jquery"], function (e) {
	      return e;
	    }), e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults", "./select2/utils"], function (i, e, o, t, s) {
	      if (null == i.fn.select2) {
	        var a = ["open", "close", "destroy"];i.fn.select2 = function (t) {
	          if ("object" == _typeof(t = t || {})) return this.each(function () {
	            var e = i.extend(!0, {}, t);new o(i(this), e);
	          }), this;if ("string" != typeof t) throw new Error("Invalid arguments for Select2: " + t);var n,
	              r = Array.prototype.slice.call(arguments, 1);return this.each(function () {
	            var e = s.GetData(this, "select2");null == e && window.console && console.error && console.error("The select2('" + t + "') method was called on an element that is not using Select2."), n = e[t].apply(e, r);
	          }), -1 < i.inArray(t, a) ? this : n;
	        };
	      }return null == i.fn.select2.defaults && (i.fn.select2.defaults = t), o;
	    }), { define: e.define, require: e.require };
	  }(),
	      t = e.require("jquery.select2");return u.fn.select2.amd = e, t;
	});

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	$(document).ready(function () {
	
		// naivgation logic
		var lastClicked = "";
		var currentClicked = "";
	
		$('.nav-trigger').on('click', function (event) {
	
			currentClicked = $(this).attr('data-trigger');
	
			//$(this).toggleClass('show');
			// closer acts for every overlay
			var closerActive = $(this).find('.open').is(':visible');
	
			// close element
			if (lastClicked == currentClicked && $("nav." + currentClicked).hasClass('active') || closerActive) {
				$('body').removeClass('nav-content-active');
				$('nav.active').removeClass('active');
				return;
			}
	
			if (currentClicked == 'search') {
	
				setTimeout(function () {
					$("#search_input").focus();
				}, 500);
			}
	
			// open
			$('nav.active').removeClass('active');
			$('body').addClass('nav-content-active');
			$("nav." + currentClicked).addClass('active');
	
			lastClicked = currentClicked;
		});
	
		// // pushpin
		// $('header.main').pushpin({
		// 	top: $('header.main').offset().top,
		// 	bottom: ($('#content').innerHeight()),
		// });
	
		$('nav .close').on('click', function (event) {
			$('body').removeClass('nav-content-active');
			$('nav.active').removeClass('active');
		});
	});

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	var logo = $('.logo');
	var content = $('#content > .container-fluid');
	var sidebar = $('.nav-main-container');
	
	$(document).ready(function () {
		positionLogo();
	
		$(window).on('resize', function () {
			positionLogo();
		});
	});
	
	function positionLogo() {
		logo.css('left', sidebar.width() + (content.offset().left - sidebar.width()) / 2 - logo.width() / 2);
	}

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
		$('.slick-intro').slick({
			dots: true,
			arrows: false,
			fade: true,
			infinite: true,
			autoplay: true
		});
	
		// slick agenda
		$('.slick-agenda').slick({
			dots: false,
			arrows: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			autoplay: true,
			autoplaySpeed: 2000,
			responsive: [{
				breakpoint: 1025,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		});
	
		// equalize height of agenda slider items
		$('.slick-agenda').on('setPosition', function () {
			$(this).find('.slick-slide').height('auto');
			var slickTrack = $(this).find('.slick-track');
			var slickTrackHeight = $(slickTrack).height();
			$(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
		});
	
		// slick news
		$('.slick-news').slick({
			dots: true,
			appendDots: '.slider-news .slick-action',
			arrows: true,
			fade: true,
			autoplay: true,
			autoplaySpeed: 3000,
			prevArrow: '.slider-news .slick-action .btn-prev',
			nextArrow: '.slider-news .slick-action .btn-next',
			//fade: true,
			infinite: true
		});
	
		var PauseIsActive = false;
	
		$('.slider-news .btn-pause').on('click', function (event) {
			event.preventDefault();
	
			$(this).toggleClass('active');
			PauseIsActive = !PauseIsActive;
	
			if (PauseIsActive) {
				$('.slick-news').slick('slickPlay');
			} else {
				$('.slick-news').slick('slickPause');
			}
		});
	});

/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	
	var myLatLng = { lat: 47.127296, lng: 7.612407 };
	var mapEl = $('#filter-map');
	var map;
	var currentMarkers = [];
	
	function initMap() {
		map = new google.maps.Map(mapEl[0], {
			zoom: 13,
			minZoom: 8,
			center: myLatLng,
			mapTypeControl: false,
			//scrollwheel: false,
			streetViewControl: false,
			styles: [{ "featureType": "all", "elementType": "geometry.fill", "stylers": [{ "weight": "2.00" }] }, { "featureType": "all", "elementType": "geometry.stroke", "stylers": [{ "color": "#9c9c9c" }] }, { "featureType": "all", "elementType": "labels.text", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] }, { "featureType": "road", "elementType": "geometry.fill", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#7b7b7b" }] }, { "featureType": "road", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#b4d7f0" }, { "visibility": "on" }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#b4d7f0" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#070707" }] }, { "featureType": "water", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ffffff" }] }]
		});
	
		addMarkers();
	}
	
	function addMarkers() {
		var markers = $('.agenda-list .filter-item:visible');
	
		$.each(currentMarkers, function (key, value) {
			value.setMap(null);
		});
	
		currentMarkers = [];
	
		$.each(markers, function (key, value) {
			var item = $(value);
	
			var icon = mapEl.attr('data-icon');
			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(item.data('lat'), item.data('long')),
				map: map,
				icon: icon,
				url: item.find('.deep-link').attr('href')
			});
	
			currentMarkers.push(marker);
	
			google.maps.event.addListener(marker, 'click', function () {
				window.location.href = this.url;
			});
		});
	}
	
	$(function () {
		if (mapEl.length) {
			initMap();
		}
	
		$('.filter').on('click', function (event) {
			addMarkers();
		});
	
		$(window).on('filtered', function (event) {
			setTimeout(function () {
				addMarkers();
			}, 350);
		});
	});

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	var gmap;
	
	$(function () {
		$('.single-map').each(function (i, map) {
			initMap(map);
		});
	});
	
	function initMap(inputmap) {
		var map = $(inputmap);
	
		var lat = map.data('lat');
		var lng = map.data('lng');
		var icon = map.attr('data-icon');
		var link = map.attr('data-link');
		var title = map.attr('data-title');
	
		if (link.length == "") {
			link = "http://maps.google.com/?q=" + lat + "," + lng;
		}
	
		gmap = new google.maps.Map(inputmap, {
			zoom: 13,
			minZoom: 8,
			center: new google.maps.LatLng(lat, lng),
			mapTypeControl: false,
			scrollwheel: false,
			streetViewControl: false,
			styles: [{ "featureType": "all", "elementType": "geometry.fill", "stylers": [{ "weight": "2.00" }] }, { "featureType": "all", "elementType": "geometry.stroke", "stylers": [{ "color": "#9c9c9c" }] }, { "featureType": "all", "elementType": "labels.text", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] }, { "featureType": "road", "elementType": "geometry.fill", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#7b7b7b" }] }, { "featureType": "road", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#b4d7f0" }, { "visibility": "on" }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#b4d7f0" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#070707" }] }, { "featureType": "water", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ffffff" }] }]
		});
	
		var marker = new google.maps.Marker({
			position: new google.maps.LatLng(lat, lng),
			map: gmap,
			icon: icon,
			url: link,
			title: title
		});
	
		google.maps.event.addListener(marker, 'click', function () {
			window.open(this.url, '_blank');
			//window.location.href = this.url;
		});
	}

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	$(function () {
	    var firstLoad = 2;
	    // tabbing
	    $('.tab a[data-filter], .filter-closer').on('click', function (event) {
	        if (!$(this).hasClass('direct')) {
	            event.preventDefault();
	
	            var tab = $(this).attr('href');
	
	            if ($(tab).css('display') == 'none') {
	                $('.filter-tab-content').hide();
	                $(tab).addClass('filter-tab-opening');
	                $(tab).show(function () {
	                    $(tab).removeClass('filter-tab-opening');
	                });
	            } else {
	                if (firstLoad < 1) {
	                    $(tab).addClass('filter-tab-closing');
	
	                    $(tab).hide(1000, function () {
	                        $(tab).removeClass('filter-tab-closing');
	                    });
	                } else {
	                    firstLoad--;
	                }
	            }
	
	            event.stopPropagation();
	        }
	    });
	
	    $(window).on('scroll', function () {
	        var visibleContent = $('.filter-tab-content:visible').first();
	        if (visibleContent.length && !visibleContent.hasClass('filter-tab-closing') && !visibleContent.hasClass('filter-tab-opening') && $(window).width() > 992) {
	            // visibleContent.find('.filter-closer').trigger('click');
	        }
	    });
	});

/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	var $grid;
	var $filter;
	var counter;
	var filterYear = "";
	var filterLink = "";
	var filterType = "";
	var firstLoad = true;
	
	var goto = false;
	
	var filterOr = [];
	
	$(document).ready(function () {
		Isotope.Item.prototype._create = function () {
			// assign id, used for original-order sorting
			this.id = this.layout.itemGUID++;
			// transition objects
			this._transn = {
				ingProperties: {},
				clean: {},
				onEnd: {}
			};
			this.sortData = {};
		};
	
		Isotope.Item.prototype.layoutPosition = function () {
			this.emitEvent('layout', [this]);
		};
	
		// layout mode that does not position items
		Isotope.LayoutMode.create('none');
	});
	
	// Reset Filter LocalStorage
	function resetFilterStorage() {
		localStorage.setItem('filterValue', '');
	}
	
	// Filter functionality
	function resetFilter() {
		filterYear = "";
		filterLink = "";
		$('input[data-filter]').prop('checked', false);
		filterType = "";
	
		resetFilterStorage();
	
		filter();
	
		$('.filter-tab-content').hide();
		$('a[data-filter]').removeClass('active');
	}
	
	function setFilterYear(item) {
		filterYear = "." + item.val();
	}
	
	function setFilterLink(item) {
		filterLink = "." + item.attr('data-filter');
	}
	
	function addFilterType(item) {
		if (item.is(':checked')) {
			filterOr.push("." + item.attr('data-filter'));
		} else {
			filterOr.splice(filterOr.indexOf("." + item.attr('data-filter')), 1);
		}
	
		//filterType = filterOr.join('');
		filterType = filterOr;
		return;
	}
	
	function getPreSelected() {
		$.each($('.filter-year'), function (index, item) {
			setFilterYear($(item));
		});
	
		$.each($('a[data-filter].active'), function (index, item) {
			setFilterLink($(item));
		});
	
		$.each($('input[data-filter][checked]'), function (index, item) {
			addFilterType($(item));
		});
	
		filter();
	}
	
	function setSotredFilters() {
		if (localStorage.getItem('filterValue') !== 'undefined' && localStorage.getItem('filterValue') !== '' && localStorage.getItem('filterValue') !== null) {
			var selected = localStorage.getItem('filterValue').split(',');
			$.each(selected, function (index, value) {
				var field = value.split('.');
				$('#filter-' + field[2]).attr('checked', true);
			});
		}
	}
	setSotredFilters();
	
	function filter() {
		var $goto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
		var filterValue = "";
	
		if (filterType.length > 0) {
			$.each(filterType, function (index, item) {
				filterValue += filterYear + filterLink + item;
	
				if (index < filterType.length - 1) {
					filterValue += ",";
				}
			});
		} else {
			filterValue = filterYear + filterLink;
		}
	
		// ptool fallback
		if (!firstLoad && $('.filter-date.filter-ptool .filter-month').length) {
			$goto = $('.filter-date.filter-ptool .filter-month').first();
		}
	
		if ($goto) {
			$grid.on('layoutComplete', function (event, laidOutItems) {
				$('html, body').animate({
					scrollTop: $goto.offset().top
				}, 500);
			});
		}
	
		$grid.isotope({
			filter: filterValue
		});
	
		if (!firstLoad && !$goto) {
			$('html, body').animate({
				scrollTop: $grid.offset().top - $('.filter-nav').height() - 80
			}, 200);
		}
	
		firstLoad = false;
		$(window).trigger('filtered');
		if (!$('.filter-date').length) {
			localStorage.setItem('filterValue', filterValue);
		}
	}
	
	function getUrlParameter(sParam) {
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
		    sURLVariables = sPageURL.split('&'),
		    sParameterName,
		    i;
	
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
	
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	};
	
	$(window).on('load', function () {
		counter = $('.filter-counter');
	
		$grid = $('.filter-list').first();
	
		if ($grid && $grid.length) {
			/* init isotope */
	
			Isotope.Item.prototype._create = function () {
				// assign id, used for original-order sorting
				this.id = this.layout.itemGUID++;
				// transition objects
				this._transn = {
					ingProperties: {},
					clean: {},
					onEnd: {}
				};
				this.sortData = {};
			};
	
			Isotope.Item.prototype.layoutPosition = function () {
				this.emitEvent('layout', [this]);
			};
	
			Isotope.prototype.arrange = function (opts) {
				// set any options pass
				this.option(opts);
				this._getIsInstant();
				// just filter
				this.filteredItems = this._filter(this.items);
				// flag for initalized
				this._isLayoutInited = true;
			};
	
			// layout mode that does not position items
			Isotope.LayoutMode.create('none');
	
			$grid.isotope({
				// options
				itemSelector: '.filter-item',
				layoutMode: 'none',
				transitionDuration: '0.3s'
			});
	
			/* wait with layouting until images are loaded */
			$grid.imagesLoaded().progress(function () {
				$grid.isotope('layout');
			});
	
			/* after layouting */
			$grid.on('arrangeComplete layoutComplete', function (event, filteredItems) {
				if (counter.length) {
					counter.find('span').html(filteredItems.length);
				}
			});
	
			/*Set Saved Filter Category*/
			if (localStorage.getItem('filterValue') !== 'undefined' && localStorage.getItem('filterValue') !== '' && localStorage.getItem('filterValue') !== null) {
	
				var selected = localStorage.getItem('filterValue').split(',');
	
				$.each(selected, function (index, value) {
	
					var field = value.split('.');
	
					if (typeof field[1] !== 'undefined' && field[1] !== '' && field[1] !== null) {
						var $cat = field[1];
						$('a[data-filter="' + field[1] + '"]').addClass('active');
						$('.filter-tab-content.' + $cat + '-category').css({ 'display': 'block' });
					}
	
					if (typeof field[2] !== 'undefined' && field[2] !== '' && field[2] !== null) {
	
						var id = field[2].replace('f', '');
						var $input = $('#filter-' + id);
	
						$input.prop('checked', true);
	
						addFilterType($input);
					}
				});
			}
	
			/* general filter */
			$('a[data-filter]').on('click', function (event) {
				if (!$(this).hasClass('direct')) {
					event.preventDefault();
	
					if ($(this).parent().hasClass('tab')) {
						if (!$(this).hasClass('active')) {
							filterType = "";
							$('input[data-filter]').prop('checked', false);
						}
					}
	
					setFilterLink($(this));
	
					$('a[data-filter]').removeClass('active');
					$(this).addClass('active');
	
					filter();
				}
			});
	
			/* special filter year */
			$('.filter-year').on('change', function (event) {
				setFilterYear($(this));
				filter();
			});
	
			/* special filter type with input */
			$('input[data-filter]').on('change', function (event) {
				event.preventDefault();
				addFilterType($(this));
				filter();
			});
	
			/* reset filter */
			$('.filter-reset').on('click', function (event) {
				event.preventDefault();
				resetFilter();
			});
	
			goto = getUrlParameter('goto');
	
			if (goto) {
				var $goto = $("#ptool-filter-item-id-" + goto);
				var date;
				if ($goto.length) {
					date = $goto.data('date');
	
					$('a[data-filter]').removeClass('active');
					$('a[data-filter=date-' + date + ']').addClass('active');
	
					addFilterType($('a[data-filter=date-' + date + ']'));
					filter($goto);
				} else {
					console.log("Selected element not found");
				}
			}
		}
	
		$grid.on('arrangeComplete', function (event, laidOutItems) {
			$grid.addClass('filter-inited');
			$grid.closest('.row').find('.filter-date').addClass('filter-inited');
			$('.filter-progress').hide();
		});
	});
	
	$(window).on('load', function () {
		if ($grid && $grid.length) {
			getPreSelected();
		}
	});
	
	/*Reset Stored Filter Values*/
	$('nav.main a').click(resetFilterStorage);

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	
	/*!
	 * Stickyfill -- `position: sticky` polyfill
	 * v. 1.1.4 | https://github.com/wilddeer/stickyfill
	 * Copyright Oleg Korsunsky | http://wd.dizaina.net/
	 *
	 * MIT License
	 */
	!function (a, b) {
	  function c() {
	    y = D = z = A = B = C = K;
	  }function d(a, b) {
	    for (var c in b) {
	      b.hasOwnProperty(c) && (a[c] = b[c]);
	    }
	  }function e(a) {
	    return parseFloat(a) || 0;
	  }function f() {
	    F = { top: b.pageYOffset, left: b.pageXOffset };
	  }function g() {
	    return b.pageXOffset != F.left ? (f(), void z()) : void (b.pageYOffset != F.top && (f(), i()));
	  }function h(a) {
	    setTimeout(function () {
	      b.pageYOffset != F.top && (F.top = b.pageYOffset, i());
	    }, 0);
	  }function i() {
	    for (var a = H.length - 1; a >= 0; a--) {
	      j(H[a]);
	    }
	  }function j(a) {
	    if (a.inited) {
	      var b = F.top <= a.limit.start ? 0 : F.top >= a.limit.end ? 2 : 1;a.mode != b && p(a, b);
	    }
	  }function k() {
	    for (var a = H.length - 1; a >= 0; a--) {
	      if (H[a].inited) {
	        var b = Math.abs(t(H[a].clone) - H[a].docOffsetTop),
	            c = Math.abs(H[a].parent.node.offsetHeight - H[a].parent.height);if (b >= 2 || c >= 2) return !1;
	      }
	    }return !0;
	  }function l(a) {
	    isNaN(parseFloat(a.computed.top)) || a.isCell || "none" == a.computed.display || (a.inited = !0, a.clone || q(a), "absolute" != a.parent.computed.position && "relative" != a.parent.computed.position && (a.parent.node.style.position = "relative"), j(a), a.parent.height = a.parent.node.offsetHeight, a.docOffsetTop = t(a.clone));
	  }function m(a) {
	    var b = !0;a.clone && r(a), d(a.node.style, a.css);for (var c = H.length - 1; c >= 0; c--) {
	      if (H[c].node !== a.node && H[c].parent.node === a.parent.node) {
	        b = !1;break;
	      }
	    }b && (a.parent.node.style.position = a.parent.css.position), a.mode = -1;
	  }function n() {
	    for (var a = H.length - 1; a >= 0; a--) {
	      l(H[a]);
	    }
	  }function o() {
	    for (var a = H.length - 1; a >= 0; a--) {
	      m(H[a]);
	    }
	  }function p(a, b) {
	    var c = a.node.style;switch (b) {case 0:
	        c.position = "absolute", c.left = a.offset.left + "px", c.right = a.offset.right + "px", c.top = a.offset.top + "px", c.bottom = "auto", c.width = "auto", c.marginLeft = 0, c.marginRight = 0, c.marginTop = 0;break;case 1:
	        c.position = "fixed", c.left = a.box.left + "px", c.right = a.box.right + "px", c.top = a.css.top, c.bottom = "auto", c.width = "auto", c.marginLeft = 0, c.marginRight = 0, c.marginTop = 0;break;case 2:
	        c.position = "absolute", c.left = a.offset.left + "px", c.right = a.offset.right + "px", c.top = "auto", c.bottom = 0, c.width = "auto", c.marginLeft = 0, c.marginRight = 0;}a.mode = b;
	  }function q(a) {
	    a.clone = document.createElement("div");var b = a.node.nextSibling || a.node,
	        c = a.clone.style;c.height = a.height + "px", c.width = a.width + "px", c.marginTop = a.computed.marginTop, c.marginBottom = a.computed.marginBottom, c.marginLeft = a.computed.marginLeft, c.marginRight = a.computed.marginRight, c.padding = c.border = c.borderSpacing = 0, c.fontSize = "1em", c.position = "static", c.cssFloat = a.computed.cssFloat, a.node.parentNode.insertBefore(a.clone, b);
	  }function r(a) {
	    a.clone.parentNode.removeChild(a.clone), a.clone = void 0;
	  }function s(a) {
	    var b = getComputedStyle(a),
	        c = a.parentNode,
	        d = getComputedStyle(c),
	        f = a.style.position;a.style.position = "relative";var g = { top: b.top, marginTop: b.marginTop, marginBottom: b.marginBottom, marginLeft: b.marginLeft, marginRight: b.marginRight, cssFloat: b.cssFloat, display: b.display },
	        h = { top: e(b.top), marginBottom: e(b.marginBottom), paddingLeft: e(b.paddingLeft), paddingRight: e(b.paddingRight), borderLeftWidth: e(b.borderLeftWidth), borderRightWidth: e(b.borderRightWidth) };a.style.position = f;var i = { position: a.style.position, top: a.style.top, bottom: a.style.bottom, left: a.style.left, right: a.style.right, width: a.style.width, marginTop: a.style.marginTop, marginLeft: a.style.marginLeft, marginRight: a.style.marginRight },
	        j = u(a),
	        k = u(c),
	        l = { node: c, css: { position: c.style.position }, computed: { position: d.position }, numeric: { borderLeftWidth: e(d.borderLeftWidth), borderRightWidth: e(d.borderRightWidth), borderTopWidth: e(d.borderTopWidth), borderBottomWidth: e(d.borderBottomWidth) } },
	        m = { node: a, box: { left: j.win.left, right: J.clientWidth - j.win.right }, offset: { top: j.win.top - k.win.top - l.numeric.borderTopWidth, left: j.win.left - k.win.left - l.numeric.borderLeftWidth, right: -j.win.right + k.win.right - l.numeric.borderRightWidth }, css: i, isCell: "table-cell" == b.display, computed: g, numeric: h, width: j.win.right - j.win.left, height: j.win.bottom - j.win.top, mode: -1, inited: !1, parent: l, limit: { start: j.doc.top - h.top, end: k.doc.top + c.offsetHeight - l.numeric.borderBottomWidth - a.offsetHeight - h.top - h.marginBottom } };return m;
	  }function t(a) {
	    for (var b = 0; a;) {
	      b += a.offsetTop, a = a.offsetParent;
	    }return b;
	  }function u(a) {
	    var c = a.getBoundingClientRect();return { doc: { top: c.top + b.pageYOffset, left: c.left + b.pageXOffset }, win: c };
	  }function v() {
	    G = setInterval(function () {
	      !k() && z();
	    }, 500);
	  }function w() {
	    clearInterval(G);
	  }function x() {
	    I && (document[L] ? w() : v());
	  }function y() {
	    I || (f(), n(), b.addEventListener("scroll", g), b.addEventListener("wheel", h), b.addEventListener("resize", z), b.addEventListener("orientationchange", z), a.addEventListener(M, x), v(), I = !0);
	  }function z() {
	    if (I) {
	      o();for (var a = H.length - 1; a >= 0; a--) {
	        H[a] = s(H[a].node);
	      }n();
	    }
	  }function A() {
	    b.removeEventListener("scroll", g), b.removeEventListener("wheel", h), b.removeEventListener("resize", z), b.removeEventListener("orientationchange", z), a.removeEventListener(M, x), w(), I = !1;
	  }function B() {
	    A(), o();
	  }function C() {
	    for (B(); H.length;) {
	      H.pop();
	    }
	  }function D(a) {
	    for (var b = H.length - 1; b >= 0; b--) {
	      if (H[b].node === a) return;
	    }var c = s(a);H.push(c), I ? l(c) : y();
	  }function E(a) {
	    for (var b = H.length - 1; b >= 0; b--) {
	      H[b].node === a && (m(H[b]), H.splice(b, 1));
	    }
	  }var F,
	      G,
	      H = [],
	      I = !1,
	      J = a.documentElement,
	      K = function K() {},
	      L = "hidden",
	      M = "visibilitychange";void 0 !== a.webkitHidden && (L = "webkitHidden", M = "webkitvisibilitychange"), b.getComputedStyle || c();for (var N = ["", "-webkit-", "-moz-", "-ms-"], O = document.createElement("div"), P = N.length - 1; P >= 0; P--) {
	    try {
	      O.style.position = N[P] + "sticky";
	    } catch (Q) {}"" != O.style.position && c();
	  }f(), b.Stickyfill = { stickies: H, add: D, remove: E, init: y, rebuild: z, pause: A, stop: B, kill: C };
	}(document, window), window.jQuery && !function ($) {
	  $.fn.Stickyfill = function (a) {
	    return this.each(function () {
	      Stickyfill.add(this);
	    }), this;
	  };
	}(window.jQuery);
	
	$(function () {
	  $('.sticky').Stickyfill();
	});

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	$.fn.isOnScreen = function () {
	    var win = $(window);
	
	    var viewport = {
	        top: win.scrollTop(),
	        left: win.scrollLeft()
	    };
	    viewport.right = viewport.left + win.width();
	    viewport.bottom = viewport.top + win.height();
	
	    var bounds = this.offset();
	    bounds.right = bounds.left + this.outerWidth();
	    bounds.bottom = bounds.top + this.outerHeight();
	
	    return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
	};
	
	$(document).ready(function () {
	    //top the top
	    $('.tothetop').on('click', function (e) {
	        e.preventDefault;
	        $("body").animate({ scrollTop: 0 });
	    });
	
	    // init scroll
	    var initScrollCheck = $('.formerror,.afterlogin,.initscroll');
	    if (initScrollCheck.length) {
	        setTimeout(function () {
	            $('html, body').animate({
	                scrollTop: initScrollCheck.offset().top
	            }, 1000);
	        }, 510);
	    }
	
	    // init jump
	    var initJumpCheck = $('.initjump');
	    if (initJumpCheck.length) {
	        setTimeout(function () {
	            $('html, body').animate({
	                scrollTop: initJumpCheck.offset().top
	            }, 0);
	        }, 510);
	    }
	
	    // scrolldown on click
	    if ($('.mxm_scrolldown').length) {
	        $('.mxm_scrolldown a').on('click', function (event) {
	            event.preventDefault();
	            $('html, body').animate({
	                scrollTop: $($(this).attr('href')).offset().top
	            }, 1000);
	        });
	    }
	});
	
	$("header.main")[0].addEventListener('touchmove', function (event) {
	    if ($(event.target).closest(".nav-main-content").length > 0) {
	        return;
	    }
	    event.preventDefault();
	});

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	$(function () {
		var firstLoad = true;
	
		$('.tab a').on('click', function (event) {
			if (!$(this).hasClass('direct')) {
				event.preventDefault();
				if (!$(this).hasClass('active')) {
	
					$(this).parents('mxm_tabs').find('.tab a').removeClass('active');
					$(this).addClass('active');
	
					if (!firstLoad) {
						$('.filter-tab-content').fadeOut('fast');
					} else {
						firstLoad = !firstLoad;
					}
	
					var tab = $(this).attr('href');
					$(tab).fadeIn();
				}
			}
		});
	
		var hash = window.location.hash.substr(1);
	
		if (hash) {
			var $link = $('a[href="#' + hash + '"]');
	
			firstLoad = true;
			$link.click();
			// $('.filter-tab-content').show();
	
			// $('.tab a').removeClass('active');
			// $link.addClass('active');
			//
			var tab = $link.attr('href');
			$(tab).show();
		}
	});

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	$(function () {
	    var dataUrl = "";
	    var link;
	
	    var overlay = $('#overlay');
	    $('a[data-overlay]').on('click', function (event) {
	        event.preventDefault();
	
	        link = $(this);
	        dataUrl = $(this).attr('data-overlay');
	
	        $('body').addClass('show-overlay');
	
	        $.ajax({
	            url: dataUrl,
	            success: success,
	            error: error
	        });
	    });
	
	    $('#overlay .close').on('click', function (event) {
	        event.preventDefault();
	        $('body').removeClass('show-overlay');
	    });
	
	    function success(data) {
	        //overlay.html("<h1>Hello World</h1>");
	        overlay.html(data);
	    }
	
	    function error(error) {
	        window.location.href = link.attr('href');
	    }
	
	    function addParameterToURL(url, param) {
	        url += (url.split('?')[1] ? '&' : '?') + param;
	        return url;
	    }
	
	    function removeQueryStringParameter(key, url) {
	        if (!url) url = window.location.href;
	
	        var hashParts = url.split('#');
	
	        var regex = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
	
	        if (hashParts[0].match(regex)) {
	            //REMOVE KEY AND VALUE
	            url = hashParts[0].replace(regex, '$1');
	
	            //REMOVE TRAILING ? OR &
	            url = url.replace(/([?&])$/, '');
	
	            //ADD HASH
	            if (typeof hashParts[1] !== 'undefined' && hashParts[1] !== null) url += '#' + hashParts[1];
	        }
	
	        return url;
	    }
	
	    $(document).ready(function () {
	        var $baseUrl = removeQueryStringParameter('olo', location.href);
	        $('.directlink a[data-id]').each(function () {
	            var $newval = addParameterToURL($baseUrl, 'olo=' + $(this).attr('data-id'));
	            $(this).attr('href', $newval);
	        });
	
	        $('.directlink a[data-id]').on('click', function (event) {
	            event.preventDefault();
	
	            var $temp = $("<input>");
	            $("body").append($temp);
	            $temp.val($(this).attr('href')).select();
	            document.execCommand("copy");
	            $temp.remove();
	        });
	
	        var $directopen = $('.directopen a.fancybox');
	
	        if ($directopen) {
	            $directopen.trigger('click');
	        }
	    });
	});

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	$(function () {
	    $('.mxm_securearea a.foldercreate').on('click', function (e) {
	        e.preventDefault();
	
	        var url = $(location).attr('href');
	        var fid = $(this).data('fid');
	
	        $.confirm({
	            title: 'Ordner erstellen',
	            content: '' + '<form action="' + url + '" id="mxm-securearea-folder-form" method="post">' + '<div class="form-group">' + '<label>Ordername</label>' + '<input type="text" name="mxm-securearea[folder-name]" placeholder="" class="title form-control" required />' + '</div>' + '</form>',
	            buttons: {
	                formSubmit: {
	                    text: 'Erstellen',
	                    btnClass: 'btn-blue',
	                    action: function action() {
	                        var name = this.$content.find('.title').val();
	                        if (!name) {
	                            $.alert('Bitte Ordnernamen eingeben.');
	                            return false;
	                        }
	                        var form = $("#mxm-securearea-folder-form");
	
	                        form.attr('action', $(location).attr('href'));
	                        form[0].submit();
	                    }
	                },
	                cancel: function cancel() {
	                    //close
	                }
	            },
	            onContentReady: function onContentReady() {
	                // bind to events
	                var jc = this;
	                this.$content.find('form').on('submit', function (e) {
	                    // if the user submits the form by pressing enter in the field.
	                    e.preventDefault();
	                    jc.$$formSubmit.trigger('click'); // reference the button and click it
	                });
	            }
	        });
	    });
	
	    $('.mxm_securearea a.fileupload').on('click', function (e) {
	        e.preventDefault();
	        //console.log("href: "+$(location).attr('href'))
	
	        var url = $(location).attr('href');
	        var fid = $(this).data('fid');
	
	        $.confirm({
	            title: 'Datei hochladen',
	            content: '' + '<form action="' + url + '" id="mxm-securearea-upload-form" method="post" enctype="multipart/form-data">' + '<div class="form-group">' + '<label>Titel</label>' + '<input type="text" name="mxm-securearea[upload-name]" placeholder="" class="title form-control" required />' + '</div>' + '<div class="form-group">' + '<label>Datei</label>' + '<input type="file" name="mxm-securearea" class="file form-control" required />' + '</div>' + '</form>',
	            buttons: {
	                formSubmit: {
	                    text: 'Datei hochladen',
	                    btnClass: 'btn-blue',
	                    action: function action() {
	                        var name = this.$content.find('.title').val();
	                        var file = this.$content.find('.file').val();
	                        if (!name && !file) {
	                            $.alert('Bitte Dateititel eingeben und eine Datei ausw&auml;hlen.');
	                            return false;
	                        } else if (!name) {
	                            $.alert('Bitte Dateititel eingeben.');
	                            return false;
	                        } else if (!file) {
	                            $.alert('Bitte Datei ausw&auml;hlen.');
	                            return false;
	                        } else {
	                            var extension = file.replace(/^.*\./, '');
	
	                            if (extension == file) {
	                                extension = '';
	                            } else {
	                                extension = extension.toLowerCase();
	                            }
	
	                            switch (extension) {
	                                case 'pdf':
	                                case 'zip':
	                                case 'psd':
	                                case 'jpg':
	                                case 'jpeg':
	                                case 'png':
	                                case 'doc':
	                                case 'docx':
	                                case 'xls':
	                                case 'xlsx':
	                                case 'ppt':
	                                case 'pptx':
	                                case 'mp4':
	                                case 'mp3':
	                                case 'dotx':
	                                case 'docm':
	                                case 'mmap':
	                                    break;
	
	                                default:
	                                    $.alert('Ung&uuml;ltiger Dateityp.');
	                                    return false;
	                            }
	                        }
	                        //$.alert('Die Datei wird hochgeladen...');
	                        var form = $("#mxm-securearea-upload-form");
	
	                        form.attr('action', $(location).attr('href'));
	                        form[0].submit();
	                        //location.reload();
	                    }
	                },
	                cancel: function cancel() {
	                    //close
	                }
	            },
	            onContentReady: function onContentReady() {
	                // bind to events
	                var jc = this;
	                this.$content.find('form').on('submit', function (e) {
	                    // if the user submits the form by pressing enter in the field.
	                    e.preventDefault();
	                    jc.$$formSubmit.trigger('click'); // reference the button and click it
	                });
	            }
	        });
	    });
	
	    $('.mxm_securearea .folderlist a.btn-delete').on('click', function (e) {
	        e.preventDefault();
	
	        var url = $(this).attr('href');
	        var foldername = $(this).parents('tr').find('.foldername a').text();
	
	        $.confirm({
	            title: 'Ordner l&ouml;schen',
	            content: 'Wollen Sie den Ordner &laquo;<strong>' + foldername + '</strong>&raquo; wirklich l&ouml;schen?',
	            buttons: {
	                confirm: function confirm() {
	                    $.alert('Der Ordner wurde gel&ouml;scht!<br />&nbsp;<br /><small>Die Seite wird nun neu geladen</small>');
	                    location.reload();
	                },
	                cancel: function cancel() {}
	            }
	        });
	    });
	
	    $('.mxm_securearea .filelist a.btn-delete').on('click', function (e) {
	        e.preventDefault();
	
	        var url = $(this).attr('href');
	        var filename = $(this).parents('tr').find('.filename').text();
	
	        $.confirm({
	            title: 'Datei l&ouml;schen',
	            content: 'Wollen Sie die Datei &laquo;<strong>' + filename + '</strong>&raquo; wirklich l&ouml;schen?',
	            buttons: {
	                confirm: function confirm() {
	                    $.alert('Die Datei wurde gel&ouml;scht!<br />&nbsp;<br /><small>Die Seite wird nun neu geladen</small>');
	                    location.reload();
	                },
	                cancel: function cancel() {}
	            }
	        });
	    });
	});

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _SecureArea = __webpack_require__(25);
	
	var _SecureArea2 = _interopRequireDefault(_SecureArea);
	
	var _dropzone = __webpack_require__(6);
	
	var _dropzone2 = _interopRequireDefault(_dropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_dropzone2.default.autoDiscover = false;
	
	// TODO: permission map as constants
	
	//run SecureArea
	global.securearea = new _SecureArea2.default();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DataFolder = __webpack_require__(26);
	
	var _DataFolder2 = _interopRequireDefault(_DataFolder);
	
	var _DataFile = __webpack_require__(29);
	
	var _DataFile2 = _interopRequireDefault(_DataFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SecureArea = function () {
	    function SecureArea() {
	        var _this = this;
	
	        _classCallCheck(this, SecureArea);
	
	        this.$parent = $('#secure-explorer');
	        this.$spinner = $('.mxm_securearea_next .progress');
	        this.deeplinkData = $('.mxm_securearea_next').data('deeplink');
	        this.deeplinkDepth = 0;
	        global.dataUrl = $('.mxm_securearea_next').data('baseurl');
	        global.maxFileSize = $('.mxm_securearea_next').data('maxfilesize');
	        global.allowedFileExtensions = $('.mxm_securearea_next').data('allowedfileextensions');
	        global.dataActionPrefix = "mxm_securearea_";
	
	        var baseFolder = parseInt($('.mxm_securearea_next').data('basefolder'));
	        if (baseFolder > 0) {
	            this.getFolderData(baseFolder, this.$parent);
	        } else {
	            this.getFolderData("", this.$parent);
	        }
	
	        if ($('.mxm_securearea_next').data('deeplinkpermissionerror')) {
	            $.confirm({
	                type: 'red',
	                typeAnimated: true,
	                icon: 'fa fa-warning',
	                title: 'Fehler!',
	                content: '<p>Sie verfügen nicht über ausreichende Berechtigung um den gewünschten Link zu öffnen.</p>',
	                buttons: {
	                    btnClose: {
	                        text: 'Schliessen',
	                        keys: ['esc']
	                    }
	                }
	            });
	        }
	
	        if ($('.mxm_securearea_next').data('deeplink')) {
	            $(window).one('entriesloaded', function () {
	                if (_this.deeplinkData && _this.deeplinkData[_this.deeplinkDepth]) {
	                    var link = _this.deeplinkData[_this.deeplinkDepth];
	                    _this.deeplinkDepth++;
	                    if (link.folder) {
	                        var folderLink = document.querySelector('[data-id="' + link.id + '"]');
	
	                        if (folderLink) {
	                            folderLink.click();
	                            if (_this.deeplinkData.length == 1) {
	                                folderLink.classList.add("focus");
	                                setTimeout(function () {
	                                    // Code, der erst nach 2 Sekunden ausgeführt wird
	                                    folderLink.scrollIntoView({ behavior: "smooth" });
	                                }, 500);
	                            }
	                        }
	                    }
	                }
	            });
	        }
	    }
	
	    _createClass(SecureArea, [{
	        key: 'loadEntries',
	        value: function loadEntries($parent, data) {
	            if (this.deeplinkData) {
	                if (this.deeplinkData.length - 1 > this.deeplinkDepth) {
	                    this.$parent[0].style.opacity = 0;
	                    this.$parent[0].style.height = 0;
	                    this.addSpinner();
	                } else {
	                    this.$parent[0].style.transition = "opacity .2s ease";
	                    this.$parent[0].style.opacity = 1;
	                    this.$parent[0].style.height = "auto";
	                    this.removeSpinner();
	                }
	            }
	
	            if (data.folders.length == 0 && data.files.length == 0) {
	                $parent.append('<p class="noentries">Keine Einträge gefunden.</p>');
	            } else {
	                this.setupList($parent, 'folders');
	                for (var i = 0; i < data.folders.length; i++) {
	                    var datafolder = new _DataFolder2.default(data.folders[i], $parent.find('ul.folders'));
	                    datafolder.addToList($parent.find('ul.folders'));
	                }
	
	                this.setupList($parent, 'files');
	                for (var _i = 0; _i < data.files.length; _i++) {
	                    var datafile = new _DataFile2.default(data.files[_i], $parent.find('ul.files'));
	                    datafile.addToList($parent.find('ul.files'));
	                }
	            }
	            $(window).trigger('entriesloaded');
	        }
	    }, {
	        key: 'setupList',
	        value: function setupList($parent, $class) {
	            $parent.append('<ul class="' + $class + '"></ul>');
	        }
	    }, {
	        key: 'getFolderData',
	        value: function getFolderData(folderId, $parent) {
	            var _this2 = this;
	
	            $.ajax({
	                type: "post",
	                dataType: "json",
	                url: dataUrl,
	                data: {
	                    "action": dataActionPrefix + "getfolder",
	                    "folderId": folderId
	                },
	                beforeSend: function beforeSend() {
	                    _this2.addSpinner();
	                },
	                complete: function complete() {
	                    if (_this2.deeplinkData == null || _this2.deeplinkData.length - 1 > _this2.deeplinkDepth) {
	                        _this2.removeSpinner();
	                    }
	                },
	                success: function success(json) {
	                    if (json.success) {
	                        _this2.loadEntries($parent, json.data);
	                    } else {
	                        _this2.showError("getfolder", json);
	                        return false;
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'showError',
	        value: function showError(action, json) {
	            console.warn(action + " START");
	            for (var i = 0; i < json.debug.length; i++) {
	                console.warn(json.debug[i]);
	            }
	            console.warn(action + " END");
	
	            var $html = '<ul>';
	            for (var _i2 = 0; _i2 < json.errors.length; _i2++) {
	                $html += '<li>' + json.errors[_i2] + '</li>';
	            }
	            $html += '</ul>';
	
	            $.confirm({
	                type: 'red',
	                typeAnimated: true,
	                icon: 'fa fa-warning',
	                title: 'Fehler!',
	                content: $html,
	
	                buttons: {
	                    btnClose: {
	                        text: 'Schliessen',
	                        keys: ['esc']
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'addSpinner',
	        value: function addSpinner() {
	            this.$spinner.addClass('showing');
	        }
	    }, {
	        key: 'removeSpinner',
	        value: function removeSpinner() {
	            this.$spinner.removeClass('showing');
	        }
	    }]);
	
	    return SecureArea;
	}();
	
	exports.default = SecureArea;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DataEntry2 = __webpack_require__(27);
	
	var _DataEntry3 = _interopRequireDefault(_DataEntry2);
	
	var _dropzone = __webpack_require__(6);
	
	var _dropzone2 = _interopRequireDefault(_dropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataFolder = function (_DataEntry) {
	    _inherits(DataFolder, _DataEntry);
	
	    function DataFolder() {
	        _classCallCheck(this, DataFolder);
	
	        return _possibleConstructorReturn(this, (DataFolder.__proto__ || Object.getPrototypeOf(DataFolder)).apply(this, arguments));
	    }
	
	    _createClass(DataFolder, [{
	        key: 'createMarkup',
	        value: function createMarkup() {
	            // this.$html = `
	            //     <li>
	            //         <a href="#" data-type="${this.entry.type}" data-id="${this.id}">
	            //             <i class="fa fa-folder"></i> <span>${this.entry.title}</span>
	            //         </a>
	            //     </li>
	            // `;
	
	            this.$li = document.createElement('li');
	
	            this.$link = document.createElement('a');
	            this.$link.setAttribute('href', "#");
	            this.$link.setAttribute('data-id', this.id);
	            this.$link.setAttribute('data-type', "folder");
	
	            this.$fa = document.createElement('i');
	            this.$fa.classList.add('fa', 'fa-folder');
	
	            this.$span = document.createElement('span');
	            this.$span.innerText = this.entry.title;
	
	            this.$link.appendChild(this.$fa);
	            this.$link.appendChild(this.$span);
	            this.$li.appendChild(this.$link);
	            this.$html = this.$li;
	        }
	    }, {
	        key: 'setClickEvent',
	        value: function setClickEvent() {
	            var _this2 = this;
	
	            this.$link.on('click', function (e) {
	                e.preventDefault();
	                if (_this2.isOpen) {
	                    _this2.closeFolder();
	                } else {
	                    _this2.openFolder();
	                }
	            });
	        }
	    }, {
	        key: 'openFolder',
	        value: function openFolder() {
	            var _this3 = this;
	
	            this.disableEntry();
	            securearea.getFolderData(this.id, this.$el);
	
	            $(window).one('entriesloaded', function (e) {
	                _this3.enableEntry();
	                _this3.isOpen = true;
	                _this3.$el.addClass('open');
	
	                if ((_this3.permissions & 8) === 8) {
	                    _this3.createDropzone();
	                }
	
	                if (securearea.deeplinkData && securearea.deeplinkData[securearea.deeplinkDepth]) {
	                    var link = securearea.deeplinkData[securearea.deeplinkDepth];
	                    securearea.deeplinkDepth++;
	                    var theLink = document.querySelector('[data-id="' + link.id + '"]');
	
	                    if (theLink) {
	                        if (link.folder) {
	                            if (theLink) {
	                                theLink.click();
	                                if (securearea.deeplinkData.length == securearea.deeplinkDepth) {
	                                    theLink.classList.add("focus");
	                                    setTimeout(function () {
	                                        // Code, der erst nach 2 Sekunden ausgeführt wird
	                                        theLink.scrollIntoView({ behavior: "smooth" });
	                                    }, 500);
	                                }
	                            }
	                        } else {
	                            theLink.classList.add("focus");
	                            setTimeout(function () {
	                                // Code, der erst nach 2 Sekunden ausgeführt wird
	                                theLink.scrollIntoView({ behavior: "smooth" });
	                            }, 500);
	                        }
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'closeFolder',
	        value: function closeFolder() {
	            this.isOpen = false;
	            this.$el.find('ul, .dropzone-multi, .noentries').remove();
	            this.$el.removeClass('open');
	            this.$el.closest('li.open').find('.dropzone-multi').show();
	        }
	    }, {
	        key: 'refreshFolder',
	        value: function refreshFolder() {
	            this.refreshPermissions();
	            this.closeFolder();
	            this.openFolder();
	        }
	    }, {
	        key: 'createDropzone',
	        value: function createDropzone() {
	            var _this4 = this;
	
	            var parentId = this.id;
	            var element = this.$el;
	
	            $('.dropzone-multi').hide();
	            element.append('<div class="dropzone dropzone-multi dropzone-theme" id="drop_' + parentId + '"><button class="btn" data-action="getfolder"><i class="fa fa-refresh"></i> Ordner aktualisieren</button></div>');
	
	            element.$dropzone = new _dropzone2.default('#drop_' + parentId, {
	                url: dataUrl + "?action=" + dataActionPrefix + "createfile&folderId=" + parentId,
	                // maxFilesize: maxFileSize,
	                // acceptedfiles: allowedFileExtensions,
	                clickable: true,
	                uploadMultiple: true,
	                timeout: 300000,
	                // thumbnailWidth: 100,
	                dictDefaultMessage: "Dateien hierhin ziehen<br />oder<br />hier klicken um Dialog zu öffnen.",
	                thumbnailMethod: "contain",
	                previewTemplate: '<div class="dz-preview dropzone-preview">\n                <div class="filename">\n                    <span class="dropzone-success-mark"><i class="fa fa-check"></i></span><span class="dropzone-error-mark"><i class="fa fa-exclamation-triangle"></i></span>\n                    <span data-dz-name class=""></span>\n                </div>\n                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress=""></span></div>\n                <div class="error-msg"><span data-dz-errormessage><small>nicht hochgeladen</small></span></div>\n            </div>',
	                accept: function accept(file, done) {
	                    var extsplit = file.name.split('.');
	                    var ext = extsplit[extsplit.length - 1].toLowerCase();
	
	                    if (allowedFileExtensions.search(ext) == -1) {
	                        file.errorMessage = "Die Datei <strong>" + file.name + "</strong> hat einen unerlaubten Dateityp.";
	                        done("Unerlaubter Typ.");
	                    } else if (file.size > maxFileSize) {
	                        file.errorMessage = "Die Datei <strong>" + file.name + "</strong> ist zu schwer.";
	                        done("Unerlaubte Grösse.");
	                    } else {
	                        done();
	                    }
	                },
	                error: function error(file) {
	                    $(file.previewElement).addClass('dz-error');
	
	                    var errormsg = "Der Server ist momentan nicht erreichbar. Bitte wenden Sie sich an den Administrator oder versuchen Sie es später nochmal.";
	                    if (file.errorMessage) {
	                        errormsg = file.errorMessage;
	                    }
	                    var json = { success: false, errors: [errormsg], errorcode: 0, debug: ["Dropzone Error: wrong file size or dropzone error", errormsg] };
	                    securearea.showError("createfile", json);
	                },
	                successmultiple: function successmultiple(dzresult, wpresult) {
	                    $('.errormsg').remove();
	
	                    if (wpresult.success) {
	                        $('#drop_' + parentId + ' .btn[data-action="getfolder"]').addClass('show');
	                    } else {
	                        securearea.showError("createfile", wpresult);
	                        return false;
	                    }
	                },
	                drop: function drop() {
	                    $('.dropzone .btn[data-action="getfolder"]').removeClass('show');
	                }
	            });
	
	            $('.dropzone .btn[data-action="getfolder"]').click(function (e) {
	                e.preventDefault();
	                _this4.refreshFolder();
	                $(e.target).removeClass('show');
	            });
	        }
	    }]);
	
	    return DataFolder;
	}(_DataEntry3.default);
	
	exports.default = DataFolder;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DataFolder = __webpack_require__(26);
	
	var _DataFolder2 = _interopRequireDefault(_DataFolder);
	
	var _Menu = __webpack_require__(28);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataEntry = function () {
	    function DataEntry(entry, $parent) {
	        _classCallCheck(this, DataEntry);
	
	        this.entry = entry;
	        this.id = entry.id;
	        this.permissions = entry.permissions;
	        this.$el = undefined;
	        this.$link = undefined;
	        this.isOpen = false;
	        this.$parent = $parent;
	        this.instance = this;
	        this.type = this instanceof _DataFolder2.default ? 'folder' : 'file';
	
	        this.createMarkup();
	        // this.addToList($parent);
	    }
	
	    _createClass(DataEntry, [{
	        key: 'createMarkup',
	        value: function createMarkup() {
	            // console.log('no markup');
	        }
	    }, {
	        key: 'addToList',
	        value: function addToList($target) {
	            $target.append(this.$html);
	
	            this.$link = $('[data-id="' + this.id + '"]');
	            this.$el = this.$link.closest('li');
	
	            if ((this.permissions & 65536) == 65536) {
	                this.showMenuButton();
	            }
	            this.setClickEvent();
	        }
	    }, {
	        key: 'showMenuButton',
	        value: function showMenuButton() {
	            var _this = this;
	
	            this.$link.on('mouseover', function (e) {
	                new _Menu2.default(_this.instance, _this.type);
	
	                e.stopPropagation();
	            });
	        }
	    }, {
	        key: 'disableEntry',
	        value: function disableEntry() {
	            if (this.$link.length) {
	                this.$link.addClass('disabled');
	                this.$link.find('.fa').addClass('fa-spin');
	            }
	        }
	    }, {
	        key: 'enableEntry',
	        value: function enableEntry() {
	            if (this.$link.length) {
	                this.$link.removeClass('disabled');
	                this.$link.find('.fa').removeClass('fa-spin');
	            }
	        }
	    }, {
	        key: 'refreshPermissions',
	        value: function refreshPermissions() {
	            var _this2 = this;
	
	            this.$el.find('.menu-wrapper').remove();
	
	            $.ajax({
	                type: "post",
	                dataType: "json",
	                url: dataUrl,
	                data: {
	                    "action": dataActionPrefix + "getpermission",
	                    "folderOrFileId": this.id
	                },
	                beforeSend: function beforeSend() {
	                    securearea.addSpinner();
	                },
	                complete: function complete() {
	                    securearea.removeSpinner();
	                },
	                success: function success(json) {
	                    if (json.success) {
	                        _this2.permissions = json.data;
	                    } else {
	                        return false;
	                    }
	                }
	            });
	        }
	    }]);
	
	    return DataEntry;
	}();
	
	exports.default = DataEntry;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DataFolder = __webpack_require__(26);
	
	var _DataFolder2 = _interopRequireDefault(_DataFolder);
	
	var _dropzone = __webpack_require__(6);
	
	var _dropzone2 = _interopRequireDefault(_dropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Menu = function () {
	    function Menu(instance, type) {
	        _classCallCheck(this, Menu);
	
	        this.instance = instance;
	        this.parentId = this.instance.id;
	        this.type = type;
	        this.permissions = this.instance.permissions;
	
	        this.buildMenu();
	    }
	
	    _createClass(Menu, [{
	        key: 'buildMenu',
	        value: function buildMenu() {
	            var _this = this;
	
	            // add and position a general wrapper
	            $('.menu-wrapper').remove();
	            this.instance.$el.append('<div class="menu-wrapper"></div>');
	            var $wrapper = this.instance.$el.find('.menu-wrapper');
	            $wrapper.css("left", this.instance.$link.find('span').width() + 60);
	
	            if (this.type == 'folder' && this.permissions == 65543 || this.type == 'file' && this.permissions == 65537) {
	                // show directly info button
	                $('.menu-btn-infos').remove();
	
	                // Permission: showinfos / share
	                $wrapper.append('<button class="menu-btn-infos" title="Teilen" data-action="share"><svg class="gfx-share-alt-light"><use xlink:href="#share-alt-light"></use></svg></button>');
	                var that = this;
	                $('button[data-action="share"]').on('click', function (e) {
	                    var shareUrl = $('.mxm_securearea_next').data('shareurl');
	                    shareUrl = shareUrl.replace('##id##', _this.parentId);
	                    var itemName = $('a[data-id="' + _this.parentId + '"] span').text();
	
	                    $.confirm({
	                        onOpen: that.onOpenConfirm,
	                        onClose: that.onCloseConfirm,
	                        columnClass: 'medium',
	                        type: 'blue',
	                        title: 'Link teilen',
	                        content: '<p>Kopieren sie folgende URL um <strong>' + itemName + '</strong> zu teilen:</p><p><a target="_blank" href="' + shareUrl + '">' + shareUrl + '</a></p>',
	
	                        buttons: {
	                            btnOk: {
	                                text: 'Schliessen',
	                                keys: ['esc']
	                            }
	                        }
	                    });
	                });
	
	                $wrapper.append('<button class="menu-btn-infos" title="Informationen" data-action="showinfos"><svg class="gfx-ODA_ICONS_gesch.ber_infos_2-dims"><use xlink:href="#ODA_ICONS_gesch.ber_infos_2"></use></svg></button>');
	                $('button[data-action="showinfos"]').on('click', function (e) {
	                    _this.ajaxCall(_this.showInfos, {
	                        "action": dataActionPrefix + "showinfos",
	                        "folderOrFileId": _this.parentId
	                    });
	                });
	            } else {
	                // show menu button and icons on hover
	                $wrapper.append('<button class="btn menu-btn"><svg class="gfx-ODA_ICONS_gesch.ber_menu_anzeigen_2-dims"><use xlink:href="#ODA_ICONS_gesch.ber_menu_anzeigen_2"></use></svg></button>');
	                var $menubtn = $wrapper.find('.menu-btn');
	
	                $menubtn.hover(function (e) {
	                    $wrapper.addClass('show-menu');
	                    $('.menu-content').remove();
	                    $wrapper.append('<div class="menu-content"></div>');
	                    _this.$menu = $('.menu-content');
	                    _this.checkPermissions();
	                });
	            }
	        }
	    }, {
	        key: 'checkPermissions',
	        value: function checkPermissions() {
	            var _this2 = this;
	
	            if (this.type == 'file' && (this.permissions & 16) == 16) {
	                // Permission: renamefile
	                this.$menu.append('<button title="Umbenennen" data-action="renamefile"><svg class="gfx-ODA_ICONS_gesch.ber_bearbeiten-dims"><use xlink:href="#ODA_ICONS_gesch.ber_bearbeiten"></use></svg></button>');
	
	                var that = this;
	                $('button[data-action="renamefile"]').on('click', function (e) {
	                    var sourceFileTitle = $(e.target).closest('li').find('[data-type] > span').text();
	
	                    $.confirm({
	                        onOpen: that.onOpenConfirm,
	                        onClose: that.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Datei umbenennen',
	                        onContentReady: function onContentReady() {
	                            var confirmContent = this.$content;
	                            confirmContent.find('input').prop('disabled', true);
	
	                            var sourceFileName = void 0;
	
	                            $.ajax({
	                                type: "post",
	                                dataType: "json",
	                                url: dataUrl,
	                                data: {
	                                    "action": dataActionPrefix + "getinfo",
	                                    "folderOrFileId": that.parentId
	                                },
	                                success: function success(json) {
	                                    $('.errormsg').remove();
	                                    if (json.success) {
	                                        confirmContent.find('.filetitle').prop('value', json.data.title);
	                                        confirmContent.find('.filename').prop('value', json.data.filename);
	                                        confirmContent.find('input').prop('disabled', false);
	                                    } else {
	                                        securearea.showError(params.action, json);
	                                        return false;
	                                    }
	                                }
	                            });
	                        },
	                        content: '' + '<form action="">' + '<div class="form-group">' + '<label>Anzeigename:</label>' + '<input type="text" class="filetitle form-control" required value="" />' + '</div>' + '<div class="form-group">' + '<label>Dateiname:</label>' + '<input type="text" class="filename form-control" required value="" />' + '</div>' + '</form>',
	                        buttons: {
	                            btnCancel: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnRename: {
	                                text: 'Umbenennen',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    var fileTitle = this.$content.find('.filetitle').val();
	                                    var fileName = this.$content.find('.filename').val();
	                                    that.fileTitle = fileTitle;
	                                    if (fileTitle && fileName) {
	                                        that.ajaxCall(that.renameFile, {
	                                            "action": dataActionPrefix + "renamefile",
	                                            "fileId": that.parentId,
	                                            "fileTitle": fileTitle,
	                                            "fileName": fileName
	                                        });
	                                    } else {
	                                        return false;
	                                    }
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'file' && (this.permissions & 32) == 32) {
	                // Permission: movefile
	                this.$menu.append('<button title="Verschieben" data-action="movefile"><svg class="gfx-ODA_ICONS_gesch.ber_verschieben-dims"><use xlink:href="#ODA_ICONS_gesch.ber_verschieben"></use></svg></button>');
	
	                var _that = this;
	                $('button[data-action="movefile"]').on('click', function (e) {
	                    $.confirm({
	                        onOpen: _that.onOpenConfirm,
	                        onClose: _that.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Datei verschieben',
	                        columnClass: 'col-md-10 col-md-offset-1',
	                        content: _that.folderBrowserContent(),
	                        onContentReady: function onContentReady() {
	                            _that.initFolderBrowser(_that, this.$content, this.buttons);
	                        },
	                        buttons: {
	                            btnCancel: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnYes: {
	                                text: 'Verschieben',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    var destinationFolder = this.$content.find('.secure_breadcrumb_ul li:last-child > a').data('id');
	                                    if (destinationFolder) {
	                                        _that.ajaxCall(_that.moveFile, {
	                                            "action": dataActionPrefix + "movefile",
	                                            "fileId": _that.parentId,
	                                            "folderId": destinationFolder
	                                        });
	                                    }
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'file' && (this.permissions & 64) == 64) {
	                // Permission: deletefile
	                this.$menu.append('<button title="Löschen" data-action="deletefile"><svg class="gfx-ODA_ICONS_gesch.ber_loeschen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_loeschen"></use></svg></button>');
	                var _that2 = this;
	                $('button[data-action="deletefile"]').on('click', function (e) {
	                    var filename = $('a[data-id="' + _this2.parentId + '"] span').text();
	
	                    $.confirm({
	                        onOpen: _that2.onOpenConfirm,
	                        onClose: _that2.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Datei löschen',
	                        content: '<p>Wollen Sie die Datei</p><p><strong>' + filename + '</strong></p><p>wirklich löschen?</p>',
	
	                        buttons: {
	                            btnNo: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnYes: {
	                                text: 'Löschen',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    _this2.ajaxCall(_this2.deleteFile, {
	                                        "action": dataActionPrefix + "deletefile",
	                                        "fileId": _this2.parentId
	                                    });
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'file' && (this.permissions & 128) == 128) {
	                // Permission: copyfile
	                this.$menu.append('<button title="Kopieren" data-action="copyfile"><svg class="gfx-ODA_ICONS_gesch.ber_datei_kopieren-dims"><use xlink:href="#ODA_ICONS_gesch.ber_datei_kopieren"></use></svg></button>');
	
	                var _that3 = this;
	                $('button[data-action="copyfile"]').on('click', function (e) {
	                    $.confirm({
	                        onOpen: _that3.onOpenConfirm,
	                        onClose: _that3.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Datei kopieren',
	                        columnClass: 'col-md-10 col-md-offset-1',
	                        content: _that3.folderBrowserContent(),
	                        onContentReady: function onContentReady() {
	                            _that3.initFolderBrowser(_that3, this.$content, this.buttons);
	                        },
	                        buttons: {
	                            btnCancel: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnYes: {
	                                text: 'Kopieren',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    var destinationFolder = this.$content.find('.secure_breadcrumb_ul li:last-child > a').data('id');
	                                    if (destinationFolder) {
	                                        _that3.ajaxCall(_that3.copyFile, {
	                                            "action": dataActionPrefix + "copyfile",
	                                            "fileId": _that3.parentId,
	                                            "folderId": destinationFolder
	                                        });
	                                    }
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'file' && (this.permissions & 256) == 256) {
	                // Permission: sortfile
	                this.$menu.append('<button title="Nach oben verschieben" data-action="sortfile" data-direction="up"><svg class="gfx-ODA_ICONS_gesch.ber_1_oben-dims"><use xlink:href="#ODA_ICONS_gesch.ber_1_oben"></use></svg></button>');
	                this.$menu.append('<button title="Nach unten verschieben" data-action="sortfile" data-direction="down"><svg class="gfx-ODA_ICONS_gesch.ber_1_unten-dims"><use xlink:href="#ODA_ICONS_gesch.ber_1_unten"></use></svg></button>');
	                this.$menu.append('<button title="An den Anfang verschieben" data-action="sortfile" data-direction="top"><svg class="gfx-ODA_ICONS_gesch.ber_anfang-dims"><use xlink:href="#ODA_ICONS_gesch.ber_anfang"></use></svg></button>');
	                this.$menu.append('<button title="An das Ende verschieben" data-action="sortfile" data-direction="bottom"><svg class="gfx-ODA_ICONS_gesch.ber_ende-dims"><use xlink:href="#ODA_ICONS_gesch.ber_ende"></use></svg></button>');
	
	                $('button[data-action="sortfile"]').on('click', function (e) {
	                    var $target = $(e.target);
	                    if (!$target.is('button')) {
	                        $target = $target.closest('button');
	                    }
	
	                    _this2.ajaxCall(_this2.sortFile, {
	                        "action": dataActionPrefix + "sortfile",
	                        "fileId": _this2.parentId,
	                        "direction": $target.data('direction')
	                    });
	
	                    _this2.sortdirection = $target.data('direction');
	                });
	            }
	
	            if (this.type == 'file' && (this.permissions & 512) == 512) {
	                // Permission: replacefile
	                this.$menu.append('<button title="Ersetzen" data-action="replacefile"><svg class="gfx-ODA_ICONS_gesch.ber_datei_ersetzen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_datei_ersetzen"></use></svg></button>');
	
	                var _that4 = this;
	                $('button[data-action="replacefile"]').on('click', function (e) {
	                    $.confirm({
	                        onOpen: _that4.onOpenConfirm,
	                        onClose: _that4.onCloseConfirm,
	                        onContentReady: function onContentReady() {
	                            var jc = this;
	
	                            var $rpdropzone = new _dropzone2.default('#drop_rp_' + _that4.parentId, {
	                                url: dataUrl + "?action=" + dataActionPrefix + "replacefile&fileId=" + _that4.parentId,
	                                clickable: true,
	                                timeout: 300000,
	                                maxFiles: 1,
	                                uploadMultiple: false,
	                                dictDefaultMessage: "Datei hierhin ziehen<br />oder<br />hier klicken um Dialog zu öffnen.",
	                                thumbnailMethod: "contain",
	                                previewTemplate: '<div class="dz-preview dropzone-preview">\n                                <div class="filename">\n                                    <span class="dropzone-success-mark"><i class="fa fa-check"></i></span><span class="dropzone-error-mark"><i class="fa fa-exclamation-triangle"></i></span>\n                                    <span data-dz-name class=""></span>\n                                </div>\n                                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress=""></span></div>\n                                <div class="error-msg"><span data-dz-errormessage><small>nicht hochgeladen</small></span></div>\n                            </div>',
	                                accept: function accept(file, done) {
	                                    var extsplit = file.name.split('.');
	                                    var ext = extsplit[extsplit.length - 1].toLowerCase();
	
	                                    this.on("addedfile", function () {
	                                        if (this.files[1] != null) {
	                                            this.removeFile(this.files[0]);
	                                        }
	                                    });
	
	                                    if (allowedFileExtensions.search(ext) == -1) {
	                                        file.errorMessage = "Die Datei <strong>" + file.name + "</strong> hat einen unerlaubten Dateityp.";
	                                        done("Unerlaubter Typ.");
	                                    } else if (file.size > maxFileSize) {
	                                        file.errorMessage = "Die Datei <strong>" + file.name + "</strong> ist zu schwer.";
	                                        done("Unerlaubte Grösse.");
	                                    } else {
	                                        done();
	                                    }
	                                },
	                                error: function error(file) {
	                                    $(file.previewElement).addClass('dz-error');
	                                    var errormsg = "Der Server ist momentan nicht erreichbar. Bitte wenden Sie sich an den Administrator oder versuchen Sie es später nochmal.";
	                                    if (file.errorMessage) {
	                                        errormsg = file.errorMessage;
	                                    }
	                                    var json = { success: false, errors: [errormsg], errorcode: 0, debug: ["Dropzone Error: wrong file size or dropzone error", errormsg] };
	                                    securearea.showError("replacefile", json);
	                                },
	                                success: function success(dzresult, wpresult) {
	                                    $('.errormsg').remove();
	
	                                    if (wpresult.success) {
	                                        $('.dropzone .btn[data-action="getfolder"]').addClass('show');
	                                        jc.buttons.btnRename.enable();
	                                    } else {
	                                        securearea.showError("replacefile", wpresult);
	                                        return false;
	                                    }
	                                }
	                            });
	                        },
	                        type: 'orange',
	                        title: 'Datei ersetzen',
	                        content: '' + '<div class="dropzone dropzone-single dropzone-theme" id="drop_rp_' + _that4.parentId + '"></div>',
	                        buttons: {
	                            btnCancel: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnRename: {
	                                text: 'Schliessen',
	                                btnClass: 'btn-orange',
	                                isDisabled: true,
	                                action: function action() {
	                                    return true;
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'folder' && (this.permissions & 1024) == 1024) {
	                // Permission: createfolder
	                this.$menu.append('<button title="Ordner erstellen" data-action="createfolder"><svg class="gfx-ODA_ICONS_gesch.ber_erstellen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_erstellen"></use></svg></button>');
	
	                var _that5 = this;
	                $('button[data-action="createfolder"]').on('click', function (e) {
	
	                    $.confirm({
	                        onOpen: _that5.onOpenConfirm,
	                        onClose: _that5.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Ordner erstellen',
	                        content: '' + '<form action="">' + '<div class="form-group">' + '<label>Anzeigename:</label>' + '<input type="text" class="foldername form-control" required />' + '</div>' + '</form>',
	                        buttons: {
	                            btnCancel: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnRename: {
	                                text: 'Erstellen',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    var folderName = this.$content.find('.foldername').val();
	                                    _that5.folderName = folderName;
	                                    if (folderName) {
	                                        _that5.ajaxCall(_that5.createFolder, {
	                                            "action": dataActionPrefix + "createfolder",
	                                            "folderId": _that5.parentId,
	                                            "folderName": folderName
	                                        });
	                                    } else {
	                                        return false;
	                                    }
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'folder' && (this.permissions & 2048) == 2048) {
	                // Permission: renamefolder
	                this.$menu.append('<button title="Umbenennen" data-action="renamefolder"><svg class="gfx-ODA_ICONS_gesch.ber_bearbeiten-dims"><use xlink:href="#ODA_ICONS_gesch.ber_bearbeiten"></use></svg>/button>');
	
	                var _that6 = this;
	                $('button[data-action="renamefolder"]').on('click', function (e) {
	                    var targetText = $(e.target).closest('li').find('[data-type] > span').first().text();
	
	                    $.confirm({
	                        onOpen: _that6.onOpenConfirm,
	                        onClose: _that6.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Ordner umbenennen',
	                        content: '' + '<form action="">' + '<div class="form-group">' + '<label>Anzeigename:</label>' + '<input type="text" class="foldername form-control" value="' + targetText + '" required />' + '</div>' + '</form>',
	
	                        buttons: {
	                            btnCancel: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnRename: {
	                                text: 'Umbenennen',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    var foldername = this.$content.find('.foldername').val();
	                                    _that6.foldername = foldername;
	                                    if (foldername) {
	                                        _that6.ajaxCall(_that6.renameFolder, {
	                                            "action": dataActionPrefix + "renamefolder",
	                                            "folderId": _that6.parentId,
	                                            "folderName": foldername
	                                        });
	                                    } else {
	                                        return false;
	                                    }
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'folder' && (this.permissions & 4096) == 4096) {
	                // Permission: movefolder
	                this.$menu.append('<button title="Verschieben" data-action="movefolder"><svg class="gfx-ODA_ICONS_gesch.ber_verschieben-dims"><use xlink:href="#ODA_ICONS_gesch.ber_verschieben"></use></svg></button>');
	
	                var _that7 = this;
	                $('button[data-action="movefolder"]').on('click', function (e) {
	                    $.confirm({
	                        onOpen: _that7.onOpenConfirm,
	                        onClose: _that7.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Ordner verschieben',
	                        columnClass: 'col-md-10 col-md-offset-1',
	                        content: _that7.folderBrowserContent(),
	                        onContentReady: function onContentReady() {
	                            _that7.initFolderBrowser(_that7, this.$content, this.buttons);
	                        },
	                        buttons: {
	                            btnCancel: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnYes: {
	                                text: 'Verschieben',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    var destinationFolder = this.$content.find('.secure_breadcrumb_ul li:last-child > a').data('id');
	                                    if (destinationFolder) {
	                                        _that7.ajaxCall(_that7.moveFolder, {
	                                            "action": dataActionPrefix + "movefolder",
	                                            "folderId": _that7.parentId,
	                                            "destinationFolderId": destinationFolder
	                                        });
	                                    }
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'folder' && (this.permissions & 8192) == 8192) {
	                // Permission: deletefolder
	                this.$menu.append('<button title="Löschen" data-action="deletefolder"><svg class="gfx-ODA_ICONS_gesch.ber_loeschen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_loeschen"></use></svg>/button>');
	                var _that8 = this;
	                $('button[data-action="deletefolder"]').on('click', function (e) {
	                    var foldername = $('a[data-id="' + _this2.parentId + '"] span').text();
	
	                    $.confirm({
	                        onOpen: _that8.onOpenConfirm,
	                        onClose: _that8.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Datei löschen',
	                        content: '<p>Wollen Sie den Ordner</p><p><strong>' + foldername + '</strong></p><p>wirklich löschen?</p>',
	
	                        buttons: {
	                            btnNo: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnYes: {
	                                text: 'Löschen',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    _this2.ajaxCall(_this2.deleteFolder, {
	                                        "action": dataActionPrefix + "deletefolder",
	                                        "folderId": _this2.parentId
	                                    });
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'folder' && (this.permissions & 131072) == 131072) {
	                // Permission: deleteFiles
	                this.$menu.append('<button title="Alle Dateien löschen" data-action="deletefiles"><svg class="gfx-ODA_ICONS_gesch.ber_alle_dateien_loeschen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_alle_dateien_loeschen"></use></svg></button>');
	
	                var _that9 = this;
	                $('button[data-action="deletefiles"]').on('click', function (e) {
	                    var foldername = $('a[data-id="' + _this2.parentId + '"] span').text();
	
	                    $.confirm({
	                        onOpen: _that9.onOpenConfirm,
	                        onClose: _that9.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Dateien löschen',
	                        content: '<p>Wollen Sie alle Dateien aus dem Ordner</p><p><strong>' + foldername + '</strong></p><p>löschen?</p>',
	
	                        buttons: {
	                            btnNo: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnYes: {
	                                text: 'Alle Löschen',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    _that9.ajaxCall(_that9.deleteFiles, {
	                                        "action": dataActionPrefix + "deletefiles",
	                                        "folderId": _that9.parentId
	                                    });
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'folder' && (this.permissions & 16384) == 16384) {
	                // Permission: copyfolder
	                this.$menu.append('<button title="Kopieren" data-action="copyfolder"><svg class="gfx-ODA_ICONS_gesch.ber_ordner_kopieren-dims"><use xlink:href="#ODA_ICONS_gesch.ber_ordner_kopieren"></use></svg></button>');
	
	                var _that10 = this;
	                $('button[data-action="copyfolder"]').on('click', function (e) {
	                    $.confirm({
	                        onOpen: _that10.onOpenConfirm,
	                        onClose: _that10.onCloseConfirm,
	                        type: 'orange',
	                        title: 'Ordner kopieren',
	                        columnClass: 'col-md-10 col-md-offset-1',
	                        content: _that10.folderBrowserContent(),
	                        onContentReady: function onContentReady() {
	                            _that10.initFolderBrowser(_that10, this.$content, this.buttons);
	                        },
	                        buttons: {
	                            btnCancel: {
	                                text: 'Abbrechen',
	                                keys: ['esc']
	                            },
	                            btnYes: {
	                                text: 'Kopieren',
	                                btnClass: 'btn-orange',
	                                action: function action() {
	                                    var destinationFolder = this.$content.find('.secure_breadcrumb_ul li:last-child > a').data('id');
	                                    if (destinationFolder) {
	                                        _that10.ajaxCall(_that10.copyFolder, {
	                                            "action": dataActionPrefix + "copyfolder",
	                                            "folderId": _that10.parentId,
	                                            "destinationFolderId": destinationFolder
	                                        });
	                                    }
	                                }
	                            }
	                        }
	                    });
	                });
	            }
	
	            if (this.type == 'folder' && (this.permissions & 32768) == 32768) {
	                // Permission: sortfolder
	                this.$menu.append('<button title="Nach oben verschieben" data-action="sortfolder" data-direction="up"><svg class="gfx-ODA_ICONS_gesch.ber_1_oben-dims"><use xlink:href="#ODA_ICONS_gesch.ber_1_oben"></use></svg></button>');
	                this.$menu.append('<button title="Nach unten verschiebe" data-action="sortfolder" data-direction="down"><svg class="gfx-ODA_ICONS_gesch.ber_1_unten-dims"><use xlink:href="#ODA_ICONS_gesch.ber_1_unten"></use></svg></button>');
	                this.$menu.append('<button title="An den Anfang verschieben" data-action="sortfolder" data-direction="top"><svg class="gfx-ODA_ICONS_gesch.ber_anfang-dims"><use xlink:href="#ODA_ICONS_gesch.ber_anfang"></use></svg></i></button>');
	                this.$menu.append('<button title="An das Ende verschieben" data-action="sortfolder" data-direction="bottom"><svg class="gfx-ODA_ICONS_gesch.ber_ende-dims"><use xlink:href="#ODA_ICONS_gesch.ber_ende"></use></svg></i></button>');
	                $('button[data-action="sortfolder"]').on('click', function (e) {
	                    var $target = $(e.target);
	                    if (!$target.is('button')) {
	                        $target = $target.closest('button');
	                    }
	
	                    _this2.ajaxCall(_this2.sortFolder, {
	                        "action": dataActionPrefix + "sortfolder",
	                        "folderId": _this2.parentId,
	                        "direction": $target.data('direction')
	                    });
	
	                    _this2.sortdirection = $target.data('direction');
	                });
	            }
	
	            if ((this.permissions & 1) == 1) {
	                // Permission: showinfos / share
	                this.$menu.append('<button title="Teilen" data-action="share"><svg class="gfx-share-alt-light"><use xlink:href="#share-alt-light"></use></svg></button>');
	                var _that11 = this;
	                $('button[data-action="share"]').on('click', function (e) {
	                    var shareUrl = $('.mxm_securearea_next').data('shareurl');
	                    shareUrl = shareUrl.replace('##id##', _this2.parentId);
	                    var itemName = $('a[data-id="' + _this2.parentId + '"] span').text();
	
	                    $.confirm({
	                        onOpen: _that11.onOpenConfirm,
	                        onClose: _that11.onCloseConfirm,
	                        columnClass: 'medium',
	                        type: 'blue',
	                        title: 'Link teilen',
	                        content: '<p>Kopieren sie folgende URL um <strong>' + itemName + '</strong> zu teilen:</p><p><a target="_blank" href="' + shareUrl + '">' + shareUrl + '</a></p>',
	
	                        buttons: {
	                            btnOk: {
	                                text: 'Schliessen',
	                                keys: ['esc']
	                            }
	                        }
	                    });
	                });
	            }
	
	            if ((this.permissions & 65536) == 65536) {
	                // Permission: showinfos
	                this.$menu.append('<button title="Informationen" data-action="showinfos"><svg class="gfx-ODA_ICONS_gesch.ber_infos_2-dims"><use xlink:href="#ODA_ICONS_gesch.ber_infos_2"></use></svg></button>');
	
	                $('button[data-action="showinfos"]').on('click', function (e) {
	                    _this2.ajaxCall(_this2.showInfos, {
	                        "action": dataActionPrefix + "showinfos",
	                        "folderOrFileId": _this2.parentId });
	                });
	            }
	        }
	    }, {
	        key: 'ajaxCall',
	        value: function ajaxCall(callback, params) {
	            var _this3 = this;
	
	            $.ajax({
	                type: "post",
	                dataType: "json",
	                url: dataUrl,
	                data: params,
	                beforeSend: function beforeSend() {
	                    securearea.addSpinner();
	                },
	                complete: function complete() {
	                    securearea.removeSpinner();
	                },
	                success: function success(json) {
	                    $('.errormsg').remove();
	                    if (json.success) {
	                        callback(_this3, json.data, params);
	                    } else {
	                        securearea.showError(params.action, json);
	                        return false;
	                    }
	                },
	                error: function error() {}
	            });
	        }
	    }, {
	        key: 'showInfos',
	        value: function showInfos(menu, data) {
	            var $html = "";
	            for (var key in data) {
	                if (data.hasOwnProperty(key)) {
	                    $html += '<tr><th>' + key + '</th>';
	                    $html += '<td>';
	                    if (data[key] !== null && _typeof(data[key]) === 'object') {
	                        if (Array.isArray(data[key])) {
	                            var tmpStr = data[key].join(', ');
	                            $html += tmpStr;
	                        } else {
	                            for (var tdobj in data[key]) {
	                                if (data[key].hasOwnProperty(tdobj)) {
	                                    var element = data[key][tdobj];
	                                    $html += '<i>' + tdobj + ': </i>';
	                                    if (Array.isArray(element)) {
	                                        $html += element.join(', ');
	                                    } else {
	                                        $html += element;
	                                    }
	                                    $html += "<br />";
	                                }
	                            }
	                        }
	                    } else {
	                        $html += data[key];
	                    }
	                    $html += '</td>';
	                    $html += '</tr>';
	                }
	            }
	
	            $.confirm({
	                onOpen: menu.onOpenConfirm,
	                onClose: menu.onCloseConfirm,
	                backgroundDismiss: true,
	                type: 'blue',
	                title: 'Informationen',
	                columnClass: 'col-md-10 col-md-offset-1',
	                content: '' + '<table class="infotable">' + $html + '</table>',
	                buttons: {
	                    btnOk: {
	                        text: 'Schliessen',
	                        keys: ['esc']
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'moveFolder',
	        value: function moveFolder(menu, data, params) {
	            menu.targetFolderRefresh(params.destinationFolderId);
	
	            var parentfolders = $('a[data-id="' + menu.instance.id + '"]').closest('.folders').siblings('[data-type="folder"]');
	            if (parentfolders.length) {
	                menu.targetFolderRefresh($(parentfolders[0]).data('id'));
	            }
	        }
	    }, {
	        key: 'moveFile',
	        value: function moveFile(menu, data, params) {
	            menu.targetFolderRefresh(params.folderId);
	
	            var parentfolders = $('a[data-id="' + menu.instance.id + '"]').closest('.files').siblings('[data-type="folder"]');
	            if (parentfolders.length) {
	                menu.targetFolderRefresh($(parentfolders[0]).data('id'));
	            }
	        }
	    }, {
	        key: 'copyFolder',
	        value: function copyFolder(menu, data, params) {
	            menu.targetFolderRefresh(params.destinationFolderId);
	        }
	    }, {
	        key: 'folderBrowserContent',
	        value: function folderBrowserContent() {
	            return '' + '<div class="progress"><div class="indeterminate"></div></div>' + '<div class="secure_breadcrumb">' + '<a href="#" data-target="root"><i class="fa fa-home"></i></a>' + '<ul class="secure_breadcrumb_ul"></ul>' + '</div>' + '<div class="secure_folderbrowser">' + '<ul></ul>' + '</div>';
	        }
	    }, {
	        key: 'initFolderBrowser',
	        value: function initFolderBrowser(that, confirmContent, buttons) {
	            var spinner = confirmContent.find('.progress');
	            var browserul = confirmContent.find('.secure_folderbrowser > ul');
	            var breadcrumbList = confirmContent.find('.secure_breadcrumb_ul');
	            var folderId = that.parentId;
	            var moveUp = that.type == 'file' ? false : true;
	            var currentfolder = void 0;
	            if (that.type == 'file') {
	                currentfolder = $('a[data-id="' + that.parentId + '"]').closest('.files').siblings('[data-type="folder"]');
	            } else {
	                currentfolder = $('a[data-id="' + that.parentId + '"]');
	            }
	
	            var sourceFolderId = currentfolder.data('id');
	
	            folderNavigation();
	
	            confirmContent.click('[data-target]', function (e) {
	                var target = $(e.target);
	
	                if (!target.data('target') || target.data('target') == undefined) {
	                    if (target.closest('[data-target]').length > 0) {
	                        target = target.closest('[data-target]');
	                    } else {
	                        return;
	                    }
	                }
	
	                target.addClass('disabled');
	                e.preventDefault();
	                currentfolder = target;
	                folderNavigation();
	            });
	
	            function folderNavigation() {
	                if (!currentfolder.data('id') || currentfolder.data('id') == undefined) {
	                    currentfolder = currentfolder.closest('[data-target]');
	                }
	
	                var root = currentfolder.data('target') == 'root';
	
	                if (!moveUp) {
	                    folderId = currentfolder.data('id');
	                }
	
	                if (root) {
	                    folderId = 0;
	                }
	
	                $.ajax({
	                    type: "post",
	                    dataType: "json",
	                    url: dataUrl,
	                    data: {
	                        "action": dataActionPrefix + "foldernavigation",
	                        "folderId": folderId,
	                        "sourceFolderId": sourceFolderId,
	                        "moveUp": moveUp ? 1 : 0
	                    },
	                    beforeSend: function beforeSend() {
	                        spinner.addClass('showing');
	                    },
	                    complete: function complete() {
	                        spinner.removeClass('showing');
	                    },
	                    success: function success(json) {
	                        if (json.success) {
	                            // disable or enable buttons
	                            if (that.type == 'file' && json.data.isCurrentFolder) {
	                                buttons.btnYes.disable();
	                            } else if (that.type == 'folder' && (json.data.isSubFolder || json.data.isCurrentFolder)) {
	                                buttons.btnYes.disable();
	                            } else {
	                                buttons.btnYes.enable();
	                            }
	
	                            // fill folders
	                            browserul.empty();
	                            if (json.data.folders == null || json.data.folders.length == 0) {
	                                browserul.append('<p class="noentries">Keine Einträge gefunden.</p>');
	                            } else {
	                                for (var i = 0; i < json.data.folders.length; i++) {
	                                    var element = json.data.folders[i];
	                                    var hasPermissions = (element.permissions & 1024) == 1024;
	                                    var isTarget = element.id == folderId;
	                                    var isDisabled = !hasPermissions || isTarget;
	                                    browserul.append('<li><a href="#"' + ' data-target="' + element.id + '" data-id="' + element.id + '">' + element.title + '</a></li>');
	                                }
	                            }
	
	                            // fill breadcrumb
	                            breadcrumbList.empty();
	                            if (json.data.breadcrumbdots) {
	                                breadcrumbList.append('<li>&hellip;</li>');
	                            }
	                            if (json.data.breadcrumb != null || json.data.breadcrumb.length != 0) {
	                                for (var _i = 0; _i < json.data.breadcrumb.length; _i++) {
	                                    var _element = json.data.breadcrumb[_i];
	                                    breadcrumbList.append('<li><a href="#" data-target="' + _element.id + '" data-id="' + _element.id + '">' + _element.title + '</a></li>');
	                                }
	                            }
	
	                            // other
	                            moveUp = false;
	                        } else {
	                            securearea.showError("foldernavigation", json);
	                            return false;
	                        }
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'copyFile',
	        value: function copyFile(menu, data, params) {
	            menu.targetFolderRefresh(params.folderId);
	        }
	    }, {
	        key: 'deleteFile',
	        value: function deleteFile(menu, data) {
	            $('a[data-id="' + menu.parentId + '"]').closest('li').remove();
	        }
	    }, {
	        key: 'deleteFolder',
	        value: function deleteFolder(menu, data) {
	            $('a[data-id="' + menu.parentId + '"]').closest('li').remove();
	        }
	    }, {
	        key: 'deleteFiles',
	        value: function deleteFiles(menu, data) {
	            menu.instance.refreshFolder();
	            menu.instance.refreshPermissions();
	        }
	    }, {
	        key: 'renameFile',
	        value: function renameFile(menu, data) {
	            $('a[data-id="' + menu.parentId + '"] span').text(menu.fileTitle);
	        }
	    }, {
	        key: 'renameFolder',
	        value: function renameFolder(menu, data) {
	            $('a[data-id="' + menu.parentId + '"] span').text(menu.foldername);
	        }
	    }, {
	        key: 'createFolder',
	        value: function createFolder(menu, data) {
	            menu.instance.refreshFolder();
	        }
	    }, {
	        key: 'replaceFile',
	        value: function replaceFile(menu, data) {
	            menu.instance.refreshFolder();
	        }
	    }, {
	        key: 'sortFolder',
	        value: function sortFolder(menu, data) {
	            menu.sortEntry(menu);
	        }
	    }, {
	        key: 'sortFile',
	        value: function sortFile(menu, data) {
	            menu.sortEntry(menu);
	        }
	    }, {
	        key: 'sortEntry',
	        value: function sortEntry(menu) {
	            var entry = menu.$menu.closest('li');
	
	            switch (menu.sortdirection) {
	                case 'up':
	                    entry.prev().insertAfter(entry);
	                    break;
	                case 'down':
	                    entry.next().insertBefore(entry);
	                    break;
	                case 'top':
	                    entry.closest('ul').prepend(entry);
	                    break;
	                case 'bottom':
	                    entry.closest('ul').append(entry);
	                    break;
	
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'onOpenConfirm',
	        value: function onOpenConfirm() {
	            document.body.style.overflow = "hidden";
	        }
	    }, {
	        key: 'onCloseConfirm',
	        value: function onCloseConfirm() {
	            document.body.style.overflow = "visible";
	        }
	    }, {
	        key: 'targetFolderRefresh',
	        value: function targetFolderRefresh(targetId) {
	            var folder = $('[data-id="' + targetId + '"]');
	
	            if (folder && folder.length) {
	                var targetfolder = new _DataFolder2.default({
	                    id: targetId,
	                    title: "",
	                    permissions: "65543"
	                }, $('[data-id="' + targetId + '"]').closest('ul'));
	                targetfolder.$el = $('[data-id="' + targetId + '"]').closest('li');
	                targetfolder.refreshFolder();
	            } else {
	                console.log('no such folder ' + targetId);
	            }
	        }
	    }]);
	
	    return Menu;
	}();
	
	exports.default = Menu;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DataEntry2 = __webpack_require__(27);
	
	var _DataEntry3 = _interopRequireDefault(_DataEntry2);
	
	var _SecureArea = __webpack_require__(25);
	
	var _SecureArea2 = _interopRequireDefault(_SecureArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataFile = function (_DataEntry) {
	    _inherits(DataFile, _DataEntry);
	
	    function DataFile() {
	        _classCallCheck(this, DataFile);
	
	        return _possibleConstructorReturn(this, (DataFile.__proto__ || Object.getPrototypeOf(DataFile)).apply(this, arguments));
	    }
	
	    _createClass(DataFile, [{
	        key: 'createMarkup',
	        value: function createMarkup() {
	            // this.$html = `
	            //     <li>
	            //         <a href="#" data-type="${this.entry.type}" data-id="${this.id}" data-extension="${this.entry.extension}">
	            //         <i class="fa fa-file-o"></i> <span>${this.entry.title}</span></a>
	            //     </li>
	            // `;
	
	            this.$li = document.createElement('li');
	
	            this.$link = document.createElement('a');
	            this.$link.setAttribute('href', "#");
	            this.$link.setAttribute('data-id', this.id);
	            this.$link.setAttribute('data-extension', this.entry.extension.toLowerCase());
	            this.$link.setAttribute('data-type', "file");
	
	            this.$fa = document.createElement('i');
	            this.$fa.classList.add('fa', 'fa-file-o');
	
	            this.$span = document.createElement('span');
	            this.$span.innerText = this.entry.title;
	
	            this.$link.appendChild(this.$fa);
	            this.$link.appendChild(this.$span);
	            this.$li.appendChild(this.$link);
	            this.$html = this.$li;
	        }
	    }, {
	        key: 'setClickEvent',
	        value: function setClickEvent() {
	            var _this2 = this;
	
	            if ((this.permissions & 1) == 1) {
	                this.$link.on('click', function (e) {
	                    e.preventDefault();
	
	                    var that = _this2;
	
	                    $.ajax({
	                        type: "post",
	                        dataType: "json",
	                        url: dataUrl,
	                        data: {
	                            "action": dataActionPrefix + "read",
	                            "fileId": that.id
	                        },
	                        beforeSend: function beforeSend() {
	                            securearea.addSpinner();
	                            that.disableEntry();
	                        },
	                        complete: function complete() {
	                            securearea.removeSpinner();
	                            that.enableEntry();
	                        },
	                        error: function error(jqXHR, textStatus, errorThrown) {
	                            console.log(jqXHR, textStatus, errorThrown);
	                        },
	                        success: function success(json) {
	                            $('.errormsg').remove();
	
	                            if (json.success) {
	                                window.location.href = json.data.downloadUrl;
	                            } else {
	                                securearea.showError("read", json);
	                                return false;
	                            }
	                        }
	                    });
	                });
	            }
	        }
	    }]);
	
	    return DataFile;
	}(_DataEntry3.default);
	
	exports.default = DataFile;

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	var isiPad = navigator.userAgent.match(/iPad/i) != null;
	function CheckOnScreen() {
		$('.svg-animation:not(.svg-loaded)').each(function () {
			if ($(this).isOnScreen()) {
				$(this).addClass('svg-loaded');
				if (!isiPad) {
					var myVivus = new Vivus($(this).find('svg')[0], {
						type: 'sync',
						pathTimingFunction: Vivus.EASE,
						animTimingFunction: Vivus.EASE_OUT,
						duration: 300
					});
					myVivus.play();
				}
			}
		});
	}
	
	$(window).on('load', function () {
		CheckOnScreen();
	
		$(window).scroll(function () {
			CheckOnScreen();
		});
	});

/***/ },
/* 31 */
/***/ function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
	  $('select:not(.form-control-course)').material_select();
	
	  $('.init-floatinglabels .input-field [placeholder]').removeAttr('placeholder');
	});

/***/ },
/* 32 */
/***/ function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
		if ($('.login-modal').length) {
	
			var $modal = $('.login-modal');
			var $html = $('html');
	
			$('.login-modal-toggler').on('click', function (e) {
				e.preventDefault();
				$modal.addClass('open');
				$html.addClass('login-modal-open');
			});
	
			$('.login-modal .close').on('click', function (e) {
				e.preventDefault();
				$modal.removeClass('open');
				$html.removeClass('login-modal-open');
			});
		}
	});

/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	
	var breadcrumb = $('.breadcrumb-container .breadcrumbs');
	var metaNav = $('nav.meta');
	
	$(function () {
	    positionBreadcrumb();
	
	    $(window).on('resize', function () {
	        positionBreadcrumb();
	    });
	});
	
	function positionBreadcrumb() {
	    var metaNavOffset = metaNav.offset().left;
	    var breadcrumbOffset = breadcrumb.offset().left;
	    if (metaNav.css('display') === 'none') {
	        breadcrumb.css('width', '100%');
	    } else {
	        breadcrumb.css('width', metaNavOffset - breadcrumbOffset - 20);
	    }
	}

/***/ },
/* 34 */
/***/ function(module, exports) {

	"use strict";
	
	$(document).ready(function () {
	    if ($(".mxm_courses").length) {
	
	        var $fields = $(".mxm_courses-fields");
	        var $login = $(".mxm_courses-login");
	
	        $(".mxm_courses .datepicker").each(function () {
	            $(this).datepicker();
	            $(this).datepicker("option", "dateFormat", 'dd.mm.yy');
	            var val = $(this)[0].defaultValue;
	
	            if (val && val != "") {
	                $(this).datepicker("setDate", val);
	            }
	        });
	
	        $('input[type=radio][name=mxm_courses-odaorg]').change(function () {
	            switch (this.value) {
	                case "0":
	                    $fields.removeClass("hidden");
	                    $login.addClass("hidden");
	                    break;
	                case "1":
	                    $login.removeClass("hidden");
	                    $fields.addClass("hidden");
	                    break;
	            }
	        });
	    }
	
	    $(".clearFile").on('click', function (e) {
	        e.preventDefault();
	        var $btn = $(e.currentTarget);
	        var $file = $btn.prev();
	        $file.val('');
	    });
	
	    $('.form-control-course').select2();
	    var groupselect = $('.group-billing .form-control-course').select2({
	        tags: true,
	        width: '100%'
	    });
	
	    var fields = ["G_FIRMA", "G_FIRMAZUSATZ", "G_ADRESSE", "G_ZUSATZ", "G_PLZ", "G_ORT"];
	
	    var isPredefinedPrev = false;
	    var isPredefined = false;
	    var isFormError = false;
	
	    groupselect.on("select2:select", function (e) {
	        var companyVal = $(e.currentTarget).val();
	
	        isPredefined = /^\d+$/.test(companyVal);
	        isFormError = $('.formerror').length;
	
	        if (isPredefined) {
	            $.ajax({
	                type: 'GET',
	                url: '/wp-json/mxm_courses/company',
	                data: { "companyid": companyVal },
	                beforeSend: function beforeSend() {
	                    loadingStart();
	                }
	            }).done(function (result) {
	                if (!result) {
	                    showError(result);
	                } else {
	                    fillFields(result);
	                }
	            }).fail(function (result) {
	                showError(result);
	            }).always(function () {
	                loadingStop();
	            });
	        } else {
	            if (typeChanged()) {
	                clearFields();
	            }
	            copyValue(companyVal);
	        }
	        isPredefinedPrev = isPredefined;
	    });
	
	    function copyValue(companyVal) {
	        $('input[name="G_FIRMA"]').val(companyVal);
	    }
	
	    function typeChanged() {
	        return isPredefinedPrev != isPredefined;
	    }
	
	    function fillFields(result) {
	        for (var i = 0; i < fields.length; i++) {
	            var field = fields[i];
	            if (result[field] && result[field] != "") {
	                $('input[name="' + field + '"]').val(result[field]).attr("readonly", true);
	            } else {
	                $('input[name="' + field + '"]').val("").attr("readonly", false);
	            }
	        }
	    }
	
	    function clearFields() {
	        for (var i = 0; i < fields.length; i++) {
	            var field = fields[i];
	            $('input[name="' + field + '"]').val("").attr("readonly", false);
	        }
	    }
	
	    function showError(result) {
	        var errorMsg = result;
	        groupselect.closest('.form-group').prepend('<div id="billing-error" class="error"><div class="help-block">Diese Geschäftsadresse können wir gerade nicht ausfindig machen. Bitte versuchen Sie es noch einmal.</div></div>');
	        console.warn('ajax error or id not found');
	        clearFields();
	        groupselect.val(null).trigger('change');
	    }
	
	    function loadingStart() {
	        groupselect.closest('.row').addClass('loading');
	        groupselect.closest('.form-group').prepend('<div id="billing-loading" class="progress showing"><div class="indeterminate"></div></div>');
	    }
	
	    function loadingStop() {
	        groupselect.closest('.row').removeClass('loading');
	        $('#billing-loading').detach().remove();
	    }
	});

/***/ },
/* 35 */
/***/ function(module, exports) {

	"use strict";
	
	$(document).ready(function () {});

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** app.js
 **/